import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {withStyles} from '@mui/styles';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import FormLabel from '@mui/material/FormLabel';
import DeleteIcon from '@mui/icons-material/Delete';
import AddUserIcon from '@mui/icons-material/Add';
import AddUserImage from '@mui/icons-material/CloudUpload';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Dropzone from 'react-dropzone';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PhoneInput from '../common/PhoneInput';
import {
  BRAND_DEFAULT_COLOR,
  isValidHexColor,
  readableTextColor,
} from '../../utils/brandColor';
import { resolveEpicScanRegexp } from '../../utils/epicRxParsing';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Selector from '../select';
import {ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import {toast} from 'react-toastify';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import './index.css';
import MultipleConnection from '../common/MultipleConnection';
import Switch from '@mui/material/Switch';
import CONNECTION_TYPE from '../common/connection-type';
import spinner from '../assign-prescriptions/images/spinner.gif';
import MaskedInput from 'react-text-mask';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Input from '@mui/material/Input';
import CopyText from '@mui/icons-material/ContentCopy';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import QRCode from 'qrcode.react';
import {Divider} from '@mui/material';
import Box from '@mui/material/Box';
import moment from 'moment-timezone';
import {Help} from '@mui/icons-material';
import {styled} from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {withTranslation} from 'react-i18next';
import AwsAuthSignIn from '../AwsService/aws-auth-signin';
import {HL7Layout} from './third-party/Hl';
import {DRXLayout} from './third-party/drx';
import SignatureFlagsSection from './SignatureFlagsSection';
import SignatureFlagsDevModeSection from './SignatureFlagsDevModeSection';
import TermsAndConditionsSection, { areTermsAndConditionsSlotsValid } from './TermsAndConditionsSection';
import AccountResourcesDialog from './related/AccountResourcesDialog';
import { getAccountLevelKioskHours } from './related/accountResourceGridUtils';
import QRCodeGenerator from 'qrcode';
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  buildManageAccountsSearchObject,
  getActionsColumn,
  openAgGridContextMenu,
  actionMenuItem,
  hideRowActionsMenu,
} from '../grid/iLocalAGGrid';

const storedEpicRegexp = (value, connectionId) => {
  if (connectionId !== CONNECTION_TYPE.EPIC) {
    return value || '';
  }
  return resolveEpicScanRegexp(value);
};

/** Connection types that show the Signature Flags section in account settings */
const SIGNATURE_FLAGS_CONNECTION_TYPES = [
  CONNECTION_TYPE.EPIC,
  CONNECTION_TYPE.EPIC_WITH_MTLS,
  CONNECTION_TYPE.ILOCALBOX_PHARMACY,
];

const DEFAULT_LIBERTY_COMPLETION_STATUS = 'Shipped';
const DEFAULT_LIBERTY_BASE_URL = 'https://api.libertysoftware.com/';
const DEFAULT_LIBERTY_VENDOR_USERNAME = 'ilocalbox';
const DEFAULT_LIBERTY_VENDOR_PASSWORD = 'Hk!3e_9mN-a';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

function TextMaskCustom(props) {
  const { innerRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      // render={(ref, props) => (
      //    innerRef={ref} {...props} />
      // )}
      mask={[/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]}
    />
  );
}
function TabContainer({ children, dir, classes }) {
  return (
    <Typography component='div' dir={dir}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};


// function onDrop(acceptedFiles, rejectedFiles) {
//   // do stuff with files...
// }

class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => (event) => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {onSelectAllClick, order, orderBy, numSelected, rowCount, sortId, t} = this.props;
    const rows = [
      {
        id: 'avatar',
        numeric: false,
        disablePadding: true,
        label: t('Accounts.Logo'),
        field: 'picture_url',
      },
      {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: t('Accounts.Name'),
        field: 'name',
      },
      {
        id: 'parent_account',
        numeric: false,
        disablePadding: false,
        label: t('Accounts.ParentAccount'),
        field: 'name',
      },
      {
        id: 'type',
        numeric: false,
        disablePadding: false,
        label: t('Accounts.AccountType'),
        field: 'name',
      },
      {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: t('Accounts.Actions'),
      },
    ];
    return (
      <TableHead sx={{ height: '56px' }}>
        <TableRow>
          <TableCell sx={{ padding: '0 12px' }}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
              sx={{
                '&.Mui-checked': { color: '#0ae' },
                '&.MuiCheckbox-indeterminate': { color: '#0ae' },
              }}
            />
          </TableCell>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === row.id ? order : false}
                sx={{
                  color: 'rgba(0, 0, 0, 0.54)',
                  fontSize: '0.75rem',
                  fontWeight: 500,
                }}
              >
                {['avatar', 'parent_account', 'actions'].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: 'text' }}>
                    {row.label}
                  </TableSortLabel>
                ) : (
                  <Tooltip
                    title={t('Global.Label.Filter.Sort')}
                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
    width: '218px',
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    //backgroundColor: theme.palette.secondary.main,
    backgroundColor: '#00a7e1',
    color: '#fff',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#6cca98',
      color: '#fff',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
  toggleContainer: {
    display: 'inline-block',
    width: '96px',
    marginRight: '10px',
    position: 'relative',
    top: '11px',
  },
  actionsContainer: {
    width: '154px',
  },
  buttonContainer: {
    textAlign: 'right',
  }, //,
  // formControl: {
  //   width: '300px'
  // }
  halfTextFieldPOS: {
    marginRight: '20px',
    marginBottom: '20px',
    width: 425,
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    add,
    confirmDelete,
    acadd,
    acdelete,
    t,
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color='inherit' variant='subheading'>
            {numSelected} {t('Accounts.SelectedRowsCount')}
          </Typography>
        ) : null}
      </div>
      <div className={classes.spacer} />
      <Box>
        {numSelected === 1 ? (
          <div className={classes.buttonContainer}>
            {acdelete === true ? (
              <Tooltip
                key='single-delete'
                title={t('Accounts.DeleteAccountTooltip')}
              >
                <IconButton
                  aria-label='Delete'
                  onClick={confirmDelete}
                  sx={() => ({
                    '&:hover': { backgroundColor: '#6cca98', color: '#fff' },
                  })}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            ) : (
              ''
            )}
          </div>
        ) : numSelected > 1 ? (
          acdelete === true ? (
            <div className={classes.buttonContainer}>
              <Tooltip
                key='multi-delete'
                title={t('Accounts.DeleteAccountTooltip')}
              >
                <IconButton
                  aria-label='Delete'
                  onClick={confirmDelete}
                  sx={() => ({
                    '&:hover': { backgroundColor: '#6cca98', color: '#fff' },
                  })}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </div>
          ) : (
            ''
          )
        ) : acadd === true ? (
          <div>
            <Tooltip key='single-add' title={t('Accounts.AddAccountTooltip')}>
              <IconButton
                aria-label={t('Accounts.AddAccountTooltip')}
                className={classes.add}
                onClick={add}
              >
                <AddUserIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          ''
        )}
      </Box>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  table: {
    minWidth: 1020,
  },
  mytablecell: {
    display: 'table-cell',
    padding: '0px 0px 0px 0px',
    textAlign: 'left',
    borderBottom: 'none',
    verticalAlign: 'inherit',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  halfTextField: {
    // marginLeft: theme.spacing.unit,
    marginRight: '20px',
    width: 390,
  },
  oneThirdTextField: {
    // marginLeft: theme.spacing.unit,
    marginRight: '20px',
    width: 253,
  },
  dropbox: {
    width: '105px',
    height: '105px',
    float: 'right',
    // borderStyle: 'solid',
    // borderWidth: 'thin',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '0px',
    right: '14px',
    position: 'relative',
  },
  advdropbox: {
    width: '175px',
    height: '175px',
    //float: "right",
    // borderStyle: 'solid',
    // borderWidth: 'thin',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '5px',
    right: "-15px",
    position: 'relative',
    marginBottom: '15px',
  },
  brnddropbox: {
    width: '105px',
    height: '105px',
    float: 'right',
    // borderStyle: 'solid',
    // borderWidth: 'thin',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '5px',
    right: '-5px',
    position: 'relative',
  },
  videodropbox: {
    width: '250px',
    height: '175px',
    //float: "right",
    // borderStyle: 'solid',
    // borderWidth: 'thin',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '5px',
    //right: "14px",
    position: 'relative',
  },
  innerBox: {
    margin: '0 auto',
    display: 'block',
    height: '100%',
  },
  dropImage: {
    width: '80%',
    height: '100%',
  },
  dropPic: {
    width: '100%',
    height: '100%',
  },
  errorDiv: {
    paddingTop: '10px',
    color: 'red',
  },
  accountType: {
    paddingTop: '25px',
  },
  accountBox: {
    height: '30px',
  },
  // paddedDiv:{
  //   padding:'0px 3% !important',
  //   lineHeight:'3.6em'
  // },
  // boxDesign:{
  //   padding: '24px',
  //   display: 'grid',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   // border: '1px solid #888'
  // },
  flexItems: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  captionText: {
    lineHeight: '1',
    color: '#8a8a8a',
    fontSize: '13px',
    marginTop: '10px',
    marginLeft: '-20px'
    // textAlign: 'center'
  },
  captionadvText: {
    lineHeight: '1',
    color: '#8a8a8a',
    fontSize: '13px',
    margin: "2px 0px" 
    //marginTop: '-15px',
    // textAlign: 'center'
  },
  twoChildren: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftChild: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  leftChildbrand: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  rightChild: {
    display: 'flex',
    flexDirection: 'column',
  },
  footer: {
    margin: '8px 4px',
    bottom: '0',
    right: '0',
    textAlign: 'center',
    position: 'fixed',
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  btnremove: {
    padding: '8px 2px',
    fontSize: '0.675rem',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  hidden: {
    display: 'none',
  },
  tableAddRowCell: {
    padding: '0px 0px 0px 0px !important',
  },
  wrapperBox: {
    boxShadow:
      '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
  },
  removePad: {
    padding: '4px 4px !important',
    width: '10px',
  },
  removeBorders: {
    borderBottom: '1px solid rgb(255, 255, 255) !important',
  },
  parentRemovePad: {
    padding: '5px !important',
  },
  SeparateRow: {
    borderCollapse: 'separate !important',
    borderSpacing: '0 15px !important',
  },
  customText: {
    margin: '0px',
  },
  previewBox: {
    height: '800px',
  },
  mainIframe: {
    width: '100%',
    height: '555px',
    border: '0px',
    outline: 'none',
  },
  bottomSliderError: {
    color: 'red',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bottomVideoSliderError: {
    color: 'red',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50%',
  },
  halfTextFieldNew: {
    // marginLeft: theme.spacing.unit,
    marginRight: '20px',
    width: 460,
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
  divider: {
    marginTop: '10px',
    height: '5px',
    borderColor: 'rgba(0, 0, 0, 0.12)',
    borderStyle: 'solid',
    borderBottomWidth: '5px',
  },
  tabs: {
    minWidth: '160px',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '6px',
    paddingBottom: '6px',
    fontSize: '0.8125rem',
  },
  menuItem: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  label: {
    color: '#000',
    marginLeft: '13px',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.46429em',
  },
  halfTextFieldToken: {
    marginRight: '20px',
    width: 390,
  },
});

let imgFile;
let AD1;
let AD2;
let AD3;
let BDLOGO;
let VD;
let CLOSEDIMG;
let HIPPA;
let LC;
let OTHER;
let BOTTOMAD1;
let BOTTOMAD2;
let BOTTOMAD3;
let banner;
let header;
//let ET;

let FilterObj = {
  searchtext: '',
  searchObject: null,
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
};

const AccountSortObj = {
  name: { tableName: 'accounts', sortColumn: 'name' },
  'parent.name': { tableName: 'parent_accounts', sortColumn: 'name' },
  'type.name': { tableName: 'account_type', sortColumn: 'name' },
  'contact.address.city': { tableName: 'addresses', sortColumn: 'city' },
  'contact.address.state': { tableName: 'addresses', sortColumn: 'state' },
  'contact.address.zip': { tableName: 'addresses', sortColumn: 'zip' },
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const tz = moment().tz(timeZone);
const findOffset = tz.utcOffset();
let string = '';
if (String(findOffset).startsWith('-')) {
  string = `- ${String(findOffset).slice(1)}`;
} else string = `+ ${String(findOffset)}`;
const zone = `(UTC ${string}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'desc',
      orderBy: 'created_on',
      selected: [],
      // data: getData(),
      page: 0,
      permissiondata: [],
      categorydata: [],
      uniquePermissionCategories: [],
      subCategories: [],
      // checkedPermission:[],
      CheckedPermissionParentCategory: [],
      CheckedPermissionSubCategory: [],
      rowsPerPage: 10,
      submitted: false,
      isButtonDisabled: false,
      isCheckedpermissiom: false,
      isConsultRequired: false,
      isConsultRequire: false,
      epicConsultKey: '',
      open: true,
      selectedTab: 0,
      id: null,
      contractLang: '',
      accountview: true,
      accountadd: true,
      accountdelete: true,
      accountedit: true,
      user: {
        first_name: '',
        last_name: '',
        email: '',
      },
      searchtext: '',
      connect: [],
      accountConnectionsId: null,
      isPaymentRequired: false, //Added by Naresh | 18-03-2019
      email: '',
      // roles: []
      // accountValues: [{label: 'test', value: 'test'}]
      //Added by Kishan | 04-Apr-2019
      accountConnectionsName: null,
      demo_email: '',
      demo_smsphone: '',
      day_id: 1,
      charCount: 300,
      MaxChar: 300,
      endpoint: '',
      pharmacyId: '',
      loader: false,
      innerLoader: false,
      pick_up_reminder_id: '1',
      Sun: false,
      Mon: false,
      Tue: false,
      Wed: false,
      Thu: false,
      Fri: false,
      Sat: false,
      TimevalidateDialog: false,
      closedMsg: '',
      healthandinfo: [],
      categories: [],
      primarylibrarytitle1: '',
      primarylibrarytitle2: '',
      isPHiS: false,
      vendor_key: '',
      data_exchange_id: '',
      AccountConnectionList: [],
      openIframe: false,
      dataUrl: '',
      epicclientid: '',
      epicusername: '',
      epicpassword: '',
      AdvancedAdvertise: false,
      xWebId: '',
      auth_Key: '',
      terminalId: '',
      fiserv_link_username: '',
      fiserv_link_password: '',
      fiserv_terminal_api_key: '',
      trustcommerce_link_custid: '',
      trustcommerce_link_password: '',
      trustcommerce_terminal_custid: '',
      trustcommerce_terminal_password: '',
      trustcommerce_aggregator1: '',
      trustcommerce_aggregators: '',
      instamed_account_id: '',
      instamed_account_id_suffix: '',
      instamed_connect_user_id: '',
      instamed_connect_password: '',
      instamed_api_key: '',
      instamed_api_secret: '',
      instamed_sso_security_key: '',
      allow_payment: false,
      isSuperAdmin: false,
      dummyxWebId: '',
      dummyauthKey: '',
      dummyterminalId: '',
      allow_consult_video: false,
      allow_consult_mobile: false,
      allow_consult_schedule: false,
      isContactLessPickupEnabled: false,
      accContactPersons: [],
      medbank_dblogin: '',
      medbank_db_password: '',
      opc_apim_subscription_key: '',
      show_medbank_dblogin: false,
      show_medbank_db_password: false,
      show_medbank_subscription_key: false,
      showXApiKey: false,
      x_api_key: '',
      showGatewayApiKey: false,
      gateway_api_key: '',
      show_client_identifier: false,
      show_third_party_token: false,
      client_identifier: '',
      third_party_token: '',
      vendor_unique_id: '',
      vendorValues: [],
      genericLink: '',
      random_key: '',
      enrollmentInviteId: '',
      enrollmentLocationId: '',
      helpLink: '',
      privacyPolicyLink: '',
      termsAndConditionsLink: '',
      is_marketplace: false,
      IsGetReady: true,
      StartGraphic: true,
      IsPatientPrimarySource: false,
      isSunday: false,
      isMonday: false,
      isTuesday: false,
      isWednesday: false,
      isThursday: false,
      isFriday: false,
      isSaturday: false,
      accountOpenTime: null,
      accountCloseTime: null,
      AccountHoursOfOperaionsArray: [
        { id: 0, value: 'Sunday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 1, value: 'Monday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 2, value: 'Tuesday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 3, value: 'Wednesday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 4, value: 'Thursday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 5, value: 'Friday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 6, value: 'Saturday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
      ],
      AccountDummyHoursOfOperaionsArray: [
        { id: 0, value: 'Sunday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 1, value: 'Monday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 2, value: 'Tuesday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 3, value: 'Wednesday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 4, value: 'Thursday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 5, value: 'Friday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
        { id: 6, value: 'Saturday', openTime: '', closeTime: '',isClosed: false, isOpenAll: true },
      ],
      autoDisabledUser: false,
      useDefaultEmail: false,
      totalRecords: 0,
      is_dispense_safety_chek: false,
      is_forgot_mypucode: false,
      is_modern_email_enabled: false,
      is_mask_kiosk_dob: true,
      timeZoneNames: [],
      store_number: '',
      mcKessoneRXrequestTemplate: '',
      binaryToken: '',
      issuer: '',
      accordianExpanded: 'panel0',
      CFRHeaderTemplate: '',
      CFRVersion: '',
      CFRMessageName: '',
      RxInfoBodyTemplate: '',
      RxInfoHeaderTemplate: '',
      RxInfoVersion: '',
      RxInfoMessageName: '',
      POSFinalizationBodyTemplate: '',
      POSFinalizationHeaderTemplate: '',
      POSFinalizationVersion: '',
      POSFinalizationMessageName: '',
      paymentGateways: [],
      paymentType: 'Global payments',
      authToken: '',
      authSecret: '',
      dummyAuthToken: '',
      dummyAuthSecret: '',
      merchant_id: '',
      hpp_identifier: '',
      preferredLanguage: [
        { id: 'en', label: this.props.t('Global.Language.English') },
        { id: 'es', label: this.props.t('Global.Language.Spanish') },
        { id: 'fr', label: this.props.t('Global.Language.French') },
      ],
      preferLanguage: 'en',
      loginType: 'DEFAULT',
      ssoIssuer: '',
      ssoEntryPoint: '',
      emailDomain: '',
      clientId: '',
      oidcCert: '',
      isSSOAccountExist: false,
      is_otp_login: false,
      is_enroll_now: false,
      enrollment_v2_enabled: true,
      hide_new_ui: true,
      is_mfa_required: false,
      allow_member_or_record_number: false,
      allow_offline_payment_skip: true,
      is_numeric_code: false,
      is_future_release: false,
      is_pre_assignment: false,
      liberty_customer_username: '',
      liberty_customer_password: '',
      liberty_rx_regrx: '',
      liberty_completion_status: DEFAULT_LIBERTY_COMPLETION_STATUS,
      purge_patient_images_toggle: false,
      purgeImageDialog: false,
      purge_patient_images_days_count: 30,
      purge_patient_username_confirmation: '',
      purge_patienet_final_confirmation_dialog: false,
      purgeSpinnerInProgress: false,
      timeToNotify: new Date(),
      selectedHours: '09',
      patient_consent: false,
      purge_patient_password: '',
      parent_id: '',
      is_consultation_notification: false,
      is_taxable: false,
      is_permission_inheritable: true,
      selectedTaxCode: -1,
      taxRate: '',
      helperText: null,
      store_ncp_id: '',
      advance_fills: true,
      KioskHoursOfOperaionsArray: [
        { id: 0, value: 'Sunday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 1, value: 'Monday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 2, value: 'Tuesday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 3, value: 'Wednesday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 4, value: 'Thursday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 5, value: 'Friday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 6, value: 'Saturday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
      ],
      KioksDummyHoursOfOperaionsArray: [
        { id: 0, value: 'Sunday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 1, value: 'Monday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 2, value: 'Tuesday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 3, value: 'Wednesday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 4, value: 'Thursday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 5, value: 'Friday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
        { id: 6, value: 'Saturday', openTime: '', closeTime: '', isClosed: false, isOpenAll: true },
      ],
      hl_x_api_key: "",
      showHLXApiKey: false,
      drx_key: "",
      showDRXKey: false,
      lunchStart:'',
      lunchEnd:'',
      tempUnit:'F',
      screensaverRotationTime: '15',
      external_id: "",
      securebadgeexpiryduration: '',
      vial_label_scan: false,
      prevent_assigning_non_ready: false,
      regexp: "",
      fill_number_api_fallback: false,
      bannerImg:"",
      isBannerSizeError:false,
      headerImg:"",
      isHeaderSizeError:false,
      optical_expiration_days: '',
      text2pay_token_expiration_days: 1,
      optical_secure_badge_expiration:'',
      isClone: false,
      purge_patient_data_toggle: false,
      purge_patient_data_days_count: 7,
      purgeDataDialog: false,
      purgeDataFinalDialog: false,
      calculate_tax: false,
      basic_first_name: '',
      basic_last_name:'',
      is_dob_optional: false,
      drx_host: "",
      cascade_account_update: false,
      signature_flags_test_mode: false,
      signature_flags_test_config: [],
      is_need_help_enabled: true,
      is_auto_logout_enabled: false,
      prx_xapi_key: "",
      prx_client_identifier: "",
      prx_client_id: "",
      prx_client_secret: "",
      prx_endoint: "",
      prx_memberid: "",
      show_prx_client_identifier: false,
      show_prx_xapi_key: false,
      show_prx_client_id: false,
      show_prx_client_secret: false,
      showAccountResources: false,
      selectedAccountIdForResources: null,
      selectedAccountNameForResources: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeBrand = this.handleChangeBrand.bind(this);
    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.handleChangeWeb = this.handleChangeWeb.bind(this);
    this.handleChangeFax = this.handleChangeFax.bind(this);
    this.handleChangePrimaryColor = this.handleChangePrimaryColor.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangeDocOne = this.handleChangeDocOne.bind(this);
    this.handleChangeDocTwo = this.handleChangeDocTwo.bind(this);
    this.handleChangeDocThree = this.handleChangeDocThree.bind(this);
    this.handleChangeHelpLink = this.handleChangeHelpLink.bind(this);
    this.handleChangePrivacyPolicyLink = this.handleChangePrivacyPolicyLink.bind(
      this
    );
    this.handleChangeTermsAndConditionsLink = this.handleChangeTermsAndConditionsLink.bind(
      this
    );
    this.handleChangeMckessoneRx = this.handleChangeMckessoneRx.bind(this);
    this.handleChangeBinaryToken = this.handleChangeBinaryToken.bind(this);
    this.handleChangeIssuer = this.handleChangeIssuer.bind(this);
    this.TaxCodes = ["Custom", "Federal", "State", "VAT"]
  }

  handleAccordianChange = (panel) => (event, newExpanded) => {
    this.setState({ accordianExpanded: newExpanded ? panel : false });
  };

  componentDidMount() {
    FilterObj.searchtext = '';
    FilterObj.searchObject = null;
    FilterObj.pageNo = 0;
    FilterObj.pageSize = 10;
    const TimeZoneNames = moment.tz.names();
    const timeZones = TimeZoneNames.map((items) => {
      const tz = moment().tz(items);
      const findOffset = tz.utcOffset();
      let string = '';
      if (String(findOffset).startsWith('-')) {
        string = `- ${String(findOffset).slice(1)}`;
      } else string = `+ ${String(findOffset)}`;
      return { zone: `(UTC ${string}) ${items}` };
    });
    this.setState({ timeZoneNames: timeZones });

    this.getPaymentGateways();
    this.setPermissions();
    fetch(process.env.REACT_APP_BASEURL + 'roles', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((roles) => {
        const roleValues = roles.map((role) => {
          return { value: role.id, label: role.name };
        });
        this.setState({ roleValues, role_id: roleValues[0].value });
      });
    fetch(process.env.REACT_APP_BASEURL + 'categories', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((categories) => {
        if (categories) {
          const categoriesdata = categories.map((category) => {
            return { id: category.id, label: category.name };
          });
          this.setState({ categories: categoriesdata });
        }
      });
    fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const accountValues = accounts.map((account) => {
          return { value: account.id, label: account.name };
        });
        this.setState({ accountValues, parent_id: accountValues[0].value });
      });

    fetch(process.env.REACT_APP_BASEURL + `api/v1/subscriptions/vendorManagement/getAllVendors?searchtext=&pageNo=0&pageSize=30&sortColumn=created_on&sortOrder=desc&tableName=`, {
      method: 'get',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((vendors) => {
        const allVendorsDetails =
          vendors && Array.isArray(vendors.allVendorsDetails)
            ? vendors.allVendorsDetails
            : [];
        const vendorValues = allVendorsDetails.map((vendor) => ({
          value: vendor.vendor_unique_id,
          label: vendor.name,
        }));
        this.setState({
          vendorValues,
          vendor_unique_id:
            vendorValues.length > 0 ? vendorValues[0].value : '',
        });
      })
      .catch(() => {
        this.setState({ vendorValues: [], vendor_unique_id: '' });
      });

    this.BindAccountConnections();
    this.BindThirdPartyPHIs();
    /*
        Removed By : Jaimin Belani
        Date : 06/17/2019
        Task : DI-667 Account/Expiration setting reverts back to 1 day after updating multiple times
      */
    // let days = [];
    // for(let i = 1 ; i < 16 ; i++)
    // {
    //      let day = {value: i , label: i.toString() + ' Day'};
    //      days.push(day);
    // }
    // this.setState({days , day_id: days[0].value});
  }
  //Bind Connection drop down
  BindAccountConnections = () => {
    fetch(process.env.REACT_APP_BASEURL + 'getAccountconnections', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((AccountConnections) => {
        this.setState({ AccountConnections });
        let connectdefault = [];
        for (let i = 0; i < AccountConnections.length; i++) {
          if (AccountConnections[i].name === CONNECTION_TYPE.UNPLUGGED) {
            connectdefault.push({
              id: AccountConnections[i].id,
              name: AccountConnections[i].name,
            });
            this.setState({ accountConnectionsId: AccountConnections[i].id });
          }
        }
        this.setState({ connectdefault: connectdefault });
      });
  };

  AssignEndPoint = (accountConnectionID, account) => {
    let endPoint = '';
    if (accountConnectionID === CONNECTION_TYPE.QS1) {
      endPoint = this.TypeBasePHI(accountConnectionID);
    } else if (accountConnectionID === CONNECTION_TYPE.THIRD_PARTY) {
      if (
        account !== null &&
        account !== undefined &&
        account.connection_details &&
        account.connection_details.endpoint
      ) {
        endPoint = account.connection_details.endpoint;
      } else {
        endPoint =
          (this.state && this.state.endpoint) || '';
      }
    } else if (accountConnectionID === CONNECTION_TYPE.PIONEERRX) {
      if (account !== null && account !== undefined) {
        endPoint = account.connection_details.endpoint;
      } else {
        endPoint = this.state && this.state.endpoint;
      }
    } else if (
      accountConnectionID === CONNECTION_TYPE.EPIC ||
      accountConnectionID === CONNECTION_TYPE.EPIC_WITH_MTLS
    ) {
      if (account !== null && account !== undefined) {
        endPoint = account.connection_details.endpoint;
      } else {
        endPoint = this.state && this.state.endpoint;
      }
    } else if (accountConnectionID === CONNECTION_TYPE.MCKESSONERX) {
      if (account !== null && account !== undefined) {
        endPoint = account.connection_details.endpoint;
      } else {
        endPoint = this.state && this.state.endpoint;
      }
    } else if (accountConnectionID === CONNECTION_TYPE.SOLIS) {
      if (
        account !== null &&
        account !== undefined &&
        account.connection_details &&
        account.connection_details.endpoint
      ) {
        endPoint = account.connection_details.endpoint;
      } else {
        endPoint = (this.state && this.state.endpoint) || '';
      }
    } else if (accountConnectionID === CONNECTION_TYPE.LIBERTY_SOFTWARE) {
      const savedEndpoint =
        account &&
        account.connection_details &&
        account.connection_details.endpoint;
      const configuredEndpoint = account
        ? savedEndpoint
        : this.state && this.state.endpoint;
      endPoint = String(configuredEndpoint || '').trim() || DEFAULT_LIBERTY_BASE_URL;
    }
    return endPoint;
  };

  AssignEpicclientID = (accountConnectionID, account) => {
    let epicclientid = '';
    if (
      accountConnectionID === CONNECTION_TYPE.EPIC ||
      accountConnectionID === CONNECTION_TYPE.EPIC_WITH_MTLS
    ) {
      if (account !== null && account !== undefined) {
        epicclientid = account.connection_details.epic_client_id;
      } else {
        epicclientid = this.state && this.state.epicclientid;
      }
    }
    return epicclientid;
  };
  AssignEpicUserName = (accountConnectionID, account) => {
    let epicusername = '';
    if (
      accountConnectionID === CONNECTION_TYPE.EPIC ||
      accountConnectionID === CONNECTION_TYPE.EPIC_WITH_MTLS
    ) {
      if (account !== null && account !== undefined) {
        epicusername = account.connection_details.epic_username;
      } else {
        epicusername = this.state && this.state.epicusername;
      }
    }
    return epicusername;
  };
  AssignEpicUserPassword = (accountConnectionID, account) => {
    let epicuserpassword = '';
    if (
      accountConnectionID === CONNECTION_TYPE.EPIC ||
      accountConnectionID === CONNECTION_TYPE.EPIC_WITH_MTLS
    ) {
      if (account !== null && account !== undefined) {
        epicuserpassword = account.connection_details.epic_password;
      } else {
        epicuserpassword = this.state && this.state.epicpassword;
      }
    }
    return epicuserpassword;
  };

  AssignMckssoRERx = (accountConnectionID, account) => {
    let store_number = '';
    if (accountConnectionID === CONNECTION_TYPE.MCKESSONERX) {
      if (account !== null && account !== undefined) {
        store_number = account.connection_details.store_number;
      } else {
        store_number = this.state && this.state.store_number;
      }
    }
    return store_number;
  };

  AssignMcKssonRXBinaryToken = (accountConnectionID, account) => {
    let binaryToken = '';
    if (accountConnectionID === CONNECTION_TYPE.MCKESSONERX) {
      if (account !== null && account !== undefined) {
        binaryToken = account.connection_details.binary_security_token;
      } else {
        binaryToken = this.state && this.state.binaryToken;
      }
    }
    return binaryToken;
  };

  TypeBasePHI = (accountConnectionID) => {
    let dataObj;
    const thirdPhartyPHIEndPoint =
      this.state && this.state.AccountConnectionList;

    if (!Array.isArray(thirdPhartyPHIEndPoint)) {
      return '';
    }

    thirdPhartyPHIEndPoint.filter((element) => {
      if (element && element.account_connection_id === accountConnectionID) {
        dataObj = element;
      }
      return true;
    });

    return (dataObj && dataObj.endpoint) || '';
  };

  BindThirdPartyPHIs = () => {
    fetch(process.env.REACT_APP_BASEURL + 'thirdPartyPHIs', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((thirdPartyPhiResponseObj) => {
        this.setState({ AccountConnectionList: thirdPartyPhiResponseObj });
      }).catch(() => {
        this.BindThirdPartyPHIs();
      });
  };

  handleConnectChange = (e) => {
    if (e.target.value !== undefined) {
      const nextConnectionId = e.target.value.id;
      const nextConnectionState = {
        connect: e.target.value,
        accountConnectionsId: nextConnectionId,
        accountConnectionsName: e.target.value.name,
        regexp: nextConnectionId === CONNECTION_TYPE.EPIC
          ? resolveEpicScanRegexp(this.state.regexp)
          : this.state.regexp,
      };
      if (nextConnectionId === CONNECTION_TYPE.LIBERTY_SOFTWARE) {
        if (!String(this.state.endpoint || '').trim()) {
          nextConnectionState.endpoint = DEFAULT_LIBERTY_BASE_URL;
        }
        if (!String(this.state.vendor_key || '').trim()) {
          nextConnectionState.vendor_key = DEFAULT_LIBERTY_VENDOR_USERNAME;
        }
        if (!String(this.state.data_exchange_id || '').trim()) {
          nextConnectionState.data_exchange_id = DEFAULT_LIBERTY_VENDOR_PASSWORD;
        }
      }
      this.setState(nextConnectionState);
      // if(e.target.value.name !== "iLocalBox Pharmacy")
      // {
      //   this.setState({demo_email: '', demo_smsphone:''});
      //   console.log("before",this.state.demo_email);
      // }
      // else{
      //   console.log("after",this.state.demo_email);
      // }
      this.writeAuditLog(`Account connection type was changed by user.`);
    }
  };
  handleSwitchChange = (name) => (event) => {
    if (event.target.checked !== undefined) {
      this.setState({ isPaymentRequired: event.target.checked });
    }
  };
  handleSwitchChangeConsult = (event) => {
    this.setState({ isConsultRequired: event.target.checked }, () => {
      if (
        this.state.isConsultRequired === false ||
        this.state.isConsultRequired === 'false'
      ) {
        this.setState({ epicConsultKey: '' });
      }
    });
  };
  handleSwitchChangeConsultRequire = (event) => {
    this.setState({ isConsultRequire: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Bypass Consult was ${status} by user.`);
  };
  handleConsultValue = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicConsultKey: event.target.value });
  };

  handleSwitchStartGraphichange = (event) => {
    this.setState({ isStartGraphic: event.target.checked });
  };
  handleSwitchChangePatientPrimarySource = (event) => {
    this.setState({ IsPatientPrimarySource: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Patient Primary Source was ${status} by user.`);
  };
  isvalidEmail(email) {
    const trulyValue = email === this.state.email;
    if (!trulyValue) {
      return false;
    }
    return trulyValue;
  }

  checkEmail = (event) => {
    const searchedString = event.target.value;
    this.setState({ email: searchedString });
    if (searchedString.length > 0) {
      let isvalid = this.isvalidEmail(searchedString);
      if (isvalid > 0) {
        fetch(
          process.env.REACT_APP_BASEURL +
          'checkemailexistornot/' +
          searchedString,
          {
            method: 'GET',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession
                  .idToken.jwtToken,
            },
          }
        )
          .then((response) => response.json())
          .then((emailcheck) => {
            if (emailcheck && emailcheck.email_Is_Exist) {
              toast.error(this.props.t('Toast.Error.Email'));
              this.setState({ email: '' });
            } else {
              this.setState({ emailcheck });
            }
          });
      }
    }
  };
  // state = {
  //   order: "asc",
  //   orderBy: "created_on",
  //   selected: [],
  //   page: 0,
  //   rowsPerPage: 10
  // };
  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === 'function') {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === 'function') {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      filterBody: FilterObj,
      mapFilterModel: buildManageAccountsSearchObject,
      sortMap: AccountSortObj,
      pageZeroBased: true,
      getPageSize: () => FilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + 'getaccounts', {
          method: 'post',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...body, searchtext: body.searchtext || '' }),
        }).then((response) => response.json()),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
          selected: [],
        });
      },
      onError: () => this.setState({ loader: false, selected: [] }),
    });
    if (typeof params.api.setServerSideDatasource === 'function') {
      params.api.setServerSideDatasource(datasource);
    }
  };

  clearFilters = () => {
    if (!this.gridApi) return;
    const filterModel = this.gridApi.getFilterModel();
    if (filterModel && Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
    }
    FilterObj.searchObject = null;
    FilterObj.searchtext = '';
    this.setState({ searchtext: '' });
    this.refreshGrid();
  };

  onRowSelected = (params) => {
    if (!params || !params.api) return;
    const selectedNodes = params.api.getSelectedNodes() || [];
    this.setState({
      selected: selectedNodes.map((n) => n.data && n.data.id).filter(Boolean),
    });
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && FilterObj.pageSize !== newPageSize) {
      FilterObj.pageSize = newPageSize;
    }
  };

  BindBoxes() {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getaccounts', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(FilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        // let secretKey = process.env.REACT_APP_CIPHER;
        // const crypter = new Crypter(secretKey);
        this.setState({ totalRecords: data && data.total });
        if (data && data.results && data.results.length > 0) {
          // for(let i = 0; i<data.length; i++) {
          //   if(data[i] && data[i].gbpconfig) {
          //     data[i].gbpconfig.tokenapikey = crypter.decrypt(data[i].gbpconfig.tokenapikey);
          //     data[i].gbpconfig.transapikey = crypter.decrypt(data[i].gbpconfig.transapikey);
          //     data[i].gbpconfig.transapisecret = crypter.decrypt(data[i].gbpconfig.transapisecret);
          //   }
          // }
          this.setState({
            data: data.results,
            loader: false,
            isDataEmpty: false,
          });
        } else {
          this.setState({ data: null, loader: false, isDataEmpty: true });
        }
      });
  }

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['name', 'type'].includes(field)) {
      tablename = 'accounts';
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ order, orderBy, sortId: property });
    FilterObj.sortOrder = order;
    FilterObj.sortColumn = field;
    FilterObj.tableName = this.gettingOnSortTableName(orderBy);
    
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.data.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };
  handleClick = (event, id) => {
    // this.contactPersonsMethod();
    const {selected} = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleTabChange = (event, value) => {
    this.setState({ selectedTab: value });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  }

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    
    FilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  handleChangeRowsPerPage = (event) => {
    
    FilterObj.pageNo = 0;
    FilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  addUser = (event) => {
    this.setState({ accContactPersons: [] }, () => {
      this.contactPersonsMethod();
    });
    this.setState({
      operation: 'Add',
      showNewUserDialog: true,
      genericLink: '',
      enrollmentInviteId: '',
      enrollmentLocationId: '',
      user: {},
      account: {},
      name: null,
      // parent_id: null,
      type_id: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      zip: null,
      phone: null,
      email: null,
      first_name: null,
      last_name: null,
      brandname: null,
      generalphone: null,
      afterHourPhone: null,
      primaryColor: '',
      is_modern_email_enabled: false,
      is_pickup_change_email_enabled: false,
      web: null,
      fax: null,
      generalemail: null,
      contractLang: '',
      avatarPreview: null,
      Adv1Preview: null,
      Adv2Preview: null,
      Adv3Preview: null,
      brndLogoPreview: null,
      videoPreview: null,
      demo_email: '',
      demo_smsphone: '',
      accountConnectionsId: CONNECTION_TYPE.UNPLUGGED,
      accountConnectionsName: 'Unplugged',
      connect: [],
      is_payment_required: false,
      value: 0,
      endpoint: '',
      pharmacyId: '',
      pick_up_reminder_id: '1',
      Sun: false,
      Mon: false,
      Tue: false,
      Wed: false,
      Thu: false,
      Fri: false,
      Sat: false,
      TimevalidateDialog: false,
      closedMsg: '',
      closedimgPreview: null,
      healthandinfo: [],
      primarylibrarytitle1: '',
      primarylibrarytitle2: '',
      HippaPreview: null,
      LCPreview: null,
      OtherPreview: null,
      fileType: '',
      filename: '',
      LCfilename: '',
      Otherfilename: '',
      docone: '',
      doctwo: '',
      docthree: '',
      helpLink: '',
      privacyPolicyLink: '',
      termsAndConditionsLink: '',
      epicclientid: '',
      epicusername: '',
      epicpassword: '',
      BottomAdv1Preview: null,
      BottomAdv2Preview: null,
      BottomAdv3Preview: null,
      AdvancedAdvertise: false,
      opentime: null,
      closetime: null,
      bottomAdvSlider1ErrorFlag: false,
      bottomAdvSlider2ErrorFlag: false,
      bottomAdvSlider3ErrorFlag: false,
      videoAdvErrorFlag: false,
      maxImageFileSize: 1048576,
      maxVideoFileSize: 3145728,
      videoMaxSizeErrorFlag: false,
      xWebId: '',
      auth_Key: '',
      terminalId: '',
      fiserv_link_username: '',
      fiserv_link_password: '',
      fiserv_terminal_api_key: '',
      trustcommerce_link_custid: '',
      trustcommerce_link_password: '',
      trustcommerce_terminal_custid: '',
      trustcommerce_terminal_password: '',
      trustcommerce_aggregator1: '',
      trustcommerce_aggregators: '',
      instamed_account_id: '',
      instamed_account_id_suffix: '',
      instamed_connect_user_id: '',
      instamed_connect_password: '',
      instamed_api_key: '',
      instamed_api_secret: '',
      instamed_sso_security_key: '',
      allow_payment: false,
      epicPharmacyNcpdpId: '',
      epicEndpointVersion: '',
      epicRequestTempate: '',
      allow_consult_video: false,
      allow_consult_mobile: false,
      allow_consult_schedule: false,
      isContactLessPickupEnabled: false,
      accContactPersons: [],
      medbank_dblogin: '',
      medbank_db_password: '',
      opc_apim_subscription_key: '',
      show_medbank_dblogin: false,
      show_medbank_db_password: false,
      show_medbank_subscription_key: false,
      showXApiKey: false,
      x_api_key: '',
      showGatewayApiKey: false,
      gateway_api_key: '',
      show_client_identifier: false,
      client_identifier: '',
      show_third_party_token: false,
      third_party_token: '',
      vendor_unique_id: '',
      isSunday: false,
      isMonday: false,
      isTuesday: false,
      isWednesday: false,
      isThursday: false,
      isFriday: false,
      isSaturday: false,
      accountOpenTime: null,
      accoountCloseTime: null,
      AccountHoursOfOperaionsArray: [
        {
          id: 0,
          value: this.props.t('Accounts.Branding.Sunday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 1,
          value: this.props.t('Accounts.Branding.Monday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 2,
          value: this.props.t('Accounts.Branding.Tuesday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 3,
          value: this.props.t('Accounts.Branding.Wednesday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 4,
          value: this.props.t('Accounts.Branding.Thursday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 5,
          value: this.props.t('Accounts.Branding.Friday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 6,
          value: this.props.t('Accounts.Branding.Saturday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
      ],
      //ETPreview:null
      is_dispense_safety_chek: false,
      is_forgot_mypucode: false,
      is_mask_kiosk_dob: true,
      time_zone: zone,
      store_number: '',
      mcKessoneRXrequestTemplate: '',
      binaryToken: '',
      issuer: '',
      accordianExpanded: 'panel0',
      CFRHeaderTemplate: '',
      CFRVersion: '',
      CFRMessageName: '',
      RxInfoBodyTemplate: '',
      RxInfoHeaderTemplate: '',
      RxInfoVersion: '',
      RxInfoMessageName: '',
      POSFinalizationBodyTemplate: '',
      POSFinalizationHeaderTemplate: '',
      POSFinalizationVersion: '',
      POSFinalizationMessageName: '',
      authToken: '',
      authSecret: '',
      paymentType: 'Global payments',
      merchant_id: '',
      hpp_identifier: '',
      preferLanguage: 'en',
      selectedTab: 0,
      is_otp_login: false,
      is_enroll_now: false,
      enrollment_v2_enabled: true,
      hide_new_ui: true,
      is_mfa_required: false,
      allow_member_or_record_number: false,
      allow_offline_payment_skip: true,
      is_numeric_code: false,
      is_future_release: false,
      is_pre_assignment: false,
      is_consultation_notification: false,
      is_taxable: false,
      is_permission_inheritable: true,
      selectedTaxCode: -1,
      taxRate: '',
      helperText: null,
      KioskHoursOfOperaionsArray: [
        {
          id: 0,
          value: this.props.t('Accounts.Branding.Sunday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 1,
          value: this.props.t('Accounts.Branding.Monday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 2,
          value: this.props.t('Accounts.Branding.Tuesday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 3,
          value: this.props.t('Accounts.Branding.Wednesday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 4,
          value: this.props.t('Accounts.Branding.Thursday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 5,
          value: this.props.t('Accounts.Branding.Friday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
        {
          id: 6,
          value: this.props.t('Accounts.Branding.Saturday'),
          openTime: '',
          closeTime: '',
          isClosed: false,
          isOpenAll:true
        },
      ],
      hl_x_api_key: "",
      showHLXApiKey: false,
      drx_key: "",
      showDRXKey: false,
      lunchStart:'',
      lunchEnd:'',
      regexp: "",
      fill_number_api_fallback: false,
      bannerImg:"",
      isBannerSizeError: false,
      headerImg: "",
      isHeaderSizeError: false,
      calculate_tax: false,
      basic_first_name:'',
      basic_last_name:'',
      is_dob_optional: false,
      tempUnit:'F',
      screensaverRotationTime: '15',
      external_id: "",
      securebadgeexpiryduration: '',
      vial_label_scan: false,
      prevent_assigning_non_ready: false,
      optical_expiration_days: '',
      text2pay_token_expiration_days: 1,
      optical_secure_badge_expiration:'',
      isClone: false,
      purge_patient_data_toggle: false,
      purge_patient_data_days_count: 7,
      purgeDataDialog: false,
      purgeDataFinalDialog: false,
      drx_host: "",
      cascade_account_update: false,
      is_need_help_enabled: true,
      is_auto_logout_enabled: false,
      prx_xapi_key: "",
      prx_client_identifier: "",
      prx_client_id: "",
      prx_client_secret: "",
      prx_endoint: "",
      prx_memberid: "",
      show_prx_client_identifier: false,
      show_prx_xapi_key: false,
      show_prx_client_id: false,
      show_prx_client_secret: false,
    });
  };

  deleteUsers = (event) => {
    this.setState({ loader: true });
    return fetch(
      process.env.REACT_APP_BASEURL +
        'accounts/' +
        this.state.selected.join(',').trim(','),
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then(async (response) => {
        this.setState({ loader: false });
        const deletedAccountNames = (this.state.forDeletion || this.state.data.filter(
          (item) => this.state.selected.indexOf(item.id) > -1
        ))
          .map((a) => a.name)
          .filter(Boolean);
        const deletedNamesLabel = deletedAccountNames.length
          ? deletedAccountNames.join(', ')
          : 'selected account(s)';

        if (!response.ok) {
          let message = 'Failed to delete account(s).';
          try {
            const body = await response.json();
            if (body && body.message) message = body.message;
          } catch (_) {}
          this.writeAuditLog(
            `User attempted to delete account(s) '${deletedNamesLabel}' but deletion was blocked or failed: ${message}.`
          );
          return { success: false, message };
        }
        const newData = [];
        this.state.data.forEach((item) => {
          if (this.state.selected.indexOf(item.id) === -1) {
            newData.push(item);
          }
        });
        this.setState({
          data: JSON.parse(JSON.stringify(newData)),
          selected: [],
        });
        this.writeAuditLog(`Account(s) '${deletedNamesLabel}' have been deleted by user.`);
        return { success: true };
      })
      .catch(() => {
        this.setState({ loader: false });
        const deletedAccountNames = (this.state.forDeletion || this.state.data.filter(
          (item) => this.state.selected.indexOf(item.id) > -1
        ))
          .map((a) => a.name)
          .filter(Boolean);
        const deletedNamesLabel = deletedAccountNames.length
          ? deletedAccountNames.join(', ')
          : 'selected account(s)';
        this.writeAuditLog(
          `User attempted to delete account(s) '${deletedNamesLabel}' but deletion failed (network or server error).`
        );
        return {
          success: false,
          message: this.props.t('Toast.Error.Generic') || 'Failed to delete account(s).',
        };
      });
  };

  handleClose = (event) => {
    this.setState({
      showNewUserDialog: false,
      account: {},
      errorMessage: '',
      selectedTab: 0,
      loginType: 'DEFAULT',
      selectedTaxCode: -1,
      taxRate: '',
      helperText: null,
      genericLink: '',
      enrollmentInviteId: '',
      enrollmentLocationId: ''
    });
  };
  handleCloseTimeDialog = (event) => {
    this.setState({ TimevalidateDialog: false });
  };
  handleDrop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      avatarPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handleAdv1Drop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      Adv1Preview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handleAdv2Drop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      Adv2Preview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handleAdv3Drop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      Adv3Preview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handlebrndLogoDrop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      brndLogoPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handlevideoDrop = (acceptedFiles, rejectedFiles) => {
    let _bottomAdv1Element = document.getElementById('videoAdvPreview');
    if (this.state && this.state.videoMaxSizeErrorFlag === false) {
      _bottomAdv1Element.style.border = 'none';
    }
    const _uploadedFileSize = acceptedFiles[0].size;
    const _allowMaxFileSize = this.state && this.state.maxVideoFileSize;
    if (_uploadedFileSize > _allowMaxFileSize) {
      this.setState({ videoMaxSizeErrorFlag: true });
      _bottomAdv1Element = document.getElementById('videoAdvPreview');
      _bottomAdv1Element.style.border = '1px solid red';
      this.setState({ videoAdvErrorFlag: false });
      return;
    } else {
      _bottomAdv1Element = document.getElementById('videoAdvPreview');
      _bottomAdv1Element.style.border = 'none';
      this.setState({ videoAdvErrorFlag: false });
      this.setState({ videoMaxSizeErrorFlag: false });
    }
    this.setState({ videoAdvErrorFlag: false });
    this.setState({
      videoPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handleclosedimgDrop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      closedimgPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handleHippaDrop = (acceptedFiles, rejectedFiles) => {
    const title = this.state.docone || '';
    if (!title || !title.trim()) {
      toast.error(this.props.t('Accounts.Terms.TitleRequiredBeforeUpload'));
      return;
    }
    console.dir(acceptedFiles);
    this.setState({
      HippaPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
      fileType: acceptedFiles[0].type,
      filename: acceptedFiles[0].name,
    });
  };
  handleLCDrop = (acceptedFiles, rejectedFiles) => {
    const title = this.state.doctwo || '';
    if (!title || !title.trim()) {
      toast.error(this.props.t('Accounts.Terms.TitleRequiredBeforeUpload'));
      return;
    }
    console.dir(acceptedFiles);
    this.setState({
      LCPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
      fileType: acceptedFiles[0].type,
      LCfilename: acceptedFiles[0].name,
    });
  };
  handleOtherDrop = (acceptedFiles, rejectedFiles) => {
    const title = this.state.docthree || '';
    if (!title || !title.trim()) {
      toast.error(this.props.t('Accounts.Terms.TitleRequiredBeforeUpload'));
      return;
    }
    console.dir(acceptedFiles);
    this.setState({
      OtherPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
      fileType: acceptedFiles[0].type,
      Otherfilename: acceptedFiles[0].name,
    });
  };
  handleBottomAdv1Drop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    let _bottomAdv1Element = document.getElementById('BottomAdv1dropzone');
    _bottomAdv1Element.style.border = 'none';
    this.setState({ bottomAdvSlider1ErrorFlag: false });
    this.setState({
      BottomAdv1Preview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handleBottomAdv2Drop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    let _bottomAdv2Element = document.getElementById('BottomAdv2dropzone');
    _bottomAdv2Element.style.border = 'none';
    this.setState({ bottomAdvSlider2ErrorFlag: false });
    this.setState({
      BottomAdv2Preview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handleBottomAdv3Drop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    let _bottomAdv3Element = document.getElementById('BottomAdv3dropzone');
    _bottomAdv3Element.style.border = 'none';
    this.setState({ bottomAdvSlider3ErrorFlag: false });
    this.setState({
      BottomAdv3Preview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  // handleETDrop = (acceptedFiles,rejectedFiles) => {
  //   console.dir(acceptedFiles);
  //   this.setState({
  //       ETPreview : acceptedFiles[0].preview,
  //       file: acceptedFiles,
  //       fileType: acceptedFiles[0].type,
  //       ETfilename: acceptedFiles[0].name
  //   })
  // };
  removeImg = () => {
    const parent = document.getElementById('avatardropzone');
    let imgSrc = ((parent.children && parent.children[0]).src = '');
    imgFile = new File([imgSrc], 'removeavtar');
    this.setState({
      avatarPreview: null,
    });
  };
  removeAdv1 = () => {
    const parent = document.getElementById('Adv1dropzone');
    let AD1Src = ((parent.children && parent.children[0]).src = '');
    AD1 = new File([AD1Src], 'removeAD1');
    this.setState({
      Adv1Preview: null,
    });
  };
  removeAdv2 = () => {
    const parent = document.getElementById('Adv2dropzone');
    let AD2Src = ((parent.children && parent.children[0]).src = '');
    AD2 = new File([AD2Src], 'removeAD2');
    this.setState({
      Adv2Preview: null,
    });
  };
  removeAdv3 = () => {
    const parent = document.getElementById('Adv3dropzone');
    let AD3Src = ((parent.children && parent.children[0]).src = '');
    AD3 = new File([AD3Src], 'removeAD3');
    this.setState({
      Adv3Preview: null,
    });
  };
  removebrndLogo = () => {
    const parent = document.getElementById('brndLogodropzone');
    let brndSrc = ((parent.children && parent.children[0]).src = '');
    BDLOGO = new File([brndSrc], 'removeBDLOGO');
    this.setState({
      brndLogoPreview: null,
    });
  };
  removeVd = () => {
    const parent = document.getElementById('videodropzone');
    let vdSrc = ((parent.children && parent.children[0]).src = '');
    VD = new File([vdSrc], 'removeVD');
    this.setState({
      videoPreview: null,
    });
  };
  removeclosedimg = () => {
    const parent = document.getElementById('closedimgdropzone');
    let ClosedimgSrc = ((parent.children && parent.children[0]).src = '');
    CLOSEDIMG = new File([ClosedimgSrc], 'removeclosedimg');
    this.setState({
      closedimgPreview: null,
    });
  };
  removeHippa = () => {
    const parent = document.getElementById('Hippadropzone');
    let HippaSrc = ((parent.children && parent.children[0]).src = '');
    HIPPA = new File([HippaSrc], 'removeHippa');
    this.setState({
      HippaPreview: null,
      filename: '',
    });
  };
  removeLC = () => {
    const parent = document.getElementById('LegalConsentdropzone');
    let LCSrc = ((parent.children && parent.children[0]).src = '');
    LC = new File([LCSrc], 'removeLC');
    this.setState({
      LCPreview: null,
      LCfilename: '',
    });
  };
  removeOther = () => {
    const parent = document.getElementById('Otherdropzone');
    let OtherSrc = ((parent.children && parent.children[0]).src = '');
    OTHER = new File([OtherSrc], 'removeOther');
    this.setState({
      OtherPreview: null,
      Otherfilename: '',
    });
  };
  removeBottomAdv1 = () => {
    const parent = document.getElementById('BottomAdv1dropzone');
    let BottomAD1Src = ((parent.children && parent.children[0]).src = '');
    BOTTOMAD1 = new File([BottomAD1Src], 'removeBottomAdv1');
    this.setState({
      BottomAdv1Preview: null,
    });
  };
  removeBottomAdv2 = () => {
    const parent = document.getElementById('BottomAdv2dropzone');
    let BottomAD2Src = ((parent.children && parent.children[0]).src = '');
    BOTTOMAD2 = new File([BottomAD2Src], 'removeBottomAdv2');
    this.setState({
      BottomAdv2Preview: null,
    });
  };
  removeBottomAdv3 = () => {
    const parent = document.getElementById('BottomAdv3dropzone');
    let BottomAD3Src = ((parent.children && parent.children[0]).src = '');
    BOTTOMAD3 = new File([BottomAD3Src], 'removeBottomAdv3');
    this.setState({
      BottomAdv3Preview: null,
    });
  };
  // removeET = () => {
  //       const parent = document.getElementById("ETdropzone");
  //       let ETSrc = (parent.children && parent.children[0]).src = '';
  //       ET = new File([ETSrc],"removeET");
  //       this.setState({
  //         ETPreview:null,
  //         ETfilename:''
  //       })
  // };
  handleChange = (event) => {
    event.preventDefault && event.preventDefault();

    //const user = {};
    const {user} = this.state;
    user.first_name = this.state.first_name;
    user.last_name = this.state.last_name;
    user.email = this.state.email;
    //user.roles=this.state.roles;
    user[event.target.id || event.target.name] = event.target.value;
    this.setState({
      dummyxWebId: user.xWebId,
      dummyauthKey: user.auth_Key,
      dummyterminalId: user.terminalId,
      dummyAuthToken: user.authToken,
      dummyAuthSecret: user.authSecret,
    });
    this.setState(user);
  };

  isTrustCommercePaymentType = (paymentType) => {
    const normalizedPaymentType = String(paymentType || '').replace(/\s+/g, '').toLowerCase();
    return normalizedPaymentType === 'trustcommerce';
  };

  isFiservPaymentType = (paymentType) => {
    const normalizedPaymentType = String(paymentType || '').replace(/\s+/g, '').toLowerCase();
    return normalizedPaymentType.includes('fiserv') || normalizedPaymentType.includes('cardpointe');
  };

  isInstaMedPaymentType = (paymentType) => {
    const normalizedPaymentType = String(paymentType || '').replace(/\s+/g, '').toLowerCase();
    return normalizedPaymentType.includes('instamed') || normalizedPaymentType.includes('jpmc');
  };

  getMaskedTrustCommerceValue = (value) => (value ? '**********' : '');

  getMaskedSecretValue = (value) => (value ? '**********' : '');

  renderFiservPaymentFields = (classes, readOnly) => {
    const fields = [
      {
        id: 'fiserv_link_username',
        label: 'Link Username',
      },
      {
        id: 'fiserv_link_password',
        label: 'Link Password',
        type: 'password',
      },
      {
        id: 'fiserv_terminal_api_key',
        label: 'Terminal API Key',
        type: 'password',
      },
    ];

    return (
      <div>
        {fields.map((field) => (
          <FormControl
            key={field.id}
            className={classes.formControl}
            style={{
              width: '100%',
              marginBottom: '16px',
            }}
          >
            <InputLabel
              htmlFor={field.id}
              style={{ marginLeft: '-1rem' }}
            >
              {field.label}
            </InputLabel>
            <Input
              className={classes.halfTextFieldNew}
              margin='normal'
              value={this.state[field.id] || ''}
              id={field.id}
              name={field.id}
              onChange={this.handleChange}
              inputProps={{ readOnly: Boolean(readOnly) }}
              type={field.type || 'text'}
              fullWidth
            />
          </FormControl>
        ))}
      </div>
    );
  };

  renderTrustCommercePaymentFields = (classes, readOnly, t) => {
    const fields = [
      {
        id: 'trustcommerce_link_custid',
        label: t('Accounts.Settings.TrustCommerceEcomCustomerID'),
      },
      {
        id: 'trustcommerce_link_password',
        label: t('Accounts.Settings.TrustCommerceEcomPassword'),
        type: 'password',
      },
      {
        id: 'trustcommerce_terminal_custid',
        label: t('Accounts.Settings.TrustCommerceTerminalCustomerID'),
      },
      {
        id: 'trustcommerce_terminal_password',
        label: t('Accounts.Settings.TrustCommerceTerminalPassword'),
        type: 'password',
      },
      {
        id: 'trustcommerce_aggregator1',
        label: t('Accounts.Settings.TrustCommerceAggregator1'),
        type: 'password',
      },
      {
        id: 'trustcommerce_aggregators',
        label: t('Accounts.Settings.TrustCommerceAggregators'),
      },
    ];

    return (
      <div>
        {fields.map((field) => (
          <FormControl
            key={field.id}
            className={classes.formControl}
            style={{
              width: '100%',
              marginBottom: '16px',
            }}
          >
            <InputLabel
              htmlFor={field.id}
              style={{ marginLeft: '-1rem' }}
            >
              {field.label}
            </InputLabel>
            <Input
              className={classes.halfTextFieldNew}
              margin='normal'
              value={this.state[field.id] || ''}
              id={field.id}
              name={field.id}
              type={field.type || 'text'}
              onChange={this.handleChange}
              inputProps={{
                readOnly: Boolean(readOnly),
                autoComplete: 'new-password',
                form: {
                  autoComplete: 'off',
                },
              }}
              label={field.label}
              placeholder=''
              fullWidth
            />
          </FormControl>
        ))}
      </div>
    );
  };

  renderInstaMedPaymentFields = (classes, readOnly) => {
    const fields = [
      {
        id: 'instamed_account_id',
        label: 'Account ID',
      },
      {
        id: 'instamed_account_id_suffix',
        label: 'Account ID Suffix',
      },
      {
        id: 'instamed_connect_user_id',
        label: 'Connect User ID',
      },
      {
        id: 'instamed_connect_password',
        label: 'Connect Password',
        type: 'password',
      },
      {
        id: 'instamed_api_key',
        label: 'API Key',
        type: 'password',
      },
      {
        id: 'instamed_api_secret',
        label: 'API Secret',
        type: 'password',
      },
      {
        id: 'instamed_sso_security_key',
        label: 'SSO Security Key',
        type: 'password',
      },
    ];

    return (
      <div>
        {fields.map((field) => (
          <FormControl
            key={field.id}
            className={classes.formControl}
            style={{
              width: '100%',
              marginBottom: '16px',
            }}
          >
            <InputLabel
              htmlFor={field.id}
              style={{ marginLeft: '-1rem' }}
            >
              {field.label}
            </InputLabel>
            <Input
              className={classes.halfTextFieldNew}
              margin='normal'
              value={this.state[field.id] || ''}
              id={field.id}
              name={field.id}
              onChange={this.handleChange}
              inputProps={{
                readOnly: Boolean(readOnly),
                autoComplete: 'new-password',
                form: {
                  autoComplete: 'off',
                },
              }}
              type={field.type || 'text'}
              fullWidth
            />
          </FormControl>
        ))}
      </div>
    );
  };

  handleChangeBinaryToken = (event) => {
    this.setState({ binaryToken: event.target.value });
  };

  handleChangeDays = (event) => {
    let selecteddays = event.target.value;
    this.setState({ day_id: selecteddays });
    this.writeAuditLog('Rx Expiration Days were changed by user.');
  };
  handleChangeText2PayTokenExpiration = (event) => {
    this.setState({ text2pay_token_expiration_days: event.target.value });
    this.writeAuditLog('Text2Pay Token Expiration was changed by user.');
  };
  //Added by Naresh | Date: 14-05-2019 | DI-87
  handleChangePickUpReminder = (event) => {
    let selecteddays = event.target.value;
    this.setState({ pick_up_reminder_id: selecteddays });
    this.writeAuditLog('Pickup Reminder Days were changed by user.');
  };
  //End Naresh
  handleChangeBrand(event) {
    event.preventDefault && event.preventDefault();
    this.setState({ brandname: event.target.value });
  }

  handleChangePhone(event) {
    event.preventDefault && event.preventDefault();
    this.setState({ [event.target.name]: event.target.value });
  }
  handleChangeWeb(event) {
    event.preventDefault && event.preventDefault();
    this.setState({ web: event.target.value });
  }
  handleChangeFax(event) {
    event.preventDefault && event.preventDefault();
    this.setState({ fax: event.target.value });
  }
  handleChangePrimaryColor(event) {
    event.preventDefault && event.preventDefault();
    const value = (event.target.value || '').trim();
    // Accept a bare hex so pasting from a style guide works, but store the
    // canonical '#RRGGBB' the API and email renderer expect.
    const normalized =
      value === '' || value.startsWith('#') ? value : `#${value}`;
    this.setState({ primaryColor: normalized.toUpperCase() });
  }
  handleChangeEmail(event) {
    event.preventDefault && event.preventDefault();
    this.setState({ generalemail: event.target.value });
  }

  handleChangeContract = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({
      contractLang: event.target.value,
      charCount: this.state.contractLang.length,
    });
  };

  handleChangeConnectEmail = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ demo_email: event.target.value });
  };
  handleChangeConnectSMSPhone = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ demo_smsphone: event.target.value });
  };
  // handleChangeQS1Endpoint = event =>
  // {
  //   event.preventDefault && event.preventDefault();
  //   this.setState({endpoint: event.target.value});
  // };
  handleChangeQS1PharmacyId = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ pharmacyId: event.target.value });
  };
  handleChangeprimaryLib1 = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ primarylibrarytitle1: event.target.value });
  };
  handleChangeprimaryLib2 = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ primarylibrarytitle2: event.target.value });
  };
  handleChangeHoursofOperation = (value) => {
    if (value === 'Sun') {
      this.setState({ Sun: !this.state.Sun });
    }
    if (value === 'Mon') {
      this.setState({ Mon: !this.state.Mon });
    }
    if (value === 'Tue') {
      this.setState({ Tue: !this.state.Tue });
    }
    if (value === 'Wed') {
      this.setState({ Wed: !this.state.Wed });
    }
    if (value === 'Thu') {
      this.setState({ Thu: !this.state.Thu });
    }
    if (value === 'Fri') {
      this.setState({ Fri: !this.state.Fri });
    }
    if (value === 'Sat') {
      this.setState({ Sat: !this.state.Sat });
    }
  };
  handleChangeAdvanceAdvertise = () => {
    this.setState({
      AdvancedAdvertise: !this.state.AdvancedAdvertise,
      bottomAdvSlider1ErrorFlag: false,
      bottomAdvSlider2ErrorFlag: false,
      bottomAdvSlider3ErrorFlag: false,
      videoAdvErrorFlag: false,
      videoMaxSizeErrorFlag: false,
    });
  };
  handleOpentimeChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ opentime: event.target.value });
  };
  handleClosetimeChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ closetime: event.target.value });
  };
  handleBlurTime = (event) => {
    if (event.target.value > '23:59') {
      this.setState({ TimevalidateDialog: true });
    }
  };
  handleChangeClosedMessage = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ closedMsg: event.target.value });
  };
  PreviewOther = () => {
    this.setState({
      openIframe: !this.state.openIframe,
      dataUrl: this.state.OtherPreview,
    });
  };
  PreviewHippa = () => {
    this.setState({
      openIframe: !this.state.openIframe,
      dataUrl: this.state.HippaPreview,
    });
  };
  PreviewLC = () => {
    this.setState({
      openIframe: !this.state.openIframe,
      dataUrl: this.state.LCPreview,
    });
  };
  // PreviewET = () => {
  //   this.setState({openIframe : !this.state.openIframe, dataUrl : this.state.ETPreview});
  // };
  handleClosePreview = () => {
    this.setState({ openIframe: false });
  };
  handleChangeDocOne = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ docone: event.target.value });
  };
  handleChangeDocTwo = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ doctwo: event.target.value });
  };
  handleChangeDocThree = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ docthree: event.target.value });
  };

  handleChangeHelpLink = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ helpLink: event.target.value });
  };
  handleChangePrivacyPolicyLink = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ privacyPolicyLink: event.target.value });
  };
  handleChangeTermsAndConditionsLink = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ termsAndConditionsLink: event.target.value });
  };
  handleChangeMarketplace = () => {
    this.setState({ is_marketplace: !this.state.is_marketplace });
  };

  convertAccountHoursOfOperationsObject = async (selectedObject) => {
    if (
      selectedObject !== '' &&
      selectedObject !== null &&
      selectedObject !== 'null' &&
      selectedObject !== undefined &&
      selectedObject !== 'undefined'
    ) {
      const {
        id,
        account_id,
        created_on,
        deleted_on,
        modified_on,
        is_deleted,
        is_enabled,
        closed_msg,
        closedimg_url,
        hop_type,
        box_id,
        lunch_start,
        lunch_end,
        ...filteredObject
      } = selectedObject;
      return filteredObject;
    }
  };

  hanldeAccountHoursOfOperations = async (selectedObject) => {
    let AccountHoursOfOperationArray = [];
    if (
      selectedObject !== '' &&
      selectedObject !== null &&
      selectedObject !== 'null' &&
      selectedObject !== undefined &&
      selectedObject !== 'undefined'
    ) {
      const Keys = Object.keys(selectedObject);
      const Values = Object.values(selectedObject);
      if (Keys && Keys.length && Keys.length > 0) {
        for (let i = 0; i < Keys.length; i++) {
          const KeyName = Keys && Keys[i];
          const HoursOfTime = Values && Values[i] && Values[i].split(',');
          AccountHoursOfOperationArray.push({
            id: i,
            value: KeyName[0].toUpperCase() + KeyName.slice(1),
            openTime: HoursOfTime && HoursOfTime[0],
            closeTime: HoursOfTime && HoursOfTime[1],
            isClosed: HoursOfTime && HoursOfTime[2],
            isOpenAll: HoursOfTime && HoursOfTime[3],
          });
        }
      }
    }
    return AccountHoursOfOperationArray;
  };

  handleView = async (event, accountOverride) => {
    const selectedObject =
      accountOverride ||
      this.state.data.find((x) => x.id === this.state.selectedRowId);
    if (!selectedObject) {
      if (event) {
        this.handleContextClose(event);
      }
      return;
    }
    const AccountsHOPObject = await this.convertAccountHoursOfOperationsObject(
      selectedObject && selectedObject.account_hoursof_operations
    );
    const AccountHoursOfOperations = await this.hanldeAccountHoursOfOperations(
      AccountsHOPObject
    );
    if (
      AccountHoursOfOperations &&
      AccountHoursOfOperations.length &&
      AccountHoursOfOperations.length > 0
    ) {
      this.setState({ AccountHoursOfOperaionsArray: AccountHoursOfOperations });
    } else {
      this.setState({
        AccountHoursOfOperaionsArray: this.state
          .AccountDummyHoursOfOperaionsArray,
      });
    }
    const kiosk_hoursof_operations = getAccountLevelKioskHours(selectedObject);
    this.setState({
      closedMsg:kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].closed_msg,
      closedimg_url:kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].closedimg_url,
      lunchStart:kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].lunch_start,
      lunchEnd:kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].lunch_end,
    })
    const KioskHOPObject = await this.convertAccountHoursOfOperationsObject(kiosk_hoursof_operations[0]);
    const KioskHoursOfOperations = await this.hanldeAccountHoursOfOperations(KioskHOPObject);
    if (KioskHoursOfOperations && KioskHoursOfOperations.length && KioskHoursOfOperations.length > 0) {
      this.setState({ KioskHoursOfOperaionsArray: KioskHoursOfOperations });
    } else {
      this.setState({
        KioskHoursOfOperaionsArray: this.state.KioksDummyHoursOfOperaionsArray,
      });
    }

    await this.getEnrollmentInvite(
      selectedObject && selectedObject.id,
      (selectedObject && selectedObject.box_id) || localStorage.getItem('selectedLocation')
    );
    let ad1preview = null;
    let ad2preview = null;
    let ad3preview = null;
    let ad4preview = null;
    let bottomad1preview = null;
    let bottomad2preview = null;
    let bottomad3preview = null;
    //this.fetchGenericLink();
    if (
      selectedObject &&
      selectedObject.brand_detail &&
      selectedObject.brand_detail.length > 0
    ) {
      for (let i = 0; i < selectedObject.brand_detail.length; i++) {
        if (selectedObject.brand_detail[i].ad_number === 'ad1') {
          ad1preview = selectedObject.brand_detail[i].logo_url;
        }
        if (selectedObject.brand_detail[i].ad_number === 'ad2') {
          ad2preview = selectedObject.brand_detail[i].logo_url;
        }
        if (selectedObject.brand_detail[i].ad_number === 'ad3') {
          ad3preview = selectedObject.brand_detail[i].logo_url;
        }
        if (selectedObject.brand_detail[i].ad_number === 'vd') {
          ad4preview = selectedObject.brand_detail[i].logo_url;
        }
        if (selectedObject.brand_detail[i].ad_number === 'bottomad1') {
          bottomad1preview = selectedObject.brand_detail[i].logo_url;
        }
        if (selectedObject.brand_detail[i].ad_number === 'bottomad2') {
          bottomad2preview = selectedObject.brand_detail[i].logo_url;
        }
        if (selectedObject.brand_detail[i].ad_number === 'bottomad3') {
          bottomad3preview = selectedObject.brand_detail[i].logo_url;
        }
      }
    }

    let brand_logo_url;
    let brand_name;
    let genereal_phone, after_hour_phone;
    let website;
    let fax;
    let general_email;
    //let email_template_url;
    if (
      selectedObject &&
      selectedObject.brand !== null &&
      selectedObject.brand !== 'null' &&
      selectedObject.brand !== undefined &&
      selectedObject.brand !== 'undefined' &&
      selectedObject.brand !== '' &&
      selectedObject.brand_id !== null &&
      selectedObject.brand_id !== 'null' &&
      selectedObject.brand_id !== undefined &&
      selectedObject.brand_id !== 'undefined' &&
      selectedObject.brand_id !== ''
    ) {
      if (
        selectedObject.brand !== null &&
        selectedObject.brand.logo_url !== null &&
        selectedObject.brand.logo_url !== 'null' &&
        selectedObject.brand.logo_url !== undefined &&
        selectedObject.brand.logo_url !== 'undefined' &&
        selectedObject.brand.logo_url !== ''
      ) {
        brand_logo_url = selectedObject.brand.logo_url;
      } else {
        brand_logo_url = '';
      }
      if (
        selectedObject.brand.name !== null &&
        selectedObject.brand.name !== 'null' &&
        selectedObject.brand.name !== undefined &&
        selectedObject.brand.name !== 'undefined' &&
        selectedObject.brand.name !== ''
      ) {
        brand_name = selectedObject.brand.name;
      } else {
        brand_name = '';
      }
      if (
        selectedObject.brand.phone !== null &&
        selectedObject.brand.phone !== 'null' &&
        selectedObject.brand.phone !== undefined &&
        selectedObject.brand.phone !== 'undefined' &&
        selectedObject.brand.phone !== ''
      ) {
        genereal_phone = selectedObject.brand.phone;
      } else {
        genereal_phone = '';
      }
      if (selectedObject.brand.after_hour_phone) {
        after_hour_phone = selectedObject.brand.after_hour_phone;
      } else {
        after_hour_phone = '';
      }
      if (
        selectedObject.brand.website !== null &&
        selectedObject.brand.website !== 'null' &&
        selectedObject.brand.website !== undefined &&
        selectedObject.brand.website !== 'undefined' &&
        selectedObject.brand.website !== ''
      ) {
        website = selectedObject.brand.website;
      } else {
        website = '';
      }
      if (
        selectedObject.brand.fax !== null &&
        selectedObject.brand.fax !== 'null' &&
        selectedObject.brand.fax !== undefined &&
        selectedObject.brand.fax !== 'undefined' &&
        selectedObject.brand.fax !== ''
      ) {
        fax = selectedObject.brand.fax;
      } else {
        fax = '';
      }
      if (
        selectedObject.brand.email !== null &&
        selectedObject.brand.email !== 'null' &&
        selectedObject.brand.email !== undefined &&
        selectedObject.brand.email !== 'undefined' &&
        selectedObject.brand.email !== ''
      ) {
        general_email = selectedObject.brand.email;
      } else {
        general_email = '';
      }
      // if(selectedObject.brand.email_template_url!==null && selectedObject.brand.email_template_url!=='null' && selectedObject.brand.email_template_url!==undefined && selectedObject.brand.email_template_url!=='undefined' && selectedObject.brand.email_template_url!==''){
      // email_template_url = selectedObject.brand.email_template_url
      // }else{
      //   email_template_url=""
      // }
    }
    let account_connections_id = [];
    if (selectedObject && selectedObject.account_connections_id !== null) {
      if (
        selectedObject.connection !== undefined &&
        selectedObject.connection.name !== undefined
      ) {
        account_connections_id.push({
          id: selectedObject.account_connections_id,
          name: selectedObject.connection.name,
        });
      }
    }
    this.setState({
      selectedTab: 0,
      showNewUserDialog: true,
      operation: 'View',
      account: selectedObject,
      name:
        selectedObject.name === null ||
          selectedObject.name === 'null' ||
          selectedObject.name === undefined ||
          selectedObject.name === '' ||
          selectedObject.name === 'undefined'
          ? ''
          : selectedObject.name,
      parent_id: selectedObject.parent && selectedObject.parent.id,
      type_id: selectedObject.type.id,
      address1:
        selectedObject.contact &&
          selectedObject.contact.address &&
          (selectedObject.contact.address.address_line_1 === '' ||
            selectedObject.contact.address.address_line_1 === 'null' ||
            selectedObject.contact.address.address_line_1 === null ||
            selectedObject.contact.address.address_line_1 === undefined ||
            selectedObject.contact.address.address_line_1 === 'undefined')
          ? ''
          : selectedObject.contact.address.address_line_1,
      address2:
        selectedObject.contact &&
          selectedObject.contact.address &&
          (selectedObject.contact.address.address_line_2 === '' ||
            selectedObject.contact.address.address_line_2 === 'null' ||
            selectedObject.contact.address.address_line_2 === null ||
            selectedObject.contact.address.address_line_2 === undefined ||
            selectedObject.contact.address.address_line_2 === 'undefined')
          ? ''
          : selectedObject.contact.address.address_line_2,
      city:
        selectedObject.contact &&
          selectedObject.contact.address &&
          (selectedObject.contact.address.city === '' ||
            selectedObject.contact.address.city === 'null' ||
            selectedObject.contact.address.city === null ||
            selectedObject.contact.address.city === undefined ||
            selectedObject.contact.address.city === 'undefined')
          ? ''
          : selectedObject.contact.address.city,
      state:
        selectedObject.contact &&
          selectedObject.contact.address &&
          (selectedObject.contact.address.state === '' ||
            selectedObject.contact.address.state === 'null' ||
            selectedObject.contact.address.state === null ||
            selectedObject.contact.address.state === undefined ||
            selectedObject.contact.address.state === 'undefined')
          ? ''
          : selectedObject.contact.address.state,
      zip:
        selectedObject.contact &&
          selectedObject.contact.address &&
          (selectedObject.contact.address.zip === '' ||
            selectedObject.contact.address.zip === 'null' ||
            selectedObject.contact.address.zip === null ||
            selectedObject.contact.address.zip === undefined ||
            selectedObject.contact.address.zip === 'undefined')
          ? ''
          : selectedObject.contact.address.zip,
      phone: selectedObject.contact && selectedObject.contact.phone,
      email:
        selectedObject.contact &&
          (selectedObject.contact.email === '' ||
            selectedObject.contact.email === 'null' ||
            selectedObject.contact.email === null ||
            selectedObject.contact.email === undefined ||
            selectedObject.contact.email === 'undefined')
          ? ''
          : selectedObject.contact.email,
      first_name:
        selectedObject.contact &&
          (selectedObject.contact.name.split(' ')[0] === '' ||
            selectedObject.contact.name.split(' ')[0] === 'null' ||
            selectedObject.contact.name.split(' ')[0] === null ||
            selectedObject.contact.name.split(' ')[0] === undefined ||
            selectedObject.contact.name.split(' ')[0] === 'undefined')
          ? ''
          : selectedObject.contact.name.split(' ')[0],
      last_name:
        selectedObject.contact &&
          (selectedObject.contact.name.split(' ')[1] === '' ||
            selectedObject.contact.name.split(' ')[1] === 'null' ||
            selectedObject.contact.name.split(' ')[1] === null ||
            selectedObject.contact.name.split(' ')[1] === undefined ||
            selectedObject.contact.name.split(' ')[1] === 'undefined')
          ? ''
          : selectedObject.contact.name.split(' ')[1],
      avatarPreview: selectedObject.picture_url,
      Adv1Preview: ad1preview,
      Adv2Preview: ad2preview,
      Adv3Preview: ad3preview,
      videoPreview: ad4preview,
      brndLogoPreview: brand_logo_url,
      brandname: brand_name,
      //ETPreview: email_template_url,
      generalphone: genereal_phone,
      afterHourPhone: after_hour_phone,
      primaryColor:
        (selectedObject.brand && selectedObject.brand.primary_color) || '',
      is_modern_email_enabled: Boolean(
        selectedObject && selectedObject.is_modern_email_enabled
      ),
      is_pickup_change_email_enabled: Boolean(
        selectedObject && selectedObject.is_pickup_change_email_enabled
      ),
      web: website,
      fax: fax,
      generalemail: general_email,
      connect: account_connections_id,
      accountConnectionsId: selectedObject.account_connections_id,
      isPaymentRequired: selectedObject.is_payment_required, //Added by Naresh
      //role_id:role_id,
      //CheckedPermissionSubCategory:viewcheckedPermissionSubCategory,
      ContractLang: '',
      demo_email: selectedObject.demo_email, //Added by Kishan
      demo_smsphone: selectedObject.demo_phone, //Added by Kishan
      accountConnectionsName:
        account_connections_id &&
        account_connections_id.length > 0 &&
        account_connections_id[0].name, //Added by Kishan
      endpoint:
        account_connections_id.length > 0
          ? this.AssignEndPoint(account_connections_id[0].id, selectedObject)
          : '',
      pharmacyId:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.pharmacyid,
      pick_up_reminder_id: selectedObject.pick_up_reminder_day,
      day_id:
        selectedObject.expiration_days !== null ||
          selectedObject.expiration_days !== '' ||
          selectedObject.expiration_days !== 'null' ||
          selectedObject.expiration_days !== '' ||
          selectedObject.expiration_days !== 'null' ||
          selectedObject.expiration_days !== null ||
          selectedObject.expiration_days !== undefined ||
          selectedObject.expiration_days !== 'undefined'
          ? selectedObject.expiration_days
          : 1,
      healthandinfo: selectedObject.health_and_informations,
      primarylibrarytitle1:
        selectedObject &&
        selectedObject.health_and_informations &&
        selectedObject.health_and_informations.length > 0 &&
        selectedObject.health_and_informations[0].primarylibrary_title1,
      primarylibrarytitle2:
        selectedObject &&
        selectedObject.health_and_informations &&
        selectedObject.health_and_informations.length > 0 &&
        selectedObject.health_and_informations[0].primarylibrary_title2,
      vendor_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.vendor_key,
      data_exchange_id:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.data_exchange_id,
      HippaPreview:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_docone_url,
      docone:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_docone_label,
      LCPreview:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_doctwo_url,
      doctwo:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_doctwo_label,
      helpLink: selectedObject.brand && selectedObject.brand.helpLink,
      privacyPolicyLink:
        selectedObject.brand && selectedObject.brand.privacy_policy_link,
      termsAndConditionsLink:
        selectedObject.brand && selectedObject.brand.termsAndConditionsLink,
      OtherPreview:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_docthree_url,
      docthree:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_docthree_label,
      epicclientid:
        account_connections_id.length > 0
          ? this.AssignEpicclientID(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      epicusername:
        account_connections_id.length > 0
          ? this.AssignEpicUserName(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      epicpassword:
        account_connections_id.length > 0
          ? this.AssignEpicUserPassword(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      BottomAdv1Preview: bottomad1preview,
      BottomAdv2Preview: bottomad2preview,
      BottomAdv3Preview: bottomad3preview,
      AdvancedAdvertise: selectedObject.is_advance_advertise,
      xWebId: '**********',
      auth_Key: '**********',
      terminalId: '**********',
      fiserv_link_username: selectedObject && selectedObject.fiserv_link_username ? selectedObject.fiserv_link_username : '',
      fiserv_link_password: this.getMaskedSecretValue(selectedObject && selectedObject.fiserv_link_password),
      fiserv_terminal_api_key: this.getMaskedSecretValue(selectedObject && selectedObject.fiserv_terminal_api_key),
      trustcommerce_link_custid: selectedObject && selectedObject.trustcommerce_link_custid ? selectedObject.trustcommerce_link_custid : '',
      trustcommerce_link_password: this.getMaskedTrustCommerceValue(selectedObject && selectedObject.trustcommerce_link_password),
      trustcommerce_terminal_custid: selectedObject && selectedObject.trustcommerce_terminal_custid ? selectedObject.trustcommerce_terminal_custid : '',
      trustcommerce_terminal_password: this.getMaskedTrustCommerceValue(selectedObject && selectedObject.trustcommerce_terminal_password),
      trustcommerce_aggregator1: this.getMaskedTrustCommerceValue(selectedObject && selectedObject.trustcommerce_aggregator1),
      trustcommerce_aggregators: selectedObject && selectedObject.trustcommerce_aggregators ? selectedObject.trustcommerce_aggregators : '',
      instamed_account_id: selectedObject && selectedObject.instamed_account_id ? selectedObject.instamed_account_id : '',
      instamed_account_id_suffix: selectedObject && selectedObject.instamed_account_id_suffix ? selectedObject.instamed_account_id_suffix : '',
      instamed_connect_user_id: selectedObject && selectedObject.instamed_connect_user_id ? selectedObject.instamed_connect_user_id : '',
      instamed_connect_password: this.getMaskedSecretValue(selectedObject && selectedObject.instamed_connect_password),
      instamed_api_key: this.getMaskedSecretValue(selectedObject && selectedObject.instamed_api_key),
      instamed_api_secret: this.getMaskedSecretValue(selectedObject && selectedObject.instamed_api_secret),
      instamed_sso_security_key: this.getMaskedSecretValue(selectedObject && selectedObject.instamed_sso_security_key),
      allow_payment:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.allow_payment
          ? selectedObject.gbpconfig.allow_payment
          : false,
      epicPharmacyNcpdpId:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.pharmacy_ncpdpid
          ? selectedObject.template.pharmacy_ncpdpid
          : '',
      epicEndpointVersion:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.versions
          ? selectedObject.template.versions
          : '',
      epicRequestTempate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.request_template
          ? selectedObject.template.request_template
          : '',
      allow_consult_video:
        selectedObject && selectedObject.is_allow_consult_video,
      allow_consult_mobile:
        selectedObject && selectedObject.is_allow_consult_mobile,
      allow_consult_schedule:
        selectedObject && selectedObject.is_allow_consult_schedule,
      isContactLessPickupEnabled:
        selectedObject && selectedObject.isContactLessPickupEnabled
          ? selectedObject.isContactLessPickupEnabled
          : false,
      accContactPersons: selectedObject && selectedObject.accContactPersons,
      show_medbank_db_password: false,
      show_medbank_dblogin: false,
      show_medbank_subscription_key: false,
      medbank_db_password:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.medbank_db_password,
      medbank_dblogin:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.medbank_dblogin,
      opc_apim_subscription_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.opc_apim_subscription_key,
      x_api_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.x_api_key,
      gateway_api_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.gateway_api_key,
      client_identifier:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.client_identifier,
      IsGetReady: selectedObject && selectedObject.is_getready,
      isConsultRequired:
        selectedObject && selectedObject.connection_details.is_consult_required,
      epicConsultKey:
        selectedObject && selectedObject.connection_details.consult_key,
      loginType: selectedObject.login_type || '',
      ssoIssuer: selectedObject.issuer || '',
      emailDomain: selectedObject.email_domain || '',
      clientId: selectedObject.client_id || '',
      oidcCert:
        (selectedObject.oidc_cert && JSON.parse(selectedObject.oidc_cert)) ||
        '',
      ssoEntryPoint: selectedObject.sso_entry_point || '',
      isSSOAccountExist: false,
      isConsultRequire: selectedObject && selectedObject.bypass_consult,
      isStartGraphic:
        selectedObject && selectedObject.is_startgraphictextvisible,
      IsPatientPrimarySource:
        selectedObject && selectedObject.is_patient_primary_source,
      autoDisabledUser: selectedObject && selectedObject.is_auto_disabled_user,
      useDefaultEmail: selectedObject && selectedObject.use_default_email,
      is_dispense_safety_chek:
        selectedObject && selectedObject.is_dispense_safety_check,
      is_forgot_mypucode: selectedObject && selectedObject.is_forgot_mypucode,
      is_mask_kiosk_dob:
        selectedObject && selectedObject.is_mask_kiosk_dob !== undefined
          ? selectedObject.is_mask_kiosk_dob
          : true,
      time_zone: selectedObject && selectedObject.timezone,
      binaryToken:
        account_connections_id.length > 0
          ? this.AssignMcKssonRXBinaryToken(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      store_number:
        account_connections_id.length > 0
          ? this.AssignMckssoRERx(account_connections_id[0].id, selectedObject)
          : '',
      mcKessoneRXrequestTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.request_template
          ? selectedObject.template.request_template
          : '',
      issuer:
        account_connections_id.length > 0
          ? this.AssignMckessonRxIssuer(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      CFRHeaderTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.cfrheadertemplate
          ? selectedObject.template.cfrheadertemplate
          : '',
      RxInfoBodyTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.rxinfobodytemplate
          ? selectedObject.template.rxinfobodytemplate
          : '',
      RxInfoHeaderTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.rxinfoheadertemplate
          ? selectedObject.template.rxinfoheadertemplate
          : '',
      POSFinalizationBodyTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.posfinalizationbodytemplate
          ? selectedObject.template.posfinalizationbodytemplate
          : '',
      POSFinalizationHeaderTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.posfinalizationheadertemplate
          ? selectedObject.template.posfinalizationheadertemplate
          : '',
      authTok: '**********',
      authSecret: '**********',
      paymentType: selectedObject && selectedObject.selected_paymentgatway,
      merchant_id:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.merchant_id
          ? selectedObject.gbpconfig.merchant_id
          : '',
      hpp_identifier:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.hpp_identifier
          ? selectedObject.gbpconfig.hpp_identifier
          : '',
      preferLanguage: selectedObject && selectedObject.preferred_language,
      is_otp_login: selectedObject && selectedObject.is_otp_login,
      is_enroll_now: selectedObject && selectedObject.is_enroll_now,
      enrollment_v2_enabled:
        selectedObject && selectedObject.enrollment_v2_enabled !== undefined
          ? selectedObject.enrollment_v2_enabled
          : true,
      hide_new_ui:
        selectedObject &&
        selectedObject.hide_new_ui !== undefined &&
        selectedObject.hide_new_ui !== null
          ? [true, 'true', 1, '1'].includes(selectedObject.hide_new_ui)
          : true,
      is_mfa_required: selectedObject && selectedObject.is_mfa_required,
      allow_member_or_record_number: selectedObject && selectedObject.allow_member_or_record_number,
      allow_offline_payment_skip: selectedObject && selectedObject.allow_offline_payment_skip,
      is_numeric_code: selectedObject && selectedObject.is_numeric_code,
      is_future_release: selectedObject && selectedObject.is_future_release,
      is_pre_assignment: selectedObject && selectedObject.is_pre_assignment,
      liberty_customer_username: selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_customer_username,
      liberty_customer_password: selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_customer_password,
      third_party_token: selectedObject && selectedObject.connection_details && selectedObject.connection_details.third_party_token,
      vendor_unique_id: selectedObject && selectedObject.connection_details && selectedObject.connection_details.vendor_unique_id,
      purge_patient_images_toggle: selectedObject && selectedObject.purge_patient_images_toggle,
      purge_patient_images_days_count: selectedObject && selectedObject.purge_patient_images_days_count,
      liberty_rx_regrx: selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_rx_regrx,
      liberty_completion_status:
        (selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_completion_status) ||
        DEFAULT_LIBERTY_COMPLETION_STATUS,
      selectedHours:  (selectedObject && selectedObject.time_to_notify) || '09',
      patient_consent: selectedObject && selectedObject.patient_consent,
      is_consultation_notification: selectedObject && selectedObject.is_consultation_notification,
      is_taxable: selectedObject && selectedObject.is_taxable,
      is_permission_inheritable: selectedObject && selectedObject.is_permission_inheritable,
      selectedTaxCode: selectedObject && selectedObject.tax_data && [0, 1, 2, 3].includes(selectedObject.tax_data.tax_code) >= 0 ? selectedObject.tax_data.tax_code : -1,
      taxRate: selectedObject && selectedObject.tax_data && selectedObject.tax_data.tax_rate ? selectedObject.tax_data.tax_rate : '',
      store_ncp_id: selectedObject && selectedObject.store_ncp_id,
      advance_fills:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.advance_fills,
      signature_flags_test_mode:
        selectedObject && selectedObject.signature_flags_test_mode,
      signature_flags_test_config:
        (selectedObject &&
          Array.isArray(selectedObject.signature_flags_test_config) &&
          selectedObject.signature_flags_test_config) ||
        [],
      hl_x_api_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.hl_x_api_key,
      drx_key: selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.drx_key,
      tempUnit: selectedObject && selectedObject.temp_unit,
      screensaverRotationTime: selectedObject && selectedObject.screensaver_rotation_timing,
      external_id: selectedObject && selectedObject.external_id,
      securebadgeexpiryduration: selectedObject && selectedObject.securebadgeexpiryduration,
      vial_label_scan: selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.vial_label_scan,
      prevent_assigning_non_ready: [true, 'true'].includes(
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.prevent_assigning_non_ready
      ),
      regexp: storedEpicRegexp(
        selectedObject && selectedObject.connection_details && selectedObject.connection_details.regexp,
        selectedObject && selectedObject.account_connections_id
      ),
      fill_number_api_fallback: [true, 'true'].includes(selectedObject && selectedObject.connection_details && selectedObject.connection_details.fill_number_api_fallback),
      bannerImg:  ![undefined,null,'undefined','null',''].includes(selectedObject.brand.banner_img) ? selectedObject.brand.banner_img : '',
      headerImg: ![undefined, null, 'undefined', 'null', ''].includes(selectedObject.brand.header_img) ? selectedObject.brand.header_img : '',
      optical_expiration_days: ![undefined, 'undefined', null, 'null', ''].includes(selectedObject && selectedObject.optical_expiration_days) ? selectedObject && selectedObject.optical_expiration_days : '',
      text2pay_token_expiration_days: ![undefined, 'undefined', null, 'null', ''].includes(selectedObject && selectedObject.text2pay_token_expiration_days)
        ? parseInt(selectedObject.text2pay_token_expiration_days, 10) || 1
        : 1,
      purge_patient_data_toggle: selectedObject && selectedObject.purge_patient_data_toggle,
      purge_patient_data_days_count: selectedObject && selectedObject.purge_patient_data_days_count,
      calculate_tax: selectedObject && selectedObject.connection_details && selectedObject.connection_details.calculate_tax,
      basic_first_name: selectedObject && selectedObject.basic_first_name,
      basic_last_name: selectedObject && selectedObject.basic_last_name,
      is_dob_optional: [true, 'true', 1, '1'].includes(selectedObject && selectedObject.is_dob_optional),
      drx_host: selectedObject && selectedObject.connection_details && selectedObject.connection_details.drx_host,
      cascade_account_update: selectedObject && selectedObject.cascade_account_update,
      is_need_help_enabled: selectedObject && selectedObject.is_need_help_enabled !== undefined ? selectedObject.is_need_help_enabled : true,
      is_auto_logout_enabled:
        selectedObject && selectedObject.is_auto_logout_enabled !== undefined
          ? selectedObject.is_auto_logout_enabled === true || selectedObject.is_auto_logout_enabled === 'true'
          : false,
      prx_xapi_key: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_xapi_key,
      prx_client_identifier: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_client_identifier,
      prx_client_id: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_client_id,
      prx_client_secret: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_client_secret,
      prx_endoint: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_endoint,
      prx_memberid: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_memberid,
    });
    this.handleContextClose(event);
  };

  getEnrollmentInvite = (accountId, locationId) => {
    if (!accountId) {
      this.setState({
        genericLink: '',
        enrollmentInviteId: '',
        enrollmentLocationId: locationId || ''
      });
      return Promise.resolve();
    }

    return fetch(
      process.env.REACT_APP_BASEURL +
      `patient/enrollment/invites/active?account_id=${accountId}`,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((payload) => {
        const normalizeEnrollmentUrl = (url) => {
          if (!url || typeof url !== 'string') return '';
          const trimmedUrl = url.trim();
          const parts = trimmedUrl.split('://');
          if (parts.length < 2) return trimmedUrl.replace(/\/{2,}/g, '/');
          const protocol = parts.shift();
          const rest = parts.join('://').replace(/\/{2,}/g, '/');
          return `${protocol}://${rest}`;
        };
        const buildEnrollmentUrlFromInvite = (invite, apiUrl) => {
          if (apiUrl) return normalizeEnrollmentUrl(apiUrl);
          const pathSegment =
            invite && (invite.short_code || invite.public_id)
              ? invite.short_code || invite.public_id
              : '';
          if (!pathSegment) return '';
          const patientBaseUrl = (process.env.REACT_APP_PATIENTURL || '').replace(/\/+$/, '');
          return normalizeEnrollmentUrl(`${patientBaseUrl}/e/${pathSegment}`);
        };
        const errorMessage =
          payload && payload.error && payload.error.message
            ? payload.error.message
            : '';
        if (payload && payload.success === false && errorMessage === 'No active invite found') {
          return this.generateEnrollmentInviteByAccountLocation(
            accountId,
            null,
            false
          );
        }
        const invite = payload && payload.data && payload.data.invite;
        const url = payload && payload.data && payload.data.url;
        this.setState({
          genericLink: buildEnrollmentUrlFromInvite(invite, url),
          enrollmentInviteId: invite && invite.id ? invite.id : '',
          enrollmentLocationId: locationId || ''
        });
      })
      .catch(() => {
        this.setState({
          genericLink: '',
          enrollmentInviteId: '',
          enrollmentLocationId: locationId || ''
        });
      });
  };

  generateEnrollmentInviteByAccountLocation = (
    accountId,
    locationId,
    showSuccessToast = true
  ) => {
    if (!accountId) {
      toast.error(this.props.t('Toast.Error.Generic'));
      return Promise.resolve();
    }

    return fetch(process.env.REACT_APP_BASEURL + 'patient/enrollment/invites', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        account_id: accountId,
        location_id: locationId || null
      })
    })
      .then((response) => response.json())
      .then((payload) => {
        const normalizeEnrollmentUrl = (url) => {
          if (!url || typeof url !== 'string') return '';
          const trimmedUrl = url.trim();
          const parts = trimmedUrl.split('://');
          if (parts.length < 2) return trimmedUrl.replace(/\/{2,}/g, '/');
          const protocol = parts.shift();
          const rest = parts.join('://').replace(/\/{2,}/g, '/');
          return `${protocol}://${rest}`;
        };
        const buildEnrollmentUrlFromInvite = (invite, apiUrl) => {
          if (apiUrl) return normalizeEnrollmentUrl(apiUrl);
          const pathSegment =
            invite && (invite.short_code || invite.public_id)
              ? invite.short_code || invite.public_id
              : '';
          if (!pathSegment) return '';
          const patientBaseUrl = (process.env.REACT_APP_PATIENTURL || '').replace(/\/+$/, '');
          return normalizeEnrollmentUrl(`${patientBaseUrl}/e/${pathSegment}`);
        };
        const backendMessage =
          payload && payload.error && payload.error.message ? payload.error.message : '';
        const invite = payload && payload.data && payload.data.invite;
        const url = payload && payload.data && payload.data.url;
        if (invite) {
          this.setState({
            genericLink: buildEnrollmentUrlFromInvite(invite, url),
            enrollmentInviteId: invite.id || '',
            enrollmentLocationId: locationId
          });
          if (showSuccessToast) {
            toast.success(this.props.t('Toast.Success.AccountUpdated'));
          }
          return;
        }
        if (showSuccessToast) {
          toast.error(backendMessage || this.props.t('Toast.Error.Generic'));
        }
      })
      .catch(() => {
        if (showSuccessToast) {
          toast.error(this.props.t('Toast.Error.Generic'));
        }
      });
  };

  generateEnrollmentInvite = () => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    const accountId = selectedObject && selectedObject.id;
    this.generateEnrollmentInviteByAccountLocation(accountId, null, true);
  };

  revokeEnrollmentInvite = () => {
    const inviteId = this.state.enrollmentInviteId;
    if (!inviteId) return;

    fetch(
      process.env.REACT_APP_BASEURL + `patient/enrollment/invites/${inviteId}/revoke`,
      {
        method: 'POST',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((payload) => {
        const invite = payload && payload.data && payload.data.invite;
        if (invite && invite.status === 'REVOKED') {
          this.setState({
            genericLink: '',
            enrollmentInviteId: ''
          });
          toast.success(this.props.t('Toast.Success.AccountUpdated'));
          return;
        }
        toast.error(this.props.t('Toast.Error.Generic'));
      })
      .catch(() => {
        toast.error(this.props.t('Toast.Error.Generic'));
      });
  };

  downloadEnrollmentQrCode = async () => {
    if (!this.state || !this.state.genericLink) {
      toast.error(this.props.t('Toast.Error.Generic'));
      return;
    }

    try {
      const finalDataUrl = await QRCodeGenerator.toDataURL(this.state.genericLink, {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        width: 1200,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
      });

      const accountName = (this.state && this.state.name) || 'account';
      const sanitizedAccount = accountName.replace(/[^a-z0-9]+/gi, '_').toLowerCase();
      const filename = `${sanitizedAccount}_enrollment_qr_hd.png`;

      const downloadLink = document.createElement('a');
      downloadLink.href = finalDataUrl;
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      toast.error(this.props.t('Toast.Error.Generic'));
    }
  };

  getShortUrlLink = (account_id) => {
    fetch(process.env.REACT_APP_BASEURL + `getshortlink/${account_id}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((shortUrlLink) => {
        if (shortUrlLink) {
          this.setState({
            genericLink:
              shortUrlLink &&
                shortUrlLink.shortUrl &&
                shortUrlLink.shortUrl[0] &&
                shortUrlLink.shortUrl[0].random_id
                ? `${process.env.REACT_APP_PATIENTURL}?id=${shortUrlLink.shortUrl[0].random_id}`
                : '',
          });
        }
      });
  };

  handleChangeHelpLink = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ helpLink: event.target.value });
  };
  handleChangePrivacyPolicyLink = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ privacyPolicyLink: event.target.value });
  };
  handleChangeTermsAndConditionsLink = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ termsAndConditionsLink: event.target.value });
  };

  handleEdit = async (event, accountOverride) => {
    const selectedObject =
      accountOverride ||
      this.state.data.find((x) => x.id === this.state.selectedRowId);
    if (!selectedObject) {
      if (event) {
        this.handleContextClose(event);
      }
      return;
    }
    const AccountsHOPObject = await this.convertAccountHoursOfOperationsObject(
      selectedObject && selectedObject.account_hoursof_operations
    );
    const AccountHoursOfOperations = await this.hanldeAccountHoursOfOperations(
      AccountsHOPObject
    );
    if (
      AccountHoursOfOperations &&
      AccountHoursOfOperations.length &&
      AccountHoursOfOperations.length > 0
    ) {
      this.setState({ AccountHoursOfOperaionsArray: AccountHoursOfOperations });
    } else {
      this.setState({
        AccountHoursOfOperaionsArray: this.state
          .AccountDummyHoursOfOperaionsArray,
      });
    }

    const kiosk_hoursof_operations = getAccountLevelKioskHours(selectedObject);
    this.setState({
      closedMsg:kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].closed_msg,
      closedimg_url:kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].closedimg_url,
      lunchStart:kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].lunch_start,
      lunchEnd:kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].lunch_end,
      
    })
    const KioskHOPObject = await this.convertAccountHoursOfOperationsObject(kiosk_hoursof_operations[0]);
    const KioskHoursOfOperations = await this.hanldeAccountHoursOfOperations(KioskHOPObject);
    if (KioskHoursOfOperations && KioskHoursOfOperations.length && KioskHoursOfOperations.length > 0) {
      this.setState({ KioskHoursOfOperaionsArray: KioskHoursOfOperations });
    } else {
      this.setState({
        KioskHoursOfOperaionsArray: this.state.KioksDummyHoursOfOperaionsArray,
      });
    }

    await this.getEnrollmentInvite(
      selectedObject && selectedObject.id,
      (selectedObject && selectedObject.box_id) || localStorage.getItem('selectedLocation')
    );
    let ad1preview = null;
    let ad2preview = null;
    let ad3preview = null;
    let ad4preview = null;
    let bottomad1preview = null;
    let bottomad2preview = null;
    let bottomad3preview = null;
    //this.fetchGenericLink();
    if (
      selectedObject &&
      selectedObject.brand_detail &&
      selectedObject.brand_detail.length > 0
    ) {
      for (let i = 0; i < selectedObject.brand_detail.length; i++) {
        if (selectedObject.brand_detail[i].ad_number === 'ad1') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            ad1preview = selectedObject.brand_detail[i].logo_url;
          } else {
            ad1preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'ad2') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            ad2preview = selectedObject.brand_detail[i].logo_url;
          } else {
            ad2preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'ad3') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            ad3preview = selectedObject.brand_detail[i].logo_url;
          } else {
            ad3preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'vd') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            ad4preview = selectedObject.brand_detail[i].logo_url;
          } else {
            ad4preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'bottomad1') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            bottomad1preview = selectedObject.brand_detail[i].logo_url;
          } else {
            bottomad1preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'bottomad2') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            bottomad2preview = selectedObject.brand_detail[i].logo_url;
          } else {
            bottomad2preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'bottomad3') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            bottomad3preview = selectedObject.brand_detail[i].logo_url;
          } else {
            bottomad3preview = '';
          }
        }
      }
    }
    let brand_logo_url;
    let brand_name;
    let genereal_phone, after_hour_phone;
    let website;
    let fax;
    let general_email;
    //let email_template_url;
    if (
      selectedObject &&
      selectedObject.brand !== null &&
      selectedObject.brand !== 'null' &&
      selectedObject.brand !== undefined &&
      selectedObject.brand !== 'undefined' &&
      selectedObject.brand !== '' &&
      selectedObject.brand_id !== null &&
      selectedObject.brand_id !== 'null' &&
      selectedObject.brand_id !== undefined &&
      selectedObject.brand_id !== 'undefined' &&
      selectedObject.brand_id !== ''
    ) {
      if (
        selectedObject.brand !== null &&
        selectedObject.brand.logo_url !== null &&
        selectedObject.brand.logo_url !== 'null' &&
        selectedObject.brand.logo_url !== undefined &&
        selectedObject.brand.logo_url !== 'undefined' &&
        selectedObject.brand.logo_url !== ''
      ) {
        brand_logo_url = selectedObject.brand.logo_url;
      } else {
        brand_logo_url = '';
      }
      if (
        selectedObject.brand.name !== null &&
        selectedObject.brand.name !== 'null' &&
        selectedObject.brand.name !== undefined &&
        selectedObject.brand.name !== 'undefined' &&
        selectedObject.brand.name !== ''
      ) {
        brand_name = selectedObject.brand.name;
      } else {
        brand_name = '';
      }
      if (
        selectedObject.brand.phone !== null &&
        selectedObject.brand.phone !== 'null' &&
        selectedObject.brand.phone !== undefined &&
        selectedObject.brand.phone !== 'undefined' &&
        selectedObject.brand.phone !== ''
      ) {
        genereal_phone = selectedObject.brand.phone;
      } else {
        genereal_phone = '';
      }
      if (selectedObject.brand.after_hour_phone) {
        after_hour_phone = selectedObject.brand.after_hour_phone;
      } else {
        after_hour_phone = '';
      }
      if (
        selectedObject.brand.website !== null &&
        selectedObject.brand.website !== 'null' &&
        selectedObject.brand.website !== undefined &&
        selectedObject.brand.website !== 'undefined' &&
        selectedObject.brand.website !== ''
      ) {
        website = selectedObject.brand.website;
      } else {
        website = '';
      }
      if (
        selectedObject.brand.fax !== null &&
        selectedObject.brand.fax !== 'null' &&
        selectedObject.brand.fax !== undefined &&
        selectedObject.brand.fax !== 'undefined' &&
        selectedObject.brand.fax !== ''
      ) {
        fax = selectedObject.brand.fax;
      } else {
        fax = '';
      }
      if (
        selectedObject.brand.email !== null &&
        selectedObject.brand.email !== 'null' &&
        selectedObject.brand.email !== undefined &&
        selectedObject.brand.email !== 'undefined' &&
        selectedObject.brand.email !== ''
      ) {
        general_email = selectedObject.brand.email;
      } else {
        general_email = '';
      }
      // if(selectedObject.brand.email_template_url!==null && selectedObject.brand.email_template_url!=='null' && selectedObject.brand.email_template_url!==undefined && selectedObject.brand.email_template_url!=='undefined' && selectedObject.brand.email_template_url!==''){
      //   email_template_url = selectedObject.brand.email_template_url
      //   }else{
      //     email_template_url=""
      // }
    }
    let account_connections_id = [];
    if (selectedObject && selectedObject.account_connections_id !== null) {
      if (
        selectedObject.connection !== undefined &&
        selectedObject.connection.name !== undefined
      ) {
        account_connections_id.push({
          id: selectedObject.account_connections_id,
          name: selectedObject.connection.name,
        });
      }
    }
    this.setState({
      id: selectedObject && selectedObject.id,
      selectedTab: 0,
      showNewUserDialog: true,
      operation: 'Edit',
      account: selectedObject,
      name:
        selectedObject.name === null ||
          selectedObject.name === 'null' ||
          selectedObject.name === undefined ||
          selectedObject.name === '' ||
          selectedObject.name === 'undefined'
          ? ''
          : selectedObject.name,
      parent_id: selectedObject.parent && selectedObject.parent.id,
      type_id: selectedObject.type.id,
      address1:
        selectedObject.contact &&
        selectedObject.contact.address &&
        selectedObject.contact.address.address_line_1,
      address2:
        selectedObject.contact &&
        selectedObject.contact.address &&
        selectedObject.contact.address.address_line_2,
      city:
        selectedObject.contact &&
        selectedObject.contact.address &&
        selectedObject.contact.address.city,
      state:
        selectedObject.contact &&
        selectedObject.contact.address &&
        selectedObject.contact.address.state,
      zip:
        selectedObject.contact &&
        selectedObject.contact.address &&
        selectedObject.contact.address.zip,
      phone: selectedObject.contact && selectedObject.contact.phone,
      email: selectedObject.contact && selectedObject.contact.email,
      first_name:
        selectedObject.contact &&
        selectedObject.contact.name &&
        selectedObject.contact.name.split(' ')[0],
      last_name:
        selectedObject.contact &&
        selectedObject.contact.name &&
        selectedObject.contact.name.split(' ')[1],
      // address1: selectedObject.contact && selectedObject.contact.address && (selectedObject.contact.address.address_line_1==='' || selectedObject.contact.address.address_line_1==='null' || selectedObject.contact.address.address_line_1===null || selectedObject.contact.address.address_line_1===undefined || selectedObject.contact.address.address_line_1==='undefined')?'':selectedObject.contact.address.address_line_1,
      // address2: selectedObject.contact && selectedObject.contact.address && (selectedObject.contact.address.address_line_2==='' || selectedObject.contact.address.address_line_2==='null' || selectedObject.contact.address.address_line_2===null || selectedObject.contact.address.address_line_2===undefined || selectedObject.contact.address.address_line_2==='undefined')?'':selectedObject.contact.address.address_line_2,
      // city: selectedObject.contact && selectedObject.contact.address && (selectedObject.contact.address.city==='' || selectedObject.contact.address.city==='null' || selectedObject.contact.address.city===null || selectedObject.contact.address.city===undefined || selectedObject.contact.address.city==='undefined')?'':selectedObject.contact.address.city,
      // state: selectedObject.contact && selectedObject.contact.address && (selectedObject.contact.address.state==='' || selectedObject.contact.address.state==='null' || selectedObject.contact.address.state===null || selectedObject.contact.address.state===undefined || selectedObject.contact.address.state==='undefined')?'':selectedObject.contact.address.state,
      // zip: selectedObject.contact && selectedObject.contact.address && (selectedObject.contact.address.zip==='' || selectedObject.contact.address.zip==='null' || selectedObject.contact.address.zip===null || selectedObject.contact.address.zip===undefined || selectedObject.contact.address.zip==='undefined')?'':selectedObject.contact.address.zip,
      // phone: selectedObject.contact && selectedObject.contact.phone,
      // email: selectedObject.contact && (selectedObject.contact.email==='' || selectedObject.contact.email==='null' || selectedObject.contact.email===null || selectedObject.contact.email===undefined || selectedObject.contact.email==='undefined')?'':selectedObject.contact.email,
      // first_name: selectedObject.contact && (selectedObject.contact.name.split(' ')[0]==='' || selectedObject.contact.name.split(' ')[0]==='null' || selectedObject.contact.name.split(' ')[0]===null || selectedObject.contact.name.split(' ')[0]===undefined || selectedObject.contact.name.split(' ')[0]==='undefined')?'':selectedObject.contact.name.split(' ')[0],
      // last_name: selectedObject.contact && (selectedObject.contact.name.split(' ')[1]==='' || selectedObject.contact.name.split(' ')[1]==='null' || selectedObject.contact.name.split(' ')[1]===null || selectedObject.contact.name.split(' ')[1]===undefined || selectedObject.contact.name.split(' ')[1]==='undefined')?'':selectedObject.contact.name.split(' ')[1],
      avatarPreview:
        selectedObject.picture_url === null ||
          selectedObject.picture_url === 'null' ||
          selectedObject.picture_url === undefined ||
          selectedObject.picture_url === '' ||
          selectedObject.picture_url === 'undefined'
          ? ''
          : selectedObject.picture_url,
      Adv1Preview: ad1preview,
      Adv2Preview: ad2preview,
      Adv3Preview: ad3preview,
      videoPreview: ad4preview,
      brndLogoPreview: brand_logo_url,
      brandname: brand_name,
      //ETPreview: email_template_url,
      generalphone: genereal_phone,
      afterHourPhone: after_hour_phone,
      primaryColor:
        (selectedObject.brand && selectedObject.brand.primary_color) || '',
      is_modern_email_enabled: Boolean(
        selectedObject && selectedObject.is_modern_email_enabled
      ),
      is_pickup_change_email_enabled: Boolean(
        selectedObject && selectedObject.is_pickup_change_email_enabled
      ),
      web: website,
      fax: fax,
      generalemail: general_email,
      connect: account_connections_id,
      accountConnectionsId: selectedObject.account_connections_id,
      isPaymentRequired: selectedObject.is_payment_required, //Added by Naresh
      // role_id:role_id,
      // CheckedPermissionSubCategory:viewcheckedPermissionSubCategory,
      contractLang: selectedObject.contract_language,
      demo_email: selectedObject.demo_email, //Added by Kishan
      demo_smsphone: selectedObject.demo_phone, //Added by Kishan
      accountConnectionsName:
        account_connections_id &&
        account_connections_id.length > 0 &&
        account_connections_id[0].name, //Added by Kishan
      endpoint:
        account_connections_id.length > 0
          ? this.AssignEndPoint(account_connections_id[0].id, selectedObject)
          : '',
      pharmacyId:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.pharmacyid,
      pick_up_reminder_id: selectedObject.pick_up_reminder_day,
      day_id:
        selectedObject.expiration_days !== null ||
          selectedObject.expiration_days !== '' ||
          selectedObject.expiration_days !== 'null' ||
          selectedObject.expiration_days !== '' ||
          selectedObject.expiration_days !== 'null' ||
          selectedObject.expiration_days !== null ||
          selectedObject.expiration_days !== undefined ||
          selectedObject.expiration_days !== 'undefined'
          ? selectedObject.expiration_days
          : 1,
      healthandinfo: selectedObject.health_and_informations,
      primarylibrarytitle1:
        selectedObject &&
        selectedObject.health_and_informations &&
        selectedObject.health_and_informations.length > 0 &&
        selectedObject.health_and_informations[0].primarylibrary_title1,
      primarylibrarytitle2:
        selectedObject &&
        selectedObject.health_and_informations &&
        selectedObject.health_and_informations.length > 0 &&
        selectedObject.health_and_informations[0].primarylibrary_title2,
      vendor_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.vendor_key,
      data_exchange_id:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.data_exchange_id,
      HippaPreview:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_docone_url,
      docone:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_docone_label,
      LCPreview:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_doctwo_url,
      doctwo:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_doctwo_label,
      OtherPreview:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_docthree_url,
      docthree:
        selectedObject.legal_compliance &&
        selectedObject.legal_compliance.legal_compliance_docthree_label,
      helpLink: selectedObject.brand && selectedObject.brand.helpLink,
      privacyPolicyLink:
        selectedObject.brand && selectedObject.brand.privacy_policy_link,
      termsAndConditionsLink:
        selectedObject.brand && selectedObject.brand.termsAndConditionsLink,
      epicclientid:
        account_connections_id.length > 0
          ? this.AssignEpicclientID(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      epicusername:
        account_connections_id.length > 0
          ? this.AssignEpicUserName(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      epicpassword:
        account_connections_id.length > 0
          ? this.AssignEpicUserPassword(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      BottomAdv1Preview: bottomad1preview,
      BottomAdv2Preview: bottomad2preview,
      BottomAdv3Preview: bottomad3preview,
      AdvancedAdvertise: selectedObject.is_advance_advertise,
      xWebId: '**********',
      auth_Key: '**********',
      terminalId: '**********',
      fiserv_link_username: selectedObject && selectedObject.fiserv_link_username ? selectedObject.fiserv_link_username : '',
      fiserv_link_password: this.getMaskedSecretValue(selectedObject && selectedObject.fiserv_link_password),
      fiserv_terminal_api_key: this.getMaskedSecretValue(selectedObject && selectedObject.fiserv_terminal_api_key),
      trustcommerce_link_custid: selectedObject && selectedObject.trustcommerce_link_custid ? selectedObject.trustcommerce_link_custid : '',
      trustcommerce_link_password: this.getMaskedTrustCommerceValue(selectedObject && selectedObject.trustcommerce_link_password),
      trustcommerce_terminal_custid: selectedObject && selectedObject.trustcommerce_terminal_custid ? selectedObject.trustcommerce_terminal_custid : '',
      trustcommerce_terminal_password: this.getMaskedTrustCommerceValue(selectedObject && selectedObject.trustcommerce_terminal_password),
      trustcommerce_aggregator1: this.getMaskedTrustCommerceValue(selectedObject && selectedObject.trustcommerce_aggregator1),
      trustcommerce_aggregators: selectedObject && selectedObject.trustcommerce_aggregators ? selectedObject.trustcommerce_aggregators : '',
      instamed_account_id: selectedObject && selectedObject.instamed_account_id ? selectedObject.instamed_account_id : '',
      instamed_account_id_suffix: selectedObject && selectedObject.instamed_account_id_suffix ? selectedObject.instamed_account_id_suffix : '',
      instamed_connect_user_id: selectedObject && selectedObject.instamed_connect_user_id ? selectedObject.instamed_connect_user_id : '',
      instamed_connect_password: this.getMaskedSecretValue(selectedObject && selectedObject.instamed_connect_password),
      instamed_api_key: this.getMaskedSecretValue(selectedObject && selectedObject.instamed_api_key),
      instamed_api_secret: this.getMaskedSecretValue(selectedObject && selectedObject.instamed_api_secret),
      instamed_sso_security_key: this.getMaskedSecretValue(selectedObject && selectedObject.instamed_sso_security_key),
      dummyxWebId:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.tokenapikey
          ? selectedObject.gbpconfig.tokenapikey
          : '',
      dummyauthKey:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.transapikey
          ? selectedObject.gbpconfig.transapikey
          : '',
      dummyterminalId:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.transapisecret
          ? selectedObject.gbpconfig.transapisecret
          : '',
      allow_payment:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.allow_payment
          ? selectedObject.gbpconfig.allow_payment
          : false,
      epicPharmacyNcpdpId:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.pharmacy_ncpdpid
          ? selectedObject.template.pharmacy_ncpdpid
          : '',
      epicEndpointVersion:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.versions
          ? selectedObject.template.versions
          : '',
      epicRequestTempate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.request_template
          ? selectedObject.template.request_template
          : '',
      allow_consult_video:
        selectedObject && selectedObject.is_allow_consult_video,
      allow_consult_mobile:
        selectedObject && selectedObject.is_allow_consult_mobile,
      allow_consult_schedule:
        selectedObject && selectedObject.is_allow_consult_schedule,
      isContactLessPickupEnabled:
        selectedObject && selectedObject.isContactLessPickupEnabled
          ? selectedObject.isContactLessPickupEnabled
          : false,
      accContactPersons: selectedObject && selectedObject.accContactPersons,
      show_medbank_db_password: false,
      show_medbank_dblogin: false,
      show_medbank_subscription_key: false,
      medbank_db_password:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.medbank_db_password,
      medbank_dblogin:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.medbank_dblogin,
      opc_apim_subscription_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.opc_apim_subscription_key,
      x_api_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.x_api_key,
      gateway_api_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.gateway_api_key,
      client_identifier:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.client_identifier,
      is_marketplace:
        selectedObject.is_marketplace !== '' &&
          selectedObject.is_marketplace !== 'null' &&
          selectedObject.is_marketplace !== null &&
          selectedObject.is_marketplace !== undefined &&
          selectedObject.is_marketplace !== 'undefined'
          ? selectedObject.is_marketplace
          : '',
      IsGetReady:
        selectedObject.is_getready !== '' &&
          selectedObject.is_getready !== 'null' &&
          selectedObject.is_getready !== null &&
          selectedObject.is_getready !== undefined &&
          selectedObject.is_getready !== 'undefined'
          ? selectedObject.is_getready
          : '',
      isConsultRequired:
        selectedObject && selectedObject.connection_details.is_consult_required,
      epicConsultKey:
        selectedObject && selectedObject.connection_details.consult_key,
      loginType: selectedObject.login_type || '',
      ssoIssuer: selectedObject.issuer || '',
      emailDomain: selectedObject.email_domain || '',
      clientId: selectedObject.client_id || '',
      oidcCert:
        (selectedObject.oidc_cert && JSON.parse(selectedObject.oidc_cert)) ||
        '',
      ssoEntryPoint: selectedObject.sso_entry_point || '',
      isSSOAccountExist: false,
      isConsultRequire: selectedObject && selectedObject.bypass_consult,
      StartGraphic:
        selectedObject.is_startgraphictextvisible !== '' &&
          selectedObject.is_startgraphictextvisible !== 'null' &&
          selectedObject.is_startgraphictextvisible !== null &&
          selectedObject.is_startgraphictextvisible !== undefined &&
          selectedObject.is_startgraphictextvisible !== 'undefined'
          ? selectedObject.is_startgraphictextvisible
          : '',
      IsPatientPrimarySource:
        selectedObject && selectedObject.is_patient_primary_source,
      autoDisabledUser: selectedObject && selectedObject.is_auto_disabled_user,
      useDefaultEmail: selectedObject && selectedObject.use_default_email,
      is_dispense_safety_chek:
        selectedObject && selectedObject.is_dispense_safety_check,
      is_forgot_mypucode: selectedObject && selectedObject.is_forgot_mypucode,
      is_mask_kiosk_dob:
        selectedObject && selectedObject.is_mask_kiosk_dob !== undefined
          ? selectedObject.is_mask_kiosk_dob
          : true,
      time_zone: selectedObject && selectedObject.timezone,
      store_number:
        account_connections_id.length > 0
          ? this.AssignMckssoRERx(account_connections_id[0].id, selectedObject)
          : '',
      binaryToken:
        account_connections_id.length > 0
          ? this.AssignMcKssonRXBinaryToken(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      mcKessoneRXrequestTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.request_template
          ? selectedObject.template.request_template
          : '',
      issuer:
        account_connections_id.length > 0
          ? this.AssignMckessonRxIssuer(
            account_connections_id[0].id,
            selectedObject
          )
          : '',
      CFRHeaderTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.cfrheadertemplate
          ? selectedObject.template.cfrheadertemplate
          : '',
      RxInfoBodyTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.rxinfobodytemplate
          ? selectedObject.template.rxinfobodytemplate
          : '',
      RxInfoHeaderTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.rxinfoheadertemplate
          ? selectedObject.template.rxinfoheadertemplate
          : '',
      POSFinalizationBodyTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.posfinalizationbodytemplate
          ? selectedObject.template.posfinalizationbodytemplate
          : '',
      POSFinalizationHeaderTemplate:
        selectedObject &&
          selectedObject.template &&
          selectedObject.template.posfinalizationheadertemplate
          ? selectedObject.template.posfinalizationheadertemplate
          : '',
      authToken: '**********',
      authSecret: '**********',
      dummyAuthToken:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.auth_token
          ? selectedObject.gbpconfig.auth_token
          : '',
      dummyAuthSecret:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.auth_secret
          ? selectedObject.gbpconfig.auth_secret
          : '',
      paymentType: selectedObject && selectedObject.selected_paymentgatway,
      merchant_id:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.merchant_id
          ? selectedObject.gbpconfig.merchant_id
          : '',
      hpp_identifier:
        selectedObject &&
          selectedObject.gbpconfig &&
          selectedObject.gbpconfig.hpp_identifier
          ? selectedObject.gbpconfig.hpp_identifier
          : '',
      preferLanguage: selectedObject && selectedObject.preferred_language,
      is_otp_login: selectedObject && selectedObject.is_otp_login,
      is_enroll_now: selectedObject && selectedObject.is_enroll_now,
      enrollment_v2_enabled:
        selectedObject && selectedObject.enrollment_v2_enabled !== undefined
          ? selectedObject.enrollment_v2_enabled
          : true,
      hide_new_ui:
        selectedObject &&
        selectedObject.hide_new_ui !== undefined &&
        selectedObject.hide_new_ui !== null
          ? [true, 'true', 1, '1'].includes(selectedObject.hide_new_ui)
          : true,
      is_mfa_required: selectedObject && selectedObject.is_mfa_required,
      allow_member_or_record_number: selectedObject && selectedObject.allow_member_or_record_number,
      allow_offline_payment_skip: selectedObject && selectedObject.allow_offline_payment_skip,
      is_numeric_code: selectedObject && selectedObject.is_numeric_code,
      is_future_release: selectedObject && selectedObject.is_future_release,
      is_pre_assignment: selectedObject && selectedObject.is_pre_assignment,
      liberty_customer_username: selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_customer_username,
      liberty_customer_password: selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_customer_password,
      liberty_rx_regrx: selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_rx_regrx,
      liberty_completion_status:
        (selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_completion_status) ||
        DEFAULT_LIBERTY_COMPLETION_STATUS,
      third_party_token: selectedObject && selectedObject.connection_details && selectedObject.connection_details.third_party_token,
      vendor_unique_id: selectedObject && selectedObject.connection_details && selectedObject.connection_details.vendor_unique_id,
      purge_patient_images_toggle: selectedObject && selectedObject.purge_patient_images_toggle,
      purge_patient_images_days_count: selectedObject && selectedObject.purge_patient_images_days_count,
      selectedHours: (selectedObject && selectedObject.time_to_notify) || '09',
      patient_consent: selectedObject && selectedObject.patient_consent,
      is_consultation_notification: selectedObject && selectedObject.is_consultation_notification,
      is_taxable: selectedObject && selectedObject.is_taxable,
      is_permission_inheritable: selectedObject && selectedObject.is_permission_inheritable,
      selectedTaxCode: selectedObject && selectedObject.tax_data && [0, 1, 2, 3].includes(selectedObject.tax_data.tax_code) ? selectedObject.tax_data.tax_code : -1,
      taxRate: selectedObject && selectedObject.tax_data && selectedObject.tax_data.tax_rate ? selectedObject.tax_data.tax_rate : '',
      store_ncp_id: selectedObject && selectedObject.store_ncp_id,
      advance_fills:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.advance_fills,
      signature_flags_test_mode:
        selectedObject && selectedObject.signature_flags_test_mode,
      signature_flags_test_config:
        (selectedObject &&
          Array.isArray(selectedObject.signature_flags_test_config) &&
          selectedObject.signature_flags_test_config) ||
        [],
      hl_x_api_key:
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.hl_x_api_key,
      drx_key: selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.drx_key,
      tempUnit: selectedObject && selectedObject.temp_unit,
      screensaverRotationTime: selectedObject && selectedObject.screensaver_rotation_timing,
      external_id: selectedObject && selectedObject.external_id,
      securebadgeexpiryduration: selectedObject && selectedObject.securebadgeexpiryduration,
      vial_label_scan: selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.vial_label_scan,
      prevent_assigning_non_ready: [true, 'true'].includes(
        selectedObject &&
        selectedObject.connection_details &&
        selectedObject.connection_details.prevent_assigning_non_ready
      ),
      regexp: storedEpicRegexp(
        selectedObject && selectedObject.connection_details && selectedObject.connection_details.regexp,
        selectedObject && selectedObject.account_connections_id
      ),
      fill_number_api_fallback: [true, 'true'].includes(selectedObject && selectedObject.connection_details && selectedObject.connection_details.fill_number_api_fallback),
      bannerImg:  ![undefined,null,'undefined','null',''].includes(selectedObject.brand.banner_img) ? selectedObject.brand.banner_img : '',
      headerImg:  ![undefined,null,'undefined','null',''].includes(selectedObject.brand.header_img) ? selectedObject.brand.header_img : '',
      optical_expiration_days: ![undefined, 'undefined', null, 'null', ''].includes(selectedObject && selectedObject.optical_expiration_days) ? selectedObject && selectedObject.optical_expiration_days : '',
      text2pay_token_expiration_days: ![undefined, 'undefined', null, 'null', ''].includes(selectedObject && selectedObject.text2pay_token_expiration_days)
        ? parseInt(selectedObject.text2pay_token_expiration_days, 10) || 1
        : 1,
      optical_secure_badge_expiration: ![undefined, 'undefined', null, 'null', ''].includes(selectedObject && selectedObject.optical_secure_badge_expiration) ? selectedObject && selectedObject.optical_secure_badge_expiration : '',
      purge_patient_data_toggle: selectedObject && selectedObject.purge_patient_data_toggle,
      purge_patient_data_days_count: selectedObject && selectedObject.purge_patient_data_days_count,
      calculate_tax: selectedObject && selectedObject.connection_details && selectedObject.connection_details.calculate_tax,
      basic_first_name: selectedObject && selectedObject.basic_first_name,
      basic_last_name: selectedObject && selectedObject.basic_last_name,
      is_dob_optional: [true, 'true', 1, '1'].includes(selectedObject && selectedObject.is_dob_optional),
      drx_host: selectedObject && selectedObject.connection_details && selectedObject.connection_details.drx_host,
      cascade_account_update: selectedObject && selectedObject.cascade_account_update,
      is_need_help_enabled: selectedObject && selectedObject.is_need_help_enabled !== undefined ? selectedObject.is_need_help_enabled : true,
      is_auto_logout_enabled:
        selectedObject && selectedObject.is_auto_logout_enabled !== undefined
          ? selectedObject.is_auto_logout_enabled === true || selectedObject.is_auto_logout_enabled === 'true'
          : false,
      prx_xapi_key: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_xapi_key,
      prx_client_identifier: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_client_identifier,
      prx_client_id: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_client_id,
      prx_client_secret: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_client_secret,
      prx_endoint: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_endoint,
      prx_memberid: selectedObject && selectedObject.connection_details && selectedObject.connection_details.prx_memberid,
    });
    this.handleContextClose(event);
  };

  handleSearchChange = (event) => {
    let searchtxt = '';
    searchtxt = event.target.value;
    this.setState({ searchtext: event.target.value });
    FilterObj.sortOrder = 'desc';
    FilterObj.sortColumn = 'created_on';
    FilterObj.tableName = '';
    if (searchtxt.length >= 3) {
      FilterObj.searchtext = searchtxt;
      this.BindBoxes();
    } else if (searchtxt.length === 0) {
      FilterObj.searchtext = '';
      this.BindBoxes();
    }
  };

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = async (event) => {
    if (this.state.selectedRowId) {
      const outcome = await this.handleDelete(event);
      if (!outcome.success) {
        toast.error(outcome.message || this.props.t('Toast.Error.Generic'));
        return;
      }
    } else {
      const outcome = await this.deleteUsers(event);
      if (!outcome.success) {
        toast.error(outcome.message || this.props.t('Toast.Error.Generic'));
        return;
      }
    }
    this.setState({ deleteDialogOpen: false });
    toast.success(this.props.t('Toast.Success.AccountRemoved'));
  };

  handleDelete = (event) => {
    const rowIdToDelete = this.state.selectedRowId;
    return fetch(
      process.env.REACT_APP_BASEURL + 'accounts/' + rowIdToDelete,
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then(async (response) => {
        let accountName = '';
        if (![null, undefined, '', 'undefined'].includes(this.state.forDeletion)) {
          accountName = this.state.forDeletion[0].name;
        }
        if (!response.ok) {
          let message = 'Failed to delete account.';
          try {
            const body = await response.json();
            if (body && body.message) message = body.message;
          } catch (_) {}
          this.writeAuditLog(
            `User attempted to delete account '${accountName || rowIdToDelete}' but deletion was blocked or failed: ${message}.`
          );
          return { success: false, message };
        }
        this.handleContextClose(event);
        const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);
        this.setState({
          data: JSON.parse(JSON.stringify(newData)),
          selected: [],
          selectedRowId: null,
        });
        this.writeAuditLog(`'${accountName || rowIdToDelete}' account has been deleted by user.`);
        this.handleContextClose(event);
        return { success: true };
      })
      .catch(() => {
        let accountName = '';
        if (![null, undefined, '', 'undefined'].includes(this.state.forDeletion)) {
          accountName = this.state.forDeletion[0].name;
        }
        this.writeAuditLog(
          `User attempted to delete account '${accountName || rowIdToDelete}' but deletion failed (network or server error).`
        );
        return {
          success: false,
          message: this.props.t('Toast.Error.Generic') || 'Failed to delete account.',
        };
      });
  };

  validateBottomSlider = () => {
    let errorArray = [];
    if (this.state && this.state.AdvancedAdvertise === true) {
      if (this.state && this.state.BottomAdv1Preview === null) {
        let _bottomAdv1Element = document.getElementById('BottomAdv1dropzone');
        _bottomAdv1Element.style.border = '1px solid red';
        this.setState({ bottomAdvSlider1ErrorFlag: true });
        let errorObj = {
          Message: 'First bottom slider advertisement must required!',
        };
        errorArray.push(errorObj);
      }
      if (this.state && this.state.BottomAdv2Preview === null) {
        let _bottomAdv2Element = document.getElementById('BottomAdv2dropzone');
        _bottomAdv2Element.style.border = '1px solid red';
        this.setState({ bottomAdvSlider2ErrorFlag: true });
        let errorObj = {
          Message: 'Second bottom slider advertisement must required!',
        };
        errorArray.push(errorObj);
      }
      if (this.state && this.state.BottomAdv3Preview === null) {
        let _bottomAdv3Element = document.getElementById('BottomAdv3dropzone');
        _bottomAdv3Element.style.border = '1px solid red';
        this.setState({ bottomAdvSlider3ErrorFlag: true });
        let errorObj = {
          Message: 'Third bottom slider advertisement must required!',
        };
        errorArray.push(errorObj);
      }
      if (this.state && this.state.videoPreview === null) {
        let _videoAdvPreview = document.getElementById('videoAdvPreview');
        _videoAdvPreview.style.border = '1px solid red';
        this.setState({ videoAdvErrorFlag: true });
        let errorObj = {
          Message: 'Video advertisement must required!',
        };
        errorArray.push(errorObj);
      }
    }
    return errorArray;
  };

  inheritPermissionsFromParent = async (accountId, parentAccountId) => {
    const data = JSON.stringify({
      accountId,
      parentAccountId,
    });

    const res = await fetch(process.env.REACT_APP_BASEURL + 'inheritPermissions', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      },
      body: data,
    })
    const result = await res.json();

    if (result.success) {
      toast.success("Permissions pushed successfully.");

      const parentAccount = this.state.accountValues.length > 0 && this.state.accountValues.find(acc => acc.value.toString() === parentAccountId.toString());
      const childAccount = this.state.accountValues.length > 0 && this.state.accountValues.find(acc => acc.value.toString() === accountId.toString());
      const parentLabel = parentAccount ? `${parentAccount.label} (${parentAccount.value})` : parentAccountId;
      const childLabel = childAccount ? `${childAccount.label} (${childAccount.value})` : accountId;

      this.writeAuditLog(
        `Permission is pushed from ${parentLabel} to ${childLabel}.`
      );
    } else {
      toast.error("Failed to push permissions.");
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ innerLoader: true });
    this.setState({ isButtonDisabled: true });
    let elms;
    let input;
    if (document && document.getElementById('avatardropzone')) {
      elms = document
        .getElementById('avatardropzone')
        .getElementsByTagName('*');
      input = elms[1];
    }
    let elms1;
    let input1;
    if (document && document.getElementById('Adv1dropzone')) {
      elms1 = document.getElementById('Adv1dropzone').getElementsByTagName('*');
      input1 = elms1[1];
    }
    let elms2;
    let input2;
    if (document && document.getElementById('Adv2dropzone')) {
      elms2 = document.getElementById('Adv2dropzone').getElementsByTagName('*');
      input2 = elms2[1];
    }
    let elms3;
    let input3;
    if (document && document.getElementById('Adv3dropzone')) {
      elms3 = document.getElementById('Adv3dropzone').getElementsByTagName('*');
      input3 = elms3[1];
    }
    let elms4;
    let input4;
    if (document && document.getElementById('brndLogodropzone')) {
      elms4 = document
        .getElementById('brndLogodropzone')
        .getElementsByTagName('*');
      input4 = elms4[1];
    }
    let elms5;
    let input5;
    if (document && document.getElementById('videodropzone')) {
      elms5 = document
        .getElementById('videodropzone')
        .getElementsByTagName('*');
      input5 = elms5[1];
    }
    let elem6;
    let input6;
    if (document && document.getElementById('closedimgdropzone')) {
      elem6 = document
        .getElementById('closedimgdropzone')
        .getElementsByTagName('*');
      input6 = elem6[1];
    }
    let elems7;
    let input7;
    if (document && document.getElementById('Hippadropzone')) {
      elems7 = document
        .getElementById('Hippadropzone')
        .getElementsByTagName('*');
      input7 = elems7[1];
    }
    let elems8;
    let input8;
    if (document && document.getElementById('LegalConsentdropzone')) {
      elems8 = document
        .getElementById('LegalConsentdropzone')
        .getElementsByTagName('*');
      input8 = elems8[1];
    }
    let elems9;
    let input9;
    if (document && document.getElementById('Otherdropzone')) {
      elems9 = document
        .getElementById('Otherdropzone')
        .getElementsByTagName('*');
      input9 = elems9[1];
    }
    let bottmAd1elms;
    let inputbottmAd1elms;
    if (document && document.getElementById('BottomAdv1dropzone')) {
      bottmAd1elms = document
        .getElementById('BottomAdv1dropzone')
        .getElementsByTagName('*');
      inputbottmAd1elms = bottmAd1elms[1];
    }
    let bottmAd2elms;
    let inputbottmAd2elms;
    if (document && document.getElementById('BottomAdv2dropzone')) {
      bottmAd2elms = document
        .getElementById('BottomAdv2dropzone')
        .getElementsByTagName('*');
      inputbottmAd2elms = bottmAd2elms[1];
    }
    let bottmAd3elms;
    let inputbottmAd3elms;
    if (document && document.getElementById('BottomAdv3dropzone')) {
      bottmAd3elms = document
        .getElementById('BottomAdv3dropzone')
        .getElementsByTagName('*');
      inputbottmAd3elms = bottmAd3elms[1];
    }
    // let elems10 = document.getElementById("ETdropzone").getElementsByTagName("*");
    // let input10 = elems10[1];
    const _validateBottomSlider = this.validateBottomSlider();
    if (_validateBottomSlider.length > 0) {
      let _parentBottomSliderContainer = document.getElementById(
        'bottomContainer'
      );
      _parentBottomSliderContainer.scrollIntoView();
      this.setState({ innerLoader: false });
      this.setState({ isButtonDisabled: false });
      return;
    }

    var data = new FormData();
    if (input && input.files && input.files.length > 0) {
      data.append('avatar', input.files[0]);
    }
    if (input1 && input1.files && input1.files.length > 0) {
      data.append('ad1', input1.files[0]);
    }
    if (input2 && input2.files && input2.files.length > 0) {
      data.append('ad2', input2.files[0]);
    }
    if (input3 && input3.files && input3.files.length > 0) {
      data.append('ad3', input3.files[0]);
    }
    if (input4 && input4.files && input4.files.length > 0) {
      data.append('blogo', input4.files[0]);
    }
    if (input5 && input5.files && input5.files.length > 0) {
      data.append('vd', input5.files[0]);
    }
    if (input6 && input6.files && input6.files.length > 0) {
      data.append('cloesdimg', input6.files[0]);
    }
    if (input7 && input7.files && input7.files.length > 0) {
      data.append('hippa', input7.files[0]);
    }
    if (input8 && input8.files && input8.files.length > 0) {
      data.append('LC', input8.files[0]);
    }
    if (input9 && input9.files && input9.files.length > 0) {
      data.append('other', input9.files[0]);
    }
    if (
      inputbottmAd1elms &&
      inputbottmAd1elms.files &&
      inputbottmAd1elms.files.length > 0
    ) {
      data.append('bottomad1', inputbottmAd1elms.files[0]);
    }
    if (
      inputbottmAd2elms &&
      inputbottmAd2elms.files &&
      inputbottmAd2elms.files.length > 0
    ) {
      data.append('bottomad2', inputbottmAd2elms.files[0]);
    }
    if (
      inputbottmAd3elms &&
      inputbottmAd3elms.files &&
      inputbottmAd3elms.files.length > 0
    ) {
      data.append('bottomad3', inputbottmAd3elms.files[0]);
    }
    // if(input10 && input10.files && input10.files.length > 0){
    //   data.append("ET",input10.files[0]);
    // }

    data.append('name', this.state.name);
    data.append('parent_id', this.state.parent_id);
    data.append('type_id', this.state.type_id);
    data.append('address1', this.state.address1);
    data.append('address2', this.state.address2);
    data.append('city', this.state.city);
    data.append('state', this.state.state);
    data.append('zip', this.state.zip);
    data.append('first_name', this.state.first_name);
    data.append('last_name', this.state.last_name);
    data.append('email', this.state.email);
    data.append('phone', this.state.phone);
    data.append('account_connections_id', this.state.accountConnectionsId);
    data.append('is_payment_required', this.state.isPaymentRequired);

    data.append('brandname', this.state.brandname);
    data.append('generalphone', this.state.generalphone);
    data.append('after_hour_phone', this.state.afterHourPhone);
    data.append('primary_color', this.state.primaryColor || '');
    data.append(
      'is_modern_email_enabled',
      this.state.is_modern_email_enabled ? 'true' : 'false'
    );
    data.append(
      'is_pickup_change_email_enabled',
      this.state.is_pickup_change_email_enabled ? 'true' : 'false'
    );
    data.append('website', this.state.web);
    data.append('fax', this.state.fax);
    data.append('generalemail', this.state.generalemail);
    // data.append("role_id",this.state.role_id);
    // data.append("permissions",JSON.stringify(this.state.CheckedPermissionSubCategory));
    data.append('contractLang', this.state.contractLang);
    // if(this.state.roles && this.state.roles.length > 0){
    //   data.append("roles", this.state.roles.map(x => x.id));
    // }
    //Added by Kishan | 04-Apr-2019
    data.append('demo_email', this.state.demo_email); //Added by Kishan
    data.append('demo_smsphone', this.state.demo_smsphone); //Added by Kishan
    data.append('Expiration_Day', this.state.day_id); //Added by Dhaval
    //Added by Kishan | 11-Apr-2019
    data.append(
      'endpoint',
      this.AssignEndPoint(this.state.accountConnectionsId, null)
    ); //Added by Kishan
    data.append('pharmacyid', this.state.pharmacyId); //Added by Kishan
    data.append('pick_up_reminder_day', this.state.pick_up_reminder_id); //Added by Naresh | Date:15-05-2019 |DI-87
    data.append('is_sunday', this.state.Sun);
    data.append('is_monday', this.state.Mon);
    data.append('is_tuesday', this.state.Tue);
    data.append('is_wednesday', this.state.Wed);
    data.append('is_thursday', this.state.Thu);
    data.append('is_friday', this.state.Fri);
    data.append('is_saturday', this.state.Sat);
    data.append('OpenTime', this.state.opentime);
    data.append('CloseTime', this.state.closetime);
    data.append('HopType', 'AccountLevel');
    data.append('closedMsg', this.state.closedMsg);
    data.append('Health_and_info', JSON.stringify(this.state.healthandinfo));
    data.append('primaryLibtitle1', this.state.primarylibrarytitle1);
    data.append('primaryLibtitle2', this.state.primarylibrarytitle2);
    data.append(
      'vendor_key',
      this.state.accountConnectionsId === CONNECTION_TYPE.LIBERTY_SOFTWARE
        ? (String(this.state.vendor_key || '').trim() || DEFAULT_LIBERTY_VENDOR_USERNAME)
        : this.state.vendor_key
    );
    data.append(
      'data_exchange_id',
      this.state.accountConnectionsId === CONNECTION_TYPE.LIBERTY_SOFTWARE
        ? (String(this.state.data_exchange_id || '').trim() || DEFAULT_LIBERTY_VENDOR_PASSWORD)
        : this.state.data_exchange_id
    );
    data.append('doc_one', this.state.docone);
    data.append('doc_two', this.state.doctwo);
    data.append('doc_three', this.state.docthree);
    data.append('helpLink', this.state.helpLink);
    data.append('privacyPolicyLink', this.state.privacyPolicyLink);
    data.append('termsAndConditionsLink', this.state.termsAndConditionsLink);
    data.append(
      'epicclientid',
      this.AssignEpicclientID(this.state.accountConnectionsId, null)
    );
    data.append(
      'epicusername',
      this.AssignEpicUserName(this.state.accountConnectionsId, null)
    );
    data.append(
      'epicpassword',
      this.AssignEpicUserPassword(this.state.accountConnectionsId, null)
    );
    data.append('is_advance_advertise', this.state.AdvancedAdvertise);
    data.append('xWebId', this.state.xWebId);
    data.append('auth_Key', this.state.auth_Key);
    data.append('terminalId', this.state.terminalId);
    data.append('fiserv_link_username', this.state.fiserv_link_username);
    data.append('fiserv_link_password', this.state.fiserv_link_password);
    data.append('fiserv_terminal_api_key', this.state.fiserv_terminal_api_key);
    data.append('trustcommerce_link_custid', this.state.trustcommerce_link_custid);
    data.append('trustcommerce_link_password', this.state.trustcommerce_link_password);
    data.append('trustcommerce_terminal_custid', this.state.trustcommerce_terminal_custid);
    data.append('trustcommerce_terminal_password', this.state.trustcommerce_terminal_password);
    data.append('trustcommerce_aggregator1', this.state.trustcommerce_aggregator1);
    data.append('trustcommerce_aggregators', this.state.trustcommerce_aggregators);
    data.append('instamed_account_id', this.state.instamed_account_id);
    data.append('instamed_account_id_suffix', this.state.instamed_account_id_suffix);
    data.append('instamed_connect_user_id', this.state.instamed_connect_user_id);
    data.append('instamed_connect_password', this.state.instamed_connect_password);
    data.append('instamed_api_key', this.state.instamed_api_key);
    data.append('instamed_api_secret', this.state.instamed_api_secret);
    data.append('instamed_sso_security_key', this.state.instamed_sso_security_key);
    data.append('allow_payment', this.state.allow_payment);
    data.append('epicPharmacyNcpdpId', this.state.epicPharmacyNcpdpId || '');
    data.append('epicEndpointVersion', this.state.epicEndpointVersion || '');
    data.append('epicRequestTempate', this.state.epicRequestTempate || '');
    data.append('allow_consult_video', this.state.allow_consult_video);
    data.append('allow_consult_mobile', this.state.allow_consult_mobile);
    data.append('allow_consult_schedule', this.state.allow_consult_schedule);
    data.append(
      'isContactLessPickupEnabled',
      this.state.isContactLessPickupEnabled
    );
    data.append(
      'accContactPersons',
      JSON.stringify(this.state && this.state.accContactPersons)
    );
    data.append('medbank_dblogin', this.state.medbank_dblogin);
    data.append('medbank_db_password', this.state.medbank_db_password);
    data.append(
      'opc_apim_subscription_key',
      this.state.opc_apim_subscription_key
    );
    data.append('x_api_key', this.state.x_api_key);
    data.append('gateway_api_key', this.state.gateway_api_key);
    data.append('client_identifier', this.state.client_identifier);
    data.append('is_marketplace', this.state.is_marketplace);
    data.append('IsGetReady', this.state.IsGetReady);
    data.append('random_id', this.state.random_key);
    data.append('is_consult_required', this.state.isConsultRequired);
    data.append('consult_key', this.state.epicConsultKey);
    data.append('active_patient', true);
    data.append('login_type', this.state.loginType);
    data.append('issuer', this.state.ssoIssuer);
    data.append('email_domain', this.state.emailDomain);
    data.append('client_id', this.state.clientId);
    data.append('oidc_cert', JSON.stringify(this.state.oidcCert));
    data.append('sso_entry_point', this.state.ssoEntryPoint);
    data.append('bypass_consult', this.state.isConsultRequire);
    data.append('StartGraphic', this.state.StartGraphic);
    data.append('IsPatientPrimarySource', this.state.IsPatientPrimarySource);
    data.append(
      'accountHoursOfOperations',
      JSON.stringify(this.state.AccountHoursOfOperaionsArray)
    );
    data.append('autoDisabledUser', this.state.autoDisabledUser);
    data.append('useDefaultEmail', this.state.useDefaultEmail);
    data.append('is_dispense_safety_check', this.state.is_dispense_safety_chek);
    data.append('is_forgot_mypucode', this.state.is_forgot_mypucode);
    data.append('is_mask_kiosk_dob', this.state.is_mask_kiosk_dob);
    data.append('timezone', this.state.time_zone);
    data.append(
      'store_number',
      this.AssignMckssoRERx(this.state.accountConnectionsId, null)
    );
    data.append(
      'mcKessoneRXrequestTemplate',
      this.state.mcKessoneRXrequestTemplate || ''
    );
    data.append('binaryToken', this.state.binaryToken);
    data.append(
      'issuerMc',
      this.AssignMckessonRxIssuer(this.state.accountConnectionsId, null)
    );
    data.append(
      'cfrheadertemplate',
      this.AssignCFRHeaderTempleteValue(this.state.accountConnectionsId, null)
    );
    data.append(
      'rxinfobodytemplate',
      this.AssignRxInfoTemplateValue(this.state.accountConnectionsId, null)
    );
    data.append(
      'rxinfoheadertemplate',
      this.AssignRxInfoHeaderTempleteValue(
        this.state.accountConnectionsId,
        null
      )
    );
    data.append(
      'posfinalizationbodytemplate',
      this.AssignPOSFinalizationBodyTempleteValue(
        this.state.accountConnectionsId,
        null
      )
    );
    data.append(
      'posfinalizationheadertemplate',
      this.AssignPOSFinalizationHeaderTempleteValue(
        this.state.accountConnectionsId,
        null
      )
    );
    data.append('paymentType', this.state.paymentType);
    data.append('merchant_id', this.state.merchant_id);
    data.append('hpp_identifier', this.state.hpp_identifier);
    data.append('preferredlanguage', this.state.preferLanguage);
    data.append('is_otp_login', this.state.is_otp_login);
    data.append('is_enroll_now', this.state.is_enroll_now);
    data.append('enrollment_v2_enabled', this.state.enrollment_v2_enabled);
    data.append('hide_new_ui', this.state.hide_new_ui);
    data.append('is_mfa_required', this.state.is_mfa_required);
    data.append('allow_member_or_record_number', this.state.allow_member_or_record_number);
    data.append('allow_offline_payment_skip', this.state.allow_offline_payment_skip);
    data.append('is_numeric_code', this.state.is_numeric_code);
    data.append('is_future_release', this.state.is_future_release);
    data.append('liberty_customer_username', this.state.liberty_customer_username);
    data.append('liberty_customer_password', this.state.liberty_customer_password);
    data.append('liberty_rx_regrx', this.state.liberty_rx_regrx);
    data.append('liberty_completion_status', this.state.liberty_completion_status || DEFAULT_LIBERTY_COMPLETION_STATUS);
    data.append('third_party_token', this.state.third_party_token);
    data.append('vendor_unique_id', this.state.vendor_unique_id);
    data.append('purge_patient_images_toggle', this.state.purge_patient_images_toggle);
    data.append('purge_patient_images_days_count', this.state.purge_patient_images_days_count)
    data.append('time_to_notify', (this.state && this.state.selectedHours) || '09')
    data.append('patient_consent',this.state.patient_consent);
    data.append('is_pre_assignment', this.state.is_pre_assignment);
    data.append('is_consultation_notification', this.state.is_consultation_notification);
    data.append('is_taxable', this.state.is_taxable);
    data.append('is_permission_inheritable', this.state.is_permission_inheritable);
    data.append('tax_code', this.state.selectedTaxCode);
    data.append('tax_rate', this.state.taxRate);
    data.append('store_ncp_id', this.state.store_ncp_id);
    data.append('advance_fills', this.state.advance_fills);
    data.append('kiosk_hoursof_operations',JSON.stringify(this.state.KioskHoursOfOperaionsArray));
    data.append('hl_x_api_key', this.state.hl_x_api_key);
    data.append('drx_key', this.state.drx_key);
    data.append('lunch_start',this.state.lunchStart);
    data.append('lunch_end',this.state.lunchEnd);
    data.append('temp_unit',this.state.tempUnit);
    data.append('screensaver_rotation_timing', this.state.screensaverRotationTime);
    data.append('external_id', this.state.external_id);
    data.append('securebadgeexpiryduration', this.state.securebadgeexpiryduration);
    data.append('vial_label_scan', this.state.vial_label_scan);
    data.append('prevent_assigning_non_ready', this.state.prevent_assigning_non_ready === true);
    data.append(
      'regexp',
      this.state.accountConnectionsId === CONNECTION_TYPE.EPIC
        ? resolveEpicScanRegexp(this.state.regexp)
        : (this.state.regexp || '')
    );
    data.append('fill_number_api_fallback', this.state.fill_number_api_fallback === true);
    data.append('optical_expiration_days', this.state.optical_expiration_days);
    data.append('text2pay_token_expiration_days', this.state.text2pay_token_expiration_days || 1);
    data.append('optical_secure_badge_expiration', this.state.optical_secure_badge_expiration);
    data.append('purge_patient_data_toggle', this.state.purge_patient_data_toggle);
    data.append('purge_patient_data_days_count', this.state.purge_patient_data_days_count);
    data.append('calculate_tax', this.state.calculate_tax);
    data.append('signature_flags_test_mode', this.state.signature_flags_test_mode);
    data.append(
      'signature_flags_test_config',
      Array.isArray(this.state.signature_flags_test_config)
        ? JSON.stringify(this.state.signature_flags_test_config)
        : '[]',
    );
    data.append('basic_first_name', this.state.basic_first_name);
    data.append('basic_last_name', this.state.basic_last_name);
    data.append('is_dob_optional', this.state.is_dob_optional);
    data.append('drx_host', this.state.drx_host);
    data.append('cascade_account_update', this.state.cascade_account_update);
    data.append('is_need_help_enabled', this.state.is_need_help_enabled);
    data.append('is_auto_logout_enabled', this.state.is_auto_logout_enabled);
    data.append('prx_xapi_key', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_xapi_key) ? '' : this.state.prx_xapi_key);
    data.append('prx_client_identifier', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_client_identifier) ? '' : this.state.prx_client_identifier);
    data.append('prx_client_id', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_client_id) ? '' : this.state.prx_client_id);
    data.append('prx_client_secret', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_client_secret) ? '' : this.state.prx_client_secret);
    data.append('prx_endoint', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_endoint) ? '' : this.state.prx_endoint);
    data.append('prx_memberid', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_memberid) ? '' : this.state.prx_memberid);
    if (this.state.type_id === null) {
      toast.error(this.props.t('Toast.Error.AccountTypeRequired'));
      this.setState({ loader: false, isButtonDisabled: false });
      return;
    }

    let isAccountAvailable = false;

    let objAvailability = {
      accountName: this.state && this.state.name,
    };

    fetch(process.env.REACT_APP_BASEURL + 'CheckAccountAvailability', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(objAvailability),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        let availabilityParsed = JSON.parse(res);
        isAccountAvailable = availabilityParsed.IsAvailable;
        if (isAccountAvailable === 'true' || isAccountAvailable === true) {
          const result = fetch(process.env.REACT_APP_BASEURL + 'accounts', {
            method: 'POST',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession
                  .idToken.jwtToken,
            },
            body: data,
          });
          result
            .then((result) => {
              result.json().then(async (res) => {
                this.setState({ loader: false });
                if (res.error) {
                  this.setState({ isButtonDisabled: false, submitted: false });
                  res.message.includes('SSO Account already exist!')
                    ? this.setState({
                      errorMessage: res.message,
                      isSSOAccountExist: true,
                    })
                    : this.setState({
                      errorMessage: res.message,
                      isSSOAccountExist: false,
                    });
                  toast.error(res.message);
                } else {
                  this.state.data.unshift(res.account);
                  const newData = JSON.parse(JSON.stringify(this.state.data));
                  sessionStorage.setItem('timeZone', this.state.time_zone);
                  /* audit report log object */                  
                  let auditObj = {
                    name : this.state.name,
                    email : this.state.email,
                    parent_id : this.state.parent_id,
                    type_id : this.state.type_id,
                  };
                  if (!res.audit_recorded && !res.audit_failed_sections) this.writeAuditLog(`'${auditObj.name}' account created by user.`, auditObj);
                  /* audit report log object */
                  const accountId = res && res.account && res.account.id
                  const parentAccountId = res && res.account && res.account.parent_account_id
                  const isPermissionInheritable = res && res.account && res.account.is_permission_inheritable
                  if ([true, 'true'].includes(isPermissionInheritable)) {
                    await this.inheritPermissionsFromParent(accountId, parentAccountId)
                  }
                  this.setState({
                    isButtonDisabled: false,
                    innerLoader: false,
                    submitted: true,
                    showNewUserDialog: false,
                    user: {},
                    avatarPreview: null,
                    errorMessage: '',
                    data: newData,
                    accountConnectionsId: null,
                    isPaymentRequired: false,
                    accountConnectionsName: '',
                    demo_email: '',
                    demo_phone: '',
                    pharmacyId: '',
                    Sun: false,
                    Mon: false,
                    Tue: false,
                    Wed: false,
                    Thu: false,
                    Fri: false,
                    Sat: false,
                    value: 0,
                    healthandinfo: [],
                    primarylibrarytitle1: '',
                    primarylibrarytitle2: '',
                    HippaPreview: null,
                    LCPreview: null,
                    OtherPreview: null,
                    //ETPreview: null,
                    docone: '',
                    doctwo: '',
                    docthree: '',
                    helpLink: '',
                    privacyPolicyLink: '',
                    termsAndConditionsLink: '',
                    AdvancedAdvertise: false,
                    allow_consult_video: false,
                    allow_consult_mobile: false,
                    allow_consult_schedule: false,
                    accContactPersons: [],
                    searchtext: '',
                    selectedTaxCode: -1,
                    taxRate: '',
                    basic_first_name:'',
                    basic_last_name:'',
                    is_dob_optional: false,
                  });
                  FilterObj.searchtext = '';
                  FilterObj.sortOrder = 'desc';
                  FilterObj.sortColumn = 'created_on';
                  FilterObj.tableName = '';
                  if (res.save_outcome === 'partial') toast.warn('Some account settings were not saved: ' + (res.failed_sections || []).join(', '));
                  else toast.success(this.props.t('Toast.Success.AccountAdded'));
                  this.BindBoxes();
                }
                if(this.state.purge_patient_images_toggle === true) {
                  await this.callPurgeService()
                }
              });
            })
            .catch((error) => {
              this.setState({ loader: false });
              this.setState({ errorMessage: error.message });
            });
        } else {
          toast.error(this.props.t('Toast.Error.AccountExist'));
          this.setState({
            loader: false,
            isButtonDisabled: false,
            innerLoader: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .catch((error) => {
        this.setState({ innerLoader: false });
        this.setState({ isButtonDisabled: false });
        this.setState({ errorMessage: error.message });
        toast.error('' + error.message);
      });
  };

  handleChangeHelpLink = (event) => {
    this.setState({ helpLink: event.target.value });
  };
  handleChangePrivacyPolicyLink = (event) => {
    this.setState({ privacyPolicyLink: event.target.value });
  };
  handleChangeTermsAndConditionsLink = (event) => {
    this.setState({ termsAndConditionsLink: event.target.value });
  };

  updateChildrenAccounts = async (parentId) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BASEURL + 'cascadeAccountUpdate',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          },
          body: JSON.stringify({ parentId }),
        }
      );
  
      const result = await response.json();
  
      if (result.error) {
        toast.error('Failed to cascade updates to child accounts');
        return;
      }
  
      toast.success(`Child accounts updated successfully`);
      this.writeAuditLog(`Cascading update applied to child account from parent account ID ${parentId}`);
    } catch (err) {
      console.error("Error cascading child account updates:", err);
      toast.error("An error occurred while updating child accounts");
    }
  }
  
  handleUpdate = (event) => {
    event.preventDefault();
    // Validate Terms & Conditions slots using shared helper
    const areSlotsValid = areTermsAndConditionsSlotsValid({
      docone: this.state.docone,
      doctwo: this.state.doctwo,
      docthree: this.state.docthree,
      hippaPreview: this.state.HippaPreview,
      lcPreview: this.state.LCPreview,
      otherPreview: this.state.OtherPreview,
      account: this.state.account,
    });
    if (!areSlotsValid) {
      toast.error(this.props.t('Accounts.Terms.TitleAndDocumentBothOrNeither'));
      return;
    }
    this.setState({ innerLoader: true });
    this.setState({ isButtonDisabled: true });
    let elms;
    let input;
    if (document && document.getElementById('avatardropzone')) {
      elms = document
        .getElementById('avatardropzone')
        .getElementsByTagName('*');
      input = elms[1];
    }
    let elms1;
    let input1;
    if (document && document.getElementById('Adv1dropzone')) {
      elms1 = document.getElementById('Adv1dropzone').getElementsByTagName('*');
      input1 = elms1[1];
    }
    let elms2;
    let input2;
    if (document && document.getElementById('Adv2dropzone')) {
      elms2 = document.getElementById('Adv2dropzone').getElementsByTagName('*');
      input2 = elms2[1];
    }
    let elms3;
    let input3;
    if (document && document.getElementById('Adv3dropzone')) {
      elms3 = document.getElementById('Adv3dropzone').getElementsByTagName('*');
      input3 = elms3[1];
    }
    let elms4;
    let input4;
    if (document && document.getElementById('brndLogodropzone')) {
      elms4 = document
        .getElementById('brndLogodropzone')
        .getElementsByTagName('*');
      input4 = elms4[1];
    }
    let elms5;
    let input5;
    if (document && document.getElementById('videodropzone')) {
      elms5 = document
        .getElementById('videodropzone')
        .getElementsByTagName('*');
      input5 = elms5[1];
    }
    let elem6;
    let input6;
    if (document && document.getElementById('closedimgdropzone')) {
      elem6 = document
        .getElementById('closedimgdropzone')
        .getElementsByTagName('*');
      input6 = elem6[1];
    }
    let elems7;
    let input7;
    if (document && document.getElementById('Hippadropzone')) {
      elems7 = document
        .getElementById('Hippadropzone')
        .getElementsByTagName('*');
      input7 = elems7[1];
    }
    let elems8;
    let input8;
    if (document && document.getElementById('LegalConsentdropzone')) {
      elems8 = document
        .getElementById('LegalConsentdropzone')
        .getElementsByTagName('*');
      input8 = elems8[1];
    }
    let elems9;
    let input9;
    if (document && document.getElementById('Otherdropzone')) {
      elems9 = document
        .getElementById('Otherdropzone')
        .getElementsByTagName('*');
      input9 = elems9[1];
    }
    let bottmAd1elms;
    let inputbottmAd1elms;
    if (document && document.getElementById('BottomAdv1dropzone')) {
      bottmAd1elms = document
        .getElementById('BottomAdv1dropzone')
        .getElementsByTagName('*');
      inputbottmAd1elms = bottmAd1elms[1];
    }
    let bottmAd2elms;
    let inputbottmAd2elms;
    if (document && document.getElementById('BottomAdv2dropzone')) {
      bottmAd2elms = document
        .getElementById('BottomAdv2dropzone')
        .getElementsByTagName('*');
      inputbottmAd2elms = bottmAd2elms[1];
    }
    let bottmAd3elms;
    let inputbottmAd3elms;
    if (document && document.getElementById('BottomAdv3dropzone')) {
      bottmAd3elms = document
        .getElementById('BottomAdv3dropzone')
        .getElementsByTagName('*');
      inputbottmAd3elms = bottmAd3elms[1];
    }
    let input10;
    if (document && document.getElementById('bannerImg')) {
      let elms10 = document.getElementById('bannerImg').getElementsByTagName('*');
      input10 = elms10[1];
    }
    let input11;
    if (document && document.getElementById('headerImg')) {
      let elms11 = document.getElementById('headerImg').getElementsByTagName('*');
      input11 = elms11[1];
    }
    // let elems10 = document.getElementById("ETdropzone").getElementsByTagName("*");
    // let input10 = elems10[1];
    //var input = document.querySelector('input[type="file"]');
    const _validateBottomSlider = this.validateBottomSlider();
    if (_validateBottomSlider.length > 0) {
      let _parentBottomSliderContainer = document.getElementById(
        'bottomContainer'
      );
      _parentBottomSliderContainer.scrollIntoView();
      this.setState({ innerLoader: false });
      this.setState({ isButtonDisabled: false });
      return;
    }
    var data = new FormData();
    //data.append("file", input.files[0] || this.state.account.picture_url);
    if (input && input.files && input.files.length > 0) {
      data.append('avatar', input.files[0]);
    } else if (imgFile && imgFile.name === 'removeavtar') {
      data.append('avatar', '');
    } else {
      data.append('avatar', this.state.account.picture_url);
    }
    if (input1 && input1.files && input1.files.length > 0) {
      data.append('ad1', input1.files[0]);
    } else if (AD1 && AD1.name === 'removeAD1') {
      data.append('ad1', '');
    } else {
      data.append('ad1', this.state.Adv1Preview);
    }
    if (input2 && input2.files && input2.files.length > 0) {
      data.append('ad2', input2.files[0]);
    } else if (AD2 && AD2.name === 'removeAD2') {
      data.append('ad2', '');
    } else {
      data.append('ad2', this.state.Adv2Preview);
    }
    if (input3 && input3.files && input3.files.length > 0) {
      data.append('ad3', input3.files[0]);
    } else if (AD3 && AD3.name === 'removeAD3') {
      data.append('ad3', '');
    } else {
      data.append('ad3', this.state.Adv3Preview);
    }
    if (input4 && input4.files && input4.files.length > 0) {
      data.append('blogo', input4.files[0]);
    } else if (BDLOGO && BDLOGO.name === 'removeBDLOGO') {
      data.append('blogo', '');
    } else {
      data.append('blogo', this.state.account.brand.logo_url);
    }
    if (input5 && input5.files && input5.files.length > 0) {
      data.append('vd', input5.files[0]);
    } else if (VD && VD.name === 'removeVD') {
      data.append('vd', '');
    } else {
      data.append('vd', this.state.videoPreview);
    }
    if (input6 && input6.files && input6.files.length > 0) {
      data.append('cloesdimg', input6.files[0]);
    } else if (CLOSEDIMG && CLOSEDIMG.name === 'removeclosedimg') {
      data.append('cloesdimg', '');
    } else {
      data.append('cloesdimg', this.state.closedimgPreview);
    }
    if (input7 && input7.files && input7.files.length > 0) {
      data.append('hippa', input7.files[0]);
    } else if (HIPPA && HIPPA.name === 'removeHippa') {
      data.append('hippa', HIPPA[0]);
    } else {
      data.append('hippa', this.state.HippaPreview);
    }
    if (input8 && input8.files && input8.files.length > 0) {
      data.append('LC', input8.files[0]);
    } else if (LC && LC.name === 'removeLC') {
      data.append('LC', LC[0]);
    } else {
      data.append('LC', this.state.LCPreview);
    }
    if (input9 && input9.files && input9.files.length > 0) {
      data.append('other', input9.files[0]);
    } else if (OTHER && OTHER.name === 'removeOther') {
      data.append('other', OTHER[0]);
    } else {
      data.append('OTHER', this.state.OtherPreview);
    }
    if (
      inputbottmAd1elms &&
      inputbottmAd1elms.files &&
      inputbottmAd1elms.files.length > 0
    ) {
      data.append('bottomad1', inputbottmAd1elms.files[0]);
    } else if (BOTTOMAD1 && BOTTOMAD1.name === 'BottomAdv1dropzone') {
      data.append('bottomad1', BOTTOMAD1[0]);
    } else {
      data.append('bottomad1', this.state.BottomAdv1Preview);
    }
    if (
      inputbottmAd2elms &&
      inputbottmAd2elms.files &&
      inputbottmAd2elms.files.length > 0
    ) {
      data.append('bottomad2', inputbottmAd2elms.files[0]);
    } else if (BOTTOMAD2 && BOTTOMAD2.name === 'BottomAdv2dropzone') {
      data.append('bottomad2', BOTTOMAD2[0]);
    } else {
      data.append('bottomad2', this.state.BottomAdv2Preview);
    }
    if (
      inputbottmAd3elms &&
      inputbottmAd3elms.files &&
      inputbottmAd3elms.files.length > 0
    ) {
      data.append('bottomad3', inputbottmAd3elms.files[0]);
    } else if (BOTTOMAD3 && BOTTOMAD3.name === 'BottomAdv3dropzone') {
      data.append('bottomad3', BOTTOMAD3[0]);
    } else {
      data.append('bottomad3', this.state.BottomAdv3Preview);
    }
    if (input10 && input10.files && input10.files.length > 0) {
      data.append('bannerImg', input10.files[0]);
    } else if (banner && banner.name === 'removeBanner') {
      data.append('bannerImg', '');
    } else {
      data.append('bannerImg', this.state.account.brand.banner_img);
    }
    if (input11 && input11.files && input11.files.length > 0) {
      data.append('headerImg', input11.files[0]);
    } else if (header && header.name === 'removeHeader') {
      data.append('headerImg', '');
    } else {
      data.append('headerImg', this.state.account.brand.header_img);
    }
    //   if(input10 && input10.files && input10.files.length > 0){
    //     data.append("ET",input10.files[0]);
    // }
    // else if(ET && ET.name === 'removeET'){
    //     data.append("ET", ET[0]);
    // }
    // else{
    //     data.append("ET", this.state.ETPreview);
    // }

    data.append('id', this.state.account.id);
    data.append('brand_id', this.state.account.brand_id);
    data.append('name', this.state.name);
    data.append('parent_id', this.getParentIdForSave());
    data.append('type_id', this.state.type_id);
    data.append('address1', this.state.address1);
    data.append('address2', this.state.address2);
    data.append('city', this.state.city);
    data.append('state', this.state.state);
    data.append('zip', this.state.zip);
    data.append('first_name', this.state.first_name);
    data.append('last_name', this.state.last_name);
    data.append('email', this.state.email);
    data.append('phone', this.state.phone);
    data.append('brandname', this.state.brandname);
    data.append('generalphone', this.state.generalphone);
    data.append('after_hour_phone', this.state.afterHourPhone);
    data.append('primary_color', this.state.primaryColor || '');
    data.append(
      'is_modern_email_enabled',
      this.state.is_modern_email_enabled ? 'true' : 'false'
    );
    data.append(
      'is_pickup_change_email_enabled',
      this.state.is_pickup_change_email_enabled ? 'true' : 'false'
    );
    data.append('website', this.state.web);
    data.append('fax', this.state.fax);
    data.append('generalemail', this.state.generalemail);
    data.append('account_connections_id', this.state.accountConnectionsId);
    data.append('is_payment_required', this.state.isPaymentRequired);
    // data.append("role_id",this.state.role_id);
    // data.append("permissions",JSON.stringify(this.state.CheckedPermissionSubCategory));
    data.append('contractLang', this.state.contractLang);
    data.append('demo_email', this.state.demo_email); //Added by Kishan
    data.append('demo_smsphone', this.state.demo_smsphone); //Added by Kishan
    data.append('Expiration_Day', this.state.day_id); //Added by Dhaval
    //Added by Kishan | 11-Apr-2019
    data.append(
      'endpoint',
      this.AssignEndPoint(this.state.accountConnectionsId, null)
    ); //Added by Kishan
    data.append('pharmacyid', this.state.pharmacyId); //Added by Kishan
    data.append('pick_up_reminder_day', this.state.pick_up_reminder_id); //Added by Naresh | Date:15-05-2019 |DI-87
    data.append('is_sunday', this.state.Sun);
    data.append('is_monday', this.state.Mon);
    data.append('is_tuesday', this.state.Tue);
    data.append('is_wednesday', this.state.Wed);
    data.append('is_thursday', this.state.Thu);
    data.append('is_friday', this.state.Fri);
    data.append('is_saturday', this.state.Sat);
    data.append('OpenTime', this.state.opentime);
    data.append('CloseTime', this.state.closetime);
    data.append('HopType', 'AccountLevel');
    data.append('closedMsg', this.state.closedMsg);
    data.append('Health_and_info', JSON.stringify(this.state.healthandinfo));
    data.append('primaryLibtitle1', this.state.primarylibrarytitle1);
    data.append('primaryLibtitle2', this.state.primarylibrarytitle2);
    data.append(
      'vendor_key',
      this.state.accountConnectionsId === CONNECTION_TYPE.LIBERTY_SOFTWARE
        ? (String(this.state.vendor_key || '').trim() || DEFAULT_LIBERTY_VENDOR_USERNAME)
        : this.state.vendor_key
    );
    data.append(
      'data_exchange_id',
      this.state.accountConnectionsId === CONNECTION_TYPE.LIBERTY_SOFTWARE
        ? (String(this.state.data_exchange_id || '').trim() || DEFAULT_LIBERTY_VENDOR_PASSWORD)
        : this.state.data_exchange_id
    );
    data.append('doc_one', this.state.docone);
    data.append('doc_two', this.state.doctwo);
    data.append('doc_three', this.state.docthree);
    data.append('helpLink', this.state.helpLink);
    data.append('privacyPolicyLink', this.state.privacyPolicyLink);
    data.append('termsAndConditionsLink', this.state.termsAndConditionsLink);
    data.append(
      'epicclientid',
      this.AssignEpicclientID(this.state.accountConnectionsId, null)
    );
    data.append(
      'epicusername',
      this.AssignEpicUserName(this.state.accountConnectionsId, null)
    );
    data.append(
      'epicpassword',
      this.AssignEpicUserPassword(this.state.accountConnectionsId, null)
    );
    data.append('is_advance_advertise', this.state.AdvancedAdvertise);
    data.append('xWebId', this.state.dummyxWebId);
    data.append('auth_Key', this.state.dummyauthKey);
    data.append('terminalId', this.state.dummyterminalId);
    data.append('fiserv_link_username', this.state.fiserv_link_username);
    data.append('fiserv_link_password', this.state.fiserv_link_password);
    data.append('fiserv_terminal_api_key', this.state.fiserv_terminal_api_key);
    data.append('trustcommerce_link_custid', this.state.trustcommerce_link_custid);
    data.append('trustcommerce_link_password', this.state.trustcommerce_link_password);
    data.append('trustcommerce_terminal_custid', this.state.trustcommerce_terminal_custid);
    data.append('trustcommerce_terminal_password', this.state.trustcommerce_terminal_password);
    data.append('trustcommerce_aggregator1', this.state.trustcommerce_aggregator1);
    data.append('trustcommerce_aggregators', this.state.trustcommerce_aggregators);
    data.append('instamed_account_id', this.state.instamed_account_id);
    data.append('instamed_account_id_suffix', this.state.instamed_account_id_suffix);
    data.append('instamed_connect_user_id', this.state.instamed_connect_user_id);
    data.append('instamed_connect_password', this.state.instamed_connect_password);
    data.append('instamed_api_key', this.state.instamed_api_key);
    data.append('instamed_api_secret', this.state.instamed_api_secret);
    data.append('instamed_sso_security_key', this.state.instamed_sso_security_key);
    data.append('allow_payment', this.state.allow_payment);
    data.append('epicPharmacyNcpdpId', this.state.epicPharmacyNcpdpId || '');
    data.append('epicEndpointVersion', this.state.epicEndpointVersion || '');
    data.append('epicRequestTempate', this.state.epicRequestTempate || '');
    data.append('allow_consult_video', this.state.allow_consult_video);
    data.append('allow_consult_mobile', this.state.allow_consult_mobile);
    data.append('allow_consult_schedule', this.state.allow_consult_schedule);
    data.append(
      'isContactLessPickupEnabled',
      this.state.isContactLessPickupEnabled
    );
    data.append(
      'accContactPerson',
      JSON.stringify(this.state && this.state.accContactPersons)
    );
    data.append('IsGetReady', this.state.IsGetReady);
    data.append('medbank_dblogin', this.state.medbank_dblogin);
    data.append('medbank_db_password', this.state.medbank_db_password);
    data.append(
      'opc_apim_subscription_key',
      this.state.opc_apim_subscription_key
    );
    data.append('x_api_key', this.state.x_api_key);
    data.append('gateway_api_key', this.state.gateway_api_key);
    data.append('client_identifier', this.state.client_identifier);
    data.append('is_marketplace', this.state.is_marketplace);
    data.append('is_consult_required', this.state.isConsultRequired);
    data.append('consult_key', this.state.epicConsultKey);
    data.append('active_patient', true);
    data.append('login_type', this.state.loginType);
    data.append('issuer', this.state.ssoIssuer);
    data.append('email_domain', this.state.emailDomain);
    data.append('client_id', this.state.clientId);
    data.append('oidc_cert', JSON.stringify(this.state.oidcCert));
    data.append('sso_entry_point', this.state.ssoEntryPoint);
    data.append('bypass_consult', this.state.isConsultRequire);
    data.append('StartGraphic', this.state.StartGraphic);
    data.append('IsPatientPrimarySource', this.state.IsPatientPrimarySource);
    data.append(
      'accountHoursOfOperations',
      JSON.stringify(this.state.AccountHoursOfOperaionsArray)
    );
    data.append('autoDisabledUser', this.state.autoDisabledUser);
    data.append('useDefaultEmail', this.state.useDefaultEmail);
    data.append('is_dispense_safety_check', this.state.is_dispense_safety_chek);
    data.append('is_forgot_mypucode', this.state.is_forgot_mypucode);
    data.append('is_mask_kiosk_dob', this.state.is_mask_kiosk_dob);
    data.append('timezone', this.state.time_zone);
    data.append(
      'store_number',
      this.AssignMckssoRERx(this.state.accountConnectionsId, null)
    );
    data.append(
      'mcKessoneRXrequestTemplate',
      this.state.mcKessoneRXrequestTemplate || ''
    );
    data.append('binaryToken', this.state.binaryToken);
    data.append(
      'issuerMc',
      this.AssignMckessonRxIssuer(this.state.accountConnectionsId, null)
    );
    data.append(
      'cfrheadertemplate',
      this.AssignCFRHeaderTempleteValue(this.state.accountConnectionsId, null)
    );
    data.append(
      'rxinfobodytemplate',
      this.AssignRxInfoTemplateValue(this.state.accountConnectionsId, null)
    );
    data.append(
      'rxinfoheadertemplate',
      this.AssignRxInfoHeaderTempleteValue(
        this.state.accountConnectionsId,
        null
      )
    );
    data.append(
      'posfinalizationbodytemplate',
      this.AssignPOSFinalizationBodyTempleteValue(
        this.state.accountConnectionsId,
        null
      )
    );
    data.append(
      'posfinalizationheadertemplate',
      this.AssignPOSFinalizationHeaderTempleteValue(
        this.state.accountConnectionsId,
        null
      )
    );
    data.append('authToken', this.state.dummyAuthToken);
    data.append('authSecret', this.state.dummyAuthSecret);
    data.append('paymentType', this.state.paymentType);
    data.append('merchant_id', this.state.merchant_id);
    data.append('hpp_identifier', this.state.hpp_identifier);
    data.append('preferredlanguage', this.state.preferLanguage);
    data.append('is_otp_login', this.state.is_otp_login);
    data.append('is_enroll_now', this.state.is_enroll_now);
    data.append('enrollment_v2_enabled', this.state.enrollment_v2_enabled);
    data.append('hide_new_ui', this.state.hide_new_ui);
    data.append('is_mfa_required', this.state.is_mfa_required);
    data.append('allow_member_or_record_number', this.state.allow_member_or_record_number);
    data.append('allow_offline_payment_skip', this.state.allow_offline_payment_skip)
    data.append('is_numeric_code', this.state.is_numeric_code);
    data.append('is_future_release', this.state.is_future_release);
    data.append('liberty_customer_username', this.state.liberty_customer_username);
    data.append('liberty_customer_password', this.state.liberty_customer_password);
    data.append('liberty_rx_regrx', this.state.liberty_rx_regrx);
    data.append('liberty_completion_status', this.state.liberty_completion_status || DEFAULT_LIBERTY_COMPLETION_STATUS);
    data.append('third_party_token', this.state.third_party_token);
    data.append('vendor_unique_id', this.state.vendor_unique_id);
    data.append('purge_patient_images_toggle', this.state.purge_patient_images_toggle);
    data.append('purge_patient_images_days_count', this.state.purge_patient_images_days_count);
    data.append('time_to_notify', (this.state && this.state.selectedHours) || '09')
    data.append('patient_consent',this.state.patient_consent);
    data.append('is_pre_assignment', this.state.is_pre_assignment);
    data.append('is_consultation_notification', this.state.is_consultation_notification);
    data.append('is_taxable', this.state.is_taxable);
    data.append('is_permission_inheritable', this.state.is_permission_inheritable);
    data.append('tax_code', this.state.selectedTaxCode);
    data.append('tax_rate', this.state.taxRate);
    data.append('store_ncp_id', this.state.store_ncp_id);
    data.append('advance_fills', this.state.advance_fills);
    data.append('kiosk_hoursof_operations',JSON.stringify(this.state.KioskHoursOfOperaionsArray));
    data.append('hl_x_api_key', this.state.hl_x_api_key);
    data.append('drx_key', this.state.drx_key);
    data.append('lunch_start',this.state.lunchStart);
    data.append('lunch_end',this.state.lunchEnd);
    data.append('temp_unit',this.state.tempUnit);
    data.append('screensaver_rotation_timing', this.state.screensaverRotationTime)
    data.append('external_id', this.state.external_id);
    data.append('securebadgeexpiryduration', this.state.securebadgeexpiryduration);
    data.append('vial_label_scan', this.state.vial_label_scan);
    data.append('prevent_assigning_non_ready', this.state.prevent_assigning_non_ready === true);
    data.append(
      'regexp',
      this.state.accountConnectionsId === CONNECTION_TYPE.EPIC
        ? resolveEpicScanRegexp(this.state.regexp)
        : (this.state.regexp || '')
    );
    data.append('fill_number_api_fallback', this.state.fill_number_api_fallback === true);
    data.append('optical_expiration_days', this.state.optical_expiration_days);
    data.append('text2pay_token_expiration_days', this.state.text2pay_token_expiration_days || 1);
    data.append('optical_secure_badge_expiration', this.state.optical_secure_badge_expiration);
    data.append('purge_patient_data_toggle', this.state.purge_patient_data_toggle);
    data.append('purge_patient_data_days_count', this.state.purge_patient_data_days_count);
    data.append('calculate_tax', this.state.calculate_tax);
    data.append('signature_flags_test_mode', this.state.signature_flags_test_mode);
    data.append(
      'signature_flags_test_config',
      Array.isArray(this.state.signature_flags_test_config)
        ? JSON.stringify(this.state.signature_flags_test_config)
        : '[]',
    );
    data.append('basic_first_name', this.state.basic_first_name);
    data.append('basic_last_name', this.state.basic_last_name);
    data.append('is_dob_optional', this.state.is_dob_optional);
    data.append('drx_host', this.state.drx_host);
    data.append('cascade_account_update', this.state.cascade_account_update);
    data.append('is_need_help_enabled', this.state.is_need_help_enabled);
    data.append('is_auto_logout_enabled', this.state.is_auto_logout_enabled);
    data.append('prx_xapi_key', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_xapi_key) ? '' : this.state.prx_xapi_key);
    data.append('prx_client_identifier', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_client_identifier) ? '' : this.state.prx_client_identifier);
    data.append('prx_client_id', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_client_id) ? '' : this.state.prx_client_id);
    data.append('prx_client_secret', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_client_secret) ? '' : this.state.prx_client_secret);
    data.append('prx_endoint', [undefined, 'undefined', null, 'null', ''].includes(this.state.prx_endoint) ? '' : this.state.prx_endoint);
    data.append('prx_memberid', this.state.prx_memberid);
    if (this.state.type_id === null) {
      toast.error(this.props.t('Toast.Error.AccountTypeRequired'));
      this.setState({ loader: false, isButtonDisabled: false });
      return;
    }
    const result = fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'PUT',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });
    result
      .then((result) => {
        result.json().then(async (res) => {
          this.setState({ innerLoader: false });
          if (res.error) {
            res.message.includes('SSO Account already exist!')
              ? this.setState({
                isButtonDisabled: false,
                submitted: false,
                errorMessage: res.message,
                isSSOAccountExist: true,
              })
              : this.setState({
                isButtonDisabled: false,
                submitted: false,
                errorMessage: res.message,
                isSSOAccountExist: false,
              });
            toast.error(res.message);
          } else {
            const newData = this.state.data.filter(
              (x) => x.id !== this.state.account.id
            );
            sessionStorage.setItem('timeZone', this.state.time_zone);

            /* audit report log object */                  
            let auditObj = {
              name : this.state.name,
              email : this.state.email,
              parent_id : this.state.parent_id,
              type_id : this.state.type_id,
            };
            if (!res.audit_recorded && !res.audit_failed_sections) this.writeAuditLog(`'${auditObj.name}' account updated by user.`, auditObj);
            /* audit report log object */
            newData.unshift(res.account);
            this.setState({
              isButtonDisabled: false,
              innerLoader: false,
              submitted: true,
              showNewUserDialog: false,
              user: {},
              account: {},
              avatarPreview: null,
              errorMessage: '',
              data: JSON.parse(JSON.stringify(newData)),
              accountConnectionsId: null,
              isPaymentRequired: false,
              accountConnectionsName: '',
              demo_email: '',
              demo_phone: '',
              pharmacyId: '',
              primarylibrarytitle1: '',
              primarylibrarytitle2: '',
              HippaPreview: null,
              LCPreview: null,
              OtherPreview: null,
              docone: '',
              doctwo: '',
              docthree: '',
              helpLink: '',
              privacyPolicyLink: '',
              termsAndConditionsLink: '',
              AdvancedAdvertise: false,
              allow_consult_video: false,
              allow_consult_mobile: false,
              allow_consult_schedule: false,
              value: 0,
              searchtext: '',
              selectedTaxCode: -1,
              taxRate: '',
              basic_first_name:'',
              basic_last_name:'',
              is_dob_optional: false,
              prx_xapi_key:'',
              prx_client_identifier:'',
              prx_client_id:'',
              prx_client_secret:'',
              prx_endoint:'',
              prx_memberid:'',
              show_prx_client_identifier: false,
              show_prx_xapi_key: false,
              show_prx_client_id: false,
              show_prx_client_secret: false,
            });
            FilterObj.searchtext = '';
            FilterObj.sortOrder = 'desc';
            FilterObj.sortColumn = 'created_on';
            FilterObj.tableName = '';
            if (res.save_outcome === 'partial') toast.warn('Some account settings were not saved: ' + (res.failed_sections || []).join(', '));
            else if (res.audit_failed_sections && res.audit_failed_sections.length) toast.warn('Account settings saved, but some audit details could not be recorded. Please contact support.');
            else toast.success(this.props.t('Toast.Success.AccountUpdated'));
            const accountId = res && res.account && res.account.id
            const isCascadeAccountUpdate = res && res.account && res.account.cascade_account_update
            if ([true, 'true'].includes(isCascadeAccountUpdate)) {
              await this.updateChildrenAccounts(accountId);
            }
            this.setState({ id: accountId });
            if(this.state.purge_patient_images_toggle === true) {
              await this.callPurgeService();
            }
            this.BindBoxes();
          }
        });
      })
      .catch((error) => {
        this.setState({ innerLoader: false });
        this.setState({ isButtonDisabled: false });
        this.setState({ errorMessage: error.message });
        toast.error(this.props.t('Toast.Error.UpdateAccountDetails') + error.message);
      });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  handleContextClick = (event, id, onReady) => {
    if (event && event.preventDefault) event.preventDefault();
    // Avoid setState when opening ⋮ menu — full page re-render causes flicker.
    if (typeof onReady === 'function') {
      // Intentional: skip setState so opening ⋮ does not re-render the page.
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.selectedRowId = id;
      onReady();
      return;
    }
    this.setState({ selectedRowId: id });
  };

  handleContextClose = (event) => {
    if (event && event.preventDefault) event.preventDefault();
    this.setState({ selectedRowId: null, value: 0 });
  };

  openRowActionsMenu = (event, params, menuHelpers) => {
    const rowId = params && params.data && params.data.id;
    const openMenu = () => {
      const items = this.getContextMenuItems({
        ...params,
        column: params.column,
        node: params.node,
        value: params.value,
      });
      if (menuHelpers && typeof menuHelpers.openMenu === 'function') {
        const opened = menuHelpers.openMenu(items);
        if (opened) {
          return;
        }
      }
      openAgGridContextMenu(params, (menuHelpers && menuHelpers.positionEvent) || event);
    };
    this.handleContextClick(event, rowId, openMenu);
  };

  getContextMenuItems = (params) => {
    const colId = params && params.column && (params.column.getColId ? params.column.getColId() : params.column.colId);
    if (colId !== 'actions') return [];
    const {t} = this.props;
    const row = params.node && params.node.data;
    if (!row) return [];
    const isIlocalUser = localStorage.getItem('isIlocalUser');
    const items = [];
    if (this.state.accountview === true) {
      items.push(actionMenuItem({ name: t('Accounts.ViewActions'), icon: 'view', action: () => this.handleView(undefined, row) }));
      items.push(actionMenuItem({ name: t('Accounts.ViewResourcesActions'), icon: 'mapping', action: () => this.viewAccountResources(row) }));
    }
    if (this.state.accountedit === true) {
      items.push(actionMenuItem({ name: t('Accounts.EditActions'), icon: 'edit', action: () => this.handleEdit(undefined, row) }));
    }
    if ([true, 'true'].includes(isIlocalUser)) {
      items.push(actionMenuItem({ name: t('Accounts.CloneActions'), icon: 'clone', action: () => this.handleOpenCloneDialog() }));
    }
    if (this.state.accountdelete === true) {
      items.push(actionMenuItem({ name: t('Accounts.DeleteActions'), icon: 'delete', action: () => this.confirmDelete() }));
    }
    return items;
  };

  viewAccountResources = (accountOverride) => {
    const selectedObject =
      accountOverride ||
      (this.state.data || []).find((x) => x.id === this.state.selectedRowId);
    if (!selectedObject || !selectedObject.id) {
      return;
    }
    this.setState({
      showAccountResources: true,
      selectedAccountIdForResources: selectedObject.id,
      selectedAccountNameForResources: selectedObject.name || '',
      selectedRowId: null,
    });
  };

  closeAccountResourcesDialog = () => {
    hideRowActionsMenu();
    this.setState({
      showAccountResources: false,
      selectedAccountIdForResources: null,
      selectedAccountNameForResources: '',
    });
  };

  openChildAccountView = (account) => {
    hideRowActionsMenu();
    this.setState({ showAccountResources: false }, () => {
      this.handleView({ preventDefault() {} }, account);
    });
  };

  openChildAccountEdit = (account) => {
    hideRowActionsMenu();
    this.setState({ showAccountResources: false }, () => {
      this.handleEdit({ preventDefault() {} }, account);
    });
  };

  checkValueOfCategory(id) {
    let result = false;
    let obj = this.state.CheckedPermissionParentCategory.find(
      (obj) => obj.value === id
    );
    if (obj !== undefined) {
      result = obj['status'];
    }
    return result;
  }
  checkValueOfsubCategory(id) {
    let result = false;
    let obj = this.state.CheckedPermissionSubCategory.find(
      (obj) => obj.value === id
    );
    if (obj !== undefined) {
      result = obj['status'];
    }
    return result;
  }
  parentcheckpermission = (id) => {
    // let obj = this.state.CheckedPermissionParentCategory.find(obj =>  obj.value === id);
    this.state.CheckedPermissionParentCategory.map((item) => {
      if (item.value === id) {
        item.status = !item.status;
      }

      return item;
    });

    let obj1 = this.state.CheckedPermissionParentCategory.find(
      (obj) => obj.value === id
    );

    this.state.CheckedPermissionSubCategory.map((item) => {
      if (item.parentvalue === id) {
        if (obj1.status) {
          item.status = true;
        } else {
          item.status = false;
        }
      }

      return item;
    });
    this.forceUpdate();
  };

  //sub
  checkedPermission = (elem_id) => {
    //let obj = this.state.CheckedPermissionSubCategory.find(obj =>  obj.value === elem_id);
    this.state.CheckedPermissionSubCategory.map((item) => {
      if (item.value === elem_id) {
        item.status = !item.status;
      }

      return item;
    });

    let obj1 = this.state.CheckedPermissionSubCategory.find(
      (obj) => obj.value === elem_id
    );
    this.state.CheckedPermissionParentCategory.map((item) => {
      if (item.value === obj1.parentvalue && obj1.status === false) {
        item.status = false;
      }
      return item;
    });
    let obj2 = this.state.CheckedPermissionSubCategory.filter(
      (obj2) => obj2.parentvalue === obj1.parentvalue
    );
    if (obj2 !== undefined) {
      obj2.forEach((item) => {
        if (item.status === false) {
          this.state.CheckedPermissionParentCategory.map((parentitem) => {
            if (parentitem.value === item.parentvalue) {
              parentitem.status = false;
            }
            return parentitem;
          });
        } else {
          let obj3 = obj2.filter((obj2) => obj2.status === true);
          if (obj3.length === obj2.length) {
            this.state.CheckedPermissionParentCategory.map((parentitem) => {
              if (parentitem.value === item.parentvalue) {
                parentitem.status = true;
              }
              return parentitem;
            });
          }
        }
      });
    }

    this.forceUpdate();
  };
  getParentCategories = () => {
    const uniqueCategories = this.getUnique(
      this.state.permissiondata,
      'entity_type_id'
    );
    this.setState({ uniquePermissionCategories: uniqueCategories });
    const paraentaarray = this.state.uniquePermissionCategories.map((item) => {
      return {
        value: item.entity_type_id,
        label: item.entity_name,
        status: false,
      };
    });
    this.setState({ CheckedPermissionParentCategory: paraentaarray });
    const subaaray = this.state.permissiondata.map((item) => {
      return {
        parentvalue: item.entity_type_id,
        parenetlabel: item.entity_name,
        value: item.id,
        label: item.name,
        status: false,
      };
    });
    this.setState({ CheckedPermissionSubCategory: subaaray });
  };

  getUnique = (arr, comp) => {
    const unique = arr
      .map((e) => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  };
  onChangename = (idx) => (evt) => {
    const handiname = this.state.healthandinfo.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        title: evt.target.value,
        description: item.description,
        video_url: item.video_url,
        category_id: item.category_id,
        primarylibrary_id: item.primarylibrary_id,
      };
    });

    this.setState({ healthandinfo: handiname });
  };
  onChangedescription = (idx) => (evt) => {
    const handidescription = this.state.healthandinfo.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        title: item.title,
        description: evt.target.value,
        video_url: item.video_url,
        category_id: item.category_id,
        primarylibrary_id: item.primarylibrary_id,
      };
    });

    this.setState({ healthandinfo: handidescription });
  };
  onChangevideoUrl = (idx) => (evt) => {
    const handivideoUrl = this.state.healthandinfo.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        title: item.title,
        description: item.description,
        video_url: evt.target.value,
        category_id: item.category_id,
        primarylibrary_id: item.primarylibrary_id,
      };
    });

    this.setState({ healthandinfo: handivideoUrl });
  };
  onChangecategory = (idx) => (evt) => {
    const handicategory = this.state.healthandinfo.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        title: item.title,
        description: item.description,
        video_url: item.video_url,
        category_id: evt.target.value,
        primarylibrary_id: item.primarylibrary_id,
      };
    });

    this.setState({ healthandinfo: handicategory });
  };
  onChangelibrary = (idx) => (evt) => {
    const handiprimarylib = this.state.healthandinfo.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        title: item.title,
        description: item.description,
        video_url: item.video_url,
        category_id: item.category_id,
        primarylibrary_id: evt.target.value,
      };
    });
    this.setState({ healthandinfo: handiprimarylib });
  };
  createRow = () => {
    const {classes} = this.props;
    let categorytype = this.state.categories;
    return (
      this.state &&
      this.state.healthandinfo &&
      this.state.healthandinfo.map(
        (val, idx) => (
          <TableRow className={classes.wrapperBox}>
            <TableCell
              colSpan={3}
              className={`${classes.parentRemovePad} ${classes.removeBorders}`}
            >
              <Table>
                <TableRow>
                  <TableCell
                    rowSpan={3}
                    className={`${classes.removePad}  ${classes.removeBorders}`}
                  >
                    <div className={classes.iconGroup}>
                      <Button
                        onClick={() => this.removeRow(idx)}
                        color='primary'
                      >
                        Remove
                      </Button>
                      {/* <IconButton className={classes.signOutButton}>
                    <RemoveIcon className={classes.iconStyle} onClick={() => this.removeRow(idx)} />
                  </IconButton> */}
                    </div>
                  </TableCell>
                  <TableCell
                    className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                  >
                    <FormControl className={classes.boxType}>
                      <TextField
                        margin='dense'
                        className={classes.halfTextField}
                        value={val.title}
                        id='Name'
                        label='Title'
                        placeholder=''
                        onChange={this.onChangename(idx)}
                        fullWidth
                        variant='standard'
                      />
                    </FormControl>
                  </TableCell>
                  <TableCell
                    className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                  >
                    <FormControl className={classes.tableDropdown}>
                      <TextField
                        margin='dense'
                        className={classes.halfTextField}
                        value={val.description}
                        id='Description'
                        label='Description'
                        placeholder=''
                        onChange={this.onChangedescription(idx)}
                        fullWidth
                        variant='standard'
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                  >
                    <FormControl className={classes.boxType}>
                      <TextField
                        className={classes.halfTextField}
                        margin='dense'
                        value={val.video_url}
                        id='videourl'
                        label='Video Url'
                        placeholder=''
                        onChange={this.onChangevideoUrl(idx)}
                        fullWidth
                        variant='standard'
                      />
                    </FormControl>
                  </TableCell>
                  <TableCell
                    className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                  >
                    <FormControl className={classes.boxType}>
                      <InputLabel
                        htmlFor='type_id'
                        style={{ marginLeft: '-1rem' }}
                      >
                        Category
                      </InputLabel>
                      <Select
                        className={classes.halfTextField}
                        value={val.category_id || ''}
                        // inputProps={{name: 'category_id',  id: 'category_id'}}
                        onChange={this.onChangecategory(idx)}
                        variant='standard'
                      >
                        {categorytype.map((type, index) => (
                          <MenuItem
                            key={index}
                            value={type.id}
                            selected
                            className={classes.menuItem}
                          >
                            {type.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                  >
                    <FormControl className={classes.boxType}>
                      <InputLabel
                        htmlFor='age-simple'
                        style={{ marginLeft: '-1rem' }}
                      >
                        Select Channel
                      </InputLabel>
                      <Select
                        className={classes.halfTextField}
                        value={val.primarylibrary_id || ''}
                        // inputProps={{name: 'category_id',  id: 'category_id'}}
                        onChange={this.onChangelibrary(idx)}
                        variant='standard'
                      //displayEmpty
                      // inputProps={{
                      //   name: 'primarylib_id',
                      //   id: 'primarylib_id',
                      // }}
                      >
                        {/* <MenuItem value="">Select</MenuItem> */}
                        <MenuItem value={1} className={classes.menuItem}>
                          Primary
                        </MenuItem>
                        <MenuItem value={2} className={classes.menuItem}>
                          Secondary
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              </Table>
            </TableCell>
          </TableRow>
        )
        // <Table>
        // <TableRow>
        //   <TableCell className={classes.tableAddRowCell}>
        //     <div className={classes.iconGroup} >
        //       <IconButton className={classes.signOutButton}>
        //         <RemoveIcon className={classes.iconStyle} onClick={() => this.removeRow(idx)} />
        //       </IconButton>
        //     </div>
        //   </TableCell>
        //   <TableCell className={classes.tableTd}>
        //     <FormControl className={classes.boxType}>
        //     <TextField
        //         margin="dense"
        //         className={classes.halfTextField}
        //         // margin="normal"
        //         value={val.name}
        //         id="Name"
        //         //inputProps={{readOnly: Boolean(readOnly),maxLength : 100}}
        //         label="Title"
        //         // type="first-name"
        //         placeholder=""
        //         onChange={this.onChangename(idx)}
        //         //fullWidth
        //       />
        //     </FormControl>
        //   </TableCell>
        //   <TableCell className={classes.tableTd}>
        //     <FormControl className={classes.tableDropdown}>
        //     <TextField
        //         margin="dense"
        //         className={classes.halfTextField}
        //         // margin="normal"
        //         value={val.description}
        //         id="Description"
        //         //inputProps={{readOnly: Boolean(readOnly),maxLength : 100}}
        //         label="Description"
        //         // type="first-name"
        //         placeholder=""
        //         onChange={this.onChangedescription(idx)}
        //         fullWidth
        //       />
        //     </FormControl>
        //   </TableCell>
        //   </TableRow>
        //   <TableRow>
        //   <TableCell className={classes.tableTd}>
        //   <FormControl className={classes.boxType}>
        //   <TextField
        //         margin="dense"
        //         className={classes.halfTextField}
        //         // margin="normal"
        //         value={val.url}
        //         id="videourl"
        //         //inputProps={{readOnly: Boolean(readOnly),maxLength : 100}}
        //         label="Video Url"
        //         // type="first-name"
        //         placeholder=""
        //         onChange={this.onChangevideoUrl(idx)}
        //         //fullWidth
        //       />
        //     </FormControl>
        //   </TableCell>
        //   <TableCell className={classes.tableTd}>
        //   <FormControl className={classes.boxType}>
        //   {/* <TextField
        //         margin="dense"
        //         //className={classes.halfTextField}
        //         // margin="normal"
        //         value={val.category}
        //         id="category"
        //         //inputProps={{readOnly: Boolean(readOnly),maxLength : 100}}
        //         label="Category"
        //         // type="first-name"
        //         placeholder=""
        //         onChange={this.onChangecategory(idx)}
        //         // fullWidth
        //       /> */}
        //       <InputLabel htmlFor="type_id">Category</InputLabel>
        //       <Select
        //           value={val.category || ''}
        //           onChange={this.onChangecategory(idx)}
        //           // inputProps={{
        //           //     name: 'expansion_id',
        //           //     id: 'expansion_id1',
        //           // }}
        //       >
        //         {
        //         categorytype.map((type, index) =>
        //           <MenuItem
        //             key={index}
        //             value={type.id}
        //             selected
        //           >
        //             {type.label}
        //           </MenuItem>
        //         )
        //         }
        //       </Select>
        //     </FormControl>
        //   </TableCell>
        //   </TableRow>,
        // </Table>
      )
    );
  };
  addRow = () => {
    this.setState({
      healthandinfo: this.state.healthandinfo.concat([
        {
          hiid: '',
          hiname: '',
          hidescription: '',
          hiurl: '',
          hicategory: '',
          hiprimary: '',
        },
      ]),
    });
  };
  removeRow = (i) => {
    this.setState({
      healthandinfo: this.state.healthandinfo.filter((s, sidx) => i !== sidx),
    });
  };
  handleChangePioneerRxEndPoint = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ endpoint: event.target.value });
  };
  handleChangePioneerRxDataExchangeId = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ data_exchange_id: event.target.value });
  };
  handleChangeepicEndPoint = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ endpoint: event.target.value });
  };
  handleChangeepicClientID = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicclientid: event.target.value });
  };
  handleChangeepicusername = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicusername: event.target.value });
  };
  handleChangPharmacyNcpDpId = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicPharmacyNcpdpId: event.target.value });
  };
  handleChangVersion = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicEndpointVersion: event.target.value });
  };
  handleChangeRequestTemplate = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicRequestTempate: event.target.value });
  };
  handleChangeepicpassword = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicpassword: event.target.value });
  };
  handleClickShowPassword = () => {
    this.setState({ showepicpassword: !this.state.showepicpassword });
  };
  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleShowHidetransxgbapikeyvisible = (event) => {
    this.setState({ transxgbapikeyvisible: !this.state.transxgbapikeyvisible });
  };

  handleShowHidetransxgbapisecretvisible = (event) => {
    this.setState({
      transxgbapisecretvisible: !this.state.transxgbapisecretvisible,
    });
  };

  handleShowHidetokenxgbapikeyvisibel = (event) => {
    this.setState({ tokenxgbapikeyvisibel: !this.state.tokenxgbapikeyvisibel });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    
    FilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  handleChangeRowsPerPage = (event) => {
    
    FilterObj.pageNo = 0;
    FilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };
  handleChangeHelpLink = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ helpLink: event.target.value });
  };
  handleChangePrivacyPolicyLink = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ privacyPolicyLink: event.target.value });
  };
  handleChangeTermsAndConditionsLink = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ termsAndConditionsLink: event.target.value });
  };

  fetchGenericLink = () => {
    fetch(
      process.env.REACT_APP_BASEURL +
      'patient/app/enrollment/account/generic-link',
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((genericLink) => {
        let parsedData = JSON.parse(genericLink);
        if (parsedData && parsedData.res) {
          let element = document.getElementById('genericLink');
          if (element) {
            let random_key = parsedData.res.split('=')[1];
            if (random_key) {
              this.setState(
                { random_key: random_key, genericLink: parsedData.res },
                () => { }
              );
            }
          }
        }
      });
  };

  removeGenericLink = () => {
    const removeGenerikLink = {
      random_id: this.state && this.state.random_key,
    };
    fetch(
      process.env.REACT_APP_BASEURL +
      'patient/app/enrollment/account/remove-generic-link',
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(removeGenerikLink),
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((removeGenericLink) => {
        if (removeGenericLink) {
        }
      })
      .catch((errorGenericLink) => {
        console.log(
          'Something went wrong to Delete Generik Link:' + errorGenericLink
        );
      });
  };

  handleChangeallow_payment = () => {
    const status = !this.state.allow_payment ? 'enabled' : 'disabled';
    this.setState({ allow_payment: !this.state.allow_payment });
    this.writeAuditLog(`Allow Mobile Payments was ${status} by user.`);
  };

  handleChangeIsContactLessPickupEnabled = () => {
    const status = !this.state.isContactLessPickupEnabled ? 'enabled' : 'disabled';
    this.setState({
      isContactLessPickupEnabled: !this.state.isContactLessPickupEnabled,
    });
    this.writeAuditLog(`Contactless Pickup was ${status} by user.`);
  };

  handleConsult_Video = () => {
    const status = !this.state.allow_consult_video ? 'enabled' : 'disabled';
    this.setState({ allow_consult_video: !this.state.allow_consult_video });
    this.writeAuditLog(`Video consultation was ${status} by user.`);
  };

  handleConsult_Mobile = () => {
    const status = !this.state.allow_consult_mobile ? 'enabled' : 'disabled';
    this.setState({ allow_consult_mobile: !this.state.allow_consult_mobile });
    this.writeAuditLog(`Audio consultation was ${status} by user.`);
  };

  onChangeContactFirstName = (idx) => (evt) => {
    const first_name =
      this.state &&
      this.state.accContactPersons.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          first_name: evt.target.value,
          last_name: item.last_name,
          email: item.email,
          phone: item.phone,
          isdefault: item.isdefault,
        };
      });
    this.setState({ accContactPersons: first_name });
  };

  onChangeContactLastName = (idx) => (evt) => {
    const last_name =
      this.state &&
      this.state.accContactPersons.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          first_name: item.first_name,
          last_name: evt.target.value,
          email: item.email,
          phone: item.phone,
          isdefault: item.isdefault,
        };
      });
    this.setState({ accContactPersons: last_name });
  };

  onChangeContactEmail = (idx) => (evt) => {
    const email =
      this.state &&
      this.state.accContactPersons.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          first_name: item.first_name,
          last_name: item.last_name,
          email: evt.target.value,
          phone: item.phone,
          isdefault: item.isdefault,
        };
      });
    this.setState({ accContactPersons: email });
  };

  onChangeContactphone = (idx) => (evt) => {
    const phone =
      this.state &&
      this.state.accContactPersons.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          first_name: item.first_name,
          last_name: item.last_name,
          email: item.email,
          phone: evt.target.value,
          isdefault: item.isdefault,
        };
      });
    this.setState({ accContactPersons: phone });
  };

  onChangeContactActive = (idx) => (evt) => {
    const isDefault =
      this.state &&
      this.state.accContactPersons.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          first_name: item.first_name,
          last_name: item.last_name,
          email: item.email,
          phone: item.phone,
          isdefault: evt.target.checked,
        };
      });
    this.setState({ accContactPersons: isDefault });
  };

  addContactPersonRow = () => {
    this.setState({
      accContactPersons:
        this.state &&
        this.state.accContactPersons &&
        this.state.accContactPersons.concat([
          {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            isdefault: false,
          },
        ]),
    });
  };

  removecontactPersonRow = (i) => {
    this.setState({
      accContactPersons: this.state.accContactPersons.filter(
        (s, sidx) => i !== sidx
      ),
    });
  };
  contactPersonsMethod = () => {
    const readOnly =
      this.state.operation === 'View' || this.state.operation === 'Edit';
    if (!readOnly) {
      this.addContactPersonRow();
      this.createRowContactPerson();
    }
  };
  createRowContactPerson = () => {
    const {t} = this.props;
    const readOnly = this.state && this.state.operation === 'View';
    let accContactPersons = this.state && this.state.accContactPersons;
    let row =
      accContactPersons &&
      accContactPersons.map((val, idx) => (
        <Box sx={{ mt: '10px' }}>
          <React.Fragment>
            <Grid container>
              <Grid item sx={{ mt: '13px' }}>
                <Button
                  onClick={() => this.removecontactPersonRow(idx)}
                  color='primary'
                >
                  {t('Accounts.AccountDetail.AddContact.Remove')}
                </Button>
              </Grid>
              <Grid item xs={1} sx={{ pl: '15px', mt: '11px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={val.isdefault}
                      onChange={this.onChangeContactActive(idx)}
                      value='default'
                      color='primary'
                    />
                  }
                  label={
                    <span
                      style={{
                        color: '#000',
                        fontSize: '0.875rem',
                        fontWeight: '400',
                        lineHeight: '1.46429em',
                      }}
                    >
                      {t('Accounts.AccountDetail.AddContact.Active')}
                    </span>
                  }
                />
              </Grid>
              <Grid item xs={2} sx={{ ml: '3%' }}>
                <TextField
                  value={val.first_name}
                  id='first_name'
                  label={t('Accounts.AccountDetail.AddContact.FirstName')}
                  placeholder=''
                  onChange={this.onChangeContactFirstName(idx)}
                  fullWidth
                  inputProps={{
                    readOnly: Boolean(readOnly),
                    maxLength: 50,
                  }}
                  variant='standard'
                  sx={{ width: '25ch' }}
                />
              </Grid>
              <Grid item xs={2} sx={{ ml: '4%' }}>
                <TextField
                  value={val.last_name}
                  id='last_Name'
                  label={t('Accounts.AccountDetail.AddContact.LastName')}
                  placeholder=''
                  onChange={this.onChangeContactLastName(idx)}
                  fullWidth
                  inputProps={{
                    readOnly: Boolean(readOnly),
                    maxLength: 50,
                  }}
                  variant='standard'
                  sx={{ width: '25ch' }}
                />
              </Grid>
              <Grid item xs={2} sx={{ ml: '4%' }}>
                <TextField
                  value={val.email}
                  id='Email'
                  label={t('Accounts.AccountDetail.AddContact.Email')}
                  placeholder=''
                  onChange={this.onChangeContactEmail(idx)}
                  fullWidth
                  inputProps={{
                    readOnly: Boolean(readOnly),
                    maxLength: 50,
                  }}
                  variant='standard'
                  sx={{ width: '25ch' }}
                />
                {/* <div id={`LocationCountry_${idx}`} style={{ color:'red',display:'none',marginBottom:'-20px'}}>
                       <label>Please Use Only Alphabets</label>
                    </div>  */}
              </Grid>
              <Grid item xs={2} sx={{ ml: '4%' }}>
                <PhoneInput
                  labelStyle={{ left: '-13px', top: '-17px' }}
                  id='phone'
                  name='phone'
                  onBlur={this.onChangeContactphone(idx)}
                  defaultValue={val.phone}
                  readOnly={readOnly}
                />
              </Grid>
            </Grid>
          </React.Fragment>
        </Box>
      ));
    return row;
  };
  handleMouseDownMedbank = (event) => {
    event.preventDefault();
  };

  handleChangeMedBankDBLogin = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ medbank_dblogin: event.target.value });
  };

  handleChangeMedBankDBPassword = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ medbank_db_password: event.target.value });
  };

  handleChangeMedBankDBSubscriptionKey = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ opc_apim_subscription_key: event.target.value });
  };

  handleClickShowMedBankDbLogin = () => {
    this.setState({ show_medbank_dblogin: !this.state.show_medbank_dblogin });
  };

  handleClickShowMedBankDbPassword = () => {
    this.setState({
      show_medbank_db_password: !this.state.show_medbank_db_password,
    });
  };

  handleClickShowMedBankSubscriptionKey = () => {
    this.setState({
      show_medbank_subscription_key: !this.state.show_medbank_subscription_key,
    });
  };

  handleChangeMScriptXApiKey = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ x_api_key: event.target.value });
  };

  handleClickMScriptXApiKey = () => {
    this.setState({ showXApiKey: !this.state.showXApiKey });
  };

  handleChangeGatewayApiKey = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ gateway_api_key: event.target.value });
  };

  handleClickGatewayApiKey = () => {
    this.setState({ showGatewayApiKey: !this.state.showGatewayApiKey });
  };

  handleMouseDownGatewayApiKey = (event) => {
    event.preventDefault();
  };

  handleMouseDownMScriptsAPIKey = (event) => {
    event.preventDefault();
  };

  handleChangeMScriptClientIdentifier = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ client_identifier: event.target.value });
  };

  handleClickMScriptClientIdentifier = () => {
    this.setState({
      show_client_identifier: !this.state.show_client_identifier,
    });
  };

  handleMouseDownMScriptsClientIdentifier = (event) => {
    event.preventDefault();
  };

  handleChangeThirdPartyToken = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ third_party_token: event.target.value });
  };

  handleClickThirdPartyToken = () => {
    this.setState({
      show_third_party_token: !this.state.show_third_party_token,
    });
  };

  handleMouseDownThirdPartyToken = (event) => {
    event.preventDefault();
  };

  handleChangeThirdPartyEndPoint = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ endpoint: event.target.value });
  };

  handleChangeThirdPartyStoreId = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ store_ncp_id: event.target.value });
  };

  copyToClipboard = (e) => {
    this.textArea.select();
    document.execCommand('copy');
    this.setState({ copySuccess: 'Copied!' });
  };

  onCopy = () => {
    this.setState({ copied: true });
    toast.success(this.props.t('Toast.Success.AccountEnrollmentCopy'));
  };

  handleSwitchGetReadyChange = (name) => (event) => {
    this.setState({ IsGetReady: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Allow Get Ready Notification was ${status} by user.`);
  };

  handleSwitchStartGraphiChange = (event) => {
    this.setState({ StartGraphic: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Touch to start-kiosk was ${status} by user.`);
  };

  handleChangeAccountHoursofOperation = (value) => {
    if (value === 'Sunday') {
      this.setState({ isSunday: !this.state.isSunday });
    }
    if (value === 'Monday') {
      this.setState({ isMonday: !this.state.isMonday });
    }
    if (value === 'Tuesday') {
      this.setState({ isTuesday: !this.state.isTuesday });
    }
    if (value === 'Wednesday') {
      this.setState({ isWednesday: !this.state.isWednesday });
    }
    if (value === 'Thursday') {
      this.setState({ isThursday: !this.state.isThursday });
    }
    if (value === 'Friday') {
      this.setState({ isFriday: !this.state.isFriday });
    }
    if (value === 'Saturday') {
      this.setState({ isSaturday: !this.state.isSaturday });
    }
  };

  handleAccountOpentimeChange = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const HoursOfOperation =
      this.state &&
      this.state.AccountHoursOfOperaionsArray &&
      this.state.AccountHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: event.target.value,
          closeTime: item.closeTime,
          isClosed: item.isClosed,
          isOpenAll: item.isOpenAll
        };
      });
    this.setState({ AccountHoursOfOperaionsArray: HoursOfOperation });
  };

  handleAccountClosetimeChange = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const HoursOfOperation =
      this.state &&
      this.state.AccountHoursOfOperaionsArray &&
      this.state.AccountHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: item.openTime,
          closeTime: event.target.value,
          isClosed: item.isClosed,
          isOpenAll: item.isOpenAll
        };
      });
    this.setState({ AccountHoursOfOperaionsArray: HoursOfOperation });
  };

  handleAccountClosedCheckBox = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const _isChecked = event.target.checked;
    const HoursOfOperation =
      this.state &&
      this.state.AccountHoursOfOperaionsArray &&
      this.state.AccountHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: item.openTime,
          closeTime: item.closeTime,
          isClosed: _isChecked,
          isOpenAll: item.isOpenAll
        };
      });
    this.setState({ AccountHoursOfOperaionsArray: HoursOfOperation });
  };

  handleAccountOpenAllCheckBox = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const _isChecked = event.target.checked;
    const HoursOfOperation =
      this.state &&
      this.state.AccountHoursOfOperaionsArray &&
      this.state.AccountHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: item.openTime,
          closeTime: item.closeTime,
          isClosed: item.isClosed,
          isOpenAll: _isChecked
        };
      });
    this.setState({ AccountHoursOfOperaionsArray: HoursOfOperation });
  };

  handleAccountBlurTime = (event) => {
    if (event && event.target && event.target.value > '23:59') {
      this.setState({ TimevalidateDialog: true });
    }
  };

  handleAutoDisabledUserChange = (event) => {
    this.setState({ autoDisabledUser: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Auto Disable User was ${status} by user.`);
  };

  getTimeZone = (event) => {
    this.setState({ time_zone: event.target.value });
    this.writeAuditLog(`Timezone was changed by user.`);
  };

  handleChangeMckessoneRx = (event) => {
    event.preventDefault();
    this.setState({ endpoint: event.target.value });
  };

  handleChangeStoreNumber = (event) => {
    event.preventDefault();
    this.setState({ store_number: event.target.value });
  };

  handleChangeMckessoneRequestTemplate = (event) => {
    event.preventDefault();
    this.setState({ mcKessoneRXrequestTemplate: event.target.value });
  };

  handleShowHideBinarytokenvisibel = () => {
    this.setState({ binaryTokenvisbel: !this.state.binaryTokenvisbel });
  };

  AssignMckessonRxIssuer = (accountConnectionID, account) => {
    let issuer = '';
    if (accountConnectionID === CONNECTION_TYPE.MCKESSONERX) {
      if (account !== null && account !== undefined) {
        issuer = account.connection_details.issuer;
      } else {
        issuer = this.state && this.state.issuer;
      }
    }
    return issuer;
  };

  AssignCFRHeaderTempleteValue(accountConnectionID, account) {
    let CFRHeaderTemplete = '';
    if (accountConnectionID === CONNECTION_TYPE.MCKESSONERX) {
      if (account !== null && account !== undefined) {
        CFRHeaderTemplete = account.connection_details.cfrheadertemplate;
      } else {
        CFRHeaderTemplete = this.state && this.state.CFRHeaderTemplate;
      }
    }
    return CFRHeaderTemplete;
  }

  AssignRxInfoTemplateValue(accountConnectionID, account) {
    let RxInfoTemplate = '';
    if (accountConnectionID === CONNECTION_TYPE.MCKESSONERX) {
      if (account !== null && account !== undefined) {
        RxInfoTemplate = account.connection_details.rxinfobodytemplate;
      } else {
        RxInfoTemplate = this.state && this.state.RxInfoBodyTemplate;
      }
    }
    return RxInfoTemplate;
  }

  AssignRxInfoHeaderTempleteValue(accountConnectionID, account) {
    let RxInfoHeaderTemplete = '';
    if (accountConnectionID === CONNECTION_TYPE.MCKESSONERX) {
      if (account !== null && account !== undefined) {
        RxInfoHeaderTemplete = account.connection_details.rxinfoheadertemplate;
      } else {
        RxInfoHeaderTemplete = this.state && this.state.RxInfoHeaderTemplate;
      }
    }
    return RxInfoHeaderTemplete;
  }

  AssignPOSFinalizationBodyTempleteValue(accountConnectionID, account) {
    let POSFinalizationBodyTemplete = '';
    if (accountConnectionID === CONNECTION_TYPE.MCKESSONERX) {
      if (account !== null && account !== undefined) {
        POSFinalizationBodyTemplete =
          account.connection_details.posfinalizationbodytemplate;
      } else {
        POSFinalizationBodyTemplete =
          this.state && this.state.POSFinalizationBodyTemplate;
      }
    }
    return POSFinalizationBodyTemplete;
  }

  AssignPOSFinalizationHeaderTempleteValue(accountConnectionID, account) {
    let POSFinalizationHeaderTemplete = '';
    if (accountConnectionID === CONNECTION_TYPE.MCKESSONERX) {
      if (account !== null && account !== undefined) {
        POSFinalizationHeaderTemplete =
          account.connection_details.posfinalizationheadertemplate;
      } else {
        POSFinalizationHeaderTemplete =
          this.state && this.state.POSFinalizationHeaderTemplate;
      }
    }
    return POSFinalizationHeaderTemplete;
  }

  handleChangeIssuer = (event) => {
    this.setState({ issuer: event.target.value });
  };
  /* Handle Events for Current Fill Request Start  */
  handleCFRHeaderTemplateChange = (event) => {
    this.setState({ CFRHeaderTemplate: event.target.value });
  };

  handleCFRVersionChange = (event) => {
    this.setState({ CFRVersion: event.target.value });
  };

  handlCFRMessageNameChange = (event) => {
    this.setState({ CFRMessageName: event.target.value });
  };
  /* Handle Events for Current Fill Request End  */

  /* Handle Events for Rx Info Request Start  */
  handleRxInfoBodyTemplateChange = (event) => {
    this.setState({ RxInfoBodyTemplate: event.target.value });
  };

  handleRxInfoHeaderTemplateChange = (event) => {
    this.setState({ RxInfoHeaderTemplate: event.target.value });
  };

  handleRxInfoVersionChange = (event) => {
    this.setState({ RxInfoVersion: event.target.value });
  };

  handlRxInfoMessageNameChange = (event) => {
    this.setState({ RxInfoVersion: event.target.value });
  };
  /* Handle Events for Rx Info Request End  */

  /* Handle Events for POS finalization Request Start  */
  handlePOSFinalizationBodyTemplateChange = (event) => {
    this.setState({ POSFinalizationBodyTemplate: event.target.value });
  };

  handlePOSFinalizationHeaderTemplateChange = (event) => {
    this.setState({ POSFinalizationHeaderTemplate: event.target.value });
  };

  handlePOSFinalizationVersionChange = (event) => {
    this.setState({ POSFinalizationVersion: event.target.value });
  };

  handlPOSFinalizationMessageNameChange = (event) => {
    this.setState({ POSFinalizationMessageName: event.target.value });
  };
  /* Handle Events for POS finalization Request End  */
  handleChangeepicWithMtlsEndPoint = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ endpoint: event.target.value });
  };

  handleChangeepicWithMtlsClientID = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicclientid: event.target.value });
  };

  handleChangepicWithMtlsPharmacyNcpDpId = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicPharmacyNcpdpId: event.target.value });
  };

  handleChangepiWithMtlsVersion = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicEndpointVersion: event.target.value });
  };

  handleChangeepicWithMtlsRequestTemplate = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ epicRequestTempate: event.target.value });
  };

  getPaymentGateways = () => {
    fetch(process.env.REACT_APP_BASEURL + 'paymentgateways', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((paymentTypes) => {
        this.setState({ paymentGateways: paymentTypes });
      });
  };

  handleChangePaymentGateway = (event) => {
    this.setState({ paymentType: event.target.value });
    this.writeAuditLog(`Payment Gateway Method was changed by user.`);
  };

  onChangePreferredLanguage = (event) => {
    event.preventDefault && event.preventDefault();
    const { value } = event.target;
    this.setState({ preferLanguage: value });
    this.writeAuditLog(`Preffered Language was changed by user.`);
  };

  handleAllowOfflinePaymentSkip = (name) => (event) => {
    this.setState({ allow_offline_payment_skip: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Allow offline payment skip was ${status} by user.`);
  };

  handleNumericCode = (name) => (event) => {
    this.setState({ is_numeric_code: event.target.checked });
    localStorage.setItem('isNumericCode', event.target.checked);
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Numeric Pin Code was ${status} by user.`);
  };

  handleFutureRelease = (name) => (event) => {
    this.setState({ is_future_release: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Future Release was ${status} by user.`);
  };

  handlePreAssignment = (name) => (event) => {
    this.setState({ is_pre_assignment: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Pre-assignment was ${status} by user.`);
  };

  handleChangeLibertyEndpoint = (event) => {
    this.setState({ endpoint: event.target.value });
  }

  handleChangeLibertyVendorUsername = (event) => {
    this.setState({ vendor_key: event.target.value });
  }

  handleChangeLibertyVendorPassword = (event) => {
    this.setState({ data_exchange_id: event.target.value });
  }

  handleClickLibertyVendorPassword = () => {
    this.setState({ showLibertyVendorPassword: !this.state.showLibertyVendorPassword });
  }

  handleClickLibertyApiKey = () => {
    this.setState({ showLibertyApiKey: !this.state.showLibertyApiKey });
  }

  handleMouseDownLibertySecret = (event) => {
    event.preventDefault();
  }

  renderLibertyFieldIcons = (helpText, visibility) => (
    <InputAdornment position='end'>
      {visibility ? (
        <IconButton
          aria-label='toggle visibility'
          onClick={visibility.onClick}
          onMouseDown={this.handleMouseDownLibertySecret}
          edge='end'
          size='small'
          tabIndex={-1}
        >
          {visibility.visible ? <Visibility fontSize='small' /> : <VisibilityOff fontSize='small' />}
        </IconButton>
      ) : null}
      <Tooltip title={helpText}>
        <Help style={{ cursor: 'help', color: 'rgba(0, 0, 0, 0.45)', fontSize: 20, marginLeft: 4 }} />
      </Tooltip>
    </InputAdornment>
  )

  handleChangeLibertyCustomerUserNameChange = (event) => {
    this.setState({ liberty_customer_username: event.target.value });
  }

  handleChangeLibertyCustomerPasswordChange = (event) => {
    this.setState({ liberty_customer_password: event.target.value });
  }

  handleChangeLibertyRxRegRxChange = (event) => {
    this.setState({ liberty_rx_regrx: event.target.value });
  }

  handleChangeLibertyCompletionStatus = (event) => {
    this.setState({ liberty_completion_status: event.target.value });
  };

  purgeImagePatientToggleAction = (event) => {
    if (event.target.checked && event.target.checked === true) {
      this.setState({
        purge_patient_images_toggle: event.target.checked,
        purgeImageDialog: true,
        purge_patienet_final_confirmation_dialog: false
      })
    } else {
      this.setState({
        purge_patient_images_toggle: event.target.checked,
        purge_patienet_final_confirmation_dialog: false
      })
    }
  }

  handlePurgeImageDialogUserName = (event) => {
    this.setState({ purge_patient_username_confirmation: event.target.value });
  }

  handlePurgeConfirmationYes = async () => {
    const {purge_patient_username_confirmation, purge_patient_password} = this.state;
    let userObj = {
      username: purge_patient_username_confirmation,
      password: purge_patient_password
    };
    let res = await AwsAuthSignIn(userObj);
    if (res && res.status === 200) {
      toast.success(res.instruction);
      this.setState({ purge_patienet_final_confirmation_dialog: true, purgeSpinnerInProgress: false })
    }
    else {
      toast.error(res.instruction);
      this.setState({ allowWait: false, readOnlyPwd: false, isButtonDisabled: false });
    }
  }

  handlePurgeConfirmationNo = () => {
    this.setState({
      purgeImageDialog: false,
      purge_patient_images_toggle: false,
      purge_patient_data_toggle: false,
      purgeSpinnerInProgress: false
    })
  }

  handlePurgeFinalConfirmationYes = () => {
    // const {purge_patient_username_confirmation} = this.state;
    const user = JSON.parse(sessionStorage.getItem('user'));
    this.setState({ purgeSpinnerInProgress: true });
    if (user) {
      const user_id = user.username;
      const auditReportObj = {
        user_id: user_id,
        description: `Paitent image purge is set to ${this.state.purge_patient_images_days_count} days.`,
        action_name: 'Account Settings',
        parent_account_id: sessionStorage.getItem('parentAccountId'),
        box_id: localStorage.getItem('selectedLocation'),
      }
      let _apiEndPoint = `${process.env.REACT_APP_BASEURL}auditreport`;
      fetch(_apiEndPoint, {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(auditReportObj)
      })
        .then((response) => response.json())
        .then((eventResponse) => {
          console.info(`Response from audit-log ${JSON.stringify(eventResponse, null, 2)}`)
          this.setState({
            purgeImageDialog: false,
            purge_patienet_final_confirmation_dialog: false,
            purge_patient_username_confirmation: '',
            purgeSpinnerInProgress: false
          })
        }).catch((error) => {
          console.info(`Error response from audit-log ${JSON.stringify(error, null, 2)}`)
          this.setState({
            purgeImageDialog: false,
            purge_patient_images_toggle: false,
            purge_patienet_final_confirmation_dialog: false,
            purge_patient_username_confirmation: '',
            purgeSpinnerInProgress: false
          })
          toast.error(error.message + ': ' + error.errorMessage);
        })
    }
  }

  handlePurgeFinalConfirmationNo = () => {
    this.setState({
      purgeImageDialog: false,
      purge_patient_images_toggle: false,
      purge_patient_data_toggle: false,
      purge_patienet_final_confirmation_dialog: false,
      purgeSpinnerInProgress: false
    })
  }

  setHours = (e) => {
    this.setState({ selectedHours: e.target.value });
    this.writeAuditLog(`Time to notify was changed by user.`);
  }

  handlePatientConsent = (name) => (event) => {
    this.setState({ patient_consent: event.target.checked });
  };

  
  handlePurgeImageDialogPasswordChange = (event) => {
    this.setState({ purge_patient_password: event.target.value });
  }

  callPurgeService = async () => {
    const parent_id = sessionStorage.getItem('parentAccountId');
    this.setState({ purgeSpinnerInProgress: true });
    let _apiEndPoint = `${process.env.REACT_APP_BASEURL}purge/patients/pictures`;
    fetch(_apiEndPoint, {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({ accountId: parent_id })
    })
      .then((response) => response.json())
      .then((eventResponse) => {
        console.info(`Response from purge service ${JSON.stringify(eventResponse, null, 2)}`)
        this.setState({
          purgeImageDialog: false,
          purge_patienet_final_confirmation_dialog: false,
          purge_patient_username_confirmation: '',
          purgeSpinnerInProgress: false
        })
      }).catch((error) => {
        console.info(`Error response from purge service ${JSON.stringify(error, null, 2)}`)
        this.setState({
          purgeImageDialog: false,
          purge_patient_images_toggle: false,
          purge_patienet_final_confirmation_dialog: false,
          purge_patient_username_confirmation: '',
          purgeSpinnerInProgress: false
        })
        toast.error(error.message + ': ' + error.errorMessage);
      })
  }

  handleConsultNotify = (name) => (event) => {
    this.setState({ is_consultation_notification: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Consultation Notification was ${status} by user.`);
  };

  handleTaxCodeChange = async (event) => {
    event.preventDefault();
    this.setState({ selectedTaxCode: event.target.value });
  };

  handleTaxRateChange = async (event) => {
    event.preventDefault();
    if (!(this.state.operation === 'View')) {
      const regex = /^$|^[0-9]+(\.[0-9]*)?$/;
      const newValue = event.target.value;
      const isMatch = regex.test(newValue);
      if (isMatch) {
        this.setState({ taxRate: newValue, helperText: null });
      } else {
        this.setState({ helperText: 'Please enter numbers and . only.' });
      }
    }
  }

  handleTaxable = (name) => (event) => {
    this.setState({ is_taxable: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Taxable was ${status} by user.`);
  };

  handlePermissionInherit = (name) => (event) => {
    this.setState({ is_permission_inheritable: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Inherit Role Permissions was ${status} by user.`);
  };

  handleCascadeAccountUpdate = (name) => (event) => {
    this.setState({ cascade_account_update: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Cascade Account Update was ${status} by user.`);
  };

  handleNeedHelpChange = (name) => (event) => {
    this.setState({ is_need_help_enabled: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`Need Help was ${status} by user.`);
  };

  writeAuditLog = (description, obj = {}) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (user) {
      const user_id = user.username;
      const auditReportObj = {
        user_id: user_id,
        description: description,
        action_name: 'Account Settings',
        parent_account_id: sessionStorage.getItem('parentAccountId'),
        box_id: localStorage.getItem('selectedLocation'),
      }
      fetch(`${process.env.REACT_APP_BASEURL}auditreport`, {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(auditReportObj)
      })
        .then((response) => response.json())
        .then((eventResponse) => {
          console.info(`Response from audit-log ${JSON.stringify(eventResponse, null, 2)}`)
        }).catch((error) => {
          console.info(`Error response from audit-log ${JSON.stringify(error, null, 2)}`)
          toast.error(error.message + ': ' + error.errorMessage);
        })
    } else {
      console.error('No user data found in session storage')
    }
  }

  handleSwitchChangeAdvanceFill = (event) => {
    this.setState({ advance_fills: event.target.checked });
  }

  handleSwitchChangeFillNumberApiFallback = (event) => {
    this.setState({ fill_number_api_fallback: event.target.checked });
  }
  
  handleKioskOpentimeChange = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const HoursOfOperation =
      this.state &&
      this.state.KioskHoursOfOperaionsArray &&
      this.state.KioskHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: event.target.value,
          closeTime: item.closeTime,
          isClosed: item.isClosed,
          isOpenAll: item.isOpenAll
        };
      });
    this.setState({ KioskHoursOfOperaionsArray: HoursOfOperation });
  };

  handleKioskClosetimeChange = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const HoursOfOperation =
      this.state &&
      this.state.KioskHoursOfOperaionsArray &&
      this.state.KioskHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: item.openTime,
          closeTime: event.target.value,
          isClosed: item.isClosed,
          isOpenAll: item.isOpenAll
        };
      });
    this.setState({ KioskHoursOfOperaionsArray: HoursOfOperation });
  };

  handleKioskBlurTime = (event) => {
    if (event && event.target && event.target.value > '23:59') {
      this.setState({ TimevalidateDialog: true });
    }
  };

  handleClosedCheckBox = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const _isChecked = event.target.checked;
    const HoursOfOperation =
      this.state &&
      this.state.KioskHoursOfOperaionsArray &&
      this.state.KioskHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: item.openTime,
          closeTime: item.closeTime,
          isClosed: _isChecked,
          isOpenAll: item.isOpenAll
        };
      });
    this.setState({ KioskHoursOfOperaionsArray: HoursOfOperation });
  };

  handleOpenAllCheckBox = (index) => (event) => {
    event.preventDefault && event.preventDefault();
    const _isChecked = event.target.checked;
    const HoursOfOperation =
      this.state &&
      this.state.KioskHoursOfOperaionsArray &&
      this.state.KioskHoursOfOperaionsArray.map((item, idx) => {
        if (idx !== index) return item;
        return {
          id: idx,
          value: item.value,
          openTime: item.openTime,
          closeTime: item.closeTime,
          isClosed: item.isClosed,
          isOpenAll: _isChecked
        };
      });
    this.setState({ KioskHoursOfOperaionsArray: HoursOfOperation });
  };

  setPermissions = () => {
    let permissions  = JSON.parse(sessionStorage.getItem('permissions'));
    let admin = JSON.parse(sessionStorage.getItem('admin'));
    let superadmin = JSON.parse(sessionStorage.getItem('superadmin'));
    if((![undefined, 'undefined', null, 'null', ''].includes(superadmin)) || (![undefined, 'undefined', null, 'null', ''].includes(admin))) {
      this.setState({ isPHiS: true, accountview: true, accountadd: true, accountedit: true, accountdelete: true, isSuperAdmin: true });
    } else {
      this.setState({ isPHiS: false, isSuperAdmin: false, accountview: false, accountadd: false, accountedit: false, accountdelete: false });
    }
    if (permissions && permissions.length > 0) {
      const _manageAccounts = permissions.filter((items) => items.permission_entity_type === 'Manage Accounts');
      console.log(_manageAccounts, "_manageAccounts")
      if (_manageAccounts && _manageAccounts.length > 0) {
        this.setState({
          isPHiS: _manageAccounts.some((x) => x.name.trim() === 'Connect to PHiS' && x.is_allowed === 1),
          accountadd: _manageAccounts.some((x) => x.name.trim() === 'Add' && x.is_allowed === 1),
          accountedit: _manageAccounts.some((x) => x.name.trim() === 'Modify' && x.is_allowed === 1),
          accountview: _manageAccounts.some((x) => x.name.trim() === 'View' && x.is_allowed === 1),
          accountdelete: _manageAccounts.some((x) => x.name.trim() === 'Delete' && x.is_allowed === 1)
        })
      } else {
        this.setState({ isPHiS: false, accountview: false, accountadd: false, accountedit: false, accountdelete: false });
      }
    } else {
      this.setState({ isPHiS: false, accountview: false, accountadd: false, accountedit: false, accountdelete: false });
    }
  }

  handleChangeHL7XApiKey = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ hl_x_api_key: event.target.value });
  }

  handleMouseDownHL7APIKey = (event) => {
    event.preventDefault();
  };

  handleClickHL7XApiKey = () => {
    this.setState({ showHLXApiKey: !this.state.showHLXApiKey });
  };

  handleChangeDRXKey = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ drx_key: event.target.value });
  }

  handleMouseDownDRXKey = (event) => {
    event.preventDefault();
  };

  handleClickDRXKey = () => {
    this.setState({ showDRXKey: !this.state.showDRXKey });
  };

  handleSetTemp=(e)=>{
    this.setState({ tempUnit: e.target.value });
    this.writeAuditLog(`Temperature Unit was changed by user.`);
  }

  handleScreenSaverRotationTimeChange = (e) => {
    const inputValue = e.target.value;

    // Allow empty string (for clearing), or positive integers (no decimals, no negatives)
    if (inputValue === '' || /^[1-9]\d*$/.test(inputValue)) {
      this.setState({ screensaverRotationTime: inputValue });
    }
  };

  handleScreenSaverRotationTimeBlur = () => {
    // Set value to empty if it's invalid when user leaves the input
    const {screensaverRotationTime} = this.state;
    if (screensaverRotationTime === '' || isNaN(Number(screensaverRotationTime)) || Number(screensaverRotationTime) <= 0) {
      this.setState({ screensaverRotationTime: '' });
    }
  };

  handleExternalIdChangeEvent = (event) => {
    event.persist();
    this.setState({ external_id: event.target.value });
  };
  handleChangeSecureBadgeDuration = (e) => {
    this.setState({ securebadgeexpiryduration: e.target.value })
    let duration = (e.target.value ? e.target.value : 0);
    this.writeAuditLog(`Secure badge activity duration was changed to '${duration}' by user.`);
  }

  checkIfExternalIdExist = () => {
    try {
      console.log();
      fetch(process.env.REACT_APP_BASEURL + "accounts/external-id-check", {
        method: "POST",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            "table": "accounts", 
            "column": "external_id", 
            "value": this.state.external_id,
            "lang": localStorage.getItem("i18nextLng")
        })
      })
        .then((response) => response.json())
        .then((idCheckResponse) => {
          console.log({ idCheckResponse });
          if(idCheckResponse.statusCode === 200) {
            toast.error(idCheckResponse && idCheckResponse.message);
          }
        }).catch((err) => {
          toast.error((err && err.message) || `Error while checking external id exists or not.`)
        });
    } catch(error) {
      toast.error(`Failed to validate external id`)
    }
  }

  handleSwitchVialScanLabel = (event) => {
    this.setState({ vial_label_scan: event.target.checked });
  };

  handleSwitchPreventAssigningNonReady = (event) => {
    this.setState({ prevent_assigning_non_ready: event.target.checked });
  };

  handleChangeRegExp = (event) => {
    this.setState({ regexp: event.target.value });
  }

  handleChangeEpicRegExp = (event) => {
    this.setState({ regexp: resolveEpicScanRegexp(event.target.value) });
  }

  handleBannerDrop = (acceptedFiles, rejectedFiles) => {
    this.setState({isBannerSizeError : false})
    const file = acceptedFiles[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = () => {
        if (img.width !== 1080 || img.height !== 180) {
          this.setState({isBannerSizeError : true})
          return;
        }

        this.setState({
          bannerImg: acceptedFiles[0].preview,
          file: acceptedFiles,
        });
      };
    };
  };

  removeBanner = () => {
    const parent = document.getElementById('bannerImg');
    let bannerImg = ((parent.children && parent.children[0]).src = '');
    banner = new File([bannerImg], 'removeBanner');
    this.setState({
      bannerImg: null,
    });
  };

  handleHeaderDrop = (acceptedFiles, rejectedFiles) => {
    this.setState({isHeaderSizeError : false})
    const file = acceptedFiles[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = () => {
        if (img.width !== 1080 || img.height !== 84) {
          this.setState({isHeaderSizeError : true})
          return;
        }

        this.setState({
          headerImg: acceptedFiles[0].preview,
          file: acceptedFiles,
        });
      };
    };
  };

  removeHeader = () => {
    const parent = document.getElementById('headerImg');
    let headerImg = ((parent.children && parent.children[0]).src = '');
    header = new File([headerImg], 'removeHeader');
    this.setState({
      headerImg: null,
    });
  };

  generateShortUniqueSuffix() {
    const timestamp = Date.now().toString(36).slice(-6); // Get the last 6 characters of the timestamp in base 36
    const randomString = Math.random().toString(36).slice(2, 6); // Short random string of 4 characters
    return `${timestamp}${randomString}`;
  }

  handleCreateClone = (data, currentAccountName) => {
    this.setState({ loader: true, anchorEl: null, selectedRowId: null});

    let isAccountAvailable = false;

    let objAvailability = { accountName: currentAccountName };

    fetch(process.env.REACT_APP_BASEURL + 'CheckAccountAvailability', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(objAvailability),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        let availabilityParsed = JSON.parse(res);
        isAccountAvailable = availabilityParsed.IsAvailable;
        if (isAccountAvailable === 'true' || isAccountAvailable === true) {
          const result = fetch(process.env.REACT_APP_BASEURL + 'accounts', {
            method: 'POST',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
            },
            body: data,
          });
          result
            .then((result) => {
              result.json().then(async (res) => {
                this.setState({ loader: false });
                if (res.error) {
                  res.message.includes('SSO Account already exist!')
                    ? this.setState({
                      errorMessage: res.message,
                      isSSOAccountExist: true,
                    })
                    : this.setState({
                      errorMessage: res.message,
                      isSSOAccountExist: false,
                    });
                  toast.error(res.message);
                } else {
                  this.state.data.unshift(res.account);
                  const newData = JSON.parse(JSON.stringify(this.state.data));
                  sessionStorage.setItem('timeZone', this.state.time_zone);
                  /* audit report log object */
                  let auditObj = {
                    name: this.state.name,
                    email: this.state.email,
                    parent_id: this.state.parent_id,
                    type_id: this.state.type_id,
                  };
                  if (!res.audit_recorded && !res.audit_failed_sections) this.writeAuditLog(`'${auditObj.name}' account created by user.`, auditObj);
                  const accountId = res && res.account && res.account.id
                  const parentAccountId = res && res.account && res.account.parent_account_id
                  const isPermissionInheritable = res && res.account && res.account.is_permission_inheritable
                  if ([true, 'true'].includes(isPermissionInheritable)) {
                    await this.inheritPermissionsFromParent(accountId, parentAccountId)
                  }
                  /* audit report log object */
                  this.setState({ data: newData })
                  FilterObj.searchtext = '';
                  FilterObj.sortOrder = 'desc';
                  FilterObj.sortColumn = 'created_on';
                  FilterObj.tableName = '';
                  if (res.save_outcome === 'partial') toast.warn('Some account settings were not saved: ' + (res.failed_sections || []).join(', '));
                  else toast.success(this.props.t('Toast.Success.AccountAdded'));
                  this.BindBoxes();
                }
              });
            })
            .catch((error) => {
              this.setState({ loader: false });
              this.setState({ errorMessage: error.message });
            });
        } else {
          toast.error(this.props.t('Toast.Error.AccountExist'));
          this.setState({ loader: false });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .catch((error) => {
        this.setState({ loader: false });
        toast.error(error.message);
      });
  };

  handleClone = async () => {
    this.setState({isClone : false})
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    var data = new FormData();

    let ad1preview = null;
    let ad2preview = null;
    let ad3preview = null;
    let vdpreview = null;
    let bottomad1preview = null;
    let bottomad2preview = null;
    let bottomad3preview = null;
    if (
      selectedObject &&
      selectedObject.brand_detail &&
      selectedObject.brand_detail.length > 0
    ) {
      for (let i = 0; i < selectedObject.brand_detail.length; i++) {
        if (selectedObject.brand_detail[i].ad_number === 'ad1') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            ad1preview = selectedObject.brand_detail[i].logo_url;
          } else {
            ad1preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'ad2') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            ad2preview = selectedObject.brand_detail[i].logo_url;
          } else {
            ad2preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'ad3') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            ad3preview = selectedObject.brand_detail[i].logo_url;
          } else {
            ad3preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'vd') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            vdpreview = selectedObject.brand_detail[i].logo_url;
          } else {
            vdpreview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'bottomad1') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            bottomad1preview = selectedObject.brand_detail[i].logo_url;
          } else {
            bottomad1preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'bottomad2') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            bottomad2preview = selectedObject.brand_detail[i].logo_url;
          } else {
            bottomad2preview = '';
          }
        }
        if (selectedObject.brand_detail[i].ad_number === 'bottomad3') {
          if (selectedObject.brand_detail[i].logo_url !== 'undefined') {
            bottomad3preview = selectedObject.brand_detail[i].logo_url;
          } else {
            bottomad3preview = '';
          }
        }
      }
    }

    const AccountsHOPObject = await this.convertAccountHoursOfOperationsObject(
      selectedObject && selectedObject.account_hoursof_operations
    );
    const AccountHoursOfOperations = await this.hanldeAccountHoursOfOperations(
      AccountsHOPObject
    );
    const accountHoursToSend =
      AccountHoursOfOperations && AccountHoursOfOperations.length
        ? AccountHoursOfOperations
        : this.state.AccountDummyHoursOfOperaionsArray;

    const kiosk_hoursof_operations = getAccountLevelKioskHours(selectedObject);
    const KioskHOPObject = await this.convertAccountHoursOfOperationsObject(kiosk_hoursof_operations[0]);
    const KioskHoursOfOperations = await this.hanldeAccountHoursOfOperations(KioskHOPObject);
    const kioskHoursToSend =
      KioskHoursOfOperations && KioskHoursOfOperations.length
        ? KioskHoursOfOperations
        : this.state.KioksDummyHoursOfOperaionsArray;

    let account_connections_id = [];
    if (selectedObject && selectedObject.account_connections_id !== null) {
      if (
        selectedObject.connection !== undefined &&
        selectedObject.connection.name !== undefined
      ) {
        account_connections_id.push({
          id: selectedObject.account_connections_id,
          name: selectedObject.connection.name,
        });
      }
    }

    data.append('id', selectedObject.id);
    data.append('avatar', ![undefined, null, 'undefined', 'null', ''].includes(selectedObject.picture_url) ? selectedObject.picture_url : '');
    data.append('ad1', ad1preview);
    data.append('ad2', ad2preview);
    data.append('ad3', ad3preview);
    data.append('blogo', ![undefined, null, 'undefined', 'null', ''].includes(selectedObject.brand.logo_url) ? selectedObject.brand.logo_url : '');
    data.append('vd', vdpreview);
    data.append('cloesdimg', kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].closedimg_url);
    data.append('hippa', selectedObject.legal_compliance && selectedObject.legal_compliance.legal_compliance_docone_url);
    data.append('LC', selectedObject.legal_compliance && selectedObject.legal_compliance.legal_compliance_doctwo_url);
    data.append('OTHER', selectedObject.legal_compliance && selectedObject.legal_compliance.legal_compliance_docthree_url);
    data.append('bottomad1', bottomad1preview);
    data.append('bottomad2', bottomad2preview);
    data.append('bottomad3', bottomad3preview);
    data.append('bannerImg', ![undefined, null, 'undefined', 'null', ''].includes(selectedObject.brand.banner_img) ? selectedObject.brand.banner_img : '')
    data.append('headerImg', ![undefined, null, 'undefined', 'null', ''].includes(selectedObject.brand.header_img) ? selectedObject.brand.header_img : '')
    data.append('brand_id', '');
    data.append('parent_id', selectedObject.parent && selectedObject.parent.id);
    data.append('type_id', selectedObject.type.id);
    data.append('address1', '');
    data.append('address2', '');
    data.append('city', '');
    data.append('state', '');
    data.append('zip', '');
    data.append('first_name', selectedObject.contact && selectedObject.contact.name && selectedObject.contact.name.split(' ')[0]);
    data.append('last_name', selectedObject.contact && selectedObject.contact.name && selectedObject.contact.name.split(' ')[1]);
    data.append('email', selectedObject.contact && selectedObject.contact.email);
    data.append('phone', selectedObject.contact && selectedObject.contact.phone);
    data.append('brandname', '');
    data.append('generalphone', '');
    data.append('after_hour_phone', '');
    data.append('website', '');
    data.append('fax', '');
    data.append('generalemail', '');
    data.append('account_connections_id', selectedObject.account_connections_id);
    data.append('is_payment_required', selectedObject.is_payment_required);
    data.append('contractLang', selectedObject.contract_language);
    data.append('demo_email', selectedObject.demo_email);
    data.append('demo_smsphone', selectedObject.demo_phone);
    data.append('Expiration_Day', ![undefined, null, 'undefined', 'null', ''].includes(selectedObject.expiration_days) ? selectedObject.expiration_days : '');
    data.append('endpoint', account_connections_id.length > 0 ? this.AssignEndPoint(account_connections_id[0].id, selectedObject) : '');
    data.append('pharmacyid', selectedObject && selectedObject.connection_details && selectedObject.connection_details.pharmacyid);
    data.append('pick_up_reminder_day', selectedObject.pick_up_reminder_day);
    data.append('HopType', 'AccountLevel');
    data.append('closedMsg', kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].closed_msg);
    data.append('Health_and_info', JSON.stringify(selectedObject.health_and_informations));
    data.append('primaryLibtitle1', selectedObject && selectedObject.health_and_informations && selectedObject.health_and_informations.length > 0 && selectedObject.health_and_informations[0].primarylibrary_title1);
    data.append('primaryLibtitle2', selectedObject && selectedObject.health_and_informations && selectedObject.health_and_informations.length > 0 && selectedObject.health_and_informations[0].primarylibrary_title2);
    data.append(
      'vendor_key',
      (selectedObject && selectedObject.account_connections_id) === CONNECTION_TYPE.LIBERTY_SOFTWARE
        ? (
          (selectedObject && selectedObject.connection_details && selectedObject.connection_details.vendor_key) ||
          DEFAULT_LIBERTY_VENDOR_USERNAME
        )
        : (selectedObject && selectedObject.connection_details && selectedObject.connection_details.vendor_key)
    );
    data.append(
      'data_exchange_id',
      (selectedObject && selectedObject.account_connections_id) === CONNECTION_TYPE.LIBERTY_SOFTWARE
        ? (
          (selectedObject && selectedObject.connection_details && selectedObject.connection_details.data_exchange_id) ||
          DEFAULT_LIBERTY_VENDOR_PASSWORD
        )
        : (selectedObject && selectedObject.connection_details && selectedObject.connection_details.data_exchange_id)
    );
    data.append('doc_one', selectedObject.legal_compliance && selectedObject.legal_compliance.legal_compliance_docone_label);
    data.append('doc_two', selectedObject.legal_compliance && selectedObject.legal_compliance.legal_compliance_doctwo_label);
    data.append('doc_three', selectedObject.legal_compliance && selectedObject.legal_compliance.legal_compliance_docthree_label);
    data.append('helpLink', '');
    data.append('privacyPolicyLink', '');
    data.append('termsAndConditionsLink', '');
    data.append('epicclientid', account_connections_id.length > 0 ? this.AssignEpicclientID(account_connections_id[0].id, null) : '');
    data.append('epicusername', account_connections_id.length > 0 ? this.AssignEpicUserName(account_connections_id[0].id, null) : '');
    data.append('epicpassword', account_connections_id.length > 0 ? this.AssignEpicUserPassword(account_connections_id[0].id, null) : '');
    data.append('is_advance_advertise', selectedObject.is_advance_advertise);
    data.append('xWebId', '**********');
    data.append('auth_Key', '**********');
    data.append('terminalId', '**********');
    data.append('fiserv_link_username', selectedObject && selectedObject.fiserv_link_username ? selectedObject.fiserv_link_username : '');
    data.append('fiserv_link_password', selectedObject && selectedObject.fiserv_link_password ? '**********' : '');
    data.append('fiserv_terminal_api_key', selectedObject && selectedObject.fiserv_terminal_api_key ? '**********' : '');
    data.append('trustcommerce_link_custid', selectedObject && selectedObject.trustcommerce_link_custid ? selectedObject.trustcommerce_link_custid : '');
    data.append('trustcommerce_link_password', selectedObject && selectedObject.trustcommerce_link_password ? '**********' : '');
    data.append('trustcommerce_terminal_custid', selectedObject && selectedObject.trustcommerce_terminal_custid ? selectedObject.trustcommerce_terminal_custid : '');
    data.append('trustcommerce_terminal_password', selectedObject && selectedObject.trustcommerce_terminal_password ? '**********' : '');
    data.append('trustcommerce_aggregator1', selectedObject && selectedObject.trustcommerce_aggregator1 ? '**********' : '');
    data.append('trustcommerce_aggregators', selectedObject && selectedObject.trustcommerce_aggregators ? selectedObject.trustcommerce_aggregators : '');
    data.append('instamed_account_id', selectedObject && selectedObject.instamed_account_id ? selectedObject.instamed_account_id : '');
    data.append('instamed_account_id_suffix', selectedObject && selectedObject.instamed_account_id_suffix ? selectedObject.instamed_account_id_suffix : '');
    data.append('instamed_connect_user_id', selectedObject && selectedObject.instamed_connect_user_id ? selectedObject.instamed_connect_user_id : '');
    data.append('instamed_connect_password', selectedObject && selectedObject.instamed_connect_password ? '**********' : '');
    data.append('instamed_api_key', selectedObject && selectedObject.instamed_api_key ? '**********' : '');
    data.append('instamed_api_secret', selectedObject && selectedObject.instamed_api_secret ? '**********' : '');
    data.append('instamed_sso_security_key', selectedObject && selectedObject.instamed_sso_security_key ? '**********' : '');
    data.append('allow_payment', selectedObject.gbpconfig &&
      selectedObject.gbpconfig.allow_payment
      ? selectedObject.gbpconfig.allow_payment
      : false);
    data.append('epicPharmacyNcpdpId', selectedObject &&
      selectedObject.template &&
      selectedObject.template.pharmacy_ncpdpid
      ? selectedObject.template.pharmacy_ncpdpid
      : '');
    data.append('epicEndpointVersion', selectedObject &&
      selectedObject.template &&
      selectedObject.template.versions
      ? selectedObject.template.versions
      : '');
    data.append('epicRequestTempate', selectedObject &&
      selectedObject.template &&
      selectedObject.template.request_template
      ? selectedObject.template.request_template
      : '');
    data.append('allow_consult_video', selectedObject && selectedObject.is_allow_consult_video);
    data.append('allow_consult_mobile', selectedObject && selectedObject.is_allow_consult_mobile);
    data.append('allow_consult_schedule', selectedObject && selectedObject.is_allow_consult_schedule);
    data.append(
      'isContactLessPickupEnabled',
      selectedObject && selectedObject.isContactLessPickupEnabled
        ? selectedObject.isContactLessPickupEnabled
        : false
    );
    data.append('accContactPersons',selectedObject && JSON.stringify(selectedObject.accContactPersons));
    data.append('IsGetReady', ![undefined, null, 'undefined', 'null', ''].includes(selectedObject.is_getready) ? selectedObject.is_getready : '');
    data.append('medbank_dblogin', selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.medbank_dblogin);
    data.append('medbank_db_password', selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.medbank_db_password);
    data.append(
      'opc_apim_subscription_key',
      selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.opc_apim_subscription_key
    );
    data.append('x_api_key', selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.x_api_key);
    data.append('gateway_api_key', selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.gateway_api_key);
    data.append('client_identifier', selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.client_identifier);
    data.append('is_marketplace', ![undefined, null, 'undefined', 'null', ''].includes(selectedObject.is_marketplace) ? selectedObject.is_marketplace : '');
    data.append('is_consult_required', selectedObject && selectedObject.connection_details.is_consult_required);
    data.append('consult_key', selectedObject && selectedObject.connection_details.consult_key);
    data.append('active_patient', true);
    data.append('login_type', "");
    data.append('issuer', "");
    data.append('email_domain', "");
    data.append('client_id', "");
    data.append('oidc_cert', "");
    data.append('sso_entry_point', "");
    data.append('bypass_consult', selectedObject && selectedObject.bypass_consult);
    data.append('StartGraphic', selectedObject && selectedObject.is_startgraphictextvisible);
    data.append('IsPatientPrimarySource', selectedObject && selectedObject.is_patient_primary_source);
    data.append('accountHoursOfOperations', JSON.stringify(accountHoursToSend));
    data.append('autoDisabledUser', selectedObject && selectedObject.is_auto_disabled_user);
    data.append('is_auto_logout_enabled', selectedObject && (selectedObject.is_auto_logout_enabled === true || selectedObject.is_auto_logout_enabled === 'true'));
    data.append('useDefaultEmail', selectedObject && selectedObject.use_default_email);
    data.append('is_dispense_safety_check', selectedObject && selectedObject.is_dispense_safety_check);
    data.append('is_forgot_mypucode', selectedObject && selectedObject.is_forgot_mypucode);
    data.append(
      'is_modern_email_enabled',
      selectedObject && selectedObject.is_modern_email_enabled ? 'true' : 'false'
    );
    data.append(
      'is_pickup_change_email_enabled',
      selectedObject && selectedObject.is_pickup_change_email_enabled ? 'true' : 'false'
    );
    data.append(
      'is_mask_kiosk_dob',
      selectedObject && selectedObject.is_mask_kiosk_dob !== undefined
        ? selectedObject.is_mask_kiosk_dob
        : true
    );
    data.append('timezone', selectedObject && selectedObject.timezone);
    data.append('store_number', account_connections_id.length > 0 ? this.AssignMckssoRERx(account_connections_id[0].id, null) : '');
    data.append('mcKessoneRXrequestTemplate', selectedObject.template &&
      selectedObject.template.request_template
      ? selectedObject.template.request_template
      : ''
    );
    data.append('binaryToken', account_connections_id.length > 0
      ? this.AssignMcKssonRXBinaryToken(
        account_connections_id[0].id,
        null
      )
      : '');
    data.append(
      'issuerMc',
      account_connections_id.length > 0
        ? this.AssignMckessonRxIssuer(
          account_connections_id[0].id,
          null
        )
        : ''
    );
    data.append(
      'cfrheadertemplate',
      selectedObject &&
        selectedObject.template &&
        selectedObject.template.cfrheadertemplate
        ? selectedObject.template.cfrheadertemplate
        : ''
    );
    data.append(
      'rxinfobodytemplate',
      selectedObject &&
        selectedObject.template &&
        selectedObject.template.rxinfobodytemplate
        ? selectedObject.template.rxinfobodytemplate
        : ''
    );
    data.append(
      'rxinfoheadertemplate',
      selectedObject.template &&
        selectedObject.template.rxinfoheadertemplate
        ? selectedObject.template.rxinfoheadertemplate
        : ''
    );
    data.append(
      'posfinalizationbodytemplate',
      selectedObject &&
        selectedObject.template &&
        selectedObject.template.posfinalizationbodytemplate
        ? selectedObject.template.posfinalizationbodytemplate
        : ''
    );
    data.append(
      'posfinalizationheadertemplate',
      selectedObject &&
        selectedObject.template &&
        selectedObject.template.posfinalizationheadertemplate
        ? selectedObject.template.posfinalizationheadertemplate
        : ''
    );
    data.append('authToken', '**********');
    data.append('authSecret', '**********');
    data.append('paymentType', selectedObject && selectedObject.selected_paymentgatway);
    data.append('merchant_id', selectedObject &&
      selectedObject.gbpconfig &&
      selectedObject.gbpconfig.merchant_id
      ? selectedObject.gbpconfig.merchant_id
      : '');
    data.append('hpp_identifier', selectedObject &&
      selectedObject.gbpconfig &&
      selectedObject.gbpconfig.hpp_identifier
      ? selectedObject.gbpconfig.hpp_identifier
      : '');
    data.append('preferredlanguage', selectedObject && selectedObject.preferred_language);
    data.append('is_otp_login', selectedObject && selectedObject.is_otp_login);
    data.append('is_enroll_now', selectedObject && selectedObject.is_enroll_now);
    data.append(
      'enrollment_v2_enabled',
      selectedObject && selectedObject.enrollment_v2_enabled !== undefined
        ? selectedObject.enrollment_v2_enabled
        : true
    );
    data.append(
      'hide_new_ui',
      selectedObject &&
        selectedObject.hide_new_ui !== undefined &&
        selectedObject.hide_new_ui !== null
        ? [true, 'true', 1, '1'].includes(selectedObject.hide_new_ui)
        : true
    );
    data.append('is_mfa_required', selectedObject && selectedObject.is_mfa_required);
    data.append('allow_member_or_record_number', selectedObject && selectedObject.allow_member_or_record_number);
    data.append('allow_offline_payment_skip', selectedObject && selectedObject.allow_offline_payment_skip)
    data.append('is_numeric_code', selectedObject && selectedObject.is_numeric_code);
    data.append('is_future_release', selectedObject && selectedObject.is_future_release);
    data.append('liberty_customer_username', selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_customer_username);
    data.append('liberty_customer_password', selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_customer_password);
    data.append('liberty_rx_regrx', selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_rx_regrx);
    data.append(
      'liberty_completion_status',
      (selectedObject && selectedObject.connection_details && selectedObject.connection_details.liberty_completion_status) ||
        DEFAULT_LIBERTY_COMPLETION_STATUS
    );
    data.append('third_party_token', selectedObject && selectedObject.connection_details && selectedObject.connection_details.third_party_token);
    data.append('vendor_unique_id', selectedObject && selectedObject.connection_details && selectedObject.connection_details.vendor_unique_id);
    data.append('purge_patient_images_toggle', selectedObject && selectedObject.purge_patient_images_toggle);
    data.append('purge_patient_images_days_count', selectedObject && selectedObject.purge_patient_images_days_count);
    data.append('time_to_notify', (selectedObject && selectedObject.time_to_notify) || '09')
    data.append('patient_consent', selectedObject && selectedObject.patient_consent);
    data.append('is_pre_assignment', selectedObject && selectedObject.is_pre_assignment);
    data.append('is_consultation_notification', selectedObject && selectedObject.is_consultation_notification);
    data.append('is_taxable', selectedObject && selectedObject.is_taxable);
    data.append('is_permission_inheritable', selectedObject && selectedObject.is_permission_inheritable);
    data.append('tax_code', selectedObject && selectedObject.tax_data && [0, 1, 2, 3].includes(selectedObject.tax_data.tax_code) ? selectedObject.tax_data.tax_code : -1);
    data.append('tax_rate', selectedObject && selectedObject.tax_data && selectedObject.tax_data.tax_rate ? selectedObject.tax_data.tax_rate : '');
    data.append('store_ncp_id', selectedObject && selectedObject.store_ncp_id);
    data.append('advance_fills', selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.advance_fills);
    data.append('kiosk_hoursof_operations',JSON.stringify(kioskHoursToSend));
    data.append('hl_x_api_key', selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.hl_x_api_key);
    data.append('drx_key', selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.drx_key);
    data.append('lunch_start', kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].lunch_start);
    data.append('lunch_end', kiosk_hoursof_operations[0] && kiosk_hoursof_operations[0].lunch_end);
    data.append('temp_unit', selectedObject && selectedObject.temp_unit);
    data.append('screensaver_rotation_timing', selectedObject && selectedObject.screensaver_rotation_timing)
    data.append('external_id', '');
    data.append('securebadgeexpiryduration', selectedObject && selectedObject.securebadgeexpiryduration);
    data.append('vial_label_scan', selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.vial_label_scan);
    data.append('prevent_assigning_non_ready', [true, 'true'].includes(
      selectedObject &&
      selectedObject.connection_details &&
      selectedObject.connection_details.prevent_assigning_non_ready
    ));
    data.append(
      'regexp',
      storedEpicRegexp(
        selectedObject && selectedObject.connection_details && selectedObject.connection_details.regexp,
        selectedObject && selectedObject.account_connections_id
      )
    );
    data.append('fill_number_api_fallback', [true, 'true'].includes(selectedObject && selectedObject.connection_details && selectedObject.connection_details.fill_number_api_fallback));
    data.append('optical_expiration_days', ![undefined, 'undefined', null, 'null', ''].includes(selectedObject && selectedObject.optical_expiration_days) ? selectedObject && selectedObject.optical_expiration_days : '');
    data.append('text2pay_token_expiration_days', ![undefined, 'undefined', null, 'null', ''].includes(selectedObject && selectedObject.text2pay_token_expiration_days) ? selectedObject.text2pay_token_expiration_days : 1);
    data.append('optical_secure_badge_expiration', ![undefined, 'undefined', null, 'null', ''].includes(selectedObject && selectedObject.optical_secure_badge_expiration) ? selectedObject && selectedObject.optical_secure_badge_expiration : '');
    data.append('purge_patient_data_toggle', selectedObject && selectedObject.purge_patient_data_toggle);
    data.append('purge_patient_data_days_count', selectedObject && selectedObject.purge_patient_data_days_count);
    data.append('basic_first_name',  selectedObject && selectedObject.basic_first_name);
    data.append('basic_last_name', selectedObject && selectedObject.basic_last_name);
    data.append('is_dob_optional', [true, 'true', 1, '1'].includes(selectedObject && selectedObject.is_dob_optional));
    data.append('cascade_account_update',  selectedObject && selectedObject.cascade_account_update);

    for (let i = 0; i < (this.state.cloneCount || 1); i++) {
      const generatedName = this.generateShortUniqueSuffix();
      let currentAccountName = `${selectedObject.name} (${generatedName})`;
      data.set('name', currentAccountName);

      await this.handleCreateClone(data, currentAccountName);

      // Add a delay of, say, 1 second (1000 ms) before the next iteration
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
  };

  handleOpenCloneDialog = () => {
    this.setState({ isClone: true })
  }
  
  handleCloseCloneDialog = () => {
    this.setState({ isClone: false })
  }

  handlePurgeDataToggle = (e) => {
    if (e.target.checked && e.target.checked === true) {
      this.setState({
        purge_patient_data_toggle: e.target.checked,
        purgeDataDialog: true,
        purgeDataFinalDialog: false
      })
    } else {
      this.setState({
        purge_patient_data_toggle: e.target.checked,
        purgeDataFinalDialog: false
      })
    }
  }

  handlePurgeDataConfirmationYes = async () => {
    const {purge_patient_username_confirmation, purge_patient_password} = this.state;
    let userObj = {
      username: purge_patient_username_confirmation,
      password: purge_patient_password
    };
    let res = await AwsAuthSignIn(userObj);
    if (res && res.status === 200) {
      toast.success(res.instruction);
      this.setState({ purgeDataFinalDialog: true, purgeSpinnerInProgress: false })
    }
    else {
      toast.error(res.instruction);
      this.setState({ allowWait: false, readOnlyPwd: false, isButtonDisabled: false });
    }
  }

  handlePurgeDataConfirmationNo = () => {
    this.setState({
      purgeDataDialog: false,
      purge_patient_data_toggle: false,
      purgeSpinnerInProgress: false
    })
  }

  handlePurgeDataFinalConfirmationYes = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    this.setState({ purgeSpinnerInProgress: true });
    if (user) {
      const user_id = user.username;
      const auditReportObj = {
        user_id: user_id,
        description: `Paitent data purge is set to ${this.state.purge_patient_data_days_count} days`,
        action_name: 'Account Settings',
        parent_account_id: sessionStorage.getItem('parentAccountId'),
        box_id: localStorage.getItem('selectedLocation'),
      }
      let _apiEndPoint = `${process.env.REACT_APP_BASEURL}auditreport`;
      fetch(_apiEndPoint, {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(auditReportObj)
      })
        .then((response) => response.json())
        .then((eventResponse) => {
          console.info(`Response from audit-log ${JSON.stringify(eventResponse, null, 2)}`)
          this.setState({
            purgeDataDialog: false,
            purgeDataFinalDialog: false,
            purge_patient_username_confirmation: '',
            purgeSpinnerInProgress: false
          })
        }).catch((error) => {
          console.info(`Error response from audit-log ${JSON.stringify(error, null, 2)}`)
          this.setState({
            purgeDataDialog: false,
            purgeDataFinalDialog: false,
            purge_patient_data_toggle: false,
            purge_patient_username_confirmation: '',
            purgeSpinnerInProgress: false
          })
          toast.error(error.message + ': ' + error.errorMessage);
        })
    }
  }

  handlePurgeDataFinalConfirmationNo = () => {
    this.setState({
      purgeDataDialog: false,
      purgeDataFinalDialog: false,
      purge_patient_data_toggle: false,
      purgeSpinnerInProgress: false
    })
  }

  handleCalculateTaxToggle = (event) => {
    this.setState({ calculate_tax: event.target.checked });
    const status = event.target.checked ? 'enabled' : 'disabled';
    this.writeAuditLog(`calculate tax was ${status} by user.`);
  };

  handleChangeDRXHost = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ drx_host: event.target.value });
  }

  handleChangePrimeRxClientIdentifier = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ prx_client_identifier: event.target.value });
  };

  handleClickPRXClientIdentifier = () => {
    this.setState({
      show_prx_client_identifier: !this.state.show_prx_client_identifier,
    });
  };

  handleMouseDownPRXClientIdentifier = (event) => {
    event.preventDefault && event.preventDefault();
  };

  handleChangePrimeRxXApiKey = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ prx_xapi_key: event.target.value });
  };

  handleClickPRXXApiKey = () => {
    this.setState({
      show_prx_xapi_key: !this.state.show_prx_xapi_key,
    });
  };

  handleMouseDownPRXXApiKey = (event) => {
    event.preventDefault && event.preventDefault();
  };

  handleChangePrimeRxEndoint = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ prx_endoint: event.target.value });
  };

  handleClickPRXClientId = () => {
    this.setState({
      show_prx_client_id: !this.state.show_prx_client_id,
    });
  };

  handleMouseDownPRXClientId = (event) => {
    event.preventDefault && event.preventDefault();
  };

  handleChangePrimeRxClientId = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ prx_client_id: event.target.value });
  };

  handleChangePrimeRxClientSecret = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ prx_client_secret: event.target.value });
  };

  handleClickPRXClientSecret = () => {
    this.setState({
      show_prx_client_secret: !this.state.show_prx_client_secret,
    });
  };

  handleMouseDownPRXClientSecret = (event) => {
    event.preventDefault && event.preventDefault();
  };

  handleChangePrimeRxMemberId = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ prx_memberid: event.target.value });
  };

  componentWillUnmount() {
    FilterObj.searchtext = '';
  }

  getLoggedInHomeAccountId = () => sessionStorage.getItem('parentAccountId');

  isEditingOwnHomeAccount = () => {
    const homeId = this.getLoggedInHomeAccountId();
    const accountId = this.state.account && this.state.account.id;
    return (
      this.state.operation !== 'Add' &&
      Boolean(homeId) &&
      Boolean(accountId) &&
      String(accountId) === String(homeId)
    );
  };

  getParentAccountSelectValues = () => {
    const accountId = this.state.account && this.state.account.id;
    const values = (Array.isArray(this.state.accountValues)
      ? this.state.accountValues
      : []
    ).filter((option) => !accountId || String(option.value) !== String(accountId));
    const parent = this.state.account && this.state.account.parent;
    if (
      parent &&
      parent.id &&
      String(parent.id) !== String(accountId) &&
      !values.some((option) => String(option.value) === String(parent.id))
    ) {
      return [
        {
          value: parent.id,
          label: parent.name || parent.id,
        },
        ...values,
      ];
    }
    return values;
  };

  getParentIdForSave = () => {
    if (this.isEditingOwnHomeAccount()) {
      const parent = this.state.account && this.state.account.parent;
      return (parent && parent.id) || this.state.parent_id;
    }
    return this.state.parent_id;
  };

  render() {
    const {classes, theme, t} = this.props;
    const {selected, TimevalidateDialog, user, purgeSpinnerInProgress, screensaverRotationTime} = this.state;
    const readOnly = this.state.operation === 'View';
    const lockHomeAccountParent = this.isEditingOwnHomeAccount();
    const disableSelect = this.state.operation === 'View';
    const parentAccountValues = this.getParentAccountSelectValues();
    const binarySecurityTokenTitle = t(
      'Accounts.Connect.McKesson.BinarySecurityTokenTooltip'
    );
    const issuerTitle = t('Accounts.Connect.McKesson.IssuerTooltip');
    const regExpHelpIconText = t('Accounts.Connect.McKesson.regExpHelpIconText');
    const fillNumberApiFallbackHelpText = t('Accounts.Connect.McKesson.FillNumberApiFallbackHelpText');
    const purgeImageHelpText = t('Account.Terms.PurgeServiceToggleHelpText');
    const _isIlocalUser = localStorage.getItem('isIlocalUser');
    const timeToNotifyHelpText = t('Accounts.TimeToNotifyHelpText');
    const AdvanceFillsHelpText = t('Accounts.AdvanceFillsHelpText');
    const hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
    const ln = localStorage.getItem('i18nextLng');
    const storeBusinessHoursHelpText = t('Accounts.AccountDetail.StoreBusinessHoursHelpText');
    const kioskBusinessHoursHelpText = t('Accounts.AccountDetail.KioskBusinessHoursHelpText');
    const libertyRegExpHelpIconText = t('Accounts.Connect.LibertySoftware.regExpHelpIconText');
    const epicRegExpHelpIconText = t('Accounts.Connect.Epic.RegExpHelp');
    const libertyCompletionStatusHelpIconText = t('Accounts.Connect.LibertySoftware.CompletionStatusHelp');
    const isSignatureFlagsConnection =
      this.state.accountConnectionsId &&
      SIGNATURE_FLAGS_CONNECTION_TYPES.includes(this.state.accountConnectionsId);
    return (
      <div className={classes.root}>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <div>
          <Dialog
            open={TimevalidateDialog || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <div
              style={{
                background: 'linear-gradient(155deg, #ce907b 0%,#ffcfa6 90%)',
              }}
            >
              <DialogContent>
                <DialogContentText
                  style={{ color: '#387371', textAlign: 'center' }}
                  id='alert-dialog-description'
                >
                  <p style={{ fontSize: '30px' }}>
                    {t('Accounts.PleaseEnterValidTime')}
                  </p>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(event) => this.handleCloseTimeDialog(event)}
                  color='primary'
                >
                  {t('Accounts.OK')}
                </Button>
              </DialogActions>
            </div>
          </Dialog>
        </div>
        <Dialog
          open={this.state.deleteDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Accounts.AreYouSureDeleteText')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Accounts.AreYouSureDeleteBodyText')}:
              <ul>
                {this.state.forDeletion &&
                  this.state.forDeletion.map(function (a) {
                    return <li>{a.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.deleteConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Accounts.CancelButton')}
            </Button>
            <Button
              onClick={this.deleteConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Accounts.DELETE')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.isClone || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Accounts.CloneDialog.Title')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <FormControl fullWidth>
                <Select
                  labelId="clone-count-label"
                  className={classes.halfTextFieldNew}
                  variant='standard'
                  value={this.state.cloneCount || 1}
                  onChange={(e) => this.setState({ cloneCount: parseInt(e.target.value, 10) })}
                >
                  {[...Array(10)].map((_, i) => (
                    <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCloseCloneDialog}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Accounts.CancelButton')}
            </Button>
            <Button
              onClick={this.handleClone}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
               {t('Accounts.CloneActions')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth={'lg'}
          open={this.state.showNewUserDialog || false}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.handleClose(event, reason);
            }
          }}
          aria-labelledby='form-dialog-title'
          PaperProps={{
            style: {
              minWidth: '1000px',
              maxWidth: ln === 'en' ? '1214px' : '1275px'
            },
          }}
        >
          {this.state.innerLoader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <AppBar position='static' color='default'>
            <Tabs
              value={this.state.selectedTab}
              onChange={this.handleTabChange}
              indicatorColor='primary'
              textColor='primary'
              variant={null}
            >
              <Tab
                label={t('Accounts.AccountDetail.AccountDetailsTitle')}
                tabIndex='0'
                className={classes.tabs}
              />
              <Tab
                label={t('Accounts.Branding.BrandingTitle')}
                tabIndex='1'
                className={classes.tabs}
              />
              {this.state.isPHiS ? (
                <Tab
                  label={t('Accounts.Connect.ConnectTitle')}
                  tabIndex='2'
                  className={classes.tabs}
                />
              ) : (
                <span></span>
              )}
              <Tab
                label={t('Accounts.Settings.SettingsTitle')}
                tabIndex='3'
                className={classes.tabs}
              />
              <Tab
                label={t('Account.Terms.Security')}
                tabIndex='5'
                className={classes.tabs}
              />
              <Tab
                label={t('Accounts.Terms.TermsConditionsTitle')}
                tabIndex='6'
                className={classes.tabs}
              />
              <Tab
                label={t('Accounts.Advanced.AdvancedTitle')}
                tabIndex='7'
                className={classes.tabs}
              />
            </Tabs>
          </AppBar>
          
          <div>
            <ValidatorForm
              ref='form'
              onSubmit={
                this.state.operation === 'Add'
                  ? this.handleSubmit
                  : this.handleUpdate
              }
            >
              <DialogContent sx={{ overflowY: "auto", maxHeight: "80vh" }}>
              <SwipeableViews
                style={{ maxWidth: ln === 'en' ? '1162px' : '1275px' }}
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={this.state.selectedTab}
                onChangeIndex={() => this.handleChangeIndex}
              >
                <TabContainer dir={theme.direction}>
                  <div className={classes.paddedBoxDivEdit}>
                    <DialogTitle id='form-dialog-title'>
                      {t(this.state.operation)}{' '}
                      {t('Accounts.Account')}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        {this.state.operation === 'Add' ? `` : ''}
                        <span className={classes.errorDiv}>
                          {this.state.errorMessage}
                        </span>
                      </DialogContentText>
                      <div style={{ display: 'flex' }}>
                        <div style={{ width: '610px' }}>
                          <Selector
                            key={`parent-${this.state.operation}-${this.state.account && this.state.account.id}-${this.state.parent_id}`}
                            id='parent_id'
                            label={t('Accounts.AccountDetail.ParentAccount')}
                            values={parentAccountValues}
                            selected={this.state.parent_id}
                            onBlur={this.handleChange}
                            disableWhenViewSelect={disableSelect || lockHomeAccountParent}
                          />
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            marginTop: '0%',
                            marginLeft: '5%',
                          }}
                        >
                          <div
                            className={classNames(classes.title)}
                            style={{
                              color: '#a5a5a5',
                              marginTop: '20%',
                              float: 'left',
                            }}
                          >
                            <span>
                              {t('Accounts.AccountDetail.MarketPlace')}
                            </span>
                          </div>
                          <div
                            className={classNames(classes.flexItemToggle)}
                            style={{ color: '#a5a5a5', marginTop: '14%' }}
                          >
                            <Switch
                              classes={{
                                switchBase: classes.iOSSwitchBase,
                                bar: classes.iOSBar,
                                icon: classes.iOSIcon,
                                iconChecked: classes.iOSIconChecked,
                                checked: classes.iOSChecked,
                              }}
                              disableRipple
                              checked={this.state.is_marketplace}
                              onChange={this.handleChangeMarketplace}
                              value={this.state.is_marketplace}
                              color='primary'
                              disabled={this.state.operation === 'View'}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <TextField
                          margin='dense'
                          className={classes.halfTextField}
                          defaultValue={this.state.store_ncp_id}
                          id='store_ncp_id'
                          name='store_ncp_id'
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 100,
                          }}
                          label={t('Accounts.AccountDetail.StoreId')}
                          placeholder=''
                          onBlur={this.handleChange}
                          variant='standard'
                        />
                      </div>
                      <div className={classes.twoChildren}>
                        <div className={classes.leftChild}>
                          <TextValidator
                            autoFocus
                            className={classes.halfTextField}
                            margin='normal'
                            value={this.state.name}
                            id='name'
                            label={t('Accounts.AccountDetail.AccountName')}
                            placeholder=''
                            onChange={this.handleChange}
                            validators={['required']}
                            errorMessages={['Account name is required!']}
                            variant='standard'
                            style={{ marginTop: '20px' }}
                          />
                          <FormControl className={classes.halfTextField}>
                            <InputLabel
                              htmlFor='type_id'
                              style={{
                                marginTop: '16px',
                                marginLeft: '-12px',
                              }}
                            >
                              {t('Accounts.AccountDetail.AccountType')}
                            </InputLabel>
                            <Select
                              style={{ marginTop: '32px' }}
                              value={this.state.type_id || ''}
                              readOnly={readOnly}
                              onChange={this.handleChange}
                              inputProps={{
                                name: 'type_id',
                                id: 'type_id',
                              }}
                              variant='standard'
                            >
                              <MenuItem
                                value={'bddff1b2-ffc7-48f4-b193-d751b1845b0e'}
                                selected
                                className={classes.menuItem}
                              >
                                {t('Accounts.AccountDetail.AccountType.Location')}
                              </MenuItem>
                              <MenuItem
                                value={'1eb5ba2c-e7de-421f-9c8d-1baafb751fc7'}
                                className={classes.menuItem}
                              >
                                {t('Accounts.AccountDetail.AccountType.Partner')}
                              </MenuItem>
                              {
                                [true, 'true'].includes(_isIlocalUser) ? (
                                  <MenuItem
                                    value={'5275e264-c6e0-4ca4-ab25-cb4168348477'}
                                    className={classes.menuItem}
                                  >
                                    {t('Accounts.AccountDetail.AccountType.Retailer')}
                                  </MenuItem>) : ('')
                              }
                              <MenuItem
                                value={'bf7a36fb-b1ba-407d-ad8c-5b9d563c4681'}
                                className={classes.menuItem}
                              >
                                {t('Accounts.AccountDetail.AccountType.Store')}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className={classes.rightChild}>
                          <div className={classes.dropbox}>
                            {readOnly ? (
                              <div>
                                {!this.state.avatarPreview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.avatarPreview && (
                                  <img
                                    alt=''
                                    src={this.state.avatarPreview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </div>
                            ) : (
                              <Dropzone
                                id='avatardropzone'
                                onDrop={this.handleDrop.bind(this)}
                                className={classes.innerBox}
                              >
                                {!this.state.avatarPreview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.avatarPreview && (
                                  <img
                                    alt=''
                                    src={this.state.avatarPreview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </Dropzone>
                            )}
                          </div>
                          <div variant='caption'>
                            <p className={classes.captionText}>
                              {t('Accounts.AccountDetail.UploadImage')}
                            </p>
                            <Button
                              className={classes.btnremove}
                              onClick={this.removeImg}
                            >
                              {t('Accounts.AccountDetail.RemoveImage')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div style={{ marginTop: '-4rem' }}>
                        <Typography
                          sx={{ fontSize: '1.3125rem', fontWeight: 500 }}
                          variant='title'
                        >
                          {t('Accounts.AccountDetail.AccountAddress')}
                        </Typography>
                      </div>
                      <div style={{ display: 'flex' }}>
                        <TextField
                          margin='dense'
                          className={classes.halfTextField}
                          defaultValue={this.state.address1}
                          id='address1'
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 100,
                          }}
                          label={t('Accounts.AccountDetail.AddressLine1')}
                          placeholder=''
                          onBlur={this.handleChange}
                          variant='standard'
                        />
                        <TextField
                          className={classes.halfTextField}
                          margin='normal'
                          defaultValue={this.state.address2}
                          id='address2'
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 100,
                          }}
                          label={t('Accounts.AccountDetail.AddressLine2')}
                          placeholder=''
                          onBlur={this.handleChange}
                          variant='standard'
                          style={{ marginTop: '9px' }}
                        />
                      </div>
                      <br />
                      <div style={{ display: 'flex', marginTop: '-1rem' }}>
                        <TextField
                          className={classes.oneThirdTextField}
                          margin='normal'
                          defaultValue={this.state.city}
                          id='city'
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 50,
                          }}
                          label={t('Accounts.AccountDetail.City')}
                          placeholder=''
                          onBlur={this.handleChange}
                          variant='standard'
                        />
                        <TextField
                          className={classes.oneThirdTextField}
                          margin='normal'
                          defaultValue={this.state.state}
                          id='state'
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 50,
                          }}
                          label={t('Accounts.AccountDetail.State')}
                          placeholder=''
                          onBlur={this.handleChange}
                          variant='standard'
                        />
                        <TextValidator
                          className={classes.oneThirdTextField}
                          margin='normal'
                          value={this.state.zip}
                          id='zip'
                          name='zip'
                          inputProps={{
                            readOnly: Boolean(readOnly)
                          }}
                          label={t('Accounts.AccountDetail.Zip')}
                          placeholder=''
                          onChange={this.handleChange}
                          validators={['required']}
                          variant='standard'
                          errorMessages={[
                            t('Validation.zip')
                          ]}
                        />
                      </div>
                      <br />
                      <div style={{ marginTop: '-1rem' }}>
                        <Typography
                          variant='title'
                          sx={{ fontSize: '1.3125rem', fontWeight: 500 }}
                        >
                          {t('Accounts.AccountDetail.ContactPerson')}
                        </Typography>
                      </div>
                      <div style={{ display: 'flex' }}>
                        <TextValidator
                          margin='dense'
                          className={classes.halfTextField}
                          value={user.first_name || this.state.first_name || ''}
                          id='first_name'
                          name='first_name'
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 50,
                          }}
                          label={t('Accounts.AccountDetail.FirstName')}
                          placeholder=''
                          onChange={this.handleChange}
                          validators={['required', 'matchRegexp:^[a-zA-Z ]*$']}
                          errorMessages={[
                            t('Validation.EnterFirstName'),
                            t('Validation.UseAlphabets'),
                          ]}
                          variant='standard'
                        />
                        <TextValidator
                          margin='dense'
                          className={classes.halfTextField}
                          value={user.last_name || this.state.last_name || ''}
                          id='last_name'
                          name='last_name'
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 50,
                          }}
                          label={t('Accounts.AccountDetail.LastName')}
                          placeholder=''
                          onChange={this.handleChange}
                          validators={['required', 'matchRegexp:^[a-zA-Z ]*$']}
                          errorMessages={[
                            t('Validation.EnterLastName'),
                            t('Validation.UseAlphabets'),
                          ]}
                          variant='standard'
                        />
                      </div>
                      <br />
                      <div style={{ display: 'flex', marginTop: '-1rem' }}>
                        <TextValidator
                          className={classes.halfTextField}
                          margin='normal'
                          value={user.email || this.state.email || ''}
                          id='email'
                          name='email'
                          inputProps={{ readOnly: Boolean(readOnly) }}
                          label={t('Accounts.AccountDetail.EmailAddress')}
                          placeholder=''
                          onChange={this.handleChange}
                          validators={['required', 'isEmail']}
                          errorMessages={[
                            t('Validation.EnterEmailAddress'),
                            t('Validation.EmailIsNotValid'),
                          ]}
                          variant='standard'
                        />
                        <PhoneInput
                          style={{ width: 390, marginTop: '16px' }}
                          id='phone'
                          onBlur={this.handleChange}
                          defaultValue={this.state.phone}
                          readOnly={readOnly}
                          labelStyle={{ left: '-13px', top: '-17px' }}
                        />
                      </div>
                      <Grid item xs={12} style={{ marginTop: '30px' }}>
                        <span>
                          <Button
                            onClick={this.addContactPersonRow}
                            color='primary'
                          >
                            {t(
                              'Accounts.AccountDetail.AddContact.AddContactPerson'
                            )}
                          </Button>
                          {this.createRowContactPerson()}
                        </span>
                      </Grid>
                      <div style={{ display: "flex", flexDirection: "row", marginTop: "30px" }}>
                        <div style={{ width: "40%" }}>
                          <div>
                            <div>
                              <Typography
                                variant='title'
                                sx={{ fontSize: '1.3125rem', fontWeight: 500 }}
                              >
                                {t('Accounts.AccountDetail.StoreBusinessHours')}
                              </Typography>
                              <Tooltip
                                title={storeBusinessHoursHelpText}
                                className={classes.customWidth}
                                style={{ marginLeft: '3%' }}
                              >
                                <Help
                                  className={classes.helpIcon}
                                ></Help>
                              </Tooltip>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between",marginRight:"22px" }}>
                              <p>{t('Accounts.AccountDetail.Day')}</p>
                              <p>{t('Accounts.AccountDetail.OpenAll')}</p>
                              <p>{t('Accounts.AccountDetail.OpenTime')}</p>
                              <p>{t('Accounts.AccountDetail.CloseTime')}</p>
                              <p>{t("Accounts.AccountDetail.Closed")}</p>
                            </div>
                          </div>
                          {this.state.AccountHoursOfOperaionsArray &&
                            this.state.AccountHoursOfOperaionsArray.length &&
                            this.state.AccountHoursOfOperaionsArray.length > 0 &&
                            this.state.AccountHoursOfOperaionsArray.map(
                              (ele, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <Grid container gap={2}>
                                      <Grid item xs={2} style={{ marginTop: '25px' }}>
                                        <label
                                          style={{
                                            color: '#000',
                                            fontSize: '0.875rem',
                                            lineHeight: '1.46429em',
                                          }}
                                          key={index}
                                        >
                                          {ele && ele.value}
                                        </label>
                                      </Grid>
                                      <Grid item xs={2} style={{ marginTop: '15px', maxWidth: "55px" }}>
                                        <Checkbox
                                          id={"checkbox" + index}
                                          checked={[true, "true"].includes(ele.isOpenAll) ? true : false}
                                          onChange={this.handleAccountOpenAllCheckBox(index)}
                                          color="primary"
                                          disabled={[true, "true"].includes(ele.isClosed) || this.state.operation === 'View'}
                                        />
                                      </Grid>
                                      <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                        <TextField
                                          id={'open' + index}
                                          name={'OpenTime' + index}
                                          autoComplete='off'
                                          value={ele && ele.openTime}
                                          InputProps={{
                                            inputComponent: TextMaskCustom,
                                            maxLength: 8,
                                            readOnly: Boolean(readOnly),
                                          }}
                                          InputLabelProps={{ shrink: true, }}
                                          onChange={this.handleAccountOpentimeChange(index)}
                                          onBlur={this.handleAccountBlurTime}
                                          variant='standard'
                                          disabled={[true, "true"].includes(ele.isClosed) || [true, "true"].includes(ele.isOpenAll)}
                                        />
                                      </Grid>
                                      <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                        <div>
                                          <TextField
                                            id={'close' + index}
                                            name={'ClosingTime' + index}
                                            autoComplete='off'
                                            value={ele && ele.closeTime}
                                            InputProps={{
                                              inputComponent: TextMaskCustom,
                                              maxLength: 8,
                                              readOnly: Boolean(readOnly),
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={this.handleAccountClosetimeChange(index)}
                                            onBlur={this.handleAccountBlurTime}
                                            variant='standard'
                                            disabled={[true, "true"].includes(ele.isClosed) || [true, "true"].includes(ele.isOpenAll)}
                                          />
                                        </div>
                                      </Grid>
                                      <Grid item xs={2} style={{ marginTop: '15px', maxWidth: "60px", display: "flex", justifyContent: "flex-end" }}>
                                        <Checkbox
                                          id={"checkbox" + index}
                                          checked={[true, "true"].includes(ele.isClosed) ? true : false}
                                          onChange={this.handleAccountClosedCheckBox(index)}
                                          color="primary"
                                          disabled={[true, "true"].includes(ele.isOpenAll) || this.state.operation === 'View'}
                                        />
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                );
                              }
                            )}
                        </div>
                        <div style={{ width: "40%" }}>
                          <div>
                            <div>
                              <Typography
                                variant='title'
                                sx={{ fontSize: '1.3125rem', fontWeight: 500 }}
                              >
                                {t('Accounts.AccountDetail.KioskBusinessHours')}
                              </Typography>
                              <Tooltip
                                title={kioskBusinessHoursHelpText}
                                className={classes.customWidth}
                                style={{ marginLeft: '10px' }}
                              >
                                <Help
                                  className={classes.helpIcon}
                                ></Help>
                              </Tooltip>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between",marginRight:"22px" }}>
                              <p>{t('Accounts.AccountDetail.Day')}</p>
                              <p>{t('Accounts.AccountDetail.OpenAll')}</p>
                              <p>{t('Accounts.AccountDetail.OpenTime')}</p>
                              <p>{t('Accounts.AccountDetail.CloseTime')}</p>
                              <p>{t("Accounts.AccountDetail.Closed")}</p>
                            </div>
                          </div>
                          <div>
                            <Grid container gap={2}>
                              <Grid item xs={3} style={{ marginTop: '25px' }}>
                                <label
                                  style={{
                                    color: '#000',
                                    fontSize: '0.875rem',
                                    lineHeight: '1.46429em',
                                  }}
                                >
                                  {t("Accounts.AccountDetail.Lunch")}
                                <Tooltip
                                  title={t('Accounts.AccountDetail.LunchHelpText')}
                                  className={classes.customWidth}
                                  style={{ marginLeft: '10px' }}
                                >
                                  <Help
                                    className={classes.helpIcon}
                                  ></Help>
                                </Tooltip>
                                </label>
                              </Grid>
                              <Grid item xs={1} style={{ marginTop: '15px', maxWidth: "55px"}}/>
                              <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                <TextField
                                  id="lunchStart"
                                  autoComplete='off'
                                  value={this.state.lunchStart}
                                  InputProps={{
                                    inputComponent: TextMaskCustom,
                                    maxLength: 8,
                                    readOnly: Boolean(readOnly),
                                  }}
                                  InputLabelProps={{ shrink: true, }}
                                  onChange={(e)=>this.setState({lunchStart:e.target.value})}
                                  onBlur={this.handleKioskBlurTime}
                                  variant='standard'
                                />
                              </Grid>
                              <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                  <TextField
                                    id="lunchEnd"
                                    autoComplete='off'
                                    value={this.state.lunchEnd}
                                    InputProps={{
                                      inputComponent: TextMaskCustom,
                                      maxLength: 8,
                                      readOnly: Boolean(readOnly),
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e)=>this.setState({lunchEnd:e.target.value})}
                                    onBlur={this.handleKioskBlurTime}
                                    variant='standard'
                                  />
                              </Grid>
                              <Grid item xs={2} style={{ marginTop: '15px'}}/>
                            </Grid>
                          </div>
                          {this.state.KioskHoursOfOperaionsArray &&
                            this.state.KioskHoursOfOperaionsArray.length &&
                            this.state.KioskHoursOfOperaionsArray.length > 0 &&
                            this.state.KioskHoursOfOperaionsArray.map(
                              (ele, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <Grid container gap={2}>
                                      <Grid item xs={2} style={{ marginTop: '25px' }}>
                                        <label
                                          style={{
                                            color: '#000',
                                            fontSize: '0.875rem',
                                            lineHeight: '1.46429em',
                                          }}
                                          key={index}
                                        >
                                          {ele && ele.value}
                                        </label>
                                      </Grid>
                                      <Grid item xs={2} style={{ marginTop: '15px', maxWidth: "55px" }}>
                                        <Checkbox
                                          id={"checkbox" + index}
                                          checked={[true, "true"].includes(ele.isOpenAll) ? true : false}
                                          onChange={this.handleOpenAllCheckBox(index)}
                                          color="primary"
                                          disabled={[true, "true"].includes(ele.isClosed) || this.state.operation === 'View'}
                                        />
                                      </Grid>
                                      <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                        <TextField
                                          id={'open' + index}
                                          name={'OpenTime' + index}
                                          autoComplete='off'
                                          value={ele && ele.openTime}
                                          InputProps={{
                                            inputComponent: TextMaskCustom,
                                            maxLength: 8,
                                            readOnly: Boolean(readOnly),
                                          }}
                                          InputLabelProps={{ shrink: true, }}
                                          onChange={this.handleKioskOpentimeChange(index)}
                                          onBlur={this.handleKioskBlurTime}
                                          variant='standard'
                                          disabled={[true, "true"].includes(ele.isClosed) || [true, "true"].includes(ele.isOpenAll)}
                                        />
                                      </Grid>
                                      <Grid item xs={3} style={{ marginTop: '15px', maxWidth: "75px" }}>
                                        <div>
                                          <TextField
                                            id={'close' + index}
                                            name={'ClosingTime' + index}
                                            autoComplete='off'
                                            value={ele && ele.closeTime}
                                            InputProps={{
                                              inputComponent: TextMaskCustom,
                                              maxLength: 8,
                                              readOnly: Boolean(readOnly),
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={this.handleKioskClosetimeChange(index)}
                                            onBlur={this.handleKioskBlurTime}
                                            variant='standard'
                                            disabled={[true, "true"].includes(ele.isClosed) || [true, "true"].includes(ele.isOpenAll)}
                                          />
                                        </div>
                                      </Grid>
                                      <Grid item xs={2} style={{ marginTop: '15px', maxWidth: "60px", display: "flex", justifyContent: "flex-end" }}>
                                        <Checkbox
                                          id={"checkbox" + index}
                                          checked={[true, "true"].includes(ele.isClosed) ? true : false}
                                          onChange={this.handleClosedCheckBox(index)}
                                          color="primary"
                                          disabled={[true, "true"].includes(ele.isOpenAll) || this.state.operation === 'View'}
                                        />
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                );
                              }
                            )}
                        </div>
                        <div style={{ width: "20%" }}>
                          <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", padding: "30px" }}>
                            <div className='box'>
                              <div className={classes.advdropbox}>
                                {readOnly ? (
                                  <div>
                                    {!this.state.closedimgPreview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.closedimgPreview && (
                                      <img
                                        alt=''
                                        src={this.state.closedimgPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <Dropzone
                                    id='closedimgdropzone'
                                    onDrop={this.handleclosedimgDrop.bind(this)}
                                    className={classes.innerBox}
                                  >
                                    {!this.state.closedimgPreview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.closedimgPreview && (
                                      <img
                                        alt=''
                                        src={this.state.closedimgPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </Dropzone>
                                )}
                              </div>
                              <div variant='caption' style={{ marginTop: '25px', paddingLeft: '20px', }}>
                                <p className={classes.captionadvText}>
                                  {t('Accounts.Branding.UploadClosedImage')}
                                </p>
                                <Button
                                  className={classes.btnremove}
                                  onClick={this.removeclosedimg}
                                >
                                  {t('Accounts.Branding.RemoveClosedImage')}
                                </Button>
                              </div>
                            </div>
                            <TextField
                              margin='dense'
                              defaultValue={this.state.closedMsg}
                              id='ClosedMessage'
                              inputProps={{ readOnly: Boolean(readOnly) }}
                              label={t('Accounts.Branding.ClosedMessage')}
                              multiline
                              rows='3'
                              rowsMax='3'
                              placeholder=''
                              onBlur={this.handleChangeClosedMessage}
                              onChange={this.handleChangeClosedMessage}
                              variant='outlined'
                            />
                          </div>
                        </div>
                      </div>    
                    </DialogContent>
                     
                  </div>
                </TabContainer>

                {/* {Branding Tab} */}
                <TabContainer dir={theme.direction}>
                  <div className={classes.paddedBoxDivEdit}>
                    <DialogTitle style={{padding:"10px 24px"}} id='form-dialog-title'>
                      {t('Accounts.Branding.Header')}
                      <p className={classes.captionadvText}>
                      {t('Accounts.Branding.HeaderNote')}
                      </p>
                    </DialogTitle>
                    <DialogContent style={{padding:"10px 24px"}}>
                      <div className={classes.rightChild}>
                        <div style={{ width: "540px", height: "42px" }} className={classes.brnddropbox}>
                          {readOnly ? (
                            <div>
                              {!this.state.headerImg && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.headerImg && (
                                <img
                                  alt=''
                                  src={this.state.headerImg}
                                  className={classes.dropPic}
                                />
                              )}
                            </div>
                          ) : (
                            <Dropzone
                              id='headerImg'
                              onDrop={this.handleHeaderDrop.bind(this)}
                              className={classes.innerBox}
                            >
                              {!this.state.headerImg && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.headerImg && (
                                <img
                                  alt=''
                                  src={this.state.headerImg}
                                  className={classes.dropPic}
                                />
                              )}
                            </Dropzone>
                          )}
                        </div>
                        <div style={{ height: "35px" }}>
                          {this.state.isHeaderSizeError && <p style={{ fontSize: "12px", color: "red", fontWeight: 400 }}>{t('Accounts.Branding.HeaderSizeError')}</p>}
                        </div>
                        <div variant='caption' style={{ display: 'grid', placeItems: 'baseline' }}>
                          <p className={classes.captionadvText}>
                            {t('Accounts.Branding.UploadHeader')}
                          </p>
                          <Button
                            className={classes.btnremove}
                            onClick={this.removeHeader}
                          >
                            {t('Accounts.Branding.RemoveHeader')}
                          </Button>
                        </div>
                      </div>
                    </DialogContent>
                    <DialogTitle style={{padding:"0px 24px"}} id='form-dialog-title'>
                      {t('Accounts.Branding.Banner')}
                      <p className={classes.captionadvText}>
                      {t('Accounts.Branding.BannerNote')}
                      </p>
                    </DialogTitle>
                    <DialogContent style={{padding:"0px 24px"}}>
                      <div className={classes.rightChild}>
                        <div style={{ width: "540px", height: "90px" }} className={classes.brnddropbox}>
                          {readOnly ? (
                            <div>
                              {!this.state.bannerImg && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.bannerImg && (
                                <img
                                  alt=''
                                  src={this.state.bannerImg}
                                  className={classes.dropPic}
                                />
                              )}
                            </div>
                          ) : (
                            <Dropzone
                              id='bannerImg'
                              onDrop={this.handleBannerDrop.bind(this)}
                              className={classes.innerBox}
                            >
                              {!this.state.bannerImg && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.bannerImg && (
                                <img
                                  alt=''
                                  src={this.state.bannerImg}
                                  className={classes.dropPic}
                                />
                              )}
                            </Dropzone>
                          )}
                        </div>
                        <div style={{ height: "35px" }}>
                          {this.state.isBannerSizeError && <p style={{ fontSize: "12px", color: "red", fontWeight: 400 }}>{t('Accounts.Branding.BannerSizeError')}</p>}
                        </div>
                        <div variant='caption' style={{ display: 'grid', placeItems: 'baseline' }}>
                          <p className={classes.captionadvText}>
                            {t('Accounts.Branding.UploadBanner')}
                          </p>
                          <Button
                            className={classes.btnremove}
                            onClick={this.removeBanner}
                          >
                            {t('Accounts.Branding.RemoveBanner')}
                          </Button>
                        </div>
                      </div>
                    </DialogContent>
                    <DialogTitle style={{padding:"10px 24px"}} id='form-dialog-title'>
                      {t('Accounts.Branding.AdvertisingScreen')}
                      {this.state.AdvancedAdvertise === false ? (
                        !readOnly ? (
                          <p className={classes.captionadvText}>
                            <span>{t('Accounts.Branding.Note')}</span>
                          </p>
                        ) : (
                          ''
                        )
                      ) : !readOnly ? (
                        <p className={classes.captionadvText}>
                          {t('Accounts.Branding.UpperSlider')}
                          <br />
                          <span>{t('Accounts.Branding.UpperSliderNote')}</span>
                        </p>
                      ) : (
                        ''
                      )}
                    </DialogTitle>
                    <DialogContent style={{padding:"0px 24px"}}>
                      <div className={classes.flexItems + ' box-container'}>
                        <div className='box'>
                          <div className={classes.advdropbox}>
                            {readOnly ? (
                              <div>
                                {!this.state.Adv1Preview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.Adv1Preview && (
                                  <img
                                    alt=''
                                    src={this.state.Adv1Preview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </div>
                            ) : (
                              <Dropzone
                                id='Adv1dropzone'
                                onDrop={this.handleAdv1Drop.bind(this)}
                                className={classes.innerBox}
                              >
                                {!this.state.Adv1Preview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.Adv1Preview && (
                                  <img
                                    alt=''
                                    src={this.state.Adv1Preview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </Dropzone>
                            )}
                          </div>
                          <div
                            variant='caption'
                            style={{ marginTop: '25px', textAlign: 'center' }}
                          >
                            <p className={classes.captionadvText}>
                              {t('Accounts.Branding.UploadAdvertisement')}
                            </p>
                            <Button
                              className={classes.btnremove}
                              onClick={this.removeAdv1}
                            >
                              {t('Accounts.Branding.RemoveAdvertisement')}
                            </Button>
                          </div>
                        </div>
                        <div className='box'>
                          <div className={classes.advdropbox}>
                            {readOnly ? (
                              <div>
                                {!this.state.Adv2Preview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.Adv2Preview && (
                                  <img
                                    alt=''
                                    src={this.state.Adv2Preview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </div>
                            ) : (
                              <Dropzone
                                id='Adv2dropzone'
                                onDrop={this.handleAdv2Drop.bind(this)}
                                className={classes.innerBox}
                              >
                                {!this.state.Adv2Preview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.Adv2Preview && (
                                  <img
                                    alt=''
                                    src={this.state.Adv2Preview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </Dropzone>
                            )}
                          </div>
                          <div
                            variant='caption'
                            style={{ marginTop: '25px', textAlign: 'center' }}
                          >
                            <p className={classes.captionadvText}>
                              {t('Accounts.Branding.UploadAdvertisement')}
                            </p>
                            <Button
                              className={classes.btnremove}
                              onClick={this.removeAdv2}
                            >
                              {t('Accounts.Branding.RemoveAdvertisement')}
                            </Button>
                          </div>
                        </div>
                        <div className='box'>
                          <div className={classes.advdropbox}>
                            {readOnly ? (
                              <div>
                                {!this.state.Adv3Preview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.Adv3Preview && (
                                  <img
                                    alt=''
                                    src={this.state.Adv3Preview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </div>
                            ) : (
                              <Dropzone
                                id='Adv3dropzone'
                                onDrop={this.handleAdv3Drop.bind(this)}
                                className={classes.innerBox}
                              >
                                {!this.state.Adv3Preview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.Adv3Preview && (
                                  <img
                                    alt=''
                                    src={this.state.Adv3Preview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </Dropzone>
                            )}
                          </div>
                          <div
                            variant='caption'
                            style={{ marginTop: '25px', textAlign: 'center' }}
                          >
                            <p className={classes.captionadvText}>
                              {t('Accounts.Branding.UploadAdvertisement')}
                            </p>
                            <Button
                              className={classes.btnremove}
                              onClick={this.removeAdv3}
                            >
                              {t('Accounts.Branding.RemoveAdvertisement')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      {this.state.AdvancedAdvertise === true ? (
                        <React.Fragment>
                          <p className={classes.captionadvText}>
                            {t('Accounts.Branding.BottomSlider')}
                            <br />
                            <span>
                              {t('Accounts.Branding.BottomSliderNote')}
                            </span>
                          </p>
                          <div
                            id='bottomContainer'
                            className={classes.flexItems + ' box-container'}
                          >
                            <div className='box' id='BottomAdv1Preview'>
                              <div className={classes.advdropbox}>
                                {readOnly ? (
                                  <div>
                                    {!this.state.BottomAdv1Preview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.BottomAdv1Preview && (
                                      <img
                                        alt=''
                                        src={this.state.BottomAdv1Preview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <Dropzone
                                    id='BottomAdv1dropzone'
                                    onDrop={this.handleBottomAdv1Drop.bind(
                                      this
                                    )}
                                    className={classes.innerBox}
                                  >
                                    {!this.state.BottomAdv1Preview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.BottomAdv1Preview && (
                                      <img
                                        alt=''
                                        src={this.state.BottomAdv1Preview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </Dropzone>
                                )}
                              </div>
                              <div
                                variant='caption'
                                style={{
                                  marginTop: '25px',
                                  textAlign: 'center',
                                }}
                              >
                                <p className={classes.captionadvText}>
                                  {t('Accounts.Branding.UploadAdvertisement')}
                                </p>
                                <Button
                                  className={classes.btnremove}
                                  onClick={this.removeBottomAdv1}
                                >
                                  {t('Accounts.Branding.RemoveAdvertisement')}
                                </Button>
                              </div>
                              {this.state &&
                                this.state.bottomAdvSlider1ErrorFlag === true ? (
                                <p className={classes.bottomSliderError}>
                                  This is a required parameter.
                                </p>
                              ) : (
                                <p></p>
                              )}
                            </div>
                            <div className='box' id='BottomAdv2Preview'>
                              <div className={classes.advdropbox}>
                                {readOnly ? (
                                  <div>
                                    {!this.state.BottomAdv2Preview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.BottomAdv2Preview && (
                                      <img
                                        alt=''
                                        src={this.state.BottomAdv2Preview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <Dropzone
                                    id='BottomAdv2dropzone'
                                    onDrop={this.handleBottomAdv2Drop.bind(
                                      this
                                    )}
                                    className={classes.innerBox}
                                  >
                                    {!this.state.BottomAdv2Preview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.BottomAdv2Preview && (
                                      <img
                                        alt=''
                                        src={this.state.BottomAdv2Preview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </Dropzone>
                                )}
                              </div>
                              <div
                                variant='caption'
                                style={{
                                  marginTop: '25px',
                                  textAlign: 'center',
                                }}
                              >
                                <p className={classes.captionadvText}>
                                  {t('Accounts.Branding.UploadAdvertisement')}
                                </p>
                                <Button
                                  className={classes.btnremove}
                                  onClick={this.removeBottomAdv2}
                                >
                                  {t('Accounts.Branding.RemoveAdvertisement')}
                                </Button>
                              </div>
                              {this.state &&
                                this.state.bottomAdvSlider2ErrorFlag === true ? (
                                <p className={classes.bottomSliderError}>
                                  This is a required parameter.
                                </p>
                              ) : (
                                <p></p>
                              )}
                            </div>
                            <div className='box' id='BottomAdv3Preview'>
                              <div className={classes.advdropbox}>
                                {readOnly ? (
                                  <div>
                                    {!this.state.BottomAdv3Preview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.BottomAdv3Preview && (
                                      <img
                                        alt=''
                                        src={this.state.BottomAdv3Preview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <Dropzone
                                    id='BottomAdv3dropzone'
                                    onDrop={this.handleBottomAdv3Drop.bind(
                                      this
                                    )}
                                    className={classes.innerBox}
                                  >
                                    {!this.state.BottomAdv3Preview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.BottomAdv3Preview && (
                                      <img
                                        alt=''
                                        src={this.state.BottomAdv3Preview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </Dropzone>
                                )}
                              </div>
                              <div
                                variant='caption'
                                style={{
                                  marginTop: '25px',
                                  textAlign: 'center',
                                }}
                              >
                                <p className={classes.captionadvText}>
                                  {t('Accounts.Branding.UploadAdvertisement')}
                                </p>
                                <Button
                                  className={classes.btnremove}
                                  onClick={this.removeBottomAdv3}
                                >
                                  {t('Accounts.Branding.RemoveAdvertisement')}
                                </Button>
                              </div>
                              {this.state &&
                                this.state.bottomAdvSlider3ErrorFlag === true ? (
                                <p className={classes.bottomSliderError}>
                                  This is a required parameter.
                                </p>
                              ) : (
                                <p></p>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      ) : (
                        ''
                      )}
                    </DialogContent>
                    {this.state.AdvancedAdvertise === true ? (
                      <React.Fragment>
                        <DialogTitle style={{padding:"0px 24px"}} id='form-dialog-title'>
                          {t('Accounts.Branding.VideoContent')}
                        </DialogTitle>
                        <DialogContent sx={{ padding: '0px 100px 24px' }}>
                          <div style={{ display: 'flex' }}>
                            <Grid item xs={6}>
                              <div
                                id='videoAdvPreview'
                                className={classes.videodropbox}
                              >
                                {readOnly ? (
                                  <div>
                                    {!this.state.videoPreview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.videoPreview && (
                                      <video
                                        alt=''
                                        src={this.state.videoPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <Dropzone
                                    id='videodropzone'
                                    accept='video/*'
                                    onDrop={this.handlevideoDrop.bind(this)}
                                    className={classes.innerBox}
                                  >
                                    {!this.state.videoPreview && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.videoPreview && (
                                      <video
                                        alt=''
                                        src={this.state.videoPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </Dropzone>
                                )}
                              </div>
                              <div
                                variant='caption'
                                style={{
                                  marginTop: '25px',
                                  paddingLeft: '70px',
                                }}
                              >
                                <p className={classes.captionadvText}>
                                  {t('Accounts.Branding.UploadVideo')}
                                </p>
                                <Button
                                  className={classes.btnremove}
                                  onClick={this.removeVd}
                                >
                                  {t('Accounts.Branding.RemoveVideo')}
                                </Button>
                              </div>
                              {this.state &&
                                this.state.videoAdvErrorFlag === true ? (
                                <p className={classes.bottomVideoSliderError}>
                                  This is a required parameter.
                                </p>
                              ) : (
                                <p></p>
                              )}
                              {this.state &&
                                this.state.videoMaxSizeErrorFlag === true ? (
                                <p className={classes.bottomVideoSliderError}>
                                  You can only upload video upto 3 MB
                                </p>
                              ) : (
                                <p></p>
                              )}
                              {/* <br />
                 <Typography variant="caption" gutterBottom >
                         Upload Video
                 </Typography>
                 <Button className={classes.btnremove} onClick={this.removeVd}>Remove Video</Button> */}
                            </Grid>
                            <Grid item xs={6}>
                              {this.state && this.state.videoPreview ? (
                                <video
                                  controls={false}
                                  autoPlay={true}
                                  src={this.state.videoPreview}
                                  style={{
                                    width: '280px',
                                    height: '230px',
                                    marginTop: '-30px',
                                  }}
                                />
                    ) : (
                      ''
                    )}
                            </Grid>
                          </div>
                        </DialogContent>
                      </React.Fragment>
                    ) : (
                      ''
                    )}
                    <DialogTitle style={{padding:"10px 24px"}} id='form-dialog-title'>
                      {t('Accounts.Branding.AboutUs')}
                      <p className={classes.captionadvText}>
                        {t('Accounts.Branding.TellYourPatientNote')}
                      </p>
                    </DialogTitle>
                    <DialogContent style={{ minHeight: '400px' }}>
                      <div className={classes.twoChildren}>
                        <div className={classes.leftChildbrand}>
                          <div style={{display:"flex",flexDirection:"row"}}>
                            <TextValidator
                              className={classes.halfTextField}
                              margin='normal'
                              value={this.state.brandname || ''}
                              id='brandName'
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t('Accounts.Branding.BrandName')}
                              placeholder=''
                              onChange={this.handleChangeBrand}
                              variant='standard'
                              validators={['required']}
                              errorMessages={[
                                t('Validation.BrandName'),
                              ]}
                            />
                            <TextField
                              className={classes.halfTextField}
                              label={t('Accounts.Branding.PhoneNumber')}
                              style={{ marginTop: '1rem' }}
                              id='phone'
                              onBlur={this.handleChangePhone}
                              name='generalphone'
                              defaultValue={this.state.generalphone}
                              readOnly={readOnly}
                              variant='standard'
                            />
                          </div>
                          <br />
                          <TextField
                            className={classes.halfTextField}
                            margin='normal'
                            defaultValue={this.state.web}
                            id='website'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                            }}
                            label={t('Accounts.Branding.Website')}
                            placeholder=''
                            onBlur={this.handleChangeWeb}
                            variant='standard'
                          />
                          <TextField
                            className={classes.halfTextField}
                            margin='normal'
                            defaultValue={this.state.fax}
                            id='fax'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                            }}
                            label={t('Accounts.Branding.Fax')}
                            placeholder=''
                            onBlur={this.handleChangeFax}
                            variant='standard'
                          />
                          <div style={{ marginTop: '1.5rem' }}>
                            <InputLabel shrink htmlFor='primaryColorHex'>
                              {t('Accounts.Branding.PrimaryColor')}
                            </InputLabel>
                            <p className={classes.captionadvText}>
                              {t('Accounts.Branding.PrimaryColorNote')}
                            </p>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '8px',
                              }}
                            >
                              <input
                                type='color'
                                id='primaryColorSwatch'
                                aria-label={t('Accounts.Branding.PrimaryColor')}
                                disabled={Boolean(readOnly)}
                                value={
                                  isValidHexColor(this.state.primaryColor)
                                    ? this.state.primaryColor
                                    : BRAND_DEFAULT_COLOR
                                }
                                onChange={this.handleChangePrimaryColor}
                                style={{
                                  width: '48px',
                                  height: '36px',
                                  padding: 0,
                                  border: '1px solid #cfd8dc',
                                  borderRadius: '4px',
                                  background: 'none',
                                  cursor: readOnly ? 'default' : 'pointer',
                                }}
                              />
                              <TextField
                                style={{ marginLeft: '12px', width: '140px' }}
                                id='primaryColorHex'
                                value={this.state.primaryColor || ''}
                                inputProps={{
                                  readOnly: Boolean(readOnly),
                                  maxLength: 7,
                                }}
                                placeholder={BRAND_DEFAULT_COLOR}
                                onChange={this.handleChangePrimaryColor}
                                variant='standard'
                              />
                              <div
                                style={{
                                  marginLeft: '20px',
                                  width: '200px',
                                  height: '36px',
                                  borderRadius: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '12px',
                                  fontFamily: 'Helvetica, Arial, sans-serif',
                                  backgroundColor: isValidHexColor(
                                    this.state.primaryColor
                                  )
                                    ? this.state.primaryColor
                                    : BRAND_DEFAULT_COLOR,
                                  color: readableTextColor(
                                    isValidHexColor(this.state.primaryColor)
                                      ? this.state.primaryColor
                                      : BRAND_DEFAULT_COLOR
                                  ),
                                }}
                              >
                                {t('Accounts.Branding.PrimaryColorPreview')}
                              </div>
                            </div>
                          </div>
                          <div style={{ marginTop: '1.25rem' }}>
                            <FormControlLabel
                              label={
                                <span>
                                  <span
                                    style={{
                                      color: '#000',
                                      fontSize: '1rem',
                                      display: 'block',
                                    }}
                                  >
                                    {t('Accounts.Branding.ModernKioskEmails')}
                                  </span>
                                  <span className={classes.captionadvText}>
                                    {t('Accounts.Branding.ModernKioskEmailsNote')}
                                  </span>
                                </span>
                              }
                              labelPlacement='start'
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={Boolean(this.state.is_modern_email_enabled)}
                                  onChange={(event) => {
                                    this.setState({
                                      is_modern_email_enabled: event.target.checked,
                                    });
                                  }}
                                  disabled={Boolean(readOnly)}
                                  color='primary'
                                  sx={{ ml: '1rem' }}
                                />
                              }
                              style={{
                                marginLeft: 0,
                                marginTop: '8px',
                                alignItems: 'flex-start',
                              }}
                            />
                          </div>
                          <div style={{ marginTop: '1rem' }}>
                            <FormControlLabel
                              label={
                                <span>
                                  <span
                                    style={{
                                      color: '#000',
                                      fontSize: '1rem',
                                      display: 'block',
                                    }}
                                  >
                                    {t('Accounts.Branding.PickupChangeEmails')}
                                  </span>
                                  <span className={classes.captionadvText}>
                                    {t('Accounts.Branding.PickupChangeEmailsNote')}
                                  </span>
                                </span>
                              }
                              labelPlacement='start'
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={Boolean(this.state.is_pickup_change_email_enabled)}
                                  onChange={(event) => {
                                    this.setState({
                                      is_pickup_change_email_enabled: event.target.checked,
                                    });
                                  }}
                                  disabled={Boolean(readOnly)}
                                  color='primary'
                                  sx={{ ml: '1rem' }}
                                />
                              }
                              style={{
                                marginLeft: 0,
                                marginTop: '8px',
                                alignItems: 'flex-start',
                              }}
                            />
                          </div>
                          <br />
                          <div style={{ display: 'flex' }}>
                            <TextValidator
                              autoFocus
                              className={classes.halfTextField}
                              margin='normal'
                              value={this.state.generalemail || ''}
                              id='general_email'
                              name='general_email'
                              inputProps={{ readOnly: Boolean(readOnly) }}
                              label={t('Accounts.Branding.EmailAddress')}
                              placeholder=''
                              onChange={this.handleChangeEmail}
                              validators={['required', 'isEmail']}
                              errorMessages={[
                                t('Validation.EnterEmailAddress'),
                                t('Validation.EmailIsNotValid'),
                              ]}
                              variant='standard'
                            />
                            {false && this.state.operation === 'Edit' ? (
                              <div
                                style={{ padding: '0px', marginTop: '2.1%' }}
                              >
                                <div style={{ display: 'inline-flex' }}>
                                  <FormControl
                                    className={classes.formControl}
                                    style={{
                                      width: '100%',
                                      marginBottom: '16px',
                                    }}
                                  >
                                    <InputLabel
                                      htmlFor='password'
                                      style={{ marginLeft: '-1rem' }}
                                    >
                                      {t(
                                        'Accounts.Branding.AccountEnrollmentForm'
                                      )}
                                    </InputLabel>
                                    <Input
                                      ref={(genericTextArea) =>
                                        (this.textArea = genericTextArea)
                                      }
                                      style={{ resize: 'none' }}
                                      id='genericLink'
                                      className={classes.halfTextField}
                                      value={
                                        this.state && this.state.genericLink
                                      }
                                      readOnly={true}
                                      margin='normal'
                                      type='text'
                                      inputProps={{ readOnly: true }}
                                      endAdornment={
                                        <InputAdornment position='end'>
                                          <CopyToClipboard
                                            onCopy={this.onCopy}
                                            text={
                                              this.state &&
                                              this.state.genericLink
                                            }
                                          >
                                            <CopyText />
                                          </CopyToClipboard>
                                        </InputAdornment>
                                      }
                                      fullWidth
                                    />
                                  </FormControl>
                                </div>
                              </div>
                            ) : null}
                            {false && this.state.operation === 'View' ? (
                              <div
                                style={{ padding: '0px', marginTop: '2.1%' }}
                              >
                                <div style={{ display: 'inline-flex' }}>
                                  <FormControl
                                    className={classes.formControl}
                                    style={{
                                      width: '100%',
                                      marginBottom: '16px',
                                    }}
                                  >
                                    <InputLabel
                                      htmlFor='password'
                                      style={{ marginLeft: '-1rem' }}
                                    >
                                      {t(
                                        'Accounts.Branding.AccountEnrollmentForm'
                                      )}
                                    </InputLabel>
                                    <Input
                                      ref={(genericTextArea) =>
                                        (this.textArea = genericTextArea)
                                      }
                                      style={{ resize: 'none' }}
                                      id='genericLink'
                                      className={classes.halfTextField}
                                      value={
                                        this.state && this.state.genericLink
                                      }
                                      readOnly={true}
                                      margin='normal'
                                      type='text'
                                      inputProps={{ readOnly: true }}
                                      endAdornment={
                                        <InputAdornment position='end'>
                                          <CopyToClipboard
                                            onCopy={this.onCopy}
                                            text={
                                              this.state &&
                                              this.state.genericLink
                                            }
                                          >
                                            <CopyText />
                                          </CopyToClipboard>
                                        </InputAdornment>
                                      }
                                      fullWidth
                                    />
                                  </FormControl>
                                </div>
                              </div>
                            ) : null}
                            {false && this.state.operation === 'Add' ? (
                              <div
                                style={{ padding: '0px', marginTop: '2.1%' }}
                              >
                                <div style={{ display: 'inline-flex' }}>
                                  <FormControl
                                    className={classes.formControl}
                                    style={{
                                      width: '100%',
                                      marginBottom: '16px',
                                    }}
                                  >
                                    <InputLabel
                                      htmlFor='password'
                                      style={{ marginLeft: '-1rem' }}
                                    >
                                      {t(
                                        'Accounts.Branding.AccountEnrollmentForm'
                                      )}
                                    </InputLabel>
                                    <Input
                                      ref={(genericTextArea) =>
                                        (this.textArea = genericTextArea)
                                      }
                                      style={{ resize: 'none' }}
                                      id='genericLink'
                                      className={classes.halfTextField}
                                      value={
                                        this.state && this.state.genericLink
                                      }
                                      readOnly={true}
                                      margin='normal'
                                      type='text'
                                      inputProps={{ readOnly: true }}
                                      endAdornment={
                                        <InputAdornment position='end'>
                                          <CopyToClipboard
                                            onCopy={this.onCopy}
                                            text={
                                              this.state &&
                                              this.state.genericLink
                                            }
                                          >
                                            <CopyText />
                                          </CopyToClipboard>
                                        </InputAdornment>
                                      }
                                      fullWidth
                                    />
                                  </FormControl>
                                </div>
                              </div>
                            ) : null}
                          </div>
                          <div>
                            <TextField
                              className={classes.halfTextField}
                              margin='normal'
                              defaultValue={this.state.helpLink}
                              id='helpLink'
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t('Accounts.Branding.Help')}
                              placeholder=''
                              onBlur={this.handleChangeHelpLink}
                              onChange={this.handleChangeHelpLink}
                              variant='standard'
                            />
                            <TextField
                              className={classes.halfTextField}
                              margin='normal'
                              defaultValue={this.state.termsAndConditionsLink}
                              id='termsAndConditionsLink'
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t('Accounts.Branding.TermsAndConditions')}
                              placeholder=''
                              onBlur={this.handleChangeTermsAndConditionsLink}
                              onChange={this.handleChangeTermsAndConditionsLink}
                              variant='standard'
                            />
                            <br />
                            <TextField
                              className={classes.halfTextField}
                              margin='normal'
                              label={t('Accounts.Branding.AfterHourPhone')}
                              id='phone'
                              onBlur={this.handleChangePhone}
                              name='afterHourPhone'
                              defaultValue={this.state.afterHourPhone}
                              readOnly={readOnly}
                              variant='standard'
                            />
                            <TextField
                              className={classes.halfTextField}
                              margin='normal'
                              defaultValue={this.state.privacyPolicyLink}
                              id='privacyPolicyLink'
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t('Accounts.Branding.PrivacyPolicy')}
                              placeholder=''
                              onBlur={this.handleChangePrivacyPolicyLink}
                              onChange={this.handleChangePrivacyPolicyLink}
                              variant='standard'
                            />
                          </div>
                        </div>
                        <div
                          className={classes.rightChild}
                          style={{ marginTop: '5rem' }}
                        >
                          <div className={classes.brnddropbox}>
                            {readOnly ? (
                              <div>
                                {!this.state.brndLogoPreview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.brndLogoPreview && (
                                  <img
                                    alt=''
                                    src={this.state.brndLogoPreview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </div>
                            ) : (
                              <Dropzone
                                id='brndLogodropzone'
                                onDrop={this.handlebrndLogoDrop.bind(this)}
                                className={classes.innerBox}
                              >
                                {!this.state.brndLogoPreview && (
                                  <AddUserImage className={classes.dropImage} />
                                )}
                                {this.state.brndLogoPreview && (
                                  <img
                                    alt=''
                                    src={this.state.brndLogoPreview}
                                    className={classes.dropPic}
                                  />
                                )}
                              </Dropzone>
                            )}
                          </div>

                          <div variant='caption' style={{ marginTop: '10px', display: 'grid', placeItems: 'baseline' }}>
                            <p className={classes.captionadvText}>
                              {t('Accounts.Branding.UploadLogo')}
                            </p>
                            <Button
                              className={classes.btnremove}
                              onClick={this.removebrndLogo}
                            >
                              {t('Accounts.Branding.RemoveLogo')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      {(this.state.operation === 'Edit' ||
                        this.state.operation === 'View') ? (
                        <div
                          style={{
                            width: '100%',
                            marginTop: '24px',
                            padding: '16px 0 0 0',
                            borderTop: '1px solid #e0e0e0',
                            position: 'relative',
                          }}
                        >
                          <div
                            style={{
                              color: '#000',
                              fontSize: '1rem',
                              fontWeight: 600,
                              marginBottom: '6px',
                            }}
                          >
                            Enrollment
                          </div>
                          <div
                            style={{
                              color: '#6b6b6b',
                              fontSize: '0.85rem',
                              marginBottom: '12px',
                            }}
                          >
                            Manage the active public enrollment invite for this account.
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'flex-start',
                              gap: '24px',
                              flexWrap: 'nowrap',
                            }}
                          >
                            <div style={{ minWidth: '360px', maxWidth: '700px', flex: '1 1 auto', paddingRight: '170px' }}>
                              <FormControl className={classes.formControl} style={{ width: '100%' }}>
                                <InputLabel htmlFor='enrollmentInviteLink' style={{ marginLeft: '-1rem' }}>
                                  {t('Accounts.Branding.AccountEnrollmentForm')}
                                </InputLabel>
                                <Input
                                  id='enrollmentInviteLink'
                                  style={{ resize: 'none' }}
                                  value={this.state && this.state.genericLink}
                                  readOnly={true}
                                  margin='normal'
                                  type='text'
                                  inputProps={{ readOnly: true }}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <CopyToClipboard
                                        onCopy={this.onCopy}
                                        text={this.state && this.state.genericLink}
                                      >
                                        <CopyText />
                                      </CopyToClipboard>
                                    </InputAdornment>
                                  }
                                  fullWidth
                                />
                              </FormControl>
                              <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                                {!this.state.genericLink ? (
                                  <Button
                                    variant='outlined'
                                    color='primary'
                                    size='small'
                                    onClick={this.generateEnrollmentInvite}
                                  >
                                    Generate Invite
                                  </Button>
                                ) : null}
                                <Button
                                  variant='outlined'
                                  color='secondary'
                                  size='small'
                                  onClick={this.revokeEnrollmentInvite}
                                  disabled={!this.state.enrollmentInviteId}
                                >
                                  Revoke Invite
                                </Button>
                                <Button
                                  variant='outlined'
                                  color='primary'
                                  size='small'
                                  onClick={this.downloadEnrollmentQrCode}
                                  disabled={!this.state.genericLink}
                                >
                                  Download QR
                                </Button>
                              </div>
                            </div>
                          </div>
                          {this.state.genericLink ? (
                            <div
                              style={{
                                position: 'absolute',
                                top: '12px',
                                right: '0',
                                padding: '8px',
                                border: '1px solid #e0e0e0',
                                borderRadius: '6px',
                                background: '#fff',
                              }}
                            >
                              <div style={{ width: 120, height: 120 }}>
                                <QRCode
                                  value={this.state.genericLink}
                                  size={120}
                                  includeMargin={true}
                                  level='H'
                                  renderAs={'canvas'}
                                />
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </DialogContent>
                     
                  </div>
                </TabContainer>
                {/* {Connect Tab} */}
                {this.state.isPHiS ? (
                  <TabContainer dir={theme.direction}>
                    <div className={classes.paddedBoxDivEdit}>
                      <DialogTitle id='form-dialog-title'>
                        {' '}
                        {t('Accounts.Connect.ConnectionType')}
                      </DialogTitle>
                      <DialogContent style={{ minHeight: '400px' }}>
                        <MultipleConnection
                          name='connect'
                          id='connect'
                          className={classes.halfTextField}
                          onChange={this.handleConnectChange}
                          lookup={this.state.AccountConnections}
                          defaultValue={
                            this.state.connect.length > 0 &&
                              this.state.connect !== null
                              ? this.state.connect
                              : this.state.connectdefault
                          }
                          readOnly={readOnly}
                        />
                        {this.state.accountConnectionsId ===
                          CONNECTION_TYPE.UNPLUGGED ||
                          this.state.accountConnectionsId === null ? (
                          <div>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={this.state.isPaymentRequired}
                                  onChange={this.handleSwitchChange('Payment')}
                                  color='primary'
                                />
                              }
                              disabled={readOnly}
                              label={
                                <span
                                  style={{ color: '#000', fontSize: '1.0rem' }}
                                >
                                  {t('Accounts.Connect.PaymentRequired')}
                                </span>
                              }
                            />
                          </div>
                        ) : (
                          ''
                        )}

                        {this.state.accountConnectionsId ===
                          CONNECTION_TYPE.ILOCALBOX_PHARMACY ? (
                          <div style={{ display: 'flex' }}>
                            <TextValidator
                              autoFocus
                              className={classes.halfTextField}
                              margin='normal'
                              value={this.state.demo_email || ''}
                              id='demoEmail'
                              name='email'
                              inputProps={{ readOnly: Boolean(readOnly) }}
                              label={t(
                                'Accounts.Connect.iLocalBox.EmailAddress'
                              )}
                              placeholder=''
                              onChange={this.handleChangeConnectEmail}
                              validators={['required', 'isEmail']}
                              errorMessages={[
                                t('Validation.EnterEmailAddress'),
                                t('Validation.EmailIsNotValid'),
                              ]}
                              variant='standard'
                            />

                            <PhoneInput
                              labelStyle={{ left: '-13px', top: '-17px' }}
                              style={{ width: 360, marginTop: '15px' }}
                              id='demoPhone'
                              onBlur={this.handleChangeConnectSMSPhone}
                              defaultValue={this.state.demo_smsphone}
                              readOnly={readOnly}
                              validators={['required']}
                            />
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.accountConnectionsId ===
                          CONNECTION_TYPE.QS1 ? (
                          <div>
                            {/* <TextValidator
                                  // margin="dense"
                                  //style={{width: '200px', paddingRight: '20px'}}
                                  autoFocus
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.endpoint || ''}
                                  id="qs1Endpoint"
                                  name="endpoint"
                                  inputProps={{readOnly: Boolean(readOnly)}}
                                  label="End Point"
                                  placeholder="HTTPS://endpoint.url.something.com"
                                  onChange={this.handleChangeQS1Endpoint}
                                  validators={['required']}
                                  errorMessages={['Please Enter End Point Address']}
                                /> */}

                            <TextValidator
                              autoFocus
                              className={classes.halfTextField}
                              margin='normal'
                              value={this.state.pharmacyId || ''}
                              id='qs1PharmacyId'
                              name='pharmacyId'
                              inputProps={{ readOnly: Boolean(readOnly) }}
                              label={t('Pharmacy ID with PhIS')}
                              placeholder={t('Pharmacy ID with PhIS')}
                              onChange={this.handleChangeQS1PharmacyId}
                              validators={['required']}
                              errorMessages={[t('Validation.EnterPharmacyID')]}
                              variant='standard'
                            />
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.accountConnectionsId ===
                          CONNECTION_TYPE.PIONEERRX ? (
                          <div style={{ display: 'flex' }}>
                            {/* <TextValidator
                                  autoFocus
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.vendor_key || ''}
                                  id="pioneerRxVendorId"
                                  name="pioneerRxVendorId"
                                  inputProps={{readOnly: Boolean(readOnly)}}
                                  label="Vendor Key"
                                  placeholder="Vendor Key"
                                  onChange={this.handleChangePioneerRxVendorKeyId}
                                  validators={['required']}
                                  errorMessages={['Please Enter Vendor Key']}
                                /> */}
                            <TextValidator
                              autoFocus
                              className={classes.halfTextField}
                              margin='normal'
                              value={this.state.data_exchange_id || ''}
                              id='pioneerDataExchangeId'
                              name='pioneerDataExchangeId'
                              label={t('Accounts.Connect.Pioneer.DataExchangeID')}
                              placeholder={t('Accounts.Connect.Pioneer.DataExchangeID')}
                              onChange={
                                this.handleChangePioneerRxDataExchangeId
                              }
                              validators={['required']}
                              errorMessages={[t('Validation.EnterDataExchangeID')]}
                              variant='standard'
                            />
                            <TextValidator
                              className={classes.halfTextField}
                              margin='normal'
                              value={this.state.endpoint || ''}
                              id='pioneerEndPoint'
                              name='pioneerEndPoint'
                              label={t('Accounts.Connect.Pioneer.EndPoint')}
                              placeholder={t(
                                'Accounts.Connect.Pioneer.EndPoint'
                              )}
                              onChange={this.handleChangePioneerRxEndPoint}
                              validators={['required']}
                              errorMessages={[t('Validation.EnterEndPoint')]}
                              variant='standard'
                            />
                            <div style={{ marginTop: '2.5%' }}>
                              <FormControlLabel
                                label={
                                  <span style={{ color: '#000', fontSize: '1rem' }}>
                                    {t('Accounts.Connect.Pioneer.CalculateTax')}
                                  </span>
                                }
                                labelPlacement='start'
                                control={
                                  <div style={{ marginLeft: '4rem' }}>
                                    <Switch
                                      classes={{
                                        switchBase: classes.iOSSwitchBase,
                                        bar: classes.iOSBar,
                                        icon: classes.iOSIcon,
                                        iconChecked: classes.iOSIconChecked,
                                        checked: classes.iOSChecked,
                                      }}
                                      checked={this.state.calculate_tax}
                                      onChange={this.handleCalculateTaxToggle}
                                      value='checked'
                                      disabled={this.state.operation === 'View'}
                                      color='primary'
                                    />
                                  </div>
                                }
                                style={{ marginLeft: '8px', marginTop: '5px' }}
                              />
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.accountConnectionsId ===
                          CONNECTION_TYPE.EPIC ? (
                          <React.Fragment>
                            <div style={{ display: 'flex' }}>
                              <TextValidator
                                autoFocus
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.endpoint || ''}
                                id='epicEndPoint'
                                name='epicEndPoint'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t('Accounts.Connect.Epic.EndPoint')}
                                placeholder={t(
                                  'Accounts.Connect.Epic.EndPoint'
                                )}
                                onChange={this.handleChangeepicEndPoint}
                                validators={['required']}
                                title={this.state.endpoint || ''}
                                errorMessages={[t('Validation.EnterEpicEndPoint')]}
                                variant='standard'
                              />
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.epicclientid || ''}
                                id='epicClientID'
                                name='epicClientID'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t('Accounts.Connect.Epic.ClientID')}
                                placeholder={t(
                                  'Accounts.Connect.Epic.ClientID'
                                )}
                                onChange={this.handleChangeepicClientID}
                                validators={['required']}
                                errorMessages={[t('Validation.EnterEpicClientID')]}
                                variant='standard'
                              />
                            </div>
                            <div style={{ display: 'flex' }}>
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.epicusername || ''}
                                id='epicUsername'
                                name='epicUsername'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t('Accounts.Connect.Epic.UserName')}
                                placeholder={t(
                                  'Accounts.Connect.Epic.UserName'
                                )}
                                onChange={this.handleChangeepicusername}
                                validators={['required']}
                                errorMessages={[t('Validation.EnterUserName')]}
                                variant='standard'
                              />
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t('Accounts.Connect.Epic.Password')}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.epicpassword || ''}
                                  id='epicPassWord'
                                  name='epicPassWord'
                                  type={
                                    this.state.showepicpassword
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label={t('Accounts.Connect.Epic.Password')}
                                  placeholder=''
                                  onChange={this.handleChangeepicpassword}
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterPassword')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={this.handleClickShowPassword}
                                        onMouseDown={
                                          this.handleMouseDownPassword
                                        }
                                      >
                                        {this.state.showepicpassword ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                            <div style={{ display: 'flex' }}>
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.epicPharmacyNcpdpId || ''}
                                id='epicPharmacyNcpdpId'
                                name='epicPharmacyNcpdpId'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t(
                                  'Accounts.Connect.Epic.PharmacyNCPDPID'
                                )}
                                placeholder=''
                                onChange={this.handleChangPharmacyNcpDpId}
                                variant='standard'
                              />
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.epicEndpointVersion || ''}
                                id='epicEndpointVersion'
                                name='epicEndpointVersion'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t('Accounts.Connect.Epic.Version')}
                                placeholder=''
                                onChange={this.handleChangVersion}
                                variant='standard'
                              />
                            </div>
                            <div style={{ display: 'flex' }}>
                              <FormControl
                                className={classes.formControl}
                                style={{
                                  marginTop: '15px',
                                  marginBottom: '8px',
                                  width: '95%',
                                }}
                              >
                                <InputLabel
                                  htmlFor='epicRegExp'
                                  sx={{ ml: '-15px' }}
                                >
                                  {t('Accounts.Connect.Epic.RegExpLabel')}
                                </InputLabel>
                                <Input
                                  margin='normal'
                                  value={resolveEpicScanRegexp(this.state.regexp)}
                                  id='epicRegExp'
                                  name='epicRegExp'
                                  inputProps={{ readOnly: Boolean(readOnly) }}
                                  label={t('Accounts.Connect.Epic.RegExpLabel')}
                                  onChange={this.handleChangeEpicRegExp}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <Tooltip
                                        title={epicRegExpHelpIconText}
                                        className={classes.customWidth}
                                      >
                                        <Help className={classes.helpIcon}></Help>
                                      </Tooltip>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                            <div
                              style={{ display: 'flex', position: 'relative' }}
                            >
                              <TextField
                                id='standard-multiline-static'
                                name='epicRequestTempate'
                                label={t(
                                  'Accounts.Connect.Epic.RequestBodyTemplate'
                                )}
                                multiline
                                rows={6}
                                defaultValue={
                                  this.state.epicRequestTempate || ''
                                }
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                className={classes.halfTextField}
                                onChange={this.handleChangeRequestTemplate}
                                title={this.state.epicRequestTempate || ''}
                                variant='standard'
                              />
                              <label>
                                {t(
                                  'Accounts.Connect.Epic.RequestBodyTemplateExample'
                                )}
                                :
                                <p style={{ fontSize: '12px' }}>
                                  <b>{t('Accounts.Connect.Epic.Note')}:</b>
                                  {t('Accounts.Connect.Epic.NoteText')}
                                </p>
                                <pre
                                  style={{
                                    overflowX: 'auto',
                                    width: '580px',
                                    height: '280px',
                                  }}
                                >
                                  {`<s:Envelope xmlns:s="XXXXXXXXXXXXXXXX" xmlns:u="XXXXXXXXXXXXXXXX">
  <s:Header>
    <o:Security s:mustUnderstand="X" xmlns:o="XXXXXXXXXX">
      <o:UsernameToken u:Id="UsernameToken-XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX">
        <o:Username>emp:{{username}}</o:Username>
        <o:Password Type="XXXXXXXXXXXXXX">{{pasword}}</o:Password>
      </o:UsernameToken>
    </o:Security>
  </s:Header>
  <s:Body>
    {{payload}}
  </s:Body>
</s:Envelope>`}
                                </pre>
                              </label>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                marginTop: '8px',
                              }}
                            >
                              <FormControlLabel
                                label={t(
                                  'Accounts.Connect.Epic.VialLabelScan'
                                )}
                                control={
                                  <Switch
                                    name='checkedConsult'
                                    color='primary'
                                    checked={this.state.vial_label_scan}
                                    onChange={this.handleSwitchVialScanLabel}
                                    value='checked'
                                    disabled={this.state.operation === 'View'}
                                  />
                                }
                              />
                              <FormControlLabel
                                label={t(
                                  'Accounts.Connect.Epic.CustomConsultFlag'
                                )}
                                control={
                                  <Switch
                                    name='checkedConsult'
                                    color='primary'
                                    checked={this.state.isConsultRequired}
                                    onChange={this.handleSwitchChangeConsult}
                                    value='checked'
                                    disabled={this.state.operation === 'View'}
                                  />
                                }
                              />
                              {this.state.isConsultRequired ? (
                                <TextValidator
                                  className={classes.halfTextField}
                                  margin='normal'
                                  id='epicConsultKey'
                                  name='epicConsultKey'
                                  type={'text'}
                                  label={t('Accounts.Connect.Epic.ConsultKey')}
                                  placeholder={t(
                                    'Accounts.Connect.Epic.ConsultKey'
                                  )}
                                  value={this.state.epicConsultKey}
                                  onChange={this.handleConsultValue}
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                  }}
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterConsultKey')]}
                                />
                              ) : null}
                              <FormControlLabel
                                label={t(
                                  'Accounts.Connect.Epic.AdvanceFill'
                                )}
                                control={
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Switch
                                      name='checkedAdvanceFill'
                                      color='primary'
                                      checked={this.state.advance_fills}
                                      onChange={this.handleSwitchChangeAdvanceFill}
                                      value='checked'
                                      disabled={this.state.operation === 'View'}
                                    />
                                    <Tooltip
                                      title={AdvanceFillsHelpText}
                                      className={classes.customWidth}
                                    >
                                      <Help
                                        className={classes.helpIcon}
                                      />
                                    </Tooltip>
                                  </div>
                                }
                              />
                              <FormControlLabel
                                label={t(
                                  'Accounts.Connect.Epic.PreventAssigningNonReady'
                                )}
                                control={
                                  <Switch
                                    name='preventAssigningNonReady'
                                    color='primary'
                                    checked={this.state.prevent_assigning_non_ready}
                                    onChange={this.handleSwitchPreventAssigningNonReady}
                                    value='checked'
                                    disabled={this.state.operation === 'View'}
                                  />
                                }
                              />
                            </div>
                          </React.Fragment>
                        ) : (
                          ''
                        )}
                        {this.state &&
                          this.state.accountConnectionsId ===
                          CONNECTION_TYPE.MEDBANK ? (
                          <React.Fragment>
                            <div style={{ display: 'flex' }}>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t('Accounts.Connect.MedBank.DBLogin')}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.medbank_dblogin || ''}
                                  id='medbank_dblogin'
                                  name='medbank_dblogin'
                                  type={
                                    this.state.show_medbank_dblogin
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label={t('Accounts.Connect.MedBank.DBLogin')}
                                  placeholder=''
                                  onChange={this.handleChangeMedBankDBLogin}
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterDBLogin')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={
                                          this.handleClickShowMedBankDbLogin
                                        }
                                        onMouseDown={
                                          this.handleMouseDownMedbank
                                        }
                                      >
                                        {this.state.show_medbank_dblogin ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t('Accounts.Connect.MedBank.DBPassword')}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.medbank_db_password || ''}
                                  id='medbank_db_password'
                                  name='medbank_db_password'
                                  type={
                                    this.state.show_medbank_db_password
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label={t(
                                    'Accounts.Connect.MedBank.DBPassword'
                                  )}
                                  placeholder=''
                                  onChange={this.handleChangeMedBankDBPassword}
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterDBPassword')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={
                                          this.handleClickShowMedBankDbPassword
                                        }
                                        onMouseDown={
                                          this.handleMouseDownMedbank
                                        }
                                      >
                                        {this.state.show_medbank_db_password ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                            <div style={{ display: 'flex' }}>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t(
                                    'Accounts.Connect.MedBank.OcpApimSubscriptionKey'
                                  )}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={
                                    this.state.opc_apim_subscription_key || ''
                                  }
                                  id='medbank_db_password'
                                  name='medbank_db_password'
                                  type={
                                    this.state.show_medbank_subscription_key
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label='Password'
                                  placeholder=''
                                  onChange={
                                    this.handleChangeMedBankDBSubscriptionKey
                                  }
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterDBPassword')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={
                                          this
                                            .handleClickShowMedBankSubscriptionKey
                                        }
                                        onMouseDown={
                                          this.handleMouseDownMedbank
                                        }
                                      >
                                        {this.state
                                          .show_medbank_subscription_key ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                          </React.Fragment>
                        ) : (
                          ''
                        )}
                        {this.state &&
                          this.state.accountConnectionsId ===
                          CONNECTION_TYPE.MSCRIPTS ? (
                          <React.Fragment>
                            <div style={{ display: 'flex' }}>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t(
                                    'Accounts.Connect.MScripts.ClientIdentifier'
                                  )}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.client_identifier || ''}
                                  id='medbank_dblogin'
                                  name='medbank_dblogin'
                                  type={
                                    this.state.show_client_identifier
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label='Password'
                                  placeholder=''
                                  onChange={
                                    this.handleChangeMScriptClientIdentifier
                                  }
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterXApiKey')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={
                                          this
                                            .handleClickMScriptClientIdentifier
                                        }
                                        onMouseDown={
                                          this
                                            .handleMouseDownMScriptsClientIdentifier
                                        }
                                      >
                                        {this.state.show_client_identifier ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t('Accounts.Connect.MScripts.XApiKey')}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.x_api_key || ''}
                                  id='medbank_dblogin'
                                  name='medbank_dblogin'
                                  type={
                                    this.state.showXApiKey ? 'text' : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label='Password'
                                  placeholder=''
                                  onChange={this.handleChangeMScriptXApiKey}
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterXApiKey')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={this.handleClickMScriptXApiKey}
                                        onMouseDown={
                                          this.handleMouseDownMScriptsAPIKey
                                        }
                                      >
                                        {this.state.showXApiKey ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                          </React.Fragment>
                        ) : (
                          ''
                        )}
                        {this.state &&
                          this.state.accountConnectionsId ===
                          CONNECTION_TYPE.MCKESSONERX ? (
                          <React.Fragment>
                            <div style={{ display: 'flex' }}>
                              <TextValidator
                                autoFocus
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.endpoint || ''}
                                id='mckessoneRxEndPoint'
                                name='mckessoneRxEndPoint'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t('Accounts.Connect.McKesson.EndPoint')}
                                placeholder={t(
                                  'Accounts.Connect.McKesson.EndPoint'
                                )}
                                onChange={this.handleChangeMckessoneRx}
                                validators={['required']}
                                title={this.state.endpoint || ''}
                                errorMessages={[
                                  t('Validation.EnterMckessoneRxEndPoint')
                                ]}
                                variant='standard'
                              />
                              <TextValidator
                                autoFocus
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.store_number || ''}
                                id='mckessoneRxStoreNo'
                                name='mckessoneRxStoreNo'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t(
                                  'Accounts.Connect.McKesson.StoreNumber'
                                )}
                                placeholder={t(
                                  'Accounts.Connect.McKesson.StoreNumber'
                                )}
                                onChange={this.handleChangeStoreNumber}
                                title={this.state.endpoint || ''}
                                validators={[
                                  'required',
                                  'matchRegexp:^[0-9]*$',
                                ]}
                                errorMessages={[
                                  t('Validation.EnterStoreNumber'),
                                  t('Validation.UseDigits'),
                                ]}
                                variant='standard'
                              />
                            </div>
                            <div style={{ display: 'flex' }}>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='binaryToken'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t(
                                    'Accounts.Connect.McKesson.BinarySecurityToken'
                                  )}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextFieldToken}
                                  margin='normal'
                                  value={this.state.binaryToken}
                                  id='binaryToken'
                                  name='binaryToken'
                                  type={
                                    this.state.binaryTokenvisbel
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label={t(
                                    'Accounts.Connect.McKesson.BinarySecurityToken'
                                  )}
                                  placeholder=''
                                  onChange={this.handleChangeBinaryToken}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle binaryToken visibility'
                                        onClick={
                                          this.handleShowHideBinarytokenvisibel
                                        }
                                        onMouseDown={
                                          this.handleMouseDownSecrets
                                        }
                                      >
                                        {this.state.binaryTokenvisbel ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                      <Tooltip
                                        title={binarySecurityTokenTitle}
                                        className={classes.customWidth}
                                      >
                                        <Help
                                          className={classes.helpIcon}
                                        ></Help>
                                      </Tooltip>
                                    </InputAdornment>
                                  }
                                  fullWidth
                                />
                              </FormControl>
                              <FormControl
                                className={classes.formControl}
                                style={{
                                  marginTop: '15px',
                                  marginBottom: '20px',
                                }}
                              >
                                <InputLabel
                                  htmlFor='Issuer'
                                  sx={{ ml: '-15px' }}
                                >
                                  Issuer
                                </InputLabel>
                                <Input
                                  className={classes.halfTextFieldToken}
                                  margin='normal'
                                  value={this.state.issuer || ''}
                                  id='issuer'
                                  name='issuer'
                                  inputProps={{ readOnly: Boolean(readOnly) }}
                                  label='Issuer'
                                  placeholder='Issuer'
                                  onChange={this.handleChangeIssuer}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <Tooltip
                                        title={issuerTitle}
                                        className={classes.customWidth}
                                      >
                                        <Help
                                          className={classes.helpIcon}
                                        ></Help>
                                      </Tooltip>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                            <div>
                              <Accordion
                                expanded={
                                  this.state.accordianExpanded === 'panel0'
                                }
                                onChange={this.handleAccordianChange('panel0')}>
                                <AccordionSummary
                                  aria-controls='panel1d-content'
                                  id='panel1d-header'>
                                  <Typography>
                                    {t(
                                      'Accounts.Connect.McKesson.PrescriptionConfiguration'
                                    )}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Grid container spacing={{ xs: 2, md: 3 }} >
                                    <Grid item xs={12}>
                                      <FormControl
                                        className={classes.formControl}
                                        style={{
                                          marginTop: '15px',
                                          marginBottom: '20px',
                                          width: '90%'
                                        }}>
                                        <InputLabel
                                          htmlFor='RegExp'
                                          sx={{ ml: '-15px' }}>
                                          {t("Accounts.Connect.McKesson.RegExpLabel")}
                                        </InputLabel>
                                        <Input
                                          margin='normal'
                                          value={this.state.regexp || ''}
                                          id='RegExp'
                                          name='RegExp'
                                          inputProps={{ readOnly: Boolean(readOnly) }}
                                          label={t("Accounts.Connect.McKesson.RegExpLabel")}
                                          placeholder={t("Accounts.Connect.McKesson.RegExpLabel")}
                                          onChange={this.handleChangeRegExp}
                                          endAdornment={
                                            <InputAdornment position='end'>
                                              <Tooltip
                                                title={regExpHelpIconText}
                                                className={classes.customWidth}>
                                                <Help
                                                  className={classes.helpIcon}></Help>
                                              </Tooltip>
                                            </InputAdornment>
                                          }
                                        />
                                        </FormControl>
                                      </Grid>
                                      <Grid item xs={12}>
                                        <FormControlLabel
                                          label={t('Accounts.Connect.McKesson.FillNumberApiFallback')}
                                          control={
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                              <Switch
                                                name='fill_number_api_fallback'
                                                color='primary'
                                                checked={this.state.fill_number_api_fallback === true}
                                                onChange={this.handleSwitchChangeFillNumberApiFallback}
                                                value='checked'
                                                disabled={Boolean(readOnly)}
                                              />
                                              <Tooltip
                                                title={fillNumberApiFallbackHelpText}
                                                className={classes.customWidth}>
                                                <Help className={classes.helpIcon}></Help>
                                              </Tooltip>
                                            </div>
                                          }
                                        />
                                      </Grid>
                                  </Grid>
                                </AccordionDetails>
                              </Accordion>
                              <Accordion
                                expanded={
                                  this.state.accordianExpanded === 'panel1'
                                }
                                onChange={this.handleAccordianChange('panel1')}
                              >
                                <AccordionSummary
                                  aria-controls='panel1d-content'
                                  id='panel1d-header'
                                >
                                  <Typography>
                                    {t(
                                      'Accounts.Connect.McKesson.CurrentFillRequestTemplate'
                                    )}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <div
                                    style={{
                                      display: 'flex',
                                      position: 'relative',
                                    }}
                                  >
                                    <TextField
                                      id='standard-multiline-static'
                                      name='mcKessoneRXrequestTemplate'
                                      label={t(
                                        'Accounts.Connect.McKesson.RequestExample'
                                      )}
                                      multiline
                                      rows={6}
                                      defaultValue={
                                        this.state.mcKessoneRXrequestTemplate ||
                                        ''
                                      }
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                      className={classes.halfTextField}
                                      onChange={
                                        this
                                          .handleChangeMckessoneRequestTemplate
                                      }
                                      title={
                                        this.state.mcKessoneRXrequestTemplate ||
                                        ''
                                      }
                                      variant='standard'
                                    />
                                    <label>
                                      {t('Accounts.Connect.McKesson.Example')}:
                                      <p style={{ fontSize: '12px' }}>
                                        <b>
                                          {t('Accounts.Connect.McKesson.Note')}:
                                        </b>
                                        {t(
                                          'Accounts.Connect.McKesson.NoteText'
                                        )}
                                      </p>
                                      <pre
                                        style={{
                                          overflowX: 'auto',
                                          width: '580px',
                                          height: '140px',
                                          margin: '0px',
                                        }}
                                      >
                                        {`<soapenv:Envelope xmlns:soapenv="XXXXXXXXXXXXXXXX"
  xmlns:com="XXXXXXXXXXXXXXXX" xmlns:oas="XXXXXXXXXXXXXXXX"
  xmlns:oas1="XXXXXXXXXXXXXXX" xmlns:_1="XXXXXXXXXXXXXXXX">
  <soapenv:Header> {{header}}  </soapenv:Header>
  <soapenv:Body> {{payload}} </soapenv:Body>
</soapenv:Envelope>`}
                                      </pre>
                                    </label>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      position: 'relative',
                                      marginTop: '25px',
                                    }}
                                  >
                                    <TextField
                                      id='standard-multiline-static'
                                      name='mcKessoneRXrequestTemplate'
                                      label={t(
                                        'Accounts.Connect.McKesson.RequestHeadersTemplate'
                                      )}
                                      multiline
                                      rows={6}
                                      defaultValue={
                                        this.state.CFRHeaderTemplate || ''
                                      }
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                      className={classes.halfTextField}
                                      onChange={
                                        this.handleCFRHeaderTemplateChange
                                      }
                                      title={this.state.CFRHeaderTemplate || ''}
                                      variant='standard'
                                    />
                                    <label>
                                      {t('Accounts.Connect.McKesson.Example')}:
                                      <p style={{ fontSize: '12px' }}>
                                        <b>
                                          {t('Accounts.Connect.McKesson.Note')}:
                                        </b>
                                        {t(
                                          'Accounts.Connect.McKesson.NoteText'
                                        )}
                                      </p>
                                      <pre
                                        style={{
                                          overflowX: 'auto',
                                          width: '580px',
                                          height: '140px',
                                          margin: '0px',
                                        }}
                                      >
                                        {`<com:MsgHeader MsgName="XXXXXXXXXX" Version="XXX" SourceID="{{StoreNumber}}"
DestinationID="XXXX" MsgID="XXXXXXXXXXXXXXXX"/>
  <oas:Security>
    <oas:BinarySecurityToken oas1:Id="XXXXXXXXXX"
    EncodingType="XXXXXXXX" ValueType="XXXXXXXX">
    {{binarySecurityToken}}
    </oas:BinarySecurityToken>
  </oas:Security>`}
                                      </pre>
                                    </label>
                                  </div>
                                </AccordionDetails>
                              </Accordion>
                              <Accordion
                                expanded={
                                  this.state.accordianExpanded === 'panel2'
                                }
                                onChange={this.handleAccordianChange('panel2')}
                              >
                                <AccordionSummary
                                  aria-controls='panel2d-content'
                                  id='panel2d-header'
                                >
                                  <Typography>
                                    {t(
                                      'Accounts.Connect.McKesson.RxInfoRequestTemplate'
                                    )}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <div
                                    style={{
                                      display: 'flex',
                                      position: 'relative',
                                    }}
                                  >
                                    <TextField
                                      id='standard-multiline-static'
                                      name='mcKessoneRXrequestTemplate'
                                      label='Request Body Template'
                                      multiline
                                      rows={6}
                                      defaultValue={
                                        this.state.RxInfoBodyTemplate || ''
                                      }
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                      className={classes.halfTextField}
                                      onChange={
                                        this.handleRxInfoBodyTemplateChange
                                      }
                                      title={
                                        this.state.RxInfoBodyTemplate || ''
                                      }
                                      variant='standard'
                                    />
                                    <label>
                                      {t(
                                        'Accounts.Connect.McKesson.RequestBodyTemplate'
                                      )}
                                      :
                                      <p style={{ fontSize: '12px' }}>
                                        <b>
                                          {t('Accounts.Connect.McKesson.Note')}:
                                        </b>
                                        {t(
                                          'Accounts.Connect.McKesson.NoteText'
                                        )}
                                      </p>
                                      <pre
                                        style={{
                                          overflowX: 'auto',
                                          width: '580px',
                                          height: '140px',
                                          margin: '0px',
                                        }}
                                      >
                                        {`<soapenv:Envelope xmlns:soapenv="XXXXXXXXXXXXXXXX"
  xmlns:com="XXXXXXXXXXXXXXXX" xmlns:oas="XXXXXXXXXXXXXXXX"
  xmlns:oas1="XXXXXXXXXXXXXXX" xmlns:_1="XXXXXXXXXXXXXXXX">
  <soapenv:Header>
          {{header}}
  </soapenv:Header>
  <soapenv:Body>
          {{payload}}
  </soapenv:Body>
</soapenv:Envelope>`}
                                      </pre>
                                    </label>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      position: 'relative',
                                    }}
                                  >
                                    <TextField
                                      id='standard-multiline-static'
                                      name='mcKessoneRXrequestTemplate'
                                      label={t(
                                        'Accounts.Connect.McKesson.RequestHeadersTemplate'
                                      )}
                                      multiline
                                      rows={6}
                                      defaultValue={
                                        this.state.RxInfoHeaderTemplate || ''
                                      }
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                      className={classes.halfTextField}
                                      onChange={
                                        this.handleRxInfoHeaderTemplateChange
                                      }
                                      title={
                                        this.state.RxInfoHeaderTemplate || ''
                                      }
                                      variant='standard'
                                    />
                                    <label>
                                      {t('Accounts.Connect.McKesson.Example')}:
                                      <p style={{ fontSize: '12px' }}>
                                        <b>
                                          {t('Accounts.Connect.McKesson.Note')}:
                                        </b>
                                        {t(
                                          'Accounts.Connect.McKesson.NoteText'
                                        )}
                                      </p>
                                      <pre
                                        style={{
                                          overflowX: 'auto',
                                          width: '580px',
                                          height: '140px',
                                          margin: '0px',
                                        }}
                                      >
                                        {`<_1:MsgHeader MsgName="RxInfoReq" Version="1.1" SourceID="{{StoreNumber}}"
DestinationID="XXXX" MsgID="XXXXXX"/>
<oas:Security>
  <oas:BinarySecurityToken wsu:Id="{{Issuer}}"
  EncodingType="XXXXXXXX" ValueType="XXXXXXXXX">
    {{BinarySecurityToken}}
  </oas:BinarySecurityToken>
</oas:Security>`}
                                      </pre>
                                    </label>
                                  </div>
                                </AccordionDetails>
                              </Accordion>
                              <Accordion
                                expanded={
                                  this.state.accordianExpanded === 'panel3'
                                }
                                onChange={this.handleAccordianChange('panel3')}
                              >
                                <AccordionSummary
                                  aria-controls='panel3d-content'
                                  id='panel3d-header'
                                >
                                  <Typography>
                                    {t(
                                      'Accounts.Connect.McKesson.POSFinalizationRequestTemplate'
                                    )}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <div
                                    style={{
                                      display: 'flex',
                                      position: 'relative',
                                    }}
                                  >
                                    <TextField
                                      id='standard-multiline-static'
                                      name='mcKessoneRXrequestTemplate'
                                      label={t(
                                        'Accounts.Connect.EpicMLTS.RequestBodyTemplate'
                                      )}
                                      multiline
                                      rows={6}
                                      defaultValue={
                                        this.state
                                          .POSFinalizationBodyTemplate || ''
                                      }
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                      className={classes.halfTextField}
                                      onChange={
                                        this
                                          .handlePOSFinalizationBodyTemplateChange
                                      }
                                      title={
                                        this.state
                                          .POSFinalizationBodyTemplate || ''
                                      }
                                      variant='standard'
                                    />
                                    <label>
                                      {t(
                                        'Accounts.Connect.McKesson.RequestBodyTemplate'
                                      )}
                                      :
                                      <p style={{ fontSize: '12px' }}>
                                        <b>
                                          {t('Accounts.Connect.McKesson.Note')}:
                                        </b>
                                        {t(
                                          'Accounts.Connect.McKesson.NoteText'
                                        )}
                                      </p>
                                      <pre
                                        style={{
                                          overflowX: 'auto',
                                          width: '580px',
                                          height: '140px',
                                          margin: '0px',
                                        }}
                                      >
                                        {`<soapenv:Envelope xmlns:soapenv="XXXXXXXXXXXXXXXX"
  xmlns:com="XXXXXXXXXXXXXXXX" xmlns:oas="XXXXXXXXXXXXXXXX"
  xmlns:oas1="XXXXXXXXXXXXXXX" xmlns:_1="XXXXXXXXXXXXXXXX">
  <soapenv:Header>
          {{header}}
  </soapenv:Header>
  <soapenv:Body>
          {{payload}}
  </soapenv:Body>
</soapenv:Envelope>`}
                                      </pre>
                                    </label>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      position: 'relative',
                                    }}
                                  >
                                    <TextField
                                      id='standard-multiline-static'
                                      name='mcKessoneRXrequestTemplate'
                                      label={t(
                                        'Accounts.Connect.McKesson.RequestHeadersTemplate'
                                      )}
                                      multiline
                                      rows={6}
                                      defaultValue={
                                        this.state
                                          .POSFinalizationHeaderTemplate || ''
                                      }
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                      className={classes.halfTextField}
                                      onChange={
                                        this
                                          .handlePOSFinalizationHeaderTemplateChange
                                      }
                                      title={
                                        this.state
                                          .POSFinalizationHeaderTemplate || ''
                                      }
                                      variant='standard'
                                    />
                                    <label>
                                      {t('Accounts.Connect.McKesson.Example')}:
                                      <p style={{ fontSize: '12px' }}>
                                        <b>
                                          {t('Accounts.Connect.McKesson.Note')}:
                                        </b>
                                        {t(
                                          'Accounts.Connect.McKesson.NoteText'
                                        )}
                                      </p>
                                      <pre
                                        style={{
                                          overflowX: 'auto',
                                          width: '580px',
                                          height: '140px',
                                          margin: '0px',
                                        }}
                                      >
                                        {`<oas:Security>
<oas:BinarySecurityToken oas1:Id="{{Issuer}}" EncodingType="XXXXXX" ValueType="XXXXXXX">
  {{BinarySecurityToken}}
</oas:BinarySecurityToken>
</oas:Security>
<com:MsgHeader MsgName="XXXXXXX" Version="8.1" SourceID="{{StoreNumber}}" DestinationID="XXXXXX" MsgID="XXXXXXXXXX"/>`}
                                      </pre>
                                    </label>
                                  </div>
                                </AccordionDetails>
                              </Accordion>
                            </div>
                          </React.Fragment>
                        ) : (
                          ''
                        )}
                        {this.state &&
                          this.state.accountConnectionsId ===
                          CONNECTION_TYPE.EPIC_WITH_MTLS ? (
                          <React.Fragment>
                            <div style={{ display: 'flex' }}>
                              <TextValidator
                                autoFocus
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.endpoint || ''}
                                id='epicEndPoint'
                                name='epicEndPoint'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t('Accounts.Connect.EpicMLTS.EndPoint')}
                                placeholder={t(
                                  'Accounts.Connect.EpicMLTS.EndPoint'
                                )}
                                onChange={this.handleChangeepicWithMtlsEndPoint}
                                validators={['required']}
                                title={this.state.endpoint || ''}
                                errorMessages={[
                                  t('Validation.EnterEpicmTLSEndPoint'),
                                ]}
                                variant='standard'
                              />
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.epicclientid || ''}
                                id='epicClientID'
                                name='epicClientID'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t('Accounts.Connect.EpicMLTS.ClientID')}
                                placeholder={t(
                                  'Accounts.Connect.EpicMLTS.ClientID'
                                )}
                                onChange={this.handleChangeepicWithMtlsClientID}
                                validators={['required']}
                                errorMessages={[
                                  t('Validation.EnterEpicmTLSClientID'),
                                ]}
                                variant='standard'
                              />
                            </div>
                            <div style={{ display: 'flex' }}>
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.epicPharmacyNcpdpId || ''}
                                id='epicPharmacyNcpdpId'
                                name='epicPharmacyNcpdpId'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t(
                                  'Accounts.Connect.EpicMLTS.PharmacyNCPDPID'
                                )}
                                placeholder=''
                                onChange={
                                  this.handleChangepicWithMtlsPharmacyNcpDpId
                                }
                                variant='standard'
                              />
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.epicEndpointVersion || ''}
                                id='epicEndpointVersion'
                                name='epicEndpointVersion'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t('Accounts.Connect.EpicMLTS.Version')}
                                placeholder=''
                                onChange={this.handleChangepiWithMtlsVersion}
                                variant='standard'
                              />
                            </div>
                            <div
                              style={{ display: 'flex', position: 'relative' }}
                            >
                              <TextField
                                id='standard-multiline-static'
                                name='epicRequestTempate'
                                label={t(
                                  'Accounts.Connect.EpicMLTS.RequestBodyTemplate'
                                )}
                                multiline
                                rows={6}
                                defaultValue={
                                  this.state.epicRequestTempate || ''
                                }
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                className={classes.halfTextField}
                                onChange={
                                  this.handleChangeepicWithMtlsRequestTemplate
                                }
                                title={this.state.epicRequestTempate || ''}
                                variant='standard'
                              />
                              <label>
                                {t(
                                  'Accounts.Connect.EpicMLTS.RequestBodyTemplateExample'
                                )}
                                :
                                <p style={{ fontSize: '12px' }}>
                                  <b>{t('Accounts.Connect.EpicMLTS.Note')}:</b>
                                  {t('Accounts.Connect.EpicMLTS.NoteText')}
                                </p>
                                <pre
                                  style={{
                                    overflowX: 'auto',
                                    width: '580px',
                                    height: '280px',
                                  }}
                                >
                                  {`<soapenv:Envelope xmlns:soapenv="XXXXXXXXXXXXXXXX" xmlns:urn="XXXXXXXXXXXXXXXX" xmlns:arr="XXXXXXXXXXXXXXXX">
    <soapenv:Header>
        <Headers xmlns="XXXXXXXXXXXXXXXX">
            <Epic-Client-ID>{{clientId}}</Epic-Client-ID>
        </Headers>
    </soapenv:Header>
    <soapenv:Body>
        {{payload}}
    </soapenv:Body>
</soapenv:Envelope>`}
                                </pre>
                              </label>
                            </div>
                            <div>
                              <FormControlLabel
                                label={t(
                                  'Accounts.Connect.Epic.AdvanceFill'
                                )}
                                control={
                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Switch
                                      name='checkedAdvanceFill'
                                      color='primary'
                                      checked={this.state.advance_fills}
                                      onChange={this.handleSwitchChangeAdvanceFill}
                                      value='checked'
                                      disabled={this.state.operation === 'View'}
                                    />
                                    <Tooltip
                                      title={AdvanceFillsHelpText}
                                      className={classes.customWidth}
                                      style={{ marginLeft: '25%', position: 'absolute' }}
                                    >
                                      <Help
                                        className={classes.helpIcon}
                                      ></Help>
                                    </Tooltip>
                                  </div>
                                }
                              />
                            </div>
                          </React.Fragment>
                        ) : (
                          ''
                        )}
                        {this.state &&
                          this.state.accountConnectionsId ===
                          CONNECTION_TYPE.THIRD_PARTY ? (
                          <React.Fragment>
                            <div style={{ display: 'flex' }}>
                              <div style={{ width: '390px', marginTop: '15px', marginRight: '15px' }}>
                                <Selector
                                  id='vendor_unique_id'
                                  label={t('Accounts.Connect.ThirdParty.SelectVendors')}
                                  values={this.state.vendorValues}
                                  selected={this.state.vendor_unique_id}
                                  onBlur={this.handleChange}
                                  disableWhenViewSelect={disableSelect}
                                />
                              </div>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t(
                                    'Accounts.Connect.ThirdParty.Token'
                                  )}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.third_party_token || ''}
                                  id='thirdparty_token'
                                  name='thirdparty_token'
                                  type={
                                    this.state.show_third_party_token
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label='Password'
                                  placeholder=''
                                  onChange={
                                    this.handleChangeThirdPartyToken
                                  }
                                  validators={['required']}
                                  errorMessages={[t('Validation.Token')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={
                                          this
                                            .handleClickThirdPartyToken
                                        }
                                        onMouseDown={
                                          this
                                            .handleMouseDownThirdPartyToken
                                        }
                                      >
                                        {this.state.show_third_party_token ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>

                            {/* New fields for 3rd party connection */}
                            <div style={{ display: 'flex' }}>
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.endpoint || ''}
                                id='thirdPartyEndPoint'
                                name='thirdPartyEndPoint'
                                inputProps={{
                                  readOnly: Boolean(readOnly),
                                }}
                                label='End Point'
                                placeholder='HTTPS://endpoint.url.something.com'
                                onChange={
                                  this.handleChangeThirdPartyEndPoint
                                }
                                validators={['required']}
                                errorMessages={[t('Validation.EnterEndPoint')]}
                                variant='standard'
                              />

                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='thirdPartyXApiKey'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t('Accounts.Connect.MScripts.XApiKey')}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.x_api_key || ''}
                                  id='thirdPartyXApiKey'
                                  name='thirdPartyXApiKey'
                                  type={
                                    this.state.showXApiKey
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label='X-Api-Key'
                                  placeholder=''
                                  onChange={this.handleChangeMScriptXApiKey}
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterXApiKey')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={this.handleClickMScriptXApiKey}
                                        onMouseDown={
                                          this.handleMouseDownMScriptsAPIKey
                                        }
                                      >
                                        {this.state.showXApiKey ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                            <div style={{ display: 'flex' }}>
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.store_ncp_id || ''}
                                id='thirdPartyStoreId'
                                name='thirdPartyStoreId'
                                inputProps={{
                                  readOnly: Boolean(readOnly),
                                }}
                                label={t('Accounts.AccountDetail.StoreId')}
                                placeholder=''
                                onChange={
                                  this.handleChangeThirdPartyStoreId
                                }
                                validators={['required']}
                                variant='standard'
                              />
                            </div>
                          </React.Fragment>
                        ) : (
                          ''
                        )}
                        {this.state.accountConnectionsId ===
                          CONNECTION_TYPE.LIBERTY_SOFTWARE ? (
                          <Grid container spacing={2} sx={{ maxWidth: 840, mt: 0.5 }}>
                            <Grid item xs={12}>
                              <TextValidator
                                autoFocus
                                fullWidth
                                margin='dense'
                                value={this.state.endpoint || DEFAULT_LIBERTY_BASE_URL}
                                id='libertySoftwareEndpoint'
                                name='libertySoftwareEndpoint'
                                label={t('Accounts.Connect.LibertySoftware.ApiUrl')}
                                placeholder={DEFAULT_LIBERTY_BASE_URL}
                                onChange={this.handleChangeLibertyEndpoint}
                                validators={['required']}
                                errorMessages={[t('Validation.EnterEndPoint')]}
                                variant='standard'
                                InputProps={{
                                  inputProps: { readOnly: Boolean(readOnly) },
                                  endAdornment: this.renderLibertyFieldIcons(
                                    t('Accounts.Connect.LibertySoftware.ApiUrlHelp')
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextValidator
                                fullWidth
                                margin='dense'
                                value={this.state.vendor_key || DEFAULT_LIBERTY_VENDOR_USERNAME}
                                id='libertySoftwareVendorUsername'
                                name='libertySoftwareVendorUsername'
                                label={t('Accounts.Connect.LibertySoftware.VendorUsername')}
                                placeholder={DEFAULT_LIBERTY_VENDOR_USERNAME}
                                onChange={this.handleChangeLibertyVendorUsername}
                                validators={['required']}
                                errorMessages={[t('Validation.EnterUserName')]}
                                variant='standard'
                                InputProps={{
                                  inputProps: { readOnly: Boolean(readOnly), autoComplete: 'off' },
                                  endAdornment: this.renderLibertyFieldIcons(
                                    t('Accounts.Connect.LibertySoftware.VendorUsernameHelp')
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextValidator
                                fullWidth
                                margin='dense'
                                type={this.state.showLibertyVendorPassword ? 'text' : 'password'}
                                value={this.state.data_exchange_id || DEFAULT_LIBERTY_VENDOR_PASSWORD}
                                id='libertySoftwareVendorPassword'
                                name='libertySoftwareVendorPassword'
                                label={t('Accounts.Connect.LibertySoftware.VendorPassword')}
                                placeholder={DEFAULT_LIBERTY_VENDOR_PASSWORD}
                                onChange={this.handleChangeLibertyVendorPassword}
                                validators={['required']}
                                errorMessages={[t('Validation.EnterPassword')]}
                                variant='standard'
                                InputProps={{
                                  inputProps: {
                                    readOnly: Boolean(readOnly),
                                    autoComplete: 'new-password',
                                  },
                                  endAdornment: this.renderLibertyFieldIcons(
                                    t('Accounts.Connect.LibertySoftware.VendorPasswordHelp'),
                                    {
                                      visible: this.state.showLibertyVendorPassword,
                                      onClick: this.handleClickLibertyVendorPassword,
                                    }
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextValidator
                                fullWidth
                                margin='dense'
                                value={this.state.liberty_customer_username || ''}
                                id='libertySoftwareCustomerUserName'
                                name='libertySoftwareCustomerUserName'
                                label={t('Accounts.Connect.LibertySoftware.CustomerUserName')}
                                placeholder={t('Accounts.Connect.LibertySoftware.CustomerUserName')}
                                onChange={this.handleChangeLibertyCustomerUserNameChange}
                                validators={['required']}
                                errorMessages={[t('Validation.Required.CustomerUserName')]}
                                variant='standard'
                                InputProps={{
                                  inputProps: { readOnly: Boolean(readOnly) },
                                  endAdornment: this.renderLibertyFieldIcons(
                                    t('Accounts.Connect.LibertySoftware.CustomerUserNameHelp')
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextValidator
                                fullWidth
                                margin='dense'
                                type={this.state.showLibertyApiKey ? 'text' : 'password'}
                                value={this.state.liberty_customer_password || ''}
                                id='libertySoftwareCustomerPassword'
                                name='libertySoftwareCustomerPassword'
                                label={t('Accounts.Connect.LibertySoftware.CustomerPassword')}
                                placeholder={t('Accounts.Connect.LibertySoftware.CustomerPassword')}
                                onChange={this.handleChangeLibertyCustomerPasswordChange}
                                validators={['required']}
                                errorMessages={[t('Validation.Required.CustomerPassword')]}
                                variant='standard'
                                InputProps={{
                                  inputProps: {
                                    readOnly: Boolean(readOnly),
                                    autoComplete: 'new-password',
                                  },
                                  endAdornment: this.renderLibertyFieldIcons(
                                    t('Accounts.Connect.LibertySoftware.CustomerPasswordHelp'),
                                    {
                                      visible: this.state.showLibertyApiKey,
                                      onClick: this.handleClickLibertyApiKey,
                                    }
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextValidator
                                fullWidth
                                margin='dense'
                                value={this.state.liberty_rx_regrx || ''}
                                id='libertyRegExp'
                                name='libertyRegExp'
                                label={t('Accounts.Connect.McKesson.RegExpLabel')}
                                placeholder={t('Accounts.Connect.McKesson.RegExpLabel')}
                                onChange={this.handleChangeLibertyRxRegRxChange}
                                variant='standard'
                                InputProps={{
                                  inputProps: { readOnly: Boolean(readOnly) },
                                  endAdornment: this.renderLibertyFieldIcons(libertyRegExpHelpIconText),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextValidator
                                fullWidth
                                margin='dense'
                                value={this.state.liberty_completion_status || ''}
                                id='libertyCompletionStatus'
                                name='libertyCompletionStatus'
                                label={t('Accounts.Connect.LibertySoftware.CompletionStatus')}
                                placeholder='Shipped'
                                onChange={this.handleChangeLibertyCompletionStatus}
                                variant='standard'
                                InputProps={{
                                  inputProps: { readOnly: Boolean(readOnly) },
                                  endAdornment: this.renderLibertyFieldIcons(libertyCompletionStatusHelpIconText),
                                }}
                              />
                            </Grid>
                          </Grid>
                        ) : (
                          ''
                        )}
                        {this.state &&
                          this.state.accountConnectionsId ===
                          CONNECTION_TYPE.HL7 ? (
                            <HL7Layout
                              t={t}
                              classes={classes}
                              handleClickHL7XApiKey={this.handleClickHL7XApiKey}
                              handleMouseDownHL7APIKey={this.handleMouseDownHL7APIKey}
                              showXApiKey={this.state.showHLXApiKey}
                              readOnly={readOnly}
                              x_api_key={this.state.hl_x_api_key}
                              handleChangeHL7XApiKey={this.handleChangeHL7XApiKey}
                            />
                        ) : (
                          ''
                        )}
                        {this.state &&
                          this.state.accountConnectionsId ===
                          CONNECTION_TYPE.DRX_INTEGRATION ? (
                            <DRXLayout
                              t={t}
                              classes={classes}
                              handleClickDRXKey={this.handleClickDRXKey}
                              handleMouseDownDRXKey={this.handleMouseDownDRXKey}
                              showDRXKey={this.state.showDRXKey}
                              readOnly={readOnly}
                              drx_key={this.state.drx_key}
                              handleChangeDRXKey={this.handleChangeDRXKey}
                              drx_host={this.state.drx_host}
                              handleChangeDRXHost={this.handleChangeDRXHost}
                              drxHelpText={t("Accounts.Connect.DRX.DRXHostHelpText")}
                            />
                        ) : (
                          ''
                        )}
                          {this.state.accountConnectionsId ===
                            CONNECTION_TYPE.BASIC ? (
                            <React.Fragment>
                            <div style={{ display: 'flex' }}>
                              <TextValidator
                                autoFocus
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.basic_first_name || ''}
                                id='FirstName'
                                name='FirstName'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t(
                                  'Accounts.AccountDetail.FirstName'
                                )}
                                placeholder=''
                                onChange={(e) => this.setState({ basic_first_name: e.target.value })}
                                validators={[
                                  // 'required',
                                  'matchRegexp:^[a-zA-Z ]*$',
                                ]}
                                errorMessages={[
                                  // t('Validation.LastNameRequired'),
                                  t('Validation.UseAlphabets'),
                                ]}
                                variant='standard'
                              />
                              <TextValidator
                                autoFocus
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.basic_last_name || ''}
                                id='LastName'
                                name='LastName'
                                inputProps={{ readOnly: Boolean(readOnly) }}
                                label={t(
                                  'Accounts.AccountDetail.LastName'
                                )}
                                placeholder=''
                                onChange={(e) => this.setState({ basic_last_name: e.target.value })}
                                validators={[
                                  // 'required',
                                  'matchRegexp:^[a-zA-Z ]*$',
                                ]}
                                errorMessages={[
                                  // t('Validation.LastNameRequired'),
                                  t('Validation.UseAlphabets'),
                                ]}
                                variant='standard'
                              />

                            </div>
                            <FormControlLabel
                              style={{ marginTop: 8, alignItems: 'flex-start' }}
                              control={
                                <Checkbox
                                  checked={[true, 'true', 1, '1'].includes(this.state.is_dob_optional)}
                                  onChange={(event) => this.setState({ is_dob_optional: event.target.checked })}
                                  disabled={Boolean(readOnly)}
                                  color='primary'
                                />
                              }
                              label={
                                <span>
                                  {t('Accounts.Connect.Basic.DobOptional')}
                                  <span style={{ display: 'block', fontSize: '0.75rem', color: '#64748b' }}>
                                    {t('Accounts.Connect.Basic.DobOptionalHelp')}
                                  </span>
                                </span>
                              }
                            />
                            </React.Fragment>
                          ) : (
                            ''
                          )}
                        {this.state &&
                          this.state.accountConnectionsId ===
                          CONNECTION_TYPE.PRIMERX ? (
                          <React.Fragment>
                            <div>
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.prx_endoint || ''}
                                id='prxEndPoint'
                                name='prxEndPoint'
                                label={t('Accounts.Connect.PRX.PRXEndoint')}
                                placeholder={t(
                                  'Accounts.Connect.PRX.PRXEndoint'
                                )}
                                onChange={this.handleChangePrimeRxEndoint}
                                variant='standard'
                              />
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t(
                                    'Accounts.Connect.PRX.PRXMemberid'
                                  )}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.prx_memberid || ''}
                                  id='prxMemberId'
                                  name='prxMemberId'
                                  type={'text'}
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                  }}
                                  label='Member ID'
                                  placeholder=''
                                  onChange={
                                    this.handleChangePrimeRxMemberId
                                  }
                                  validators={['required']}
                                  errorMessages={[t('Validation.MemberId')]}
                                />
                              </FormControl>
                            </div>
                            <div style={{ display: 'flex' }}>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t(
                                    'Accounts.Connect.PRX.PRXClientIdentifier'
                                  )}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.prx_client_identifier || ''}
                                  id='prxClientIdentifier'
                                  name='prxClientIdentifier'
                                  type={
                                    this.state.show_prx_client_identifier
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label='Password'
                                  placeholder=''
                                  onChange={
                                    this.handleChangePrimeRxClientIdentifier
                                  }
                                  validators={['required']}
                                  errorMessages={[t('Validation.ClientIdentifier')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={
                                          this
                                            .handleClickPRXClientIdentifier
                                        }
                                        onMouseDown={
                                          this
                                            .handleMouseDownPRXClientIdentifier
                                        }
                                      >
                                        {this.state.show_prx_client_identifier ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t('Accounts.Connect.PRX.PRXXApiKey')}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.prx_xapi_key || ''}
                                  id='prxXApiKey'
                                  name='prxXApiKey'
                                  type={
                                    this.state.show_prx_xapi_key ? 'text' : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label='Password'
                                  placeholder=''
                                  onChange={this.handleChangePrimeRxXApiKey}
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterXApiKey')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={this.handleClickPRXXApiKey}
                                        onMouseDown={
                                          this.handleMouseDownPRXXApiKey
                                        }
                                      >
                                        {this.state.show_prx_xapi_key ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                            <div style={{ display: 'flex' }}>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t(
                                    'Accounts.Connect.PRX.PRXClientId'
                                  )}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.prx_client_id || ''}
                                  id='prxClientId'
                                  name='prxClientId'
                                  type={
                                    this.state.show_prx_client_id
                                      ? 'text'
                                      : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label='Password'
                                  placeholder=''
                                  onChange={
                                    this.handleChangePrimeRxClientId
                                  }
                                  validators={['required']}
                                  errorMessages={[t('Validation.ClientId')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={
                                          this
                                            .handleClickPRXClientId
                                        }
                                        onMouseDown={
                                          this
                                            .handleMouseDownPRXClientId
                                        }
                                      >
                                        {this.state.show_prx_client_id ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel
                                  htmlFor='password'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t('Accounts.Connect.PRX.PRXClientSecret')}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.prx_client_secret || ''}
                                  id='prxClientSecret'
                                  name='prxClientSecret'
                                  type={
                                    this.state.show_prx_client_secret ? 'text' : 'password'
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    name: 'random-name',
                                    autoComplete: 'new-password',
                                    form: {
                                      autoComplete: 'off',
                                    },
                                  }}
                                  label='Password'
                                  placeholder=''
                                  onChange={this.handleChangePrimeRxClientSecret}
                                  validators={['required']}
                                  errorMessages={[t('Validation.ClientSecret')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={this.handleClickPRXClientSecret}
                                        onMouseDown={
                                          this.handleMouseDownPRXClientSecret
                                        }
                                      >
                                        {this.state.show_prx_client_secret ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                          </React.Fragment>
                        ) : (
                          ''
                        )}
                        {this.state &&
                          this.state.accountConnectionsId ===
                          CONNECTION_TYPE.SOLIS ? (
                          <React.Fragment>
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.client_identifier || ''}
                                id='solisClientIdentifier'
                                name='solisClientIdentifier'
                                label='Client Identifier'
                                placeholder='Client Identifier'
                                onChange={this.handleChangeMScriptClientIdentifier}
                                validators={['required']}
                                errorMessages={[t('Validation.EnterXApiKey')]}
                                variant='standard'
                              />
                              <TextValidator
                                className={classes.halfTextField}
                                margin='normal'
                                value={this.state.endpoint || ''}
                                id='solisWebUrl'
                                name='solisWebUrl'
                                label='Solis Web URL'
                                placeholder='https://solis.example.com'
                                onChange={this.handleChangeThirdPartyEndPoint}
                                validators={['required']}
                                errorMessages={[t('Validation.EnterEndPoint')]}
                                variant='standard'
                              />
                            </div>
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel htmlFor='solisApiKey' style={{ marginLeft: '-1rem' }}>
                                  Inbound API Key
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.x_api_key || ''}
                                  id='solisApiKey'
                                  name='solisApiKey'
                                  type={this.state.showXApiKey ? 'text' : 'password'}
                                  inputProps={{ readOnly: Boolean(readOnly) }}
                                  onChange={this.handleChangeMScriptXApiKey}
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterXApiKey')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle inbound api key visibility'
                                        onClick={this.handleClickMScriptXApiKey}
                                        onMouseDown={this.handleMouseDownMScriptsAPIKey}
                                      >
                                        {this.state.showXApiKey ? <Visibility /> : <VisibilityOff />}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel htmlFor='solisGatewayApiKey' style={{ marginLeft: '-1rem' }}>
                                  Gateway API Key
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.gateway_api_key || ''}
                                  id='solisGatewayApiKey'
                                  name='solisGatewayApiKey'
                                  type={this.state.showGatewayApiKey ? 'text' : 'password'}
                                  inputProps={{ readOnly: Boolean(readOnly) }}
                                  onChange={this.handleChangeGatewayApiKey}
                                  validators={['required']}
                                  errorMessages={[t('Validation.EnterXApiKey')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle gateway api key visibility'
                                        onClick={this.handleClickGatewayApiKey}
                                        onMouseDown={this.handleMouseDownGatewayApiKey}
                                      >
                                        {this.state.showGatewayApiKey ? <Visibility /> : <VisibilityOff />}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                              <FormControl
                                className={classes.formControl}
                                style={{ marginTop: '15px' }}
                              >
                                <InputLabel htmlFor='solisAuthToken' style={{ marginLeft: '-1rem' }}>
                                  Auth Token
                                </InputLabel>
                                <Input
                                  className={classes.halfTextField}
                                  margin='normal'
                                  value={this.state.third_party_token || ''}
                                  id='solisAuthToken'
                                  name='solisAuthToken'
                                  type={this.state.show_third_party_token ? 'text' : 'password'}
                                  inputProps={{ readOnly: Boolean(readOnly) }}
                                  onChange={this.handleChangeThirdPartyToken}
                                  validators={['required']}
                                  errorMessages={[t('Validation.Token')]}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle auth token visibility'
                                        onClick={this.handleClickThirdPartyToken}
                                        onMouseDown={this.handleMouseDownThirdPartyToken}
                                      >
                                        {this.state.show_third_party_token ? <Visibility /> : <VisibilityOff />}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                          </React.Fragment>
                        ) : (
                          ''
                        )}
                      </DialogContent>
                       
                    </div>
                  </TabContainer>
                ) : (
                  <span></span>
                )}
                {/* {Setting Tab} */}
                <TabContainer dir={theme.direction}>
                  <div>
                    <div style={{ float: 'left', width: 'calc(100% - 50%)' }}>
                      <DialogTitle id='form-dialog-title'>
                        {' '}
                        {t('Accounts.Settings.RxExpirationDays')}
                      </DialogTitle>
                      <DialogContent
                        className={classes.halfTextFieldNew}
                        style={{
                          overflow: 'unset',
                          padding: '0px 24px 0px !important',
                        }}
                      >
                        {t('Accounts.Settings.SelectRxExpirationDays')}
                        <Select
                          className={classes.halfTextFieldNew}
                          value={this.state.day_id || 1}
                          onChange={this.handleChangeDays}
                          inputProps={{
                            name: 'day_id',
                            id: 'day_id',
                          }}
                          variant='standard'
                        >
                          <MenuItem
                            value={'1'}
                            selected
                            className={classes.menuItem}
                          >
                            1 {t('Day')}
                          </MenuItem>
                          <MenuItem value={'2'} className={classes.menuItem}>
                            2 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'3'} className={classes.menuItem}>
                            3 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'4'} className={classes.menuItem}>
                            4 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'5'} className={classes.menuItem}>
                            5 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'6'} className={classes.menuItem}>
                            6 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'7'} className={classes.menuItem}>
                            7 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'8'} className={classes.menuItem}>
                            8 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'9'} className={classes.menuItem}>
                            9 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'10'} className={classes.menuItem}>
                            10 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'11'} className={classes.menuItem}>
                            11 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'12'} className={classes.menuItem}>
                            12 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'13'} className={classes.menuItem}>
                            13 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'14'} className={classes.menuItem}>
                            14 {t('Days')}
                          </MenuItem>
                          <MenuItem value={'15'} className={classes.menuItem}>
                            15 {t('Days')}
                          </MenuItem>
                        </Select>
                      </DialogContent>
                      <DialogTitle id='form-dialog-title'>
                        {' '}
                        {t('Accounts.Settings.PatientNotifications')}
                      </DialogTitle>
                      <DialogContent
                        className={classes.halfTextFieldNew}
                        style={{ overflow: 'unset' }}
                      >
                        <Select
                          className={classes.halfTextFieldNew}
                          value={this.state.pick_up_reminder_id || '1'}
                          readOnly={readOnly}
                          onChange={this.handleChangePickUpReminder}
                          inputProps={{
                            name: 'pick_up_reminder_id',
                            id: 'pick_up_reminder_id',
                          }}
                          variant='standard'
                        >
                          <MenuItem
                            value={'1'}
                            selected
                            className={classes.menuItem}
                          >
                            {t('Accounts.Type.StockDate')}
                          </MenuItem>
                          <MenuItem value={'2'} className={classes.menuItem}>
                            {t('Accounts.Type.TwoDays')}
                          </MenuItem>
                          <MenuItem value={'3'} className={classes.menuItem}>
                            {t('Accounts.Type.ThreeDays')}
                          </MenuItem>
                          <MenuItem value={'4'} className={classes.menuItem}>
                            {t('Accounts.Type.FourDays')}
                          </MenuItem>
                          <MenuItem value={'5'} className={classes.menuItem}>
                            {t('Accounts.Type.FiveDays')}
                          </MenuItem>
                          <MenuItem value={'-1'} className={classes.menuItem}>
                            {t('Accounts.Type.Never')}
                          </MenuItem>
                        </Select>
                      </DialogContent>
                      <DialogTitle id='form-dialog-title'>
                        {t('Accounts.Settings.Consult')}
                      </DialogTitle>
                      <DialogContent
                        className={classes.halfTextFieldNew}
                        style={{ overflow: 'unset', marginLeft: '8px' }}
                      >
                        {t('Accounts.Settings.HideShowConsultOptions')}
                        <div>
                          <FormControlLabel
                            control={
                              <Checkbox
                                disabled={this.state.operation === 'View'}
                                checked={this.state.allow_consult_video}
                                onChange={() => this.handleConsult_Video('')}
                                value={this.state.allow_consult_video}
                                color='primary'
                              />
                            }
                            style={{ marginLeft: '-15px', marginRight: '0px' }}
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.ConsultNowVideo')}
                              </span>
                            }
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            control={
                              <Checkbox
                                disabled={this.state.operation === 'View'}
                                checked={this.state.allow_consult_mobile}
                                onChange={() => this.handleConsult_Mobile('')}
                                value={this.state.allow_consult_mobile}
                                color='primary'
                              />
                            }
                            style={{ marginLeft: '-15px', marginRight: '0px' }}
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.ConsultNowAudio')}
                              </span>
                            }
                          />
                        </div>
                      </DialogContent>
                      <DialogTitle id='form-dialog-title'>
                        {t('Accounts.Settings.General')}
                      </DialogTitle>
                      <DialogContent
                        sx={{
                          '& .MuiFormControlLabel-root': {
                            display: 'flex',
                            width: 348,
                            maxWidth: '100%',
                            marginLeft: '8px !important',
                            marginRight: '0 !important',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            boxSizing: 'border-box',
                          },
                          '& .MuiFormControlLabel-label': {
                            marginLeft: 0,
                            marginRight: 0,
                          },
                          '& .MuiSwitch-root': {
                            marginLeft: '0 !important',
                            marginRight: '0 !important',
                          },
                          '& .MuiFormControlLabel-root > div': {
                            marginLeft: '0 !important',
                            marginRight: '0 !important',
                          },
                        }}
                      >
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t(
                                  'Accounts.Settings.AllowGetReadyNotification'
                                )}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.IsGetReady}
                                onChange={this.handleSwitchGetReadyChange(
                                  'check'
                                )}
                                value='check'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                              />
                            }
                            style={{ marginLeft: '8px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.BypassConsult')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <div style={{ marginLeft: '6rem' }}>
                                <Switch
                                  name='checkConsult'
                                  color='primary'
                                  checked={this.state.isConsultRequire}
                                  onChange={
                                    this.handleSwitchChangeConsultRequire
                                  }
                                  disabled={this.state.operation === 'View'}
                                  value='checked'
                                />
                              </div>
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.PatientPrimarySource')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <div style={{ marginLeft: '2.7rem' }}>
                                <Switch
                                  name='checkPatientPrimarySource'
                                  color='primary'
                                  checked={this.state.IsPatientPrimarySource}
                                  onChange={
                                    this.handleSwitchChangePatientPrimarySource
                                  }
                                  disabled={this.state.operation === 'View'}
                                  value='checked'
                                />
                              </div>
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.TouchToStartKiosk')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <div style={{ marginLeft: '4rem' }}>
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.StartGraphic}
                                  onChange={this.handleSwitchStartGraphiChange}
                                  value='checked'
                                  disabled={this.state.operation === 'View'}
                                  color='primary'
                                />
                              </div>
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.AutoDisableUser')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <div style={{ marginLeft: '5rem' }}>
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.autoDisabledUser}
                                  onChange={this.handleAutoDisabledUserChange}
                                  value='checked'
                                  disabled={this.state.operation === 'View'}
                                  color='primary'
                                />
                              </div>
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.EmailOptional')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.useDefaultEmail}
                                onChange={(event) => {
                                  this.setState({ useDefaultEmail: event.target.checked })
                                  const status = event.target.checked ? 'enabled' : 'disabled';
                                  this.writeAuditLog(`Email Optional was ${status} by user.`);
                                }}
                                value='checked'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                                sx={{ ml: '6.3rem' }}
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.DispenseSafetyCheck')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.is_dispense_safety_chek}
                                onChange={(event) => {
                                  this.setState({ is_dispense_safety_chek: event.target.checked })
                                  const status = event.target.checked ? 'enabled' : 'disabled';
                                  this.writeAuditLog(`Dispense Safety Check was ${status} by user.`);
                                }}
                                value='checked'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                                sx={{ ml: '2.5rem' }}
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.ForgotMyCode')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.is_forgot_mypucode}
                                onChange={(event) => {
                                  this.setState({ is_forgot_mypucode: event.target.checked })
                                  const status = event.target.checked ? 'enabled' : 'disabled';
                                  this.writeAuditLog(`Forgot my code was ${status} by user.`);
                                }}
                                value='checked'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                                sx={{ ml: '5.7rem' }}
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.MaskKioskDob')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.is_mask_kiosk_dob}
                                onChange={(event) => {
                                  this.setState({ is_mask_kiosk_dob: event.target.checked });
                                  const status = event.target.checked ? 'enabled' : 'disabled';
                                  this.writeAuditLog(`Kiosk DOB masking was ${status} by user.`);
                                }}
                                value='checked'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                                sx={{ ml: '2.5rem' }}
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        {/* <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.ShowEnrollNow')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.is_enroll_now}
                                onChange={(event) => {
                                  this.setState({ is_enroll_now: event.target.checked })
                                  const status = event.target.checked ? 'enabled' : 'disabled';
                                  this.writeAuditLog(`Show Enroll Now was ${status} by user.`);
                                }}
                                value='checked'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                                sx={{ ml: '5.2rem' }}
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div> */}
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t(
                                  'Accounts.Settings.AllowOfflinePaymentSkip'
                                )}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                sx={{ ml: "0.5rem" }}
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.allow_offline_payment_skip}
                                onChange={this.handleAllowOfflinePaymentSkip(
                                  'check'
                                )}
                                value='check'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                              />
                            }
                            style={{ marginLeft: '8px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.NumericCode')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                sx={{ ml: "4.5rem" }}
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.is_numeric_code}
                                onChange={this.handleNumericCode(
                                  'check'
                                )}
                                value='check'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.FutureRelease')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                sx={{ ml: "5.9rem" }}
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.is_future_release}
                                onChange={this.handleFutureRelease(
                                  'check'
                                )}
                                value='check'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.PreAssignment')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                sx={{ ml: "5.5rem" }}
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.is_pre_assignment}
                                onChange={this.handlePreAssignment('check')}
                                value='check'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.ConsultNotification')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                sx={{ ml: "1.3rem" }}
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.is_consultation_notification}
                                onChange={this.handleConsultNotify('check')}
                                value='check'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.Taxable')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                sx={{ ml: "9.2rem" }}
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.is_taxable}
                                onChange={this.handleTaxable('check')}
                                value='check'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                            <FormControlLabel
                              label={
                                <span style={{ color: '#000', fontSize: '1rem' }}>
                                  {t('Accounts.Settings.InheritRolePermissions')}
                                </span>
                              }
                              labelPlacement='start'
                              control={
                                <Switch
                                  sx={{ ml: "1.5rem" }}
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_permission_inheritable}
                                  onChange={this.handlePermissionInherit('check')}
                                  value='check'
                                  disabled={this.state.operation === 'View'}
                                  color='primary'
                                />
                              }
                              style={{ marginLeft: '8px' }}
                            />
                            <Tooltip
                              title={t('Accounts.Settings.InheritRolePermissionsHelpText')}
                              className={classes.customWidth}
                              style={{ marginLeft: '1rem' }}
                            >
                              <Help className={classes.helpIcon} />
                            </Tooltip>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                            <FormControlLabel
                              label={
                                <span style={{ color: '#000', fontSize: '1rem' }}>
                                  {t('Accounts.Settings.CascadeAccountUpdate')}
                                </span>
                              }
                              labelPlacement='start'
                              control={
                                <Switch
                                  sx={{ ml: "1.5rem" }}
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.cascade_account_update}
                                  onChange={this.handleCascadeAccountUpdate('check')}
                                  value='check'
                                  disabled={this.state.operation === 'View'}
                                  color='primary'
                                />
                              }
                              style={{ marginLeft: '8px' }}
                            />
                            <Tooltip
                              title={t('Accounts.Settings.CascadeAccountUpdateHelpText')}
                              className={classes.customWidth}
                              style={{ marginLeft: '1rem' }}
                            >
                              <Help className={classes.helpIcon} />
                            </Tooltip>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                            <FormControlLabel
                              label={
                                <span style={{ color: '#000', fontSize: '1rem' }}>
                                  {t('Accounts.Settings.NeedHelp')}
                                </span>
                              }
                              labelPlacement='start'
                              control={
                                <Switch
                                  sx={{ ml: "6.5rem" }}
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_need_help_enabled}
                                  onChange={this.handleNeedHelpChange('check')}
                                  value='check'
                                  disabled={this.state.operation === 'View'}
                                  color='primary'
                                />
                              }
                              style={{ marginLeft: '8px' }}
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                            <FormControlLabel
                              label={
                                <span style={{ color: '#000', fontSize: '1rem' }}>
                                  {t('Accounts.Settings.AllowMemberOrRecordNumber')}
                                </span>
                              }
                              labelPlacement='start'
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.allow_member_or_record_number}
                                  onChange={(event) => {
                                    this.setState({ allow_member_or_record_number: event.target.checked });
                                    const status = event.target.checked ? 'enabled' : 'disabled';
                                    this.writeAuditLog(`Allow Member or Record number was ${status} by user.`);
                                  }}
                                  value='checked'
                                  disabled={this.state.operation === 'View'}
                                  color='primary'
                                  sx={{ ml: '0.5rem' }}
                                />
                              }
                              style={{ marginLeft: '8px' }}
                            />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.EnrollmentV2Enabled')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.enrollment_v2_enabled}
                                onChange={(event) => {
                                  this.setState({
                                    enrollment_v2_enabled: event.target.checked,
                                  });
                                  const status = event.target.checked ? 'enabled' : 'disabled';
                                  this.writeAuditLog(
                                    `Enrollment v2 was ${status} by user.`
                                  );
                                }}
                                value='checked'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                                sx={{ ml: '4.8rem' }}
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px' }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label={
                              <span style={{ color: '#000', fontSize: '1rem' }}>
                                {t('Accounts.Settings.HideNewUi')}
                              </span>
                            }
                            labelPlacement='start'
                            control={
                              <Switch
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.hide_new_ui !== false}
                                onChange={(event) => {
                                  this.setState({
                                    hide_new_ui: event.target.checked,
                                  });
                                  const status = event.target.checked ? 'turned on' : 'turned off';
                                  this.writeAuditLog(
                                    `Hide new Connect UI was ${status} by user.`
                                  );
                                }}
                                value='checked'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                                sx={{ ml: '5.4rem' }}
                              />
                            }
                            style={{ marginLeft: '8px', marginTop: '5px', whiteSpace: 'nowrap' }}
                          />
                        </div>
                      </DialogContent>
                    </div>
                    <div style={{ float: 'right', width: 'calc(100% - 50%)' }}>
                      <DialogTitle id='form-dialog-title'>
                        {t('Accounts.Settings.iPayCommerce')}
                      </DialogTitle>
                      <DialogContent>
                        <div style={{ marginBottom: '16px' }}>
                          {t('Accounts.Settings.SelectPaymentGateway')}
                          <Select
                            style={{ width: '455px' }}
                            value={this.state.paymentType || ''}
                            onChange={this.handleChangePaymentGateway}
                            readOnly={this.state.operation === 'View'}
                            inputProps={{
                              name: 'paymentType',
                              id: 'paymentType',
                            }}
                            variant='standard'
                          >
                            {this.state &&
                              this.state.paymentGateways.map((type, index) => (
                                <MenuItem
                                  key={index}
                                  value={type && type.payment_type}
                                  selected
                                >
                                  {type && type.payment_type}
                                </MenuItem>
                              ))}
                          </Select>
                        </div>
                        {/*
                        ------------ iPay Configuration -----------
                        Added By: Jaimin Belani
                        Added Date : 05/12/2020
                        Description: To configure the iPay Configuration for online payment gateway
                        Note: Please do not change any code without permission. It will fail the patient payment
                        -------------------------------------------
                      */}
                        {this.state.isSuperAdmin === true ? (
                          <div>
                            {this.state &&
                              this.state.paymentType === 'AxiaMed' ? (
                              <div>
                                <FormControl
                                  className={classes.formControl}
                                  style={{
                                    width: '100%',
                                    marginBottom: '16px',
                                  }}
                                >
                                  <InputLabel
                                    htmlFor='authToken'
                                    style={{ marginLeft: '-1rem' }}
                                  >
                                    {t('Accounts.Settings.ApiID')}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldNew}
                                    margin='normal'
                                    value={this.state.authToken}
                                    id='authToken'
                                    name='authToken'
                                    type={
                                      this.state.tokenxgbapikeyvisibel
                                        ? 'text'
                                        : 'password'
                                    }
                                    onChange={this.handleChange}
                                    inputProps={{
                                      readOnly: Boolean(readOnly),
                                      name: 'random-name',
                                      autoComplete: 'new-password',
                                      form: {
                                        autoComplete: 'off',
                                      },
                                    }}
                                    label={t('Accounts.Settings.ApiID')}
                                    placeholder=''
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton
                                          aria-label='toggle xWebId visibility'
                                          onClick={
                                            this
                                              .handleShowHidetokenxgbapikeyvisibel
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state.tokenxgbapikeyvisibel ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    fullWidth
                                  />
                                </FormControl>
                                <FormControl
                                  className={classes.formControl}
                                  style={{
                                    width: '100%',
                                    marginBottom: '16px',
                                  }}
                                >
                                  <InputLabel
                                    htmlFor='authSecret'
                                    style={{ marginLeft: '-1rem' }}
                                  >
                                    {t('Accounts.Settings.APIToken')}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldNew}
                                    margin='normal'
                                    value={this.state.authSecret}
                                    id='authSecret'
                                    name='authSecret'
                                    type={
                                      this.state.tokenxgbapikeyvisibel
                                        ? 'text'
                                        : 'password'
                                    }
                                    onChange={this.handleChange}
                                    inputProps={{
                                      readOnly: Boolean(readOnly),
                                      name: 'random-name',
                                      autoComplete: 'new-password',
                                      form: {
                                        autoComplete: 'off',
                                      },
                                    }}
                                    label={t('Accounts.Settings.APIToken')}
                                    placeholder=''
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton
                                          aria-label='toggle xWebId visibility'
                                          onClick={
                                            this
                                              .handleShowHidetokenxgbapikeyvisibel
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state.tokenxgbapikeyvisibel ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    fullWidth
                                  />
                                </FormControl>
                                <FormControl
                                  className={classes.formControl}
                                  style={{
                                    width: '100%',
                                    marginBottom: '16px',
                                  }}
                                >
                                  <InputLabel
                                    htmlFor='authToken'
                                    style={{ marginLeft: '-1rem' }}
                                  >
                                    {t('Accounts.Settings.MerchantID')}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldNew}
                                    margin='normal'
                                    value={this.state.merchant_id}
                                    id='merchant_id'
                                    name='merchant_id'
                                    onChange={this.handleChange}
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label={t('Accounts.Settings.MerchantID')}
                                    fullWidth
                                  />
                                </FormControl>
                                <FormControl
                                  className={classes.formControl}
                                  style={{
                                    width: '100%',
                                    marginBottom: '16px',
                                  }}
                                >
                                  <InputLabel
                                    htmlFor='hpp_identifier'
                                    style={{ marginLeft: '-1rem' }}
                                  >
                                    {t('Accounts.Settings.HPPIdentifier')}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldNew}
                                    margin='normal'
                                    value={this.state.hpp_identifier}
                                    id='hpp_identifier'
                                    name='hpp_identifier'
                                    onChange={this.handleChange}
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label={t('Accounts.Settings.HPPIdentifier')}
                                    fullWidth
                                  />
                                </FormControl>
                              </div>
                            ) : this.isTrustCommercePaymentType(this.state.paymentType) ? (
                              this.renderTrustCommercePaymentFields(classes, readOnly, t)
                            ) : this.isInstaMedPaymentType(this.state.paymentType) ? (
                              this.renderInstaMedPaymentFields(classes, readOnly)
                            ) : this.isFiservPaymentType(this.state.paymentType) ? (
                              this.renderFiservPaymentFields(classes, readOnly)
                            ) : (
                              <div>
                                <FormControl
                                  className={classes.formControl}
                                  style={{
                                    width: '100%',
                                    marginBottom: '16px',
                                  }}
                                >
                                  <InputLabel
                                    htmlFor='xWebId'
                                    style={{ marginLeft: '-1rem' }}
                                  >
                                    {t('Accounts.Settings.XWebID')}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldNew}
                                    margin='normal'
                                    value={this.state.xWebId}
                                    id='xWebId'
                                    name='xWebId'
                                    type={
                                      this.state.tokenxgbapikeyvisibel
                                        ? 'text'
                                        : 'password'
                                    }
                                    inputProps={{
                                      readOnly: Boolean(readOnly),
                                      name: 'random-name',
                                      autoComplete: 'new-password',
                                      form: {
                                        autoComplete: 'off',
                                      },
                                    }}
                                    label='Transaction X-GB-API-Key'
                                    placeholder=''
                                    onChange={this.handleChange}
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton
                                          aria-label='toggle xWebId visibility'
                                          onClick={
                                            this
                                              .handleShowHidetokenxgbapikeyvisibel
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state.tokenxgbapikeyvisibel ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    fullWidth
                                  />
                                </FormControl>
                                <FormControl
                                  className={classes.formControl}
                                  style={{
                                    width: '100%',
                                    marginBottom: '16px',
                                  }}
                                >
                                  <InputLabel
                                    htmlFor='auth_Key'
                                    style={{ marginLeft: '-1rem' }}
                                  >
                                    {t('Accounts.Settings.AuthKey')}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldNew}
                                    margin='normal'
                                    value={this.state.auth_Key}
                                    id='auth_Key'
                                    name='auth_Key'
                                    type={
                                      this.state.transxgbapikeyvisible
                                        ? 'text'
                                        : 'password'
                                    }
                                    inputProps={{
                                      readOnly: Boolean(readOnly),
                                      name: 'random-name',
                                      autoComplete: 'new-password',
                                      form: {
                                        autoComplete: 'off',
                                      },
                                    }}
                                    label='Transaction X-GB-API-Key'
                                    placeholder=''
                                    onChange={this.handleChange}
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton
                                          aria-label='toggle auth_Key visibility'
                                          onClick={
                                            this
                                              .handleShowHidetransxgbapikeyvisible
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state.transxgbapikeyvisible ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    fullWidth
                                  />
                                </FormControl>
                                <FormControl
                                  className={classes.formControl}
                                  style={{
                                    width: '100%',
                                    marginBottom: '16px',
                                  }}
                                >
                                  <InputLabel
                                    htmlFor='terminalId'
                                    style={{ marginLeft: '-1rem' }}
                                  >
                                    {t('Accounts.Settings.TerminalID')}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldNew}
                                    margin='normal'
                                    value={this.state.terminalId}
                                    id='terminalId'
                                    name='terminalId'
                                    type={
                                      this.state.transxgbapisecretvisible
                                        ? 'text'
                                        : 'password'
                                    }
                                    inputProps={{
                                      readOnly: Boolean(readOnly),
                                      name: 'random-name',
                                      autoComplete: 'new-password',
                                      form: {
                                        autoComplete: 'off',
                                      },
                                    }}
                                    label='Transaction X-GB-API-Key'
                                    placeholder=''
                                    onChange={this.handleChange}
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton
                                          aria-label='toggle terminalId visibility'
                                          onClick={
                                            this
                                              .handleShowHidetransxgbapisecretvisible
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state
                                            .transxgbapisecretvisible ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    fullWidth
                                  />
                                </FormControl>
                              </div>
                            )}
                            <div>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={this.state.operation === 'View'}
                                    checked={this.state.allow_payment}
                                    onChange={() =>
                                      this.handleChangeallow_payment('')
                                    }
                                    value={this.state.allow_payment}
                                    color='primary'
                                  />
                                }
                                style={{
                                  marginLeft: '-15px',
                                  marginRight: '0px',
                                }}
                                label={
                                  <span
                                    style={{ color: '#000', fontSize: '1rem' }}
                                  >
                                    {t(
                                      'Accounts.Settings.AllowMobilePayments'
                                    )}
                                  </span>
                                }
                              />
                            </div>
                            <div>
                              <DialogContent
                                className={classes.halfTextFieldNew}
                                style={{
                                  overflow: 'unset',
                                  padding: '8px 0 16px 0',
                                }}
                              >
                                {t('Accounts.Settings.Text2PayTokenExpiration')}
                                <Select
                                  className={classes.halfTextFieldNew}
                                  value={String(this.state.text2pay_token_expiration_days || 1)}
                                  onChange={this.handleChangeText2PayTokenExpiration}
                                  disabled={this.state.operation === 'View'}
                                  inputProps={{
                                    name: 'text2pay_token_expiration_days',
                                    id: 'text2pay_token_expiration_days',
                                  }}
                                  variant='standard'
                                >
                                  {[...Array(15)].map((_, index) => (
                                    <MenuItem
                                      key={index + 1}
                                      value={String(index + 1)}
                                      className={classes.menuItem}
                                    >
                                      {index + 1} {t(index === 0 ? 'Day' : 'Days')}
                                    </MenuItem>
                                  ))}
                                </Select>
                                <Typography
                                  variant='caption'
                                  display='block'
                                  style={{ color: '#666', marginTop: '4px' }}
                                >
                                  {t('Accounts.Settings.Text2PayTokenExpirationHelpText')}
                                </Typography>
                              </DialogContent>
                            </div>
                            <div>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={this.state.operation === 'View'}
                                    checked={
                                      this.state.isContactLessPickupEnabled
                                    }
                                    onChange={() =>
                                      this.handleChangeIsContactLessPickupEnabled(
                                        ''
                                      )
                                    }
                                    value={
                                      this.state.isContactLessPickupEnabled
                                    }
                                    color='primary'
                                  />
                                }
                                style={{
                                  marginLeft: '-15px',
                                  marginRight: '0px',
                                }}
                                label={
                                  <span
                                    style={{ color: '#000', fontSize: '1rem' }}
                                  >
                                    {t(
                                      'Accounts.Settings.EnableContactlessPickup'
                                    )}
                                  </span>
                                }
                              />
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </DialogContent>
                      <DialogTitle id='form-dialog-title'>
                        {t('Accounts.Settings.TimeZone')}
                      </DialogTitle>
                      <DialogContent>
                        <div>
                          <Select
                            className={classes.halfTextFieldNew}
                            value={this.state.time_zone || zone}
                            onChange={this.getTimeZone}
                            readOnly={this.state.operation === 'View'}
                            inputProps={{
                              name: 'time_zone',
                              id: 'time_zone',
                            }}
                            variant='standard'
                          >
                            {this.state &&
                              this.state.timeZoneNames.map((type, index) => (
                                <MenuItem
                                  key={index}
                                  value={type && type.zone}
                                  selected
                                >
                                  {type && type.zone}
                                </MenuItem>
                              ))}
                          </Select>
                        </div>
                      </DialogContent>
                      <DialogTitle id='form-dialog-title'>
                        {t('Accounts.Settings.PreferredLanguage')}
                      </DialogTitle>
                      <DialogContent>
                        <div>
                          <Select
                            className={classes.halfTextFieldNew}
                            value={this.state.preferLanguage || ''}
                            onChange={this.onChangePreferredLanguage}
                            readOnly={readOnly}
                            inputProps={{
                              name: 'preferrdlanguage',
                              id: 'preferrdlanguage',
                            }}
                            variant='standard'
                          >
                            {this.state &&
                              this.state.preferredLanguage.map(
                                (item, index) => (
                                  <MenuItem
                                    key={index}
                                    value={item && item.id}
                                    selected
                                  >
                                    {item && item.label}
                                  </MenuItem>
                                )
                              )}
                          </Select>
                        </div>
                      </DialogContent>
                      <DialogTitle id='form-dialog-title'>
                        {t('Accounts.Settings.TimtToNotify')}
                      </DialogTitle>
                      <DialogContent>
                        <div  style={{ display: 'flex', alignItems: 'center' }}>
                          <Select
                            value={this.state.selectedHours}
                            readOnly={readOnly}
                            onChange={this.setHours}
                            inputProps={{
                              name: 'selectedHours',
                              id: 'selectedHours',
                            }}
                            variant='standard'
                          >
                            {hours.map((hour, index) => (
                              <MenuItem
                                key={index}
                                value={hour}
                                selected
                                className={classes.menuItem}
                              >
                                {hour}
                              </MenuItem>
                            ))}
                          </Select>
                          <Tooltip
                            title={timeToNotifyHelpText}
                            className={classes.customWidth}
                            style={{ marginLeft: '3%' }}
                          >
                            <Help
                              className={classes.helpIcon}
                            ></Help>
                          </Tooltip>
                        </div>
                      </DialogContent>
                      <DialogTitle id='form-dialog-title'>
                        {t('Accounts.Settings.TemperatureUnit')}
                      </DialogTitle>
                      <DialogContent>
                        <div  style={{ display: 'flex', alignItems: 'center' }}>
                          <Select
                            value={this.state.tempUnit}
                            readOnly={readOnly}
                            onChange={this.handleSetTemp}
                            inputProps={{
                              name: 'tempUnit',
                              id: 'tempUnit',
                            }}
                            variant='standard'
                          >
                              <MenuItem
                                value="F"
                                selected
                                className={classes.menuItem}
                              >
                                Fahrenheit (F)
                              </MenuItem>
                              <MenuItem
                                value="C"
                                selected
                                className={classes.menuItem}
                              >
                                 Celsius (C)
                              </MenuItem>
                          </Select>
                        </div>
                      </DialogContent>
                      <DialogTitle id='form-dialog-title'>
                        {t('Accounts.Settings.ScreenSaverRotationTime')}
                      </DialogTitle>
                      <DialogContent>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <TextField
                            variant='standard'
                            value={screensaverRotationTime}
                            onChange={this.handleScreenSaverRotationTimeChange}
                            onBlur={this.handleScreenSaverRotationTimeBlur}
                            type="number"  // This sets the input type to 'number'
                            inputProps={{ readOnly: readOnly, min: 1, pattern: '[0-9]*' }}  // Ensure no negative or non-numeric values
                            sx={{ borderBottom: '1px solid black', width: '60px' }}
                          />
                          <label>Seconds</label>
                        </Box>
                      </DialogContent>
                      <DialogTitle id='form-dialog-title'>
                        {t("Location.lblExternalId")}
                      </DialogTitle>
                      <DialogContent>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <TextField
                            id="ExternalId"
                            name="ExternalId"
                            label={t("Location.lblExternalId")}
                            onChange={(event) =>
                              this.handleExternalIdChangeEvent(event)
                            }
                            onBlur={(e) => {
                              this.state.external_id.length > 0 && this.checkIfExternalIdExist()
                            }}
                            defaultValue={this.state.external_id}
                            inputProps={{
                              autoComplete: "new-password",
                              form: {
                                autoComplete: "off",
                              },
                            }}
                            variant="standard"
                            // sx={{ width: "60%" }}
                          />
                        </Box>
                      </DialogContent>

                      <DialogTitle id='form-dialog-title'>
                        {t("Accounts.Settings.duration")}
                      </DialogTitle>
                      <DialogContent
                        className={classes.halfTextFieldNew}
                        style={{ overflow: 'unset' }}
                      >
                        <Select
                          className={classes.halfTextFieldNew}
                          value={this.state.securebadgeexpiryduration} 
                          onChange={this.handleChangeSecureBadgeDuration}
                          inputProps={{}}
                          variant='standard'
                        >
                          <MenuItem value={'30 minutes'}>30 Minutes</MenuItem>
                          <MenuItem value={'1 hour'}>1 Hour</MenuItem>
                          <MenuItem value={'24 hours'}>24 Hours</MenuItem>
                          <MenuItem value={'7 days'}>7 Days</MenuItem>
                          <MenuItem value={'30 days'}>30 Days</MenuItem>
                          <MenuItem value={'60 days'}>60 Days</MenuItem>
                          <MenuItem value={'90 days'} >90 Days</MenuItem>
                          <MenuItem value={'120 days'} >120 Days</MenuItem>
                          <MenuItem value={'150 days'} >150 Days</MenuItem>
                          <MenuItem value={'180 days'} >180 Days</MenuItem>
                        </Select>
                      </DialogContent>

                      
                    </div>
                     
                  </div>
                </TabContainer>
                {/* {Security Tab} */}
                <TabContainer dir={theme.direction}>
                  <div>
                    <DialogTitle id='form-dialog-title'>
                      {t('Accounts.Settings.OIDCLoginSetup')}
                    </DialogTitle>
                    <DialogContent>
                      <FormControl
                        className={classes.formControl}
                        style={{
                          width: '100%',
                          marginBottom: '16px',
                          marginTop: '15px',
                        }}
                      >
                        <Select
                          className={classes.halfTextFieldNew}
                          value={this.state.loginType}
                          onChange={(e) =>
                            this.setState({ loginType: e.target.value })
                          }
                          variant='standard'
                        >
                          <MenuItem key='DEFAULT' value='DEFAULT' selected>
                            {t('Accounts.Default')}
                          </MenuItem>
                          <MenuItem key='OKTA' value='OKTA' selected>
                            Okta
                          </MenuItem>
                          <MenuItem key='PING' value='PING' selected>
                            Ping Identity
                          </MenuItem>
                          <MenuItem key='SAML' value='SAML' selected>
                            SAML 2.0
                          </MenuItem>
                        </Select>
                      </FormControl>
                      {this.state.loginType === 'DEFAULT' ? (
                        ''
                      ) : (
                        <React.Fragment>
                          <FormControl
                            className={classes.formControl}
                            style={{ width: '100%', marginBottom: '16px' }}
                          >
                            <InputLabel
                              htmlFor='ssoIssuer'
                              style={{ marginLeft: '-1rem' }}
                            >
                              {t('Accounts.Security.Issuer')}
                            </InputLabel>
                            <Input
                              error={this.state.isSSOAccountExist}
                              className={classes.halfTextFieldNew}
                              margin='normal'
                              value={this.state.ssoIssuer}
                              id='ssoIssuer'
                              name='ssoIssuer'
                              type='text'
                              label={t('Accounts.Security.Issuer')}
                              placeholder=''
                              onChange={({ target }) =>
                                this.setState({ ssoIssuer: target.value })
                              }
                              fullWidth
                              inputProps={{ readOnly: Boolean(readOnly) }}
                            />
                          </FormControl>
                          <FormControl
                            className={classes.formControl}
                            style={{ width: '100%', marginBottom: '16px' }}
                          >
                            <InputLabel
                              htmlFor='emailDomain'
                              style={{ marginLeft: '-1rem' }}
                            >
                              {t('Accounts.Security.EmailDomainOrUsername')}
                            </InputLabel>
                            <Input
                              error={this.state.isSSOAccountExist}
                              className={classes.halfTextFieldNew}
                              margin='normal'
                              value={this.state.emailDomain}
                              id='emailDomain'
                              name='emailDomain'
                              type='text'
                              label={t('Accounts.Security.EmailDomainOrUsername')}
                              placeholder=''
                              onChange={({ target }) =>
                                this.setState({ emailDomain: target.value })
                              }
                              fullWidth
                              inputProps={{ readOnly: Boolean(readOnly) }}
                            />
                          </FormControl>
                          {this.state.loginType === 'SAML' ? (
                            <React.Fragment>
                              <FormControl
                                className={classes.formControl}
                                style={{
                                  width: '100%',
                                  marginBottom: '16px',
                                }}
                              >
                                <InputLabel
                                  htmlFor='oidcCert'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t('Accounts.Security.Certificate')}
                                </InputLabel>
                                <Input
                                  error={this.state.isSSOAccountExist}
                                  className={classes.halfTextFieldNew}
                                  margin='normal'
                                  value={this.state.oidcCert}
                                  id='oidcCert'
                                  name='oidcCert'
                                  type='text'
                                  label={t('Accounts.Security.Certificate')}
                                  placeholder=''
                                  onChange={({ target }) =>
                                    this.setState({ oidcCert: target.value })
                                  }
                                  fullWidth
                                  inputProps={{ readOnly: Boolean(readOnly) }}
                                  multiline={true}
                                  sx={{
                                    height: this.state.oidcCert
                                      ? '70px'
                                      : 'auto',
                                    overflow: 'auto',
                                  }}
                                />
                              </FormControl>
                              <FormControl
                                className={classes.formControl}
                                style={{
                                  width: '100%',
                                  marginBottom: '16px',
                                }}
                              >
                                <InputLabel
                                  htmlFor='ssoEntryPoint'
                                  style={{ marginLeft: '-1rem' }}
                                >
                                  {t('Accounts.Security.SSOEntryPoint')}
                                </InputLabel>
                                <Input
                                  error={this.state.isSSOAccountExist}
                                  className={classes.halfTextFieldNew}
                                  margin='normal'
                                  value={this.state.ssoEntryPoint}
                                  id='ssoEntryPoint'
                                  name='ssoEntryPoint'
                                  type='text'
                                  label={t('Accounts.Security.SSOEntryPoint')}
                                  placeholder=''
                                  onChange={({ target }) =>
                                    this.setState({
                                      ssoEntryPoint: target.value,
                                    })
                                  }
                                  fullWidth
                                  inputProps={{ readOnly: Boolean(readOnly) }}
                                />
                              </FormControl>
                            </React.Fragment>
                          ) : (
                            <FormControl
                              className={classes.formControl}
                              style={{ width: '100%', marginBottom: '16px' }}
                            >
                              <InputLabel
                                htmlFor='clientId'
                                style={{ marginLeft: '-1rem' }}
                              >
                                {t('Accounts.Security.ClientID')}
                              </InputLabel>
                              <Input
                                error={this.state.isSSOAccountExist}
                                className={classes.halfTextFieldNew}
                                margin='normal'
                                value={this.state.clientId}
                                id='clientId'
                                name='clientId'
                                type='text'
                                label={t('Accounts.Security.ClientID')}
                                placeholder=''
                                onChange={({ target }) =>
                                  this.setState({ clientId: target.value })
                                }
                                fullWidth
                                inputProps={{ readOnly: Boolean(readOnly) }}
                              />
                            </FormControl>
                          )}
                        </React.Fragment>
                      )}
                      <br />
                      <FormControlLabel
                        label={
                          <span style={{ color: '#000', fontSize: '1rem' }}>
                            {t('Accounts.Security.MFA')}
                          </span>
                        }
                        labelPlacement='end'
                        control={
                          <React.Fragment>
                            <span style={{ color: '#000', fontSize: '1rem' }}>
                              {t('Accounts.Security.BasicAuth')}
                            </span>
                            <Switch
                              name='is_otp_login'
                              classes={{
                                switchBase: classes.iOSSwitchBase,
                                bar: classes.iOSBar,
                                icon: classes.iOSIcon,
                                iconChecked: classes.iOSIconChecked,
                                checked: classes.iOSChecked,
                              }}
                              checked={this.state.is_mfa_required}
                              onChange={(event) =>
                                this.setState({
                                  is_mfa_required: event.target.checked,
                                })
                              }
                              value='checked'
                              disabled={this.state.operation === 'View'}
                              color='primary'
                              sx={{ ml: '5.7rem', margin: 0 }}
                            />
                          </React.Fragment>
                        }
                        style={{ marginLeft: '0', marginTop: '5px' }}
                      />
                      <br />
                      <FormControlLabel
                        label={
                          <span style={{ color: '#000', fontSize: '1rem' }}>
                            {t('Accounts.Security.AutoLogoutOnTokenExpiry')}
                          </span>
                        }
                        labelPlacement='end'
                        control={
                          <Switch
                            name='is_auto_logout_enabled'
                            classes={{
                              switchBase: classes.iOSSwitchBase,
                              bar: classes.iOSBar,
                              icon: classes.iOSIcon,
                              iconChecked: classes.iOSIconChecked,
                              checked: classes.iOSChecked,
                            }}
                            checked={this.state.is_auto_logout_enabled}
                            onChange={(event) =>
                              this.setState({
                                is_auto_logout_enabled: event.target.checked,
                              })
                            }
                            value='checked'
                            disabled={this.state.operation === 'View'}
                            color='primary'
                          />
                        }
                        style={{ marginLeft: '0', marginTop: '5px' }}
                      />
                      <Typography variant='caption' display='block' style={{ color: '#666', marginTop: '4px' }}>
                        {t('Accounts.Security.AutoLogoutOnTokenExpiryHelpText')}
                      </Typography>
                    </DialogContent>
                    <DialogTitle id='form-dialog-title'>
                      {t('Accounts.Security.KioskLoginSetup')}
                    </DialogTitle>
                    <DialogContent>
                      <FormControlLabel
                        label={
                          <span style={{ color: '#000', fontSize: '1rem' }}>
                            {t('Accounts.Security.LoginWithOTP')}
                          </span>
                        }
                        labelPlacement='end'
                        control={
                          <React.Fragment>
                            <span style={{ color: '#000', fontSize: '1rem' }}>
                              {t('Accounts.Security.BasicAuth')}
                            </span>
                            <Switch
                              name='is_otp_login'
                              classes={{
                                switchBase: classes.iOSSwitchBase,
                                bar: classes.iOSBar,
                                icon: classes.iOSIcon,
                                iconChecked: classes.iOSIconChecked,
                                checked: classes.iOSChecked,
                              }}
                              checked={this.state.is_otp_login}
                              onChange={(event) =>
                                this.setState({
                                  is_otp_login: event.target.checked,
                                })
                              }
                              value='checked'
                              disabled={this.state.operation === 'View'}
                              color='primary'
                              sx={{ ml: '5.7rem', margin: 0 }}
                            />
                          </React.Fragment>
                        }
                        style={{ marginLeft: '0', marginTop: '5px' }}
                      />
                    </DialogContent>
                    <DialogTitle id='form-dialog-title'>
                      {t('Account.Security.Purge')}
                    </DialogTitle>
                    <DialogContent>
                        <FormControlLabel
                          label={
                            <span style={{ color: '#000', fontSize: '1rem', width: "200px", display: "block" }}>
                              {t('Account.Security.PurgePatientData')}
                            </span>
                          }
                          labelPlacement='start'
                          control={
                            <React.Fragment>
                              <Switch
                                name='purge_data_serivce'
                                classes={{
                                  switchBase: classes.iOSSwitchBase,
                                  bar: classes.iOSBar,
                                  icon: classes.iOSIcon,
                                  iconChecked: classes.iOSIconChecked,
                                  checked: classes.iOSChecked,
                                }}
                                checked={this.state.purge_patient_data_toggle}
                                onChange={(event) => this.handlePurgeDataToggle(event)}
                                value='checked'
                                disabled={this.state.operation === 'View'}
                                color='primary'
                                sx={{ ml: '5.7rem', margin: 0 }}
                              />
                            </React.Fragment>
                          }
                          style={{ marginLeft: '0', marginTop: '5px' }}
                        />
                        <Tooltip
                          title={t('Account.Security.PurgePatientDataTooltip')}
                          className={classes.customWidth}
                          style={{ position: 'absolute', marginTop: '1.2%', marginLeft: '1.2%' }}
                        >
                          <Help
                            className={classes.helpIcon}
                          ></Help>
                        </Tooltip>
                        <br />
                        {this.state.purge_patient_data_toggle === true && (
                          <React.Fragment>
                            <FormControl style={{ marginTop: '15px' }}>
                              <InputLabel
                                htmlFor='purge_patient_data_days_count'
                                style={{ marginLeft: '-15px' }}
                              >
                                {t('Account.Security.DaysConfig')}
                              </InputLabel>
                              <Select
                                className={classes.halfTextFieldNew}
                                value={this.state.purge_patient_data_days_count}
                                onChange={(e) =>
                                  this.setState({ purge_patient_data_days_count: e.target.value })
                                }
                                variant='standard'
                              >
                                <MenuItem key='7' value='7'>
                                  7
                                </MenuItem>
                                <MenuItem key='15' value='15'>
                                  15
                                </MenuItem>
                                <MenuItem key='30' value='30'>
                                  30
                                </MenuItem>
                                <MenuItem key='60' value='60'>
                                  60
                                </MenuItem>
                                <MenuItem key='90' value='90'>
                                  90
                                </MenuItem>
                                <MenuItem key='180' value='180'>
                                  180
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <br />
                          </React.Fragment>

                        )}
                      <FormControlLabel
                        label={
                            <span style={{ color: '#000', fontSize: '1rem', width: "200px", display: "block" }}>
                              {t('Account.Terms.PurgeServiceToggleLabel')}
                            </span>
                        }
                        labelPlacement='start'
                        control={
                          <React.Fragment>
                            <Switch
                              name='purge_image_serivce'
                              classes={{
                                switchBase: classes.iOSSwitchBase,
                                bar: classes.iOSBar,
                                icon: classes.iOSIcon,
                                iconChecked: classes.iOSIconChecked,
                                checked: classes.iOSChecked,
                              }}
                              checked={this.state.purge_patient_images_toggle}
                              onChange={(event) => this.purgeImagePatientToggleAction(event)}
                              value='checked'
                              disabled={this.state.operation === 'View'}
                              color='primary'
                              sx={{ ml: '5.7rem', margin: 0 }}
                            />
                          </React.Fragment>
                        }
                        style={{ marginLeft: '0', marginTop: '5px' }}
                      />
                      <Tooltip
                        title={purgeImageHelpText}
                        className={classes.customWidth}
                        style={{ position: 'absolute', marginTop: '1.2%', marginLeft: '1.2%' }}
                      >
                        <Help
                          className={classes.helpIcon}
                        ></Help>
                      </Tooltip>
                      <br />
                      {this.state.purge_patient_images_toggle === true ? (
                        <FormControl style={{ marginTop: '15px' }}>
                          <InputLabel
                            htmlFor='purge_patient_images_days_count'
                            style={{ marginLeft: '-15px' }}
                          >
                            Select days configuration
                          </InputLabel>
                          <Select
                            className={classes.halfTextFieldNew}
                            value={this.state.purge_patient_images_days_count}
                            onChange={(e) =>
                              this.setState({ purge_patient_images_days_count: e.target.value })
                            }
                            variant='standard'
                          >
                            <MenuItem key='30' value='30' selected>
                              30
                            </MenuItem>
                            <MenuItem key='60' value='60'>
                              60
                            </MenuItem>
                            <MenuItem key='90' value='90'>
                              90
                            </MenuItem>
                            <MenuItem key='180' value='180'>
                              180
                            </MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        ''
                      )}
                      <Dialog
                        open={this.state.purgeImageDialog || false}
                        aria-labelledby='alert-dialog-title'
                        aria-describedby='alert-dialog-description'
                      >
                        <DialogContent>
                          <DialogContentText>
                            <p>
                              {t('Account.Terms.PurgeServiceToggleConfirmationText')}
                            </p>
                            <TextValidator
                              autoFocus
                              className={classes.halfTextField}
                              margin='normal'
                              value={this.state.purge_patient_username_confirmation || ''}
                              id='purgeImageUserName'
                              name='purgeImageUserName'
                              label={t('Account.Terms.PurgeServicePopupUsernamePlaceHolder')}
                              placeholder={t('Account.Terms.PurgeServicePopupUsernamePlaceHolder')}
                              onChange={this.handlePurgeImageDialogUserName}
                              variant='standard'
                            />
                            <TextValidator
                              id="password"
                              name="password"
                              type="password"
                              label={t("Report.Stocked.ManualOverride.Password")}
                              className={classes.halfTextField}
                              value={this.state.purge_patient_password}
                              onChange={this.handlePurgeImageDialogPasswordChange}
                              margin="normal"
                              variant="standard"
                              inputProps={{
                                name: 'random-name',
                                autoComplete: 'new-password',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                            />
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={(event) => this.handlePurgeConfirmationYes(event)}
                            color='primary'
                          >
                            {t('Global.Consultation.Action.Yes')}
                          </Button>
                          <Button
                            onClick={(event) => this.handlePurgeConfirmationNo(event)}
                            color='primary'
                          >
                            {t('Global.Consultation.Action.No')}
                          </Button>
                        </DialogActions>
                      </Dialog>
                      <Dialog
                        open={this.state.purge_patienet_final_confirmation_dialog || false}
                        aria-labelledby='alert-dialog-title'
                        aria-describedby='alert-dialog-description'
                      >
                        <DialogContent>
                          <DialogContentText>
                            {
                              purgeSpinnerInProgress ?
                                (
                                  <img style={{ width: '50px' }} src={spinner} alt="Purge Spinner" />
                                )
                                :
                                (
                                  <p>
                                    {t('Account.Terms.PurgeServicePopupFinalConfirmationMessage')}
                                  </p>
                                )
                            }
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={(event) => this.handlePurgeFinalConfirmationYes(event)}
                            color='primary'
                            disabled={purgeSpinnerInProgress === true}
                          >
                            {t('Global.Consultation.Action.Yes')}
                          </Button>
                          <Button
                            onClick={(event) => this.handlePurgeFinalConfirmationNo(event)}
                            color='primary'
                            disabled={purgeSpinnerInProgress === true}
                          >
                            {t('Global.Consultation.Action.No')}
                          </Button>
                        </DialogActions>
                      </Dialog>
                      <Dialog
                        open={this.state.purgeDataDialog || false}
                        aria-labelledby='alert-dialog-title'
                        aria-describedby='alert-dialog-description'
                      >
                        <DialogContent>
                          <DialogContentText>
                            <p>
                              {t('Account.Terms.PurgeServiceToggleConfirmationText')}
                            </p>
                            <TextValidator
                              autoFocus
                              className={classes.halfTextField}
                              margin='normal'
                              value={this.state.purge_patient_username_confirmation || ''}
                              id='purgeImageUserName'
                              name='purgeImageUserName'
                              label={t('Account.Terms.PurgeServicePopupUsernamePlaceHolder')}
                              placeholder={t('Account.Terms.PurgeServicePopupUsernamePlaceHolder')}
                              onChange={this.handlePurgeImageDialogUserName}
                              variant='standard'
                            />
                            <TextValidator
                              id="password"
                              name="password"
                              type="password"
                              label={t("Report.Stocked.ManualOverride.Password")}
                              className={classes.halfTextField}
                              value={this.state.purge_patient_password}
                              onChange={this.handlePurgeImageDialogPasswordChange}
                              margin="normal"
                              variant="standard"
                              inputProps={{
                                name: 'random-name',
                                autoComplete: 'new-password',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                            />
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={(event) => this.handlePurgeDataConfirmationYes(event)}
                            color='primary'
                          >
                            {t('Global.Consultation.Action.Yes')}
                          </Button>
                          <Button
                            onClick={(event) => this.handlePurgeDataConfirmationNo(event)}
                            color='primary'
                          >
                            {t('Global.Consultation.Action.No')}
                          </Button>
                        </DialogActions>
                      </Dialog>
                      <Dialog
                        open={this.state.purgeDataFinalDialog || false}
                        aria-labelledby='alert-dialog-title'
                        aria-describedby='alert-dialog-description'
                      >
                        <DialogContent>
                          <DialogContentText>
                            {
                              purgeSpinnerInProgress ?
                                (
                                  <img style={{ width: '50px' }} src={spinner} alt="Purge Spinner" />
                                )
                                :
                                (
                                  <p>
                                    {t('Account.Terms.PurgeServicePopupFinalConfirmationMessage')}
                                  </p>
                                )
                            }
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={(event) => this.handlePurgeDataFinalConfirmationYes(event)}
                            color='primary'
                            disabled={purgeSpinnerInProgress === true}
                          >
                            {t('Global.Consultation.Action.Yes')}
                          </Button>
                          <Button
                            onClick={(event) => this.handlePurgeDataFinalConfirmationNo(event)}
                            color='primary'
                            disabled={purgeSpinnerInProgress === true}
                          >
                            {t('Global.Consultation.Action.No')}
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </DialogContent>     
                  </div>
                </TabContainer>
                {/* {Health&Information Tab} */}
                {/* <TabContainer dir={theme.direction}>
                  <div>
                    <DialogTitle id='form-dialog-title'>
                      Health & information
                    </DialogTitle>
                    <DialogContent>
                      <div>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            autoFocus
                            className={classes.halfTextField}
                            margin='normal'
                            value={this.state.primarylibrarytitle1 || ''}
                            id='primarylib1'
                            name='primarylib1'
                            inputProps={{ readOnly: Boolean(readOnly) }}
                            label='Primary Videos'
                            placeholder='Primary Videos'
                            onChange={this.handleChangeprimaryLib1}
                            style={{ width: '482px' }}
                            //validators={['required']}
                            //errorMessages={[t('Validation.EnterPharmacyID)]}
                            variant='standard'
                          />
                          <TextValidator
                            autoFocus
                            className={classes.halfTextField}
                            margin='normal'
                            value={this.state.primarylibrarytitle2 || ''}
                            id='primarylib2'
                            name='primarylib2'
                            inputProps={{ readOnly: Boolean(readOnly) }}
                            label='Secondary Videos'
                            placeholder='Secondary Videos'
                            onChange={this.handleChangeprimaryLib2}
                            style={{ width: '482px' }}
                            variant='standard'
                          />
                        </div>
                        <Table className={classes.SeparateRow}>
                          <TableHead>
                            <TableRow>
                              <TableCell
                                colSpan={3}
                                className={classes.tableAddRowCell}
                                align='center'>
                                <div className={classes.addRowIcon}>
                                  <Button
                                    onClick={this.addRow}
                                    color='primary'
                                    style={{ marginLeft: '-56rem' }}>
                                    Add Videos
                                  </Button>
                                </div>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{this.createRow()}</TableBody>
                        </Table>
                      </div>
                    </DialogContent>
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '0',
                        width: '100%',
                      }}>
                      <DialogActions>
                        <Button
                          onClick={this.handleClose}
                          color='primary'
                          className={classes.primaryButton}>
                          {this.state.operation === 'View' ? 'Close' : 'Cancel'}
                        </Button>
                        {this.state.operation !== 'View' && (
                          <Button
                            type='submit'
                            disabled={this.state.isButtonDisabled}
                            color='primary'
                            className={classes.primaryButton}>
                            {this.state.operation === 'Edit'
                              ? 'Update Account'
                              : 'Add Account'}
                          </Button>
                        )}
                      </DialogActions>
                    </div>
                  </div>
                </TabContainer> */}
                  {/* {Terms&Condition Tab} */}
                  <TabContainer dir={theme.direction}>
                    <TermsAndConditionsSection
                      readOnly={readOnly}
                      classes={classes}
                      t={t}
                      patientConsent={this.state.patient_consent}
                      onPatientConsentChange={this.handlePatientConsent('check')}
                      contractLang={this.state.contractLang}
                      charCount={this.state.charCount}
                      maxChar={this.state.MaxChar}
                      onContractChange={this.handleChangeContract}
                      docone={this.state.docone}
                      doctwo={this.state.doctwo}
                      docthree={this.state.docthree}
                      onDocOneChange={this.handleChangeDocOne}
                      onDocTwoChange={this.handleChangeDocTwo}
                      onDocThreeChange={this.handleChangeDocThree}
                      hippaPreview={this.state.HippaPreview}
                      lcPreview={this.state.LCPreview}
                      otherPreview={this.state.OtherPreview}
                      filename={this.state.filename}
                      lcFilename={this.state.LCfilename}
                      otherFilename={this.state.Otherfilename}
                      onHippaDrop={this.handleHippaDrop}
                      onLCDrop={this.handleLCDrop}
                      onOtherDrop={this.handleOtherDrop}
                      onPreviewHippa={this.PreviewHippa}
                      onPreviewLC={this.PreviewLC}
                      onPreviewOther={this.PreviewOther}
                      onRemoveHippa={this.removeHippa}
                      onRemoveLC={this.removeLC}
                      onRemoveOther={this.removeOther}
                      operation={this.state.operation}
                    />
                  </TabContainer>
                {/* Signature flags test/dev mode configuration (separate component) */}
                {isSignatureFlagsConnection && (
                    <div>
                      <SignatureFlagsDevModeSection
                        t={t}
                        readOnly={Boolean(readOnly)}
                        classes={classes}
                        signatureFlagsTestMode={this.state.signature_flags_test_mode}
                        signatureFlagsTestConfig={this.state.signature_flags_test_config}
                        disabled={this.state.operation === 'View'}
                        onChangeMode={(checked) =>
                          this.setState({ signature_flags_test_mode: checked })
                        }
                        onChangeConfig={(parts) =>
                          this.setState({ signature_flags_test_config: parts })
                        }
                      />
                      <SignatureFlagsSection
                        accountId={this.state.id}
                        operation={this.state.operation}
                        t={t}
                      />
                    </div>
                  )
                }
                {/* {Advanced Tab} */}
                <TabContainer dir={theme.direction}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>
                        {t('Accounts.Advanced.ProductsTitle')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        Products
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>
                        {t('Accounts.Advanced.TaxesTitle')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Paper sx={{ margin: '15px', height: '200px' }}>
                        <DialogTitle id='form-dialog-title'>
                          {t("Accounts.Advanced.TaxHeader")}
                        </DialogTitle>
                        <DialogContent>
                          <Grid container spacing={2}>
                            <Grid item>
                              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                <FormLabel component="legend">{t("Accounts.Advanced.TaxCodeLabel")}</FormLabel>
                                <Select
                                  style={{ marginTop: '5px' }}
                                  autoWidth={true}
                                  value={this.state.selectedTaxCode}
                                  onChange={this.handleTaxCodeChange}
                                  inputProps={{
                                    name: 'tax_code',
                                    id: 'tax_codes',
                                  }}
                                  readOnly={readOnly}
                                >
                                  {this.TaxCodes && this.TaxCodes.map((TaxCode, index) => (
                                    <MenuItem
                                      key={index}
                                      value={index}
                                      selected
                                      className={classes.locationType}
                                    >
                                      {TaxCode}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item style={{ marginTop: '8px' }}>
                              <FormLabel component="legend" style={{ marginBottom: '5px' }}>{t("Accounts.Advanced.RateLabel")}</FormLabel>
                              <TextField
                                id="tax-rate"
                                size="small"
                                value={this.state.taxRate}
                                onChange={this.handleTaxRateChange}
                                disabled={readOnly}
                                helperText={<b>{this.state.helperText}</b>}
                              >
                              </TextField>
                            </Grid>
                          </Grid>
                        </DialogContent>
                      </Paper>
                    </AccordionDetails>
                  </Accordion>
                  
                </TabContainer>
              </SwipeableViews>
              </DialogContent>
              {/* sticky actions buttons */}  
              <DialogActions sx={{
                  position: "sticky",
                  bottom: 0,
                  backgroundColor: "white", // Optional: Add background color to avoid overlap
                  zIndex: 1, // Ensure it stays above content
                }}
              >
                <Button
                  onClick={this.handleClose}
                  color='primary'
                  className={classes.primaryButton}
                >
                  {this.state.operation === 'View'
                    ? t('Accounts.CloseButton')
                    : t('Accounts.CancelButton')}
                </Button>
                {this.state.operation !== 'View' && (
                  <Button
                    type='submit'
                    disabled={this.state.isButtonDisabled}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {this.state.operation === 'Edit'
                      ? t('Accounts.UpdateAccountButton')
                      : t('Accounts.AddAccountButton')}
                  </Button>
                )}
              </DialogActions> 
            </ValidatorForm>
          </div> 
          
        </Dialog>

        <EnhancedTableToolbar
          numSelected={selected.length}
          add={this.addUser}
          deleteUsers={this.deleteUsers}
          editUser={this.editUser}
          confirmDelete={this.confirmDelete}
          acadd={this.state.accountadd}
          acdelete={this.state.accountdelete}
        />
        <div className={classes.tableWrapper}>
          <Divider className={classes.divider} />
                    <ILocalAGGrid
            columnDefs={[
              {
                field: 'picture_url',
                headerName: t('Accounts.Logo'),
                sortable: false,
                filter: false,
                maxWidth: 100,
                cellRenderer: (params) => (
                  <Avatar alt='' src={params.data && params.data.picture_url} />
                ),
              },
              { field: 'name', headerName: t('Accounts.Name') },
              {
                field: 'parent.name',
                headerName: t('Accounts.ParentAccount'),
                valueGetter: (params) =>
                  (params.data && params.data.parent && params.data.parent.name) || '',
              },
              {
                field: 'type.name',
                headerName: t('Accounts.AccountType'),
                valueGetter: (params) =>
                  (params.data && params.data.type && params.data.type.name) || '',
              },
              {
                field: 'contact.address.city',
                headerName: t('Accounts.City'),
                valueGetter: (params) =>
                  (params.data &&
                    params.data.contact &&
                    params.data.contact.address &&
                    params.data.contact.address.city) ||
                  '',
              },
              {
                field: 'contact.address.state',
                headerName: t('Accounts.State'),
                valueGetter: (params) =>
                  (params.data &&
                    params.data.contact &&
                    params.data.contact.address &&
                    params.data.contact.address.state) ||
                  '',
              },
              {
                field: 'contact.address.zip',
                headerName: t('Accounts.Zip'),
                valueGetter: (params) =>
                  (params.data &&
                    params.data.contact &&
                    params.data.contact.address &&
                    params.data.contact.address.zip) ||
                  '',
              },
              getActionsColumn({
                headerName: t('Accounts.Actions'),
                onActionsClick: (event, params, menuHelpers) =>
                  this.openRowActionsMenu(event, params, menuHelpers),
              }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowSelection='multiple'
            rowModelType='serverSide'
            cacheBlockSize={FilterObj.pageSize || 10}
            paginationPageSize={FilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={45}
            getRowId={(params) => params.data && params.data.id}
            onGridReady={this.onGridReady}
            onRowSelected={this.onRowSelected}
            onPaginationChanged={this.onPaginationChanged}
            getContextMenuItems={this.getContextMenuItems}
          />
        </div>
        <Dialog
          fullWidth
          maxWidth='xl'
          open={this.state.showAccountResources || false}
          aria-labelledby='account-resources-dialog-title'
          PaperProps={{ style: { minHeight: '75vh' } }}
        >
          <DialogTitle id='account-resources-dialog-title'>
            {t('Accounts.ViewResourcesDialog.Title')}
            {this.state.selectedAccountNameForResources
              ? ` - ${this.state.selectedAccountNameForResources}`
              : ''}
          </DialogTitle>
          <DialogContent>
            {this.state.showAccountResources &&
            this.state.selectedAccountIdForResources ? (
              <AccountResourcesDialog
                accountId={this.state.selectedAccountIdForResources}
                canView={this.state.accountview === true}
                canEdit={this.state.accountedit === true}
                onViewAccount={this.openChildAccountView}
                onEditAccount={this.openChildAccountEdit}
              />
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.closeAccountResourcesDialog}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Accounts.CloseButton')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    ); 
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  withTranslation()(EnhancedTable)
);



// WEBPACK FOOTER //
// ./src/components/account-list/index.js